webpackJsonp([72],{

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_moment__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(104);
/* globals Url */


 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__["a" /* default */].View.extend({
  DAYS: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  initialize: function initialize(options) {
    this.service = options.service;
    this.$el.addClass('js-service-dates-spec');
  },
  isRecurring: function isRecurring() {
    return false;
  },
  propagateDatesChanged: function propagateDatesChanged(target) {
    var _this = this;

    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'datesChanged';
    this.listenTo(target, event, __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].bind(function () {
      return _this.trigger('datesChanged');
    }, this));
  },
  getDaysFromUrl: function getDaysFromUrl() {
    var url = new Url();
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.DAYS, function (day) {
      var value = url.query[day];
      if (!value) return false;
      return value.toLowerCase() === 'true';
    });
  },
  getDateRangeFromUrl: function getDateRangeFromUrl() {
    var url = new Url();

    if (url.query.start_date && url.query.end_date) {
      return this.dateRange(url.query.start_date, url.query.end_date);
    }

    return [];
  },
  formatDate: function formatDate(dateString) {
    var date = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_moment__["a" /* default */])(dateString, [__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT, __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO]).toDate();
    if (!dateString) return null;
    return this.dateInISOFormat(date);
  },
  dateInISOFormat: function dateInISOFormat(date) {
    function zeroPad(s) {
      s += '';
      return "".concat(s.length < 2 ? '0' : '').concat(s);
    }

    return "".concat(date.getFullYear(), "-").concat(zeroPad(date.getMonth() + 1), "-").concat(zeroPad(date.getDate()));
  },
  dateRange: function dateRange(startDate, endDate) {
    var date = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_moment__["a" /* default */])(startDate, [__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT, __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO]);
    var end = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_moment__["a" /* default */])(endDate, [__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT, __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO]);
    var dateRange = [date.format(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT)]; // If the service's end date is exclusive, we need to exclude the last day selected

    if (this.service.is_end_date_exclusive()) {
      end = end.subtract(1, 'days');
    }

    while (date.isBefore(end)) {
      date = date.add(1, 'days');
      dateRange.push(date.format(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT));
    }

    return dateRange;
  }
}));

/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__ = __webpack_require__(31);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__["a" /* default */].Model.extend({
  dateFormat: __WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO,
  dateDisplayFormat: __WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT,
  idAttribute: 'url',
  isRecurring: false,
  url: function url() {
    return this.get('url');
  },
  initialize: function initialize() {
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].bindAll(this, 'acceptRequest', 'createRequest', 'toggleRequesterAddOn');
  },
  getOpk: function getOpk() {
    // This should be overridden by "subclasses"
    return '';
  },
  getState: function getState() {
    var state = this.get('status');
    var request = this.get('request');

    if (state === 'booked' || state === 'cancelled') {
      return 'booked';
    } else if (!request) {
      return 'authorize';
    } else if (request && request.requester_actions.indexOf('accepted') !== -1) {
      return 'pay';
    } else if (request && request.provider_actions.indexOf('accepted') !== -1) {
      return 'requested';
    } // We shouldn't get here


    return null;
  },
  getUnit: function getUnit() {
    var addOn = __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].findWhere(this.get('booking_add_ons'), {
      is_alternative_rate: true
    });

    return addOn ? addOn.frequency : null;
  },
  isBooked: function isBooked() {
    return this.getState() === 'booked';
  },
  isPayingState: function isPayingState() {
    return ['authorize', 'pay'].indexOf(this.getState()) !== -1 && !__WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__["default"].context.isSitter;
  },
  getActiveBookingAddOns: function getActiveBookingAddOns() {
    var pets = this.get('pets') || [];

    var petUrls = __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].pluck(pets, 'url');

    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.get('booking_add_ons'), function (addon) {
      // exclude inactive addons and ones with pets not in the pets attribute
      if (!addon.active) {
        return false;
      }

      if (!addon.pet) {
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].contains(petUrls, addon.pet);
    });
  },
  hasRequest: function hasRequest() {
    return this.get('request') !== null;
  },
  getRequestVersion: function getRequestVersion() {
    if (!this.hasRequest()) {
      return null;
    }

    return this.get('request').request_version;
  },
  includesPet: function includesPet(petUrl) {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].chain(this.get('pets')).pluck('url').contains(petUrl).value();
  },
  getRequestRecipient: function getRequestRecipient() {
    if (!this.hasRequest()) {
      return null;
    }

    var request = this.get('request');
    return this.getParticipantByUrl(request.recipient);
  },
  getParticipantByUrl: function getParticipantByUrl(url) {
    var participants = [this.get('requester'), this.get('provider')];
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].chain(participants).filter(function (person) {
      return person.url === url;
    }).first().value();
  },
  setPets: function setPets(pets) {
    var bookingAddOns = this.getCleanBookingAddOns(pets);
    this.set({
      pets: pets,
      booking_add_ons: bookingAddOns
    });
  },
  getCleanBookingAddOns: function getCleanBookingAddOns(pets) {
    // get a list of addons which are either !is_alternative_rate or is a rate
    // for a pet included in the given list
    var bookingAddOns = this.get('booking_add_ons');

    var petUrls = __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].pluck(pets, 'url');

    return bookingAddOns.filter(function (bao) {
      return bao.active && !bao.is_alternative_rate || petUrls.indexOf(bao.pet) > -1;
    });
  },
  toggleRequesterAddOn: function toggleRequesterAddOn(addOnSlug, active) {
    var _this = this;

    var addOn = __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.get('requester_add_ons'), function (ao) {
      return ao.slug === addOnSlug;
    })[0];

    if (addOn.active === active) return;
    this.trigger('changing:requester_add_ons', addOnSlug, true);
    addOn.active = active;
    this.getDraftPricing({
      booking_add_ons: this.get('booking_add_ons'),
      requester_add_ons: this.get('requester_add_ons')
    }).then(function (data) {
      _this.trigger('change:requester_add_ons', _this, _this.get('requester_add_ons'));

      _this.set('total_price', data.total_price);
    }, function () {
      addOn.active = !active;

      _this.trigger('change:requester_add_ons', _this, _this.get('requester_add_ons'));
    }).always(function () {
      _this.trigger('changing:requester_add_ons', addOnSlug, false);
    });
  },
  parse: function parse(response, xhr) {
    // The API returns inactive addons which are not useful to us. Remove them.
    return _objectSpread(_objectSpread({}, response), {}, {
      booking_add_ons: __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(response.booking_add_ons, function (bao) {
        return bao.active;
      })
    });
  },
  createRequest: function createRequest() {
    // aka "Book It"
    return this.shadowSave({
      request: {
        status: 'pending',
        request_version: null
      },
      source: __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__["default"].utils.getSourceDescription()
    });
  },
  cancelRequest: function cancelRequest() {
    return this.shadowSave({
      request: {
        status: 'cancelled',
        request_version: this.getRequestVersion()
      },
      source: __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__["default"].utils.getSourceDescription()
    });
  },
  declineRequest: function declineRequest() {
    return this.shadowSave({
      request: {
        status: 'declined',
        request_version: this.getRequestVersion()
      },
      source: __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__["default"].utils.getSourceDescription()
    });
  },
  acceptRequest: function acceptRequest() {
    return this.shadowSave({
      request: {
        status: 'accepted',
        request_version: this.getRequestVersion()
      },
      source: __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__["default"].utils.getSourceDescription()
    });
  },
  getAlternativeRateAddOns: function getAlternativeRateAddOns() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.getActiveBookingAddOns(), function (ao) {
      return ao.is_alternative_rate;
    });
  },
  getNonAlternativeRateAddOns: function getNonAlternativeRateAddOns() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.getActiveBookingAddOns(), function (ao) {
      return !ao.is_alternative_rate;
    });
  },
  getActiveRequesterAddOns: function getActiveRequesterAddOns() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.get('requester_add_ons'), function (ao) {
      return ao.active;
    });
  },
  getOptionalRequesterAddOns: function getOptionalRequesterAddOns() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].filter(this.get('requester_add_ons'), function (ao) {
      return !ao.is_required;
    });
  },
  fetchModel: function fetchModel(options) {
    // Normal fetch().then() gets (attributes, message, xhr) as arguments
    // For this method, fetchModel().then() gets (model, response) as arguments
    // so you can do normal promise chains and void having to use the
    // success and error callbacks.
    var d = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].Deferred();

    var o = _objectSpread({
      success: d.resolve,
      error: d.reject
    }, options);

    this.fetch(o);
    return d.promise();
  },
  getPricing: function getPricing() {
    return this.getDraftPricing();
  },
  updateDraftPricing: function updateDraftPricing(attrs) {
    var _this2 = this;

    var newAttrs = attrs;
    newAttrs.booking_add_ons = this.get('booking_add_ons');
    this.getDraftPricing(newAttrs).then(function (data) {
      _this2.set(data);
    });
  },
  savePricingData: function savePricingData(data, deferred) {
    var _this3 = this;

    var d = deferred || __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].Deferred();
    var originalAttributes = {};

    __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].each(data, function (attr, key) {
      var oldValue = _this3.get(key);

      if (oldValue) {
        originalAttributes[key] = oldValue;

        _this3.set(key, attr);
      }
    });

    this.save({}, {
      success: function success(model, response, options) {
        d.resolve(response);
      },
      error: function error(model, response, options) {
        _this3.set(originalAttributes);

        d.reject(response);
      }
    });
    return d.promise();
  },
  handleError: function handleError(err) {
    if (err.status === 400) {
      var nonFieldErrors = err.responseJSON.non_field_errors || [];
      var bookingAddOnsErrors = err.responseJSON.booking_add_ons || [];

      if (nonFieldErrors.includes('free bookings are not allowed')) {
        alert(__WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._('Free bookings are not allowed.'));
      } else if (bookingAddOnsErrors.includes('Total stay price must not be negative')) {
        alert(__WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._('Total stay price must not be negative.'));
      } else {
        alert(__WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._('An unknown error occurred.  Please try again.'));
      }
    }
  },
  saveDraftPricing: function saveDraftPricing(attrs) {
    var _this4 = this;

    var optimisticAttrUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var d = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].Deferred();

    if (optimisticAttrUpdate) {
      this.set(attrs);
    }

    this.getDraftPricing(attrs).then(function (data) {
      _this4.savePricingData(data, d);
    }, d.reject);
    return d.promise();
  }
}));

/***/ }),

/***/ 1103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./js/backbone/views/service_date_spec_view.js
var service_date_spec_view = __webpack_require__(1019);

// EXTERNAL MODULE: ../globals/backbone.ts
var backbone = __webpack_require__(17);

// EXTERNAL MODULE: ../globals/Mustache.ts
var Mustache = __webpack_require__(103);

// EXTERNAL MODULE: ../globals/underscore.ts
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../globals/jquery.ts
var jquery = __webpack_require__(9);

// CONCATENATED MODULE: ./js/backbone/models/num_units_model.js

/* harmony default export */ var num_units_model = (backbone["a" /* default */].Model.extend({
  defaults: {
    num_units: 1
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/service_num_units_view.js





/* harmony default export */ var service_num_units_view = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/common/num_units'),
  bindings: {
    '.js-num-units-select': {
      observe: 'num_units',
      onSet: function onSet(value) {
        return parseInt(value, 10);
      }
    },
    '.js-num-units-description': {
      observe: 'num_units',
      onGet: 'getDescription'
    }
  },
  initialize: function initialize(opts) {
    this.model = new num_units_model();
    this.descriptions = opts.desc;
    this.context = {
      label: opts.label,
      desc: this.getDescription()
    };
    backbone["a" /* default */].$ = window.$; // Remove once we are off the old version of Backbone
  },
  render: function render() {
    var _this = this;

    var ctx = underscore["default"].extend(this.context, this.model.attributes);

    this.$el.html(this.template.render(ctx));
    this.stickit();
    setTimeout(function () {
      Object(jquery["default"])('.js-num-units-select').val(_this.model.get('num_units'));
    }, 0);
    return this;
  },
  getDescription: function getDescription(numUnits) {
    return this.descriptions(numUnits);
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/num_units_support_view.js


/* harmony default export */ var num_units_support_view = __webpack_exports__["a"] = (service_date_spec_view["a" /* default */].extend({
  initialize: function initialize(options) {
    service_date_spec_view["a" /* default */].prototype.initialize.call(this, options);

    if (this.service.supports_num_units_per_day()) {
      this.numUnitsView = this.createNumUnitsView();
    } else {
      this.numUnitsView = null;
    }
  },
  createNumUnitsView: function createNumUnitsView() {
    var view = new service_num_units_view({
      label: this.service.num_units_label(),
      desc: this.service.num_units_description.bind(this.service)
    });
    this.propagateDatesChanged(view.model, 'change');
    return view;
  },
  getNumUnits: function getNumUnits() {
    if (this.numUnitsView) return this.numUnitsView.model.get('num_units');
    return 1;
  }
}));

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./js/backbone/views/num_units_support_view.js + 2 modules
var num_units_support_view = __webpack_require__(1103);

// EXTERNAL MODULE: ./js/backbone/views/service_date_spec_view.js
var service_date_spec_view = __webpack_require__(1019);

// EXTERNAL MODULE: ../globals/backbone.ts
var backbone = __webpack_require__(17);

// CONCATENATED MODULE: ./js/backbone/models/recurring_dates_model.js

/* harmony default export */ var recurring_dates_model = (backbone["a" /* default */].Model.extend({
  defaults: {
    start_date: null,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
  },
  reset: function reset() {
    this.set(this.defaults);
  }
}));
// EXTERNAL MODULE: ../globals/Mustache.ts
var Mustache = __webpack_require__(103);

// EXTERNAL MODULE: ../globals/underscore.ts
var underscore = __webpack_require__(27);

// CONCATENATED MODULE: ./js/backbone/views/days_of_week_view.js





/* harmony default export */ var days_of_week_view = __webpack_exports__["a"] = (num_units_support_view["a" /* default */].extend({
  template: Mustache["default"].template('new_design/common/recurring_days'),
  bindings: {
    '.js-monday': 'monday',
    '.js-tuesday': 'tuesday',
    '.js-wednesday': 'wednesday',
    '.js-thursday': 'thursday',
    '.js-friday': 'friday',
    '.js-saturday': 'saturday',
    '.js-sunday': 'sunday',
    '.js-hidden-input': {
      observe: service_date_spec_view["a" /* default */].prototype.DAYS,
      onGet: function onGet(values) {
        var total = underscore["default"].filter(values, function (value) {
          return value;
        }).length;

        return total ? '1' : '';
      },
      updateModel: false
    }
  },
  initialize: function initialize(options) {
    num_units_support_view["a" /* default */].prototype.initialize.call(this, options);
    var self = this;
    this.model = new recurring_dates_model();

    underscore["default"].each(this.getDaysFromUrl(), function (day) {
      return self.model.set(day, true);
    });

    this.propagateDatesChanged(this.model, 'change');
    this.model.on('change', underscore["default"].bind(this.onModelChange, this));
  },
  render: function render() {
    var ctx = underscore["default"].extend(this.model.toJSON(), {
      slug: this.service.get('slug'),
      units: this.service.units(),
      supportsNumUnitsPerDay: this.numUnitsView !== null
    });

    this.$el.html(this.template.render(ctx));

    if (this.numUnitsView) {
      this.$('.js-recurring-num-units').append(this.numUnitsView.render().$el);
    }

    this.stickit();
    return this;
  },
  getDatesData: function getDatesData() {
    var numUnits = this.getNumUnits();
    var days = [];
    var self = this;

    underscore["default"].each(this.DAYS, function (day) {
      if (self.model.get(day)) {
        days.push({
          day: day,
          num_units: numUnits
        });
      }
    });

    if (!days.length) return {};
    return {
      days: days
    };
  },
  isRecurring: function isRecurring() {
    return true;
  },
  hasErrors: function hasErrors() {
    return this.$('.js-days-of-the-week').hasClass('has-error');
  },
  onModelChange: function onModelChange() {
    if (this.hasErrors()) {
      this.$('.js-hidden-input').valid();
    }
  }
}));

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_service__ = __webpack_require__(87);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__["a" /* default */].Model.extend({
  supports_num_units_per_day: function supports_num_units_per_day() {
    return this.get('service_type').supports_num_units_per_day;
  },
  supports_recurring_billing: function supports_recurring_billing() {
    return this.get('service_type').supports_recurring_billing;
  },
  is_end_date_exclusive: function is_end_date_exclusive() {
    return this.get('service_type').is_end_date_exclusive;
  },
  num_units_label: function num_units_label() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "How many {0}?",
      values: {
        0: this.num_units_description(999)
      }
    });
  },
  isHosting: function isHosting() {
    return this.get('service_type').location === 'provider_home';
  },
  isSDV: function isSDV() {
    return this.get('service_type').supports_service_delivery_verification;
  },
  units: function units() {
    if (this.get('slug') === 'doggy-day-care') return 'day care';
    return __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__["default"]._(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_service__["a" /* SERVICE_ADD_ON_UNITS */][this.standard_rate_add_on().unit](999));
  },
  unit: function unit() {
    return __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__["default"]._(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_service__["a" /* SERVICE_ADD_ON_UNITS */][this.standard_rate_add_on().unit](1));
  },
  num_units_description: function num_units_description() {
    var numUnits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{0} per day",
      values: {
        0: __WEBPACK_IMPORTED_MODULE_1__rover_utilities_translation__["default"]._(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_service__["a" /* SERVICE_ADD_ON_UNITS */][this.standard_rate_add_on().unit](numUnits))
      }
    });
  },
  standard_rate_add_on: function standard_rate_add_on() {
    var srao = {};

    __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].each(this.get('service_add_ons'), function (o) {
      if (o.slug === 'standard-rate') {
        srao = o;
      }
    });

    return srao;
  }
}));

/***/ }),

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animated_scroll_to__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animated_scroll_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animated_scroll_to__);
// $FlowFixMe


var scrollToElement = function scrollToElement(elem) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var el = document.querySelector("".concat(elem));

  if (el) {
    __WEBPACK_IMPORTED_MODULE_0_animated_scroll_to___default()(el, options);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (scrollToElement);

/***/ }),

/***/ 1696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getConversationOpk(url) {
  if (!url) {
    return '';
  }

  var match = url.match(/conversations\/([a-zA-z0-9]+)\/$/);

  if (!match) {
    return '';
  }

  return match[1] || '';
}

/* harmony default export */ __webpack_exports__["a"] = (getConversationOpk);

/***/ }),

/***/ 1697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_conversation__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_rover_modal__ = __webpack_require__(322);





__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].views.ArchiveModalView = __WEBPACK_IMPORTED_MODULE_4__components_rover_modal__["a" /* default */].extend({
  initialize: function initialize(options) {
    __WEBPACK_IMPORTED_MODULE_4__components_rover_modal__["a" /* default */].prototype.initialize.call(this, options); // super()

    this.initBindings();
    this.initConversation();
    this.initPrimaryButton();
  },
  initBindings: function initBindings() {
    __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bindAll(this, 'togglePrimaryButton');

    __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bindAll(this, 'toggleNeuter');

    __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bindAll(this, 'toggleSpay');
  },
  initConversation: function initConversation() {
    var self = this;
    this.conversation = new __WEBPACK_IMPORTED_MODULE_3__models_conversation__["default"]({
      url: this.options.conversationDetailUrl
    });
    var promise = this.conversation.fetch();
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"].when(promise).then(function () {
      self.serviceType = self.conversation.get('service_type');
      self.initPreferences();
      self.initReasons();
      self.$el.find('.js-requester-short-name').text(self.conversation.get('requester').short_name);
      self.$el.find('.js-archive-reason-message').text('');
    });
  },
  initReasons: function initReasons() {
    var self = this;
    var $el = this.$el;
    $el.find('.js-archived-reasons').change(function () {
      self.archivedReason = Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(this).val();
      var isBadFit = Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(this).val() === 'dog_not_good_fit';

      if (isBadFit && !self.isTravelingService()) {
        var isPrimaryEnabled = !self.options.showNeuteredOpts && !self.options.showSpayedOpts;
        self.toggleNeuter(self.options.showNeuteredOpts);
        self.toggleSpay(self.options.showSpayedOpts);
        self.togglePrimaryButton(isPrimaryEnabled);
      } else {
        self.toggleNeuter(false);
        self.toggleSpay(false);
        self.togglePrimaryButton(true);
      }

      var message = Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(this).find(':selected').attr('data-message');
      $el.find('.js-archive-reason-message').text(message);
    });
  },
  initPreferences: function initPreferences() {
    var self = this;
    var options = this.options;
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"].get(__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].urls.serviceHostingPreferences, function (data) {
      var acceptsNonNeutered = data.accepts_non_neutered_males;
      var acceptsNonSpayed = data.accepts_unspayed_females;
      var hasNonNeutered = self.hasNonNeuteredMale(self.conversation.get('pets'));
      var hasNonSpayed = self.hasNonSpayedFemale(self.conversation.get('pets'));
      options.showNeuteredOpts = hasNonNeutered && acceptsNonNeutered !== false; // is true or null

      options.showSpayedOpts = hasNonSpayed && acceptsNonSpayed !== false; // is true or null

      self.$el.find('.js-archived-reasons').removeAttr('disabled');
    }).fail(function () {
      options.showNeuteredOpts = false;
      options.showSpayedOpts = false;
      self.$el.find('.js-archived-reasons').removeAttr('disabled');
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-neuter-options label').click(function () {
      options.shouldAcceptNonNeutered = Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(this).find('input').val() === 'yes';

      if (options.showSpayedOpts && options.shouldAcceptNonSpayed !== undefined || !options.showSpayedOpts) {
        self.togglePrimaryButton(true);
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-spay-options label').click(function () {
      options.shouldAcceptNonSpayed = Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(this).find('input').val() === 'yes';

      if (options.showNeuteredOpts && options.shouldAcceptNonNeutered !== undefined || !options.showNeuteredOpts) {
        self.togglePrimaryButton(true);
      }
    });
  },
  initPrimaryButton: function initPrimaryButton() {
    var self = this;
    this.$el.find('.js-modal-primary-action').click(function () {
      self.options.onSave({
        reason: self.archivedReason,
        shouldAcceptNonSpayed: self.options.shouldAcceptNonSpayed,
        shouldAcceptNonNeutered: self.options.shouldAcceptNonNeutered
      });
    });
  },
  hasNonNeuteredMale: function hasNonNeuteredMale(pets) {
    for (var i = 0; i < pets.length; i++) {
      var pet = pets[i];

      if (pet.gender === 'm' && !pet.spayed_neutered) {
        return true;
      }
    }

    return false;
  },
  hasNonSpayedFemale: function hasNonSpayedFemale(pets) {
    for (var i = 0; i < pets.length; i++) {
      var pet = pets[i];

      if (pet.gender === 'f' && !pet.spayed_neutered) {
        return true;
      }
    }

    return false;
  },
  render: function render() {
    __WEBPACK_IMPORTED_MODULE_4__components_rover_modal__["a" /* default */].prototype.render.call(this); // super()

    this.$el.find('.js-archive-modal').show();
    this.togglePrimaryButton(false);
    this.renderReasons();
  },
  renderReasons: function renderReasons() {
    var $el = this.$el;
    $el.find('.js-archived-reasons > option:not([disabled])').remove();
    $el.find('.js-archived-reasons > option').prop('selected', true);
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"].get(__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].urls.providerArchivedReasons, function (data) {
      data.results.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item.reason;
        opt.text = item.title;
        opt.setAttribute('data-message', item.message || '');
        $el.find('.js-archived-reasons').append(opt);
      });
    });
  },
  toggleNeuter: function toggleNeuter(show) {
    this.$el.find('.js-neuter-options').toggle(show);
  },
  toggleSpay: function toggleSpay(show) {
    this.$el.find('.js-spay-options').toggle(show);
  },
  isTravelingService: function isTravelingService() {
    return this.conversation.getServiceType().location !== 'provider_home';
  },
  togglePrimaryButton: function togglePrimaryButton(active, loading) {
    var selector = this.$el.find('.js-modal-primary-action');

    if (active) {
      selector.removeAttr('disabled');
    } else {
      selector.attr('disabled', 'true');
    }

    selector.children('i').toggleClass('hidden', !loading);
  }
});

/***/ }),

/***/ 1698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../utilities/Alerts.js
var Alerts = __webpack_require__(353);

// EXTERNAL MODULE: ../globals/Rover.ts
var Rover = __webpack_require__(13);

// EXTERNAL MODULE: ../globals/backbone.ts
var backbone = __webpack_require__(17);

// EXTERNAL MODULE: ../globals/Mustache.ts
var Mustache = __webpack_require__(103);

// EXTERNAL MODULE: ../globals/underscore.ts
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../globals/jquery.ts
var jquery = __webpack_require__(9);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(35);

// CONCATENATED MODULE: ./js/backbone/views/service_selector_view.js



/* harmony default export */ var service_selector_view = (backbone["a" /* default */].View.extend({
  events: {
    'click .rover-button': 'onRoverBtnClick'
  },
  initialize: function initialize() {
    underscore["default"].bindAll(this, 'onCollectionChange');

    this.collection.on('change', this.onCollectionChange);
  },
  onCollectionChange: function onCollectionChange() {
    var service = this.collection.getSelected();
    this.$('.rover-button').removeClass('active');
    if (!service) return;
    this.$(".rover-button[data-slug=\"".concat(service.get('slug'), "\"]")).addClass('active');
  },
  onRoverBtnClick: function onRoverBtnClick(evt) {
    var $target = Object(jquery["default"])(evt.target).closest('.rover-button');
    this.collection.setSelected($target.data('slug'));
  }
}));
// EXTERNAL MODULE: ./js/backbone/views/num_units_support_view.js + 2 modules
var num_units_support_view = __webpack_require__(1103);

// CONCATENATED MODULE: ./js/backbone/views/contiguous_dates_view.js
/* globals Url */




/* harmony default export */ var contiguous_dates_view = (num_units_support_view["a" /* default */].extend({
  template: Mustache["default"].template('new_design/common/contiguous_dates'),
  initialize: function initialize(options) {
    num_units_support_view["a" /* default */].prototype.initialize.call(this, options);
    var url = new Url();
    this.datesModel = new Rover["default"].models.DateRange({
      start_date: options.startDate || url.query.start_date,
      end_date: url.query.end_date
    });
    this.propagateDatesChanged(this.datesModel, 'change');
    this.datePickerView = new Rover["default"].views.ServiceDateRangePicker({
      slug: this.service.get('service_type').slug,
      model: this.datesModel,
      disableStart: options.disableStart
    });
  },
  render: function render() {
    var ctx = {
      serviceName: this.service.get('service_type').name.toLowerCase(),
      supportsNumUnitsPerDay: this.numUnitsView !== null
    };
    this.$el.html(this.template.render(ctx));
    this.$('.js-dates-view').append(this.datePickerView.render().$el);

    if (this.numUnitsView) {
      this.$('.js-num-units-view').append(this.numUnitsView.render().$el);
    }

    return this;
  },
  getDatesData: function getDatesData() {
    var _this$datesModel$toJS = this.datesModel.toJSON(),
        startDate = _this$datesModel$toJS.start_date,
        endDate = _this$datesModel$toJS.end_date;

    var self = this;
    var numUnits = this.getNumUnits();
    if (!startDate || !endDate) return {};
    startDate = this.formatDate(startDate);
    endDate = this.formatDate(endDate);

    if (this.numUnitsView) {
      var dates = this.dateRange(startDate, endDate);
      return {
        dates: underscore["default"].map(dates, function (date) {
          return {
            date: self.formatDate(date),
            num_units: numUnits
          };
        })
      };
    }

    return {
      start_date: startDate,
      end_date: endDate
    };
  }
}));
// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/datetimeInjected.ts + 1 modules
var datetimeInjected = __webpack_require__(104);

// CONCATENATED MODULE: ./js/backbone/views/non_contiguous_dates_view.js


 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'



/* harmony default export */ var non_contiguous_dates_view = (num_units_support_view["a" /* default */].extend({
  template: Mustache["default"].template('new_design/common/noncontiguous_dates'),
  initialize: function initialize(options) {
    num_units_support_view["a" /* default */].prototype.initialize.call(this, options);
    this.datesModel = new Rover["default"].models.MultiDate();

    if (this.service.get('service_type').supports_day_of_week_search) {
      this.datesModel.setDays(this.getDaysFromUrl());
    } else {
      this.datesModel.set('dates', this.getDateRangeFromUrl());
    }

    this.propagateDatesChanged(this.datesModel, 'change');
    this.datePickerView = new Rover["default"].views.DatesPicker({
      slug: this.service.get('service_type').slug,
      model: this.datesModel,
      disableStart: options.disableStart,
      dateFormat: datetimeInjected["b" /* default */].DATE_PICKER,
      momentFormat: datetimeInjected["b" /* default */].DATE_SHORT,
      momentLogFormat: datetimeInjected["b" /* default */].MONTH_DAY_FULL
    });
  },
  render: function render() {
    var ctx = {
      units: this.service.units()
    };
    this.$el.html(this.template.render(ctx));
    this.$('.js-dates-view').append(this.datePickerView.render().$el);

    if (this.numUnitsView) {
      this.$('.js-num-units-view').append(this.numUnitsView.render().$el);
    }

    return this;
  },
  getDatesData: function getDatesData() {
    var dates = this.datesModel.get('dates');
    var numUnits = this.getNumUnits();
    var self = this;
    if (!dates.length) return {};
    return {
      dates: underscore["default"].map(dates, function (date) {
        return {
          date: self.formatDate(date),
          num_units: numUnits
        };
      })
    };
  }
}));
// EXTERNAL MODULE: ./js/backbone/views/service_date_spec_view.js
var service_date_spec_view = __webpack_require__(1019);

// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(31);

// EXTERNAL MODULE: ./js/backbone/views/days_of_week_view.js + 1 modules
var days_of_week_view = __webpack_require__(1104);

// CONCATENATED MODULE: ./js/backbone/views/days_of_week_with_start_date_view.js






/* harmony default export */ var days_of_week_with_start_date_view = (days_of_week_view["a" /* default */].extend({
  template: Mustache["default"].template('new_design/common/recurring_dates'),
  bindings: underscore["default"].extend(days_of_week_view["a" /* default */].prototype.bindings, {
    '.js-start-date': 'start_date'
  }),
  initialize: function initialize(options) {
    days_of_week_view["a" /* default */].prototype.initialize.call(this, options);
    this.startDateView = new Rover["default"].views.DatePicker({
      model: this.model,
      slug: this.service.get('slug'),
      field: 'start_date',
      dateText: translation["default"]._('Start Date')
    });
  },
  render: function render() {
    days_of_week_view["a" /* default */].prototype.render.call(this);
    this.$('.js-recurring-start-date').append(this.startDateView.render().$el);
    return this;
  },
  getDatesData: function getDatesData() {
    var data = this.model.toJSON();
    var startDate = data.start_date;
    var datesData = days_of_week_view["a" /* default */].prototype.getDatesData.call(this);
    if (!startDate || !datesData) return {};
    return {
      start_date: this.formatDate(startDate),
      days: datesData.days
    };
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/recurring_dates_support_view.js






/* harmony default export */ var recurring_dates_support_view = (service_date_spec_view["a" /* default */].extend({
  template: Mustache["default"].template('new_design/common/recurring'),
  bindings: {
    '.js-is-recurring': {
      observe: 'isRecurring',
      getVal: function getVal($el, event, options) {
        return Object(jquery["default"])(event.currentTarget).find('input').val() === 'true';
      }
    }
  },
  initialize: function initialize(options) {
    service_date_spec_view["a" /* default */].prototype.initialize.call(this, options);
    this.model = new backbone["a" /* default */].Model({
      isRecurring: null
    });
    this.recurringView = new days_of_week_with_start_date_view(options);
    this.propagateDatesChanged(this.recurringView);
    this.nonRecurringView = options.nonRecurringView;
    this.propagateDatesChanged(this.nonRecurringView); // TODO: Change to listenTo when base_transition is gone

    this.model.on('change:isRecurring', underscore["default"].bind(this.onIsRecurringChange, this));
  },
  render: function render() {
    var ctx = {
      units: this.service.units()
    };
    this.$el.html(this.template.render(ctx));
    this.$el.append(this.recurringView.render().$el.addClass('hidden'));
    this.$el.append(this.nonRecurringView.render().$el.addClass('hidden'));
    this.stickit();
    this.onIsRecurringChange(this.model, this.model.get('isRecurring'));
    return this;
  },
  getDatesData: function getDatesData() {
    if (this.isRecurring()) return this.recurringView.getDatesData();
    return this.nonRecurringView.getDatesData();
  },
  isRecurring: function isRecurring() {
    return this.model.get('isRecurring');
  },
  onIsRecurringChange: function onIsRecurringChange(model, isRecurring) {
    this.recurringView.$el.toggleClass('hidden', !isRecurring);
    this.nonRecurringView.$el.toggleClass('hidden', isRecurring || isRecurring === null);
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/service_button_group_view.js







/**
 * services_el
 *   The div wrapping the service selection buttons.
 *   This div must have the buttons pre-rendered.
 * dates_el
 *   The div wrapping the num units and date pickers.
 * collection
 *   A ServiceButtonGroupCollection.
 */

/* harmony default export */ var service_button_group_view = (backbone["a" /* default */].View.extend({
  initialize: function initialize(opts) {
    var self = this;
    var selector = new service_selector_view(underscore["default"].extend({
      collection: this.collection
    }, opts.services));
    this.dates = opts.dates;
    this.viewContainer = new backbone["a" /* default */].ChildViewContainer();
    this.collection.each(function (service) {
      var serviceType = service.get('service_type');
      var nonContiguous = serviceType.supports_non_contiguous_dates;
      var isRecurring = serviceType.supports_recurring_billing;
      var Component = nonContiguous ? non_contiguous_dates_view : contiguous_dates_view;
      var viewOpts = {
        service: service,
        disableStart: opts.dates.disableStart,
        startDate: opts.dates.startDate
      };
      var view = new Component(viewOpts);

      if (isRecurring) {
        view = new recurring_dates_support_view({
          service: service,
          nonRecurringView: view
        });
      }

      return self.addServiceDateSelector(view);
    });
  },
  render: function render() {
    var container = document.createDocumentFragment();
    this.viewContainer.each(function (view) {
      return container.appendChild(view.render().el);
    });
    this.dates.el.find('.js-dates-for-service').append(container);
    return this;
  },
  addServiceDateSelector: function addServiceDateSelector(view) {
    var _this = this;

    this.viewContainer.add(view, view.service.get('slug')); // Set up the service date views to hide / show themselves
    // when the selected service changes

    this.listenTo(view.service, 'change:selected', function (model, show) {
      return view.$el.toggleClass('hidden', !show);
    });

    if (!view.service.get('selected')) {
      view.$el.addClass('hidden');
    } // propagate the datesChanged event


    this.listenTo(view, 'datesChanged', underscore["default"].bind(function () {
      return _this.trigger('datesChanged');
    }, this));
    return view.render();
  },
  getActiveView: function getActiveView() {
    var activeService = this.collection.getSelected();
    if (!activeService) return null;
    return this.viewContainer.findByCustom(activeService.get('slug'));
  },
  getDatesData: function getDatesData() {
    var view = this.getActiveView();
    if (!view) return {};
    return view.getDatesData();
  },
  isRecurring: function isRecurring() {
    var view = this.getActiveView();
    if (!view) return false;
    return view.isRecurring();
  },
  getContactUrl: function getContactUrl() {
    if (this.isRecurring()) return Rover["default"].urls.recurringBillingCreationUrl;
    return Rover["default"].urls.conversationCreationUrl;
  }
}));
// CONCATENATED MODULE: ./js/backbone/collections/service_button_group_collection.js

/* harmony default export */ var service_button_group_collection = (backbone["a" /* default */].Collection.extend({
  setSelected: function setSelected(slug) {
    var selected = this.getSelected();
    var toSelect = this.getBySlug(slug);

    if (selected) {
      selected.set('selected', false);
    }

    if (toSelect) {
      toSelect.set('selected', true);
    } else {
      this.first().set('selected', true);
    }
  },
  getSelected: function getSelected() {
    return this.findWhere({
      selected: true
    });
  },
  getBySlug: function getBySlug(slug) {
    return this.findWhere({
      slug: slug
    });
  }
}));
// EXTERNAL MODULE: ./js/backbone/models/service_button_group_model.js
var service_button_group_model = __webpack_require__(1105);

// EXTERNAL MODULE: ../globals/currentUser/index.ts + 1 modules
var currentUser = __webpack_require__(446);

// EXTERNAL MODULE: ../utilities/modals.js
var modals = __webpack_require__(1017);

// EXTERNAL MODULE: ./js/components/intl_tel_input.js
var intl_tel_input = __webpack_require__(816);

// CONCATENATED MODULE: ./js/backbone/models/dogs.js


Rover["default"].models = Rover["default"].models || {};
Rover["default"].collections = Rover["default"].collections || {};
Rover["default"].models.Dog = backbone["a" /* default */].Model.extend({
  defaults: {
    id: null,
    name: '',
    weight: '',
    breeds: [],
    gender: ''
  }
});
Rover["default"].collections.DogCollection = backbone["a" /* default */].Collection.extend({
  model: Rover["default"].models.Dog // Future: set this up and fetch dogs asynchronously
  // url: fetchUsersDogsUrl
  //

});
// CONCATENATED MODULE: ./js/backbone/views/rebook_dialog.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















Rover["default"].views = Rover["default"].views || {};
Rover["default"].views.RebookDialogView = backbone["a" /* default */].View.extend({
  /*
     *  Class variables
     */
  userPets: null,
  template: Mustache["default"].template('js/app/stays/rebook'),
  $form: null,
  sender: null,
  receiver: null,
  service_url: null,
  person: currentUser["a" /* default */],
  isSubmitting: false,

  /*
     *  Initialization functions
     */
  initialize: function initialize(options) {
    underscore["default"].bindAll(this, 'preRenderSetup', 'render', 'getContext', '_fetchUserPets', 'cancel', 'submit', 'conversationCreated');

    var browsable_services = options.services.filter(function (s) {
      return s.service_type.browsable;
    });
    this.services = new service_button_group_collection(browsable_services.map(function (s) {
      return new service_button_group_model["a" /* default */](s);
    }));
    this.userPets = new Rover["default"].collections.DogCollection(); // Pre-setup

    var that = this;
    this.options = options;
    this.url = options.url;
    this.selected_service = options.selected_service;
    this.sender = options.sender;
    this.receiver = options.receiver;
    this.provider = options.provider;
    this.requester = options.requester;
    this.service_url = options.service_url;
    this.extraContext = options.extraContext;
    this.preRenderSetup().done(function () {
      that.render();
    });
  },
  initServiceButtonGroupView: function initServiceButtonGroupView() {
    return new service_button_group_view({
      services: {
        el: this.$('.js-service-selection')
      },
      dates: {
        el: this.$('.stay-duration'),
        disableStart: !!this.getContext().startDate,
        startDate: this.getContext().startDate
      },
      collection: this.services
    }).render();
  },
  preRenderSetup: function preRenderSetup() {
    var petRequests = this._fetchUserPets();

    return jquery["default"].when.apply(jquery["default"], _toConsumableArray(petRequests));
  },
  postRenderSetup: function postRenderSetup() {
    this.$form = this.$el.find('.js-rebook-form');
    this.$form.validate({
      ignore: ':hidden:not(.js-validate-element),' + '.js-service-dates-spec.hidden input'
    });
    var context = this.getContext();

    if (context.needsPhoneNumber) {
      var $intlTelInput = Object(intl_tel_input["b" /* initIntlTelInput */])(this.$el.find('.js-phone-number-input'));
      $intlTelInput.each(intl_tel_input["c" /* updateCleaveForInputs */]);
      $intlTelInput.on('countrychange', intl_tel_input["c" /* updateCleaveForInputs */]);
    }
  },
  _fetchUserPets: function _fetchUserPets() {
    var that = this;

    underscore["default"].each(this.requester.pets, function (pet) {
      if (pet.active) {
        that.userPets.add(new Rover["default"].models.Dog(pet));
      }
    });

    return [];
  },
  render: function render() {
    var context = this.getContext();
    this.$el.html(this.template.render(context));
    this.previouslyActiveElement = document.activeElement;
    this.postRenderSetup();
    Object(jquery["default"])('.modal-backdrop').remove();
    Object(jquery["default"])(this.el).find('.js-rebook-modal').modal();
    this.tabListener = Object(modals["b" /* trapFocusWithinElement */])(this.$el);
    this.serviceView = this.initServiceButtonGroupView({
      startDate: context.startDate
    });

    if (this.services.getBySlug(this.selected_service)) {
      this.services.setSelected(this.selected_service);
    } else {
      this.services.setSelected(this.services.at(0).get('slug'));
    }
  },
  getContext: function getContext() {
    var pets = this.userPets.toJSON();
    pets[pets.length - 1].last = true;
    var context = {
      provider: this.provider,
      requester: this.requester,
      sender: this.sender,
      receiver: this.receiver,
      pets: pets,
      service_url: this.service_url,
      action: this.url || Object(apiUrl["a" /* apiUrl */])('conversations/'),
      needsPhoneNumber: this.sender["private"].has_phone_number === 'False'
    };
    var services = this.services.toJSON();

    if (services.length > 1) {
      context.services = services;
      this.setServiceColWidth(context);
    }

    underscore["default"].each(services, function (service) {
      var p = service.service_type.name.split(/\s+/);
      service.top_name = p[0];
      p.splice(0, 1);
      service.bottom_name = p.join(' ');
    });

    jquery["default"].extend(context, this.extraContext || {});
    return context;
  },
  setServiceColWidth: function setServiceColWidth(context) {
    context.col_sm = Math.floor(12 / this.services.length);

    if (context.col_sm === 2) {
      context.col_sm = 15;
    }
  },
  cancel: function cancel() {
    if (this.tabListener) Object(modals["a" /* removeFocusTrap */])(this.tabListener);
    Object(jquery["default"])(this.el).find('.js-rebook-modal').modal('hide');
    if (this.previouslyActiveElement) this.previouslyActiveElement.focus();
  },
  submit: function submit() {
    // logic to prevent the rare case of double submission
    if (this.isSubmitting) {
      return false;
    }

    this.isSubmitting = true;

    try {
      this._ajaxSubmit();
    } catch (err) {
      // TODO - Consider sending this to Sentry
      this.isSubmitting = false;
      console.log(err);
      Alerts["a" /* default */].showAlert('extending your stay');
    } finally {
      // We need to always prevent form submission since it will be done
      // by the browser and will return an error page from the
      // Browseable API (due to missing CSRF, which is required if you
      // send the request as application/x-www-form-urlencoded)
      return false;
    }
  },
  getPostData: function getPostData() {
    var context = this.getContext();
    var formData = this.$form.serializeObject(),
        data = {};
    data.pets = formData.pets || [];

    if (!data.pets.push) {
      data.pets = [data.pets];
    }

    data.content = formData.content;
    data.provider = formData.provider;
    data.requester = formData.requester;
    data.sender = formData.sender;
    data.source = 'web';
    data.service = this.services.getSelected().get('url');

    if (context.needsPhoneNumber) {
      data.phone_number = formData.phone_number;
    }

    data = underscore["default"].extend(data, this.serviceView.getDatesData());
    return data;
  },
  _ajaxSubmit: function _ajaxSubmit() {
    var data = this.getPostData(),
        that = this;
    this.$('.js-submit-rebook-request').btn('loading');
    jquery["default"].ajax({
      url: this.serviceView.getContactUrl(),
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: that.conversationCreated,
      error: function error(xhr) {
        var validator = that.$form.validate({
          ignore: [':hidden:not(.js-validate-element)'],
          errorPlacement: function errorPlacement($error, $element) {
            if ($element.hasClass('js-form-group-error-placement')) {
              $element = $element.closest('.form-group');
            }

            jquery["default"].validator.defaults.errorPlacement($error, $element);
          }
        });
        validator.showErrors(xhr.responseJSON.error);
        that.$('.js-submit-rebook-request').btn('reset');
      }
    });
  },
  conversationCreated: function conversationCreated(conversation) {
    this.isSubmitting = false;
    window.location = "".concat(conversation.web_url, "?is_rebook");
  },
  events: {
    'click .js-cancel': 'cancel',
    'click .js-modal-close': 'cancel',
    'submit .js-rebook-form': 'submit'
  }
}); // This view and its associated template (extend.mustache) appear to be unreachable.
// The view is referenced in conversations.js, but the click trigger (.js-show-rebook)
// is preempted by the same trigger in stays/past.js.
// Not removing it because this precedence could be due to the sometimes arbitrary order
// in which Webpack bundles files.

Rover["default"].views.ExtendDialogView = Rover["default"].views.RebookDialogView.extend({
  template: Mustache["default"].template('js/app/stays/extend'),
  getPostData: function getPostData() {
    var data = Rover["default"].views.RebookDialogView.prototype.getPostData.call(this),
        formData = this.$form.serializeObject();
    data.extended_stay_conversation = 1;
    data.original_conversation = formData.original_conversation;
    return data;
  }
});

/***/ }),

/***/ 1699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_translation__ = __webpack_require__(31);



Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('body').hasClass('account-payments')) {
    return;
  }

  var setUpPaymentMethodSelectionTable = function setUpPaymentMethodSelectionTable() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-method-specific').addClass('disabled');
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-method-specific').on('click', function () {
      var $this = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this);
      var $radio = $this.closest('.js-nested-selection-wdiget').find('.js-method-select');

      if ($this.length > 0) {
        $radio.prop('checked', true);
      }

      $radio.trigger('change');
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-method-select').on('change', function () {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-method-select').each(function (i, radio) {
        var $radio = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this);
        var $select = $radio.closest('.js-nested-selection-widget').find('.js-method-specific');
        var $submit = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-withdrawal-submit');

        if ($radio.prop('checked')) {
          var needs_w9 = $radio.attr('id') === 'check-select' && $radio.attr('data-w9-submitted') === 'false';
          var $w9_warning = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('#w9-warning');
          $select.removeClass('disabled');
          $submit.val(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_translation__["default"]._(
          /* i18n: {0} is a payment method e.g. Withdraw via PayPal */
          {
            id: "Withdraw via {0}",
            values: {
              0: $radio.val()
            }
          }));

          if (needs_w9) {
            $submit.addClass('disabled');
            $w9_warning.show();
          } else {
            $submit.removeClass('disabled');
            $w9_warning.hide();
          }
        } else {
          $select.addClass('disabled');
        }
      });
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-method-select').trigger('change');
  }; // Make this available inside autopay.js


  __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].setUpPaymentMethodSelectionTable = setUpPaymentMethodSelectionTable;

  var displayActiveFlatNav = function displayActiveFlatNav(id) {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-payments-table').hide();
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(id).show();
  };

  var displayHashedView = function displayHashedView(defaultHash) {
    var hash = window.location.hash || defaultHash;

    if (hash) {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])("a[href=\"".concat(hash, "\"]")).trigger('click');
    }
  };

  var addBindings = function addBindings() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-payments-nav').on('click', function (e) {
      var $this = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this);
      var href = $this.attr('href');
      displayActiveFlatNav(href);

      if (history && history.replaceState) {
        history.replaceState({}, '', href);
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-payments-nav').closest('li').removeClass('active');
      $this.closest('li').addClass('active');
      e.preventDefault();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-gus-tip-dismiss').on('click', function () {
      var $gusTip = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).closest('.js-gus-tip');
      __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].cookie($gusTip.data('gus-tip-cookie'), 'dismissed', {
        expires: 180
      });
      $gusTip.hide();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.currencywidget').money_field({
      symbol: Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.before_text').text()
    });
  };

  var init = function init() {
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].stickyPopover('[data-toggle="sticky-popover"]', {
      container: 'body',
      placement: 'top'
    }); // Ensure that we don't allow double click on redeeming funds Submit button

    var $redeem_button = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-redeem-button');
    var $redeem_form = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-redeem-form');
    $redeem_button.removeAttr('disabled');
    $redeem_form.on('submit', function () {
      $redeem_button.attr('disabled', 'disabled'); // Fix a chrome bug: http://code.google.com/p/chromium/issues/detail?id=37402

      if ($redeem_form.attr('data-submitted') !== 'true') {
        $redeem_form.attr('data-submitted', 'true');
        return true;
      } else if ($redeem_form.attr('data-submitted') === 'true') {
        return false;
      }
    }); // Set up payment methods table - clicking anywhere on a row selects that row, and
    // the method select for each row is disabled until that row is selected.

    setUpPaymentMethodSelectionTable('#redemption-table');
    addBindings();
    window.setTimeout(function () {
      displayHashedView('#payments-earnings');
    }, 0);
  };

  init();
});

/***/ }),

/***/ 1700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSignupCountryConfiguration", function() { return getSignupCountryConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zipCodeValidator", function() { return zipCodeValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postalCodeValidator", function() { return postalCodeValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_moment__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rover_utilities_injector__ = __webpack_require__(23);
 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'







__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].ValidationUtils = __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].ValidationUtils || {};

function PostalCodesRegex(postal) {
  //  Any supported country should have the postal code regex added there
  //  Source of GB Regex: https://roverdotcom.atlassian.net/browse/DEV-20164
  var regexRules = {
    usRegex: /^\d{5}-\d{4}$|^\d{5}$/,
    caRegex: /^[A-Z][0-9][A-Z][-\s]?[0-9][A-Z][0-9]$/,
    gbRegex: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$/,
    deAndFrRegex: /^([0-8]\d|9[0-8])\d{3}$/
  };
  return {
    valid: function validate() {
      return Object.values(regexRules).some(function (rule) {
        return rule.test(postal);
      });
    }
  };
}

__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.addMethod('min_words', function (value, element, n) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(element).wordCount() >= n;
}, function (n) {
  return __WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._(
  /*i18n*/
  {
    id: "Please write at least {n} words.",
    values: {
      n: n
    }
  });
});
var getSignupCountryConfiguration = function getSignupCountryConfiguration(countrySelector) {
  var string = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('#sign-up-country-configuration').val();

  if (string) {
    var signup_country_configuration = JSON.parse(string);
    var country_code = countrySelector.val();

    if (signup_country_configuration.hasOwnProperty(country_code)) {
      return signup_country_configuration[country_code];
    }

    return signup_country_configuration.US;
  }

  return null;
};
var zipCodeValidator = function zipCodeValidator(postal, element, params) {
  var configuration = getSignupCountryConfiguration(params.countrySelector);

  if (configuration != null) {
    var regex = configuration.postalCodeRegex;
    var zipCodeValue = postal;
    return !!zipCodeValue.match(regex);
  }

  return false;
};
var postalCodeValidator = function postalCodeValidator(postal, element) {
  var optionalCheck = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(element).validate().optional(element);
  return optionalCheck || PostalCodesRegex(postal).valid();
};

(function () {
  var filters = null;
  var contact = '';

  function initFilters() {
    if (filters) return;
    var emailDefinite = [/[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/];
    var urlDefinite = [/(http:\/\/|https:\/\/)?([a-zA-Z0-9]{2,4}\.)?[a-zA-Z0-9]+\.(com|org|gov|biz|cat|coop|info|int|jobs|mobi|museum|name|net|pro|tel|travel|co\.uk|COM|ORG|GOV|BIZ|CAT|COOP|INFO|INT|JOBS|MOBI|MUSEUM|NAME|NET|PRO|TEL|TRAVEL|CO\.UK)(\/[-a-zA-Z0-9\/]+)?/];
    var phoneDefinite = [/(1[- \.])?\(?\d{3}\)?[- \.]?\d{3}[- \.]?\d{4}/, /\d{3}[- \.]?\d{4}/];
    filters = emailDefinite.concat(urlDefinite).concat(phoneDefinite);
  }

  function runFilters(text) {
    var matches = __WEBPACK_IMPORTED_MODULE_4__rover_globals_underscore__["default"].map(filters, function (filter) {
      return text.match(filter);
    });

    matches = __WEBPACK_IMPORTED_MODULE_4__rover_globals_underscore__["default"].filter(matches, function (match) {
      return !!match && !match[0].match(/rover.com/i);
    });
    return matches;
  }

  function onContactsFound(contacts) {
    contact = contacts[0][0];
  }

  __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.addMethod('disallow_contact', function (value, element) {
    initFilters();
    var contacts = runFilters(Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(element).val());
    if (contacts.length) onContactsFound(contacts);
    return contacts.length === 0;
  }, function () {
    return __WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "For your security, please remove \"{contact}\" from your description. Owners will contact you through Rover, and you must book all stays through the site. It's safe and easy - plus, the stay will be covered by premium insurance and 24/7 emergency support.",
      values: {
        contact: contact
      }
    });
  });
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.addMethod('zippostalValidate', zipCodeValidator, function (params, element) {
    return __WEBPACK_IMPORTED_MODULE_5__rover_utilities_translation__["default"]._(
    /* i18n: {0} Name of the country */
    {
      id: "You have not entered a valid postcode for {0}. Enter a valid postcode, or switch country",
      values: {
        0: getSignupCountryConfiguration(params.countrySelector).country_name_as_subject
      }
    });
  });
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.addMethod('l10ndate', function (value, element) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_moment__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_1__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT).isValid();
  }, 'Please enter a valid date.');
})();

(function (o) {
  /**
   * $ validation plugin does not play well with
   * bootstrap's button plugin. In particular when a button
   * is clicked, the event is not caught by the $
   * validation plugin becasue the event target is bootstrap's
   * div wrapper, not the input element.
   *
   * This click handler refires a click event from the
   * input element when there is an error pop-over over
   * the element.
   */
  var namespace = '.hideValidationErrorOnButtonClick';

  o.hideValidationErrorOnButtonClick = function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('[data-toggle^="button"]').off(namespace).on("click".concat(namespace), function (evt) {
      var $target = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(evt.target).closest('[data-toggle^="button"]');
      var $errorPopover = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.error-popover', $target);
      $target.off(namespace);
      if (!$errorPopover.size()) return;
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])("input[aria-describedby=\"".concat($errorPopover.attr('id'), "\"]"), $target).click();
      evt.stopImmediatePropagation();
    });
  };
})(__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].ValidationUtils);

/* harmony default export */ __webpack_exports__["default"] = (postalCodeValidator);

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1703:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2241:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2242);
__webpack_require__(2243);
__webpack_require__(2244);
__webpack_require__(2245);
__webpack_require__(2246);
__webpack_require__(2247);
__webpack_require__(2248);
__webpack_require__(2249);
__webpack_require__(2250);
__webpack_require__(2251);
__webpack_require__(2252);
__webpack_require__(1687);
__webpack_require__(2253);
__webpack_require__(1102);
__webpack_require__(707);
__webpack_require__(2254);
__webpack_require__(2255);
__webpack_require__(2256);
__webpack_require__(1690);
__webpack_require__(2257);
__webpack_require__(2258);
__webpack_require__(2260);
__webpack_require__(1688);
__webpack_require__(2261);
__webpack_require__(1689);
__webpack_require__(2262);
__webpack_require__(2263);
__webpack_require__(2264);
__webpack_require__(2265);
__webpack_require__(2266);
__webpack_require__(2267);
__webpack_require__(2268);
__webpack_require__(1698);
__webpack_require__(2275);
__webpack_require__(1699);
__webpack_require__(2276);
__webpack_require__(1700);
__webpack_require__(2277);
__webpack_require__(2278);
__webpack_require__(2280);
__webpack_require__(2281);
__webpack_require__(1701);
__webpack_require__(1702);
__webpack_require__(1703);
__webpack_require__(2282);
__webpack_require__(2283);
__webpack_require__(2284);
module.exports = __webpack_require__(2285);


/***/ }),

/***/ 2242:
/***/ (function(module, exports) {

/* =========================================================
 * bootstrap-slider.js v3.0.0
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

(function( $ ) {

    var ErrorMsgs = {
        formatInvalidInputErrorMsg : function(input) {
            return "Invalid input value '" + input + "' passed in";
        },
        callingContextNotSliderInstance : "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
    };

    var Slider = function(element, options) {
        var el = this.element = $(element).hide();
        var origWidth =  $(element)[0].style.width;

        var updateSlider = false;
        var parent = this.element.parent();


        if (parent.hasClass('slider') === true) {
            updateSlider = true;
            this.picker = parent;
        } else {
            this.picker = $('<div class="slider">'+
                                '<div class="slider-track">'+
                                    '<div class="slider-selection"></div>'+
                                    '<div class="slider-handle" aria-label="' + options.ariaLabel[0] + '"></div>'+
                                    '<div class="slider-handle" aria-label="' + options.ariaLabel[1] + '"></div>'+
                                '</div>'+
                                '<div id="tooltip" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                                '<div id="tooltip_min" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                                '<div id="tooltip_max" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                            '</div>')
                                .insertBefore(this.element)
                                .append(this.element);
        }

        this.id = this.element.data('slider-id')||options.id;
        if (this.id) {
            this.picker[0].id = this.id;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
            this.touchCapable = true;
        }

        var tooltip = this.element.data('slider-tooltip')||options.tooltip;

        this.tooltip = this.picker.find('#tooltip');
        this.tooltipInner = this.tooltip.find('div.tooltip-inner');

        this.tooltip_min = this.picker.find('#tooltip_min');
        this.tooltipInner_min = this.tooltip_min.find('div.tooltip-inner');

        this.tooltip_max = this.picker.find('#tooltip_max');
        this.tooltipInner_max= this.tooltip_max.find('div.tooltip-inner');

        if (updateSlider === true) {
            // Reset classes
            this.picker.removeClass('slider-horizontal');
            this.picker.removeClass('slider-vertical');
            this.tooltip.removeClass('hide');
            this.tooltip_min.removeClass('hide');
            this.tooltip_max.removeClass('hide');

        }

        this.orientation = this.element.data('slider-orientation')||options.orientation;
        switch(this.orientation) {
            case 'vertical':
                this.picker.addClass('slider-vertical');
                this.stylePos = 'top';
                this.mousePos = 'pageY';
                this.sizePos = 'offsetHeight';
                this.tooltip.addClass('right')[0].style.left = '100%';
                this.tooltip_min.addClass('right')[0].style.left = '100%';
                this.tooltip_max.addClass('right')[0].style.left = '100%';
                break;
            default:
                this.picker
                    .addClass('slider-horizontal')
                    .css('width', origWidth);
                this.orientation = 'horizontal';
                this.stylePos = 'left';
                this.mousePos = 'pageX';
                this.sizePos = 'offsetWidth';
                this.tooltip.addClass('top')[0].style.top = -this.tooltip.outerHeight() - 14 + 'px';
                this.tooltip_min.addClass('top')[0].style.top = -this.tooltip_min.outerHeight() - 14 + 'px';
                this.tooltip_max.addClass('top')[0].style.top = -this.tooltip_max.outerHeight() - 14 + 'px';
                break;
        }

        var self = this;
        $.each(['min',
                'max',
                'step',
                'precision',
                'value',
                'reversed',
                'handle'
            ], function(i, attr) {
                if (typeof el.data('slider-' + attr) !== 'undefined') {
                    self[attr] = el.data('slider-' + attr);
                } else if (typeof options[attr] !== 'undefined') {
                    self[attr] = options[attr];
                } else if (typeof el.prop(attr) !== 'undefined') {
                    self[attr] = el.prop(attr);
                } else {
                    self[attr] = 0; // to prevent empty string issues in calculations in IE
                }
        });

        if (this.value instanceof Array) {
            if (updateSlider && !this.range) {
                this.value = this.value[0];
            } else {
                this.range = true;
            }
        } else if (this.range) {
            // User wants a range, but value is not an array
            this.value = [this.value, this.max];
        }

        this.selection = this.element.data('slider-selection')||options.selection;
        this.selectionEl = this.picker.find('.slider-selection');
        if (this.selection === 'none') {
            this.selectionEl.addClass('hide');
        }

        this.selectionElStyle = this.selectionEl[0].style;

        this.handle1 = this.picker.find('.slider-handle:first');
        this.handle1Stype = this.handle1[0].style;

        this.handle2 = this.picker.find('.slider-handle:last');
        this.handle2Stype = this.handle2[0].style;

        if (updateSlider === true) {
            // Reset classes
            this.handle1.removeClass('round triangle');
            this.handle2.removeClass('round triangle hide');
        }

        switch(this.handle) {
            case 'round':
                this.handle1.addClass('round');
                this.handle2.addClass('round');
                break;
            case 'triangle':
                this.handle1.addClass('triangle');
                this.handle2.addClass('triangle');
                break;
        }

        this.offset = this.picker.offset();
        this.size = this.picker[0][this.sizePos];
        this.formater = options.formater;

        this.tooltip_separator = options.tooltip_separator;
        this.tooltip_split = options.tooltip_split;

        this.setValue(this.value);

        this.handle1.on({
            keydown: $.proxy(this.keydown, this, 0)
        });
        this.handle2.on({
            keydown: $.proxy(this.keydown, this, 1)
        });

        if (this.touchCapable) {
            // Touch: Bind touch events:
            this.picker.on({
                touchstart: $.proxy(this.mousedown, this)
            });
        }
        // Bind mouse events:
        this.picker.on({
            mousedown: $.proxy(this.mousedown, this)
        });

        if(tooltip === 'hide') {
            this.tooltip.addClass('hide');
            this.tooltip_min.addClass('hide');
            this.tooltip_max.addClass('hide');
        } else if(tooltip === 'always') {
            this.showTooltip();
            this.alwaysShowTooltip = true;
        } else {
            this.picker.on({
                mouseenter: $.proxy(this.showTooltip, this),
                mouseleave: $.proxy(this.hideTooltip, this)
            });
            this.handle1.on({
                focus: $.proxy(this.showTooltip, this),
                blur: $.proxy(this.hideTooltip, this)
            });
            this.handle2.on({
                focus: $.proxy(this.showTooltip, this),
                blur: $.proxy(this.hideTooltip, this)
            });
        }

        this.enabled = options.enabled &&
                        (this.element.data('slider-enabled') === undefined || this.element.data('slider-enabled') === true);
        if(this.enabled) {
            this.enable();
        } else {
            this.disable();
        }
    };

    Slider.prototype = {
        constructor: Slider,

        over: false,
        inDrag: false,

        showTooltip: function(){
            if (this.tooltip_split === false ){
                this.tooltip.addClass('in');
            } else {
                this.tooltip_min.addClass('in');
                this.tooltip_max.addClass('in');
            }

            this.over = true;
        },

        hideTooltip: function(){
            if (this.inDrag === false && this.alwaysShowTooltip !== true) {
                this.tooltip.removeClass('in');
                this.tooltip_min.removeClass('in');
                this.tooltip_max.removeClass('in');
            }
            this.over = false;
        },

        layout: function(){
            var positionPercentages;

            if(this.reversed) {
                positionPercentages = [ 100 - this.percentage[0], this.percentage[1] ];
            } else {
                positionPercentages = [ this.percentage[0], this.percentage[1] ];
            }

            this.handle1Stype[this.stylePos] = positionPercentages[0]+'%';
            this.handle2Stype[this.stylePos] = positionPercentages[1]+'%';

            if (this.orientation === 'vertical') {
                this.selectionElStyle.top = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
                this.selectionElStyle.height = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';
            } else {
                this.selectionElStyle.left = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
                this.selectionElStyle.width = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';

                var offset_min = this.tooltip_min[0].getBoundingClientRect();
                var offset_max = this.tooltip_max[0].getBoundingClientRect();

                if (offset_min.right > offset_max.left) {
                    this.tooltip_max.removeClass('top');
                    this.tooltip_max.addClass('bottom')[0].style.top = 18 + 'px';
                } else {
                    this.tooltip_max.removeClass('bottom');
                    this.tooltip_max.addClass('top')[0].style.top = -30 + 'px';
                }
            }

            if (this.range) {
                this.tooltipInner.text(
                    this.formater(this.value[0]) + this.tooltip_separator + this.formater(this.value[1])
                );
                this.tooltip[0].style[this.stylePos] = this.size * (positionPercentages[0] + (positionPercentages[1] - positionPercentages[0])/2)/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';

                this.tooltipInner_min.text(
                    this.formater(this.value[0])
                );
                this.tooltipInner_max.text(
                    this.formater(this.value[1])
                );

                this.tooltip_min[0].style[this.stylePos] = this.size * ( (positionPercentages[0])/100) - (this.orientation === 'vertical' ? this.tooltip_min.outerHeight()/2 : this.tooltip_min.outerWidth()/2) +'px';
                this.tooltip_max[0].style[this.stylePos] = this.size * ( (positionPercentages[1])/100) - (this.orientation === 'vertical' ? this.tooltip_max.outerHeight()/2 : this.tooltip_max.outerWidth()/2) +'px';

            } else {
                this.tooltipInner.text(
                    this.formater(this.value[0])
                );
                this.tooltip[0].style[this.stylePos] = this.size * positionPercentages[0]/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
            }
        },

        mousedown: function(ev) {
            if(!this.isEnabled()) {
                return false;
            }
            // Touch: Get the original event:
            if (this.touchCapable && ev.type === 'touchstart') {
                ev = ev.originalEvent;
            }

            this.triggerFocusOnHandle();

            this.offset = this.picker.offset();
            this.size = this.picker[0][this.sizePos];

            var percentage = this.getPercentage(ev);

            if (this.range) {
                var diff1 = Math.abs(this.percentage[0] - percentage);
                var diff2 = Math.abs(this.percentage[1] - percentage);
                this.dragged = (diff1 < diff2) ? 0 : 1;
            } else {
                this.dragged = 0;
            }

            this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
            this.layout();

            if (this.touchCapable) {
                // Touch: Bind touch events:
                $(document).on({
                    touchmove: $.proxy(this.mousemove, this),
                    touchend: $.proxy(this.mouseup, this)
                });
            }
            // Bind mouse events:
            $(document).on({
                mousemove: $.proxy(this.mousemove, this),
                mouseup: $.proxy(this.mouseup, this)
            });

            this.inDrag = true;
            var val = this.calculateValue();
            this.element.trigger({
                    type: 'slideStart',
                    value: val
                })
                .data('value', val)
                .prop('value', val);
            this.setValue(val);
            return true;
        },

        triggerFocusOnHandle: function(handleIdx) {
            if(handleIdx === 0) {
                this.handle1.focus();
            }
            if(handleIdx === 1) {
                this.handle2.focus();
            }
        },

        keydown: function(handleIdx, ev) {
            if(!this.isEnabled()) {
                return false;
            }

            var dir;
            switch (ev.which) {
                case 37: // left
                case 40: // down
                    dir = -1;
                    break;
                case 39: // right
                case 38: // up
                    dir = 1;
                    break;
            }
            if (!dir) {
                return;
            }

            var oneStepValuePercentageChange = dir * this.percentage[2];
            var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;

            if (percentage > 100) {
                percentage = 100;
            } else if (percentage < 0) {
                percentage = 0;
            }

            this.dragged = handleIdx;
            this.adjustPercentageForRangeSliders(percentage);
            this.percentage[this.dragged] = percentage;
            this.layout();

            var val = this.calculateValue();

            this.element.trigger({
                    type: 'slideStart',
                    value: val
                })
                .data('value', val)
                .prop('value', val);

            this.slide(val);

            this.element
                .trigger({
                    type: 'slideStop',
                    value: val
                })
                .data('value', val)
                .prop('value', val);
            return false;
        },

        mousemove: function(ev) {
            if(!this.isEnabled()) {
                return false;
            }
            // Touch: Get the original event:
            if (this.touchCapable && ev.type === 'touchmove') {
                ev = ev.originalEvent;
            }

            var percentage = this.getPercentage(ev);
            this.adjustPercentageForRangeSliders(percentage);
            this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
            this.layout();

            var val = this.calculateValue();
            this.slide(val);

            return false;
        },
        slide: function(val) {
            this.setValue(val);

            var slideEventValue = this.range ? this.value : this.value[0];
            this.element
                .trigger({
                    'type': 'slide',
                    'value': slideEventValue
                })
                .data('value', this.value)
                .prop('value', this.value);
        },
        adjustPercentageForRangeSliders: function(percentage) {
            if (this.range) {
                if (this.dragged === 0 && this.percentage[1] < percentage) {
                    this.percentage[0] = this.percentage[1];
                    this.dragged = 1;
                } else if (this.dragged === 1 && this.percentage[0] > percentage) {
                    this.percentage[1] = this.percentage[0];
                    this.dragged = 0;
                }
            }
        },

        mouseup: function() {
            if(!this.isEnabled()) {
                return false;
            }
            if (this.touchCapable) {
                // Touch: Unbind touch event handlers:
                $(document).off({
                    touchmove: this.mousemove,
                    touchend: this.mouseup
                });
            }
            // Unbind mouse event handlers:
            $(document).off({
                mousemove: this.mousemove,
                mouseup: this.mouseup
            });

            this.inDrag = false;
            if (this.over === false) {
                this.hideTooltip();
            }
            var val = this.calculateValue();
            this.layout();
            this.element
                .data('value', val)
                .prop('value', val)
                .trigger({
                    type: 'slideStop',
                    value: val
                });
            return false;
        },

        calculateValue: function() {
            var val;
            if (this.range) {
                val = [this.min,this.max];
                if (this.percentage[0] !== 0){
                    val[0] = (Math.max(this.min, this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step));
                    val[0] = this.applyPrecision(val[0]);
                }
                if (this.percentage[1] !== 100){
                    val[1] = (Math.min(this.max, this.min + Math.round((this.diff * this.percentage[1]/100)/this.step)*this.step));
                    val[1] = this.applyPrecision(val[1]);
                }
                this.value = val;
            } else {
                val = (this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step);
                if (val < this.min) {
                    val = this.min;
                }
                else if (val > this.max) {
                    val = this.max;
                }
                val = parseFloat(val);
                val = this.applyPrecision(val);
                this.value = [val, this.value[1]];
            }
            return val;
        },
        applyPrecision: function(val) {
            var precision = this.precision || this.getNumDigitsAfterDecimalPlace(this.step);
            return this.applyToFixedAndParseFloat(val, precision);
        },
        /*
            Credits to Mike Samuel for the following method!
            Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
        */
        getNumDigitsAfterDecimalPlace: function(num) {
            var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if (!match) { return 0; }
            return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        },

        applyToFixedAndParseFloat: function(num, toFixedInput) {
            var truncatedNum = num.toFixed(toFixedInput);
            return parseFloat(truncatedNum);
        },

        getPercentage: function(ev) {
            if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
                ev = ev.touches[0];
            }
            var percentage = (ev[this.mousePos] - this.offset[this.stylePos])*100/this.size;
            percentage = Math.round(percentage/this.percentage[2])*this.percentage[2];
            return Math.max(0, Math.min(100, percentage));
        },

        getValue: function() {
            if (this.range) {
                return this.value;
            }
            return this.value[0];
        },

        setValue: function(val) {
            if (!val) {
                val = 0;
            }
            this.value = this.validateInputValue(val);

            if (this.range) {
                this.value[0] = this.applyPrecision(this.value[0]);
                this.value[1] = this.applyPrecision(this.value[1]);

                this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
                this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
            } else {
                this.value = this.applyPrecision(this.value);
                this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
                this.handle2.addClass('hide');
                if (this.selection === 'after') {
                    this.value[1] = this.max;
                } else {
                    this.value[1] = this.min;
                }
            }

            this.diff = this.max - this.min;
            if (this.diff > 0) {
                this.percentage = [
                    (this.value[0] - this.min) * 100 / this.diff,
                    (this.value[1] - this.min) * 100 / this.diff,
                    this.step * 100 / this.diff
                ];
            } else {
                this.percentage = [0, 0, 100];
            }

            this.layout();
        },

        validateInputValue : function(val) {
            if(typeof val === 'number') {
                return val;
            } else if(val instanceof Array) {
                $.each(val, function(i, input) { if (typeof input !== 'number') { throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(input) ); }});
                return val;
            } else {
                throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(val) );
            }
        },

        destroy: function(){
            this.handle1.off();
            this.handle2.off();
            this.element.off().show().insertBefore(this.picker);
            this.picker.off().remove();
            $(this.element).removeData('slider');
        },

        disable: function() {
            this.enabled = false;
            this.handle1.removeAttr("tabindex");
            this.handle2.removeAttr("tabindex");
            this.picker.addClass('slider-disabled');
            this.element.trigger('slideDisabled');
        },

        enable: function() {
            this.enabled = true;
            this.handle1.attr("tabindex", 0);
            this.handle2.attr("tabindex", 0);
            this.picker.removeClass('slider-disabled');
            this.element.trigger('slideEnabled');
        },

        toggle: function() {
            if(this.enabled) {
                this.disable();
            } else {
                this.enable();
            }
        },

        isEnabled: function() {
            return this.enabled;
        },

        setAttribute: function(attribute, value) {
            this[attribute] = value;
        },

        getAttribute: function(attribute) {
            return this[attribute];
        }

    };

    var publicMethods = {
        getValue : Slider.prototype.getValue,
        setValue : Slider.prototype.setValue,
        setAttribute : Slider.prototype.setAttribute,
        getAttribute : Slider.prototype.getAttribute,
        destroy : Slider.prototype.destroy,
        disable : Slider.prototype.disable,
        enable : Slider.prototype.enable,
        toggle : Slider.prototype.toggle,
        isEnabled: Slider.prototype.isEnabled
    };

    $.fn.slider = function (option) {
        if (typeof option === 'string' && option !== 'refresh') {
            var args = Array.prototype.slice.call(arguments, 1);
            return invokePublicMethod.call(this, option, args);
        } else {
            return createNewSliderInstance.call(this, option);
        }
    };

    function invokePublicMethod(methodName, args) {
        if(publicMethods[methodName]) {
            var sliderObject = retrieveSliderObjectFromElement(this);
            var result = publicMethods[methodName].apply(sliderObject, args);

            if (typeof result === "undefined") {
                return $(this);
            } else {
                return result;
            }
        } else {
            throw new Error("method '" + methodName + "()' does not exist for slider.");
        }
    }

    function retrieveSliderObjectFromElement(element) {
        var sliderObject = $(element).data('slider');
        if(sliderObject && sliderObject instanceof Slider) {
            return sliderObject;
        } else {
            throw new Error(ErrorMsgs.callingContextNotSliderInstance);
        }
    }

    function createNewSliderInstance(opts) {
        var $this = $(this);
        $this.each(function() {
            var $this = $(this),
                slider = $this.data('slider'),
                options = typeof opts === 'object' && opts;

            // If slider already exists, use its attributes
            // as options so slider refreshes properly
            if (slider && !options) {
                options = {};

                $.each($.fn.slider.defaults, function(key) {
                    options[key] = slider[key];
                });
            }

            $this.data('slider', (new Slider(this, $.extend({}, $.fn.slider.defaults, options))));
        });
        return $this;
    }

    $.fn.slider.defaults = {
        min: 0,
        max: 10,
        step: 1,
        precision: 0,
        orientation: 'horizontal',
        value: 5,
        range: false,
        selection: 'before',
        tooltip: 'show',
        tooltip_separator: ':',
        tooltip_split: false,
        handle: 'round',
        reversed : false,
        enabled: true,
        ariaLabel: ["Slider handle (minimum)", "Slider handle (maximum)"],
        formater: function(value) {
            return value;
        }
    };

    $.fn.slider.Constructor = Slider;

})( window.jQuery );


/***/ }),

/***/ 2243:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* Chosen v1.1.0 | (c) 2011-2013 by Harvest | MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md */
!function(){var a,AbstractChosen,Chosen,SelectParser,b,c={}.hasOwnProperty,d=function(a,b){function d(){this.constructor=a}for(var e in b)c.call(b,e)&&(a[e]=b[e]);return d.prototype=b.prototype,a.prototype=new d,a.__super__=b.prototype,a};SelectParser=function(){function SelectParser(){this.options_index=0,this.parsed=[]}return SelectParser.prototype.add_node=function(a){return"OPTGROUP"===a.nodeName.toUpperCase()?this.add_group(a):this.add_option(a)},SelectParser.prototype.add_group=function(a){var b,c,d,e,f,g;for(b=this.parsed.length,this.parsed.push({array_index:b,group:!0,label:this.escapeExpression(a.label),children:0,disabled:a.disabled}),f=a.childNodes,g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(this.add_option(c,b,a.disabled));return g},SelectParser.prototype.add_option=function(a,b,c){return"OPTION"===a.nodeName.toUpperCase()?(""!==a.text?(null!=b&&(this.parsed[b].children+=1),this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,value:a.value,text:a.text,html:a.innerHTML,selected:a.selected,disabled:c===!0?c:a.disabled,group_array_index:b,classes:a.className,style:a.style.cssText})):this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,empty:!0}),this.options_index+=1):void 0},SelectParser.prototype.escapeExpression=function(a){var b,c;return null==a||a===!1?"":/[\&\<\>\"\'\`]/.test(a)?(b={"<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},c=/&(?!\w+;)|[\<\>\"\'\`]/g,a.replace(c,function(a){return b[a]||"&amp;"})):a},SelectParser}(),SelectParser.select_to_array=function(a){var b,c,d,e,f;for(c=new SelectParser,f=a.childNodes,d=0,e=f.length;e>d;d++)b=f[d],c.add_node(b);return c.parsed},AbstractChosen=function(){function AbstractChosen(a,b){this.form_field=a,this.options=null!=b?b:{},AbstractChosen.browser_is_supported()&&(this.is_multiple=this.form_field.multiple,this.set_default_text(),this.set_default_values(),this.setup(),this.set_up_html(),this.register_observers())}return AbstractChosen.prototype.set_default_values=function(){var a=this;return this.click_test_action=function(b){return a.test_active_click(b)},this.activate_action=function(b){return a.activate_field(b)},this.active_field=!1,this.mouse_on_container=!1,this.results_showing=!1,this.result_highlighted=null,this.allow_single_deselect=null!=this.options.allow_single_deselect&&null!=this.form_field.options[0]&&""===this.form_field.options[0].text?this.options.allow_single_deselect:!1,this.disable_search_threshold=this.options.disable_search_threshold||0,this.disable_search=this.options.disable_search||!1,this.enable_split_word_search=null!=this.options.enable_split_word_search?this.options.enable_split_word_search:!0,this.group_search=null!=this.options.group_search?this.options.group_search:!0,this.search_contains=this.options.search_contains||!1,this.single_backstroke_delete=null!=this.options.single_backstroke_delete?this.options.single_backstroke_delete:!0,this.max_selected_options=this.options.max_selected_options||1/0,this.inherit_select_classes=this.options.inherit_select_classes||!1,this.display_selected_options=null!=this.options.display_selected_options?this.options.display_selected_options:!0,this.display_disabled_options=null!=this.options.display_disabled_options?this.options.display_disabled_options:!0},AbstractChosen.prototype.set_default_text=function(){return this.default_text=this.form_field.getAttribute("data-placeholder")?this.form_field.getAttribute("data-placeholder"):this.is_multiple?this.options.placeholder_text_multiple||this.options.placeholder_text||AbstractChosen.default_multiple_text:this.options.placeholder_text_single||this.options.placeholder_text||AbstractChosen.default_single_text,this.results_none_found=this.form_field.getAttribute("data-no_results_text")||this.options.no_results_text||AbstractChosen.default_no_result_text},AbstractChosen.prototype.mouse_enter=function(){return this.mouse_on_container=!0},AbstractChosen.prototype.mouse_leave=function(){return this.mouse_on_container=!1},AbstractChosen.prototype.input_focus=function(){var a=this;if(this.is_multiple){if(!this.active_field)return setTimeout(function(){return a.container_mousedown()},50)}else if(!this.active_field)return this.activate_field()},AbstractChosen.prototype.input_blur=function(){var a=this;return this.mouse_on_container?void 0:(this.active_field=!1,setTimeout(function(){return a.blur_test()},100))},AbstractChosen.prototype.results_option_build=function(a){var b,c,d,e,f;for(b="",f=this.results_data,d=0,e=f.length;e>d;d++)c=f[d],b+=c.group?this.result_add_group(c):this.result_add_option(c),(null!=a?a.first:void 0)&&(c.selected&&this.is_multiple?this.choice_build(c):c.selected&&!this.is_multiple&&this.single_set_selected_text(c.text));return b},AbstractChosen.prototype.result_add_option=function(a){var b,c;return a.search_match?this.include_option_in_results(a)?(b=[],a.disabled||a.selected&&this.is_multiple||b.push("active-result"),!a.disabled||a.selected&&this.is_multiple||b.push("disabled-result"),a.selected&&b.push("result-selected"),null!=a.group_array_index&&b.push("group-option"),""!==a.classes&&b.push(a.classes),c=document.createElement("li"),c.className=b.join(" "),c.style.cssText=a.style,c.setAttribute("data-option-array-index",a.array_index),c.innerHTML=a.search_text,this.outerHTML(c)):"":""},AbstractChosen.prototype.result_add_group=function(a){var b;return a.search_match||a.group_match?a.active_options>0?(b=document.createElement("li"),b.className="group-result",b.innerHTML=a.search_text,this.outerHTML(b)):"":""},AbstractChosen.prototype.results_update_field=function(){return this.set_default_text(),this.is_multiple||this.results_reset_cleanup(),this.result_clear_highlight(),this.results_build(),this.results_showing?this.winnow_results():void 0},AbstractChosen.prototype.reset_single_select_options=function(){var a,b,c,d,e;for(d=this.results_data,e=[],b=0,c=d.length;c>b;b++)a=d[b],a.selected?e.push(a.selected=!1):e.push(void 0);return e},AbstractChosen.prototype.results_toggle=function(){return this.results_showing?this.results_hide():this.results_show()},AbstractChosen.prototype.results_search=function(){return this.results_showing?this.winnow_results():this.results_show()},AbstractChosen.prototype.winnow_results=function(){var a,b,c,d,e,f,g,h,i,j,k,l,m;for(this.no_results_clear(),e=0,g=this.get_search_text(),a=g.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&"),d=this.search_contains?"":"^",c=new RegExp(d+a,"i"),j=new RegExp(a,"i"),m=this.results_data,k=0,l=m.length;l>k;k++)b=m[k],b.search_match=!1,f=null,this.include_option_in_results(b)&&(b.group&&(b.group_match=!1,b.active_options=0),null!=b.group_array_index&&this.results_data[b.group_array_index]&&(f=this.results_data[b.group_array_index],0===f.active_options&&f.search_match&&(e+=1),f.active_options+=1),(!b.group||this.group_search)&&(b.search_text=b.group?b.label:b.html,b.search_match=this.search_string_match(b.search_text,c),b.search_match&&!b.group&&(e+=1),b.search_match?(g.length&&(h=b.search_text.search(j),i=b.search_text.substr(0,h+g.length)+"</em>"+b.search_text.substr(h+g.length),b.search_text=i.substr(0,h)+"<em>"+i.substr(h)),null!=f&&(f.group_match=!0)):null!=b.group_array_index&&this.results_data[b.group_array_index].search_match&&(b.search_match=!0)));return this.result_clear_highlight(),1>e&&g.length?(this.update_results_content(""),this.no_results(g)):(this.update_results_content(this.results_option_build()),this.winnow_results_set_highlight())},AbstractChosen.prototype.search_string_match=function(a,b){var c,d,e,f;if(b.test(a))return!0;if(this.enable_split_word_search&&(a.indexOf(" ")>=0||0===a.indexOf("["))&&(d=a.replace(/\[|\]/g,"").split(" "),d.length))for(e=0,f=d.length;f>e;e++)if(c=d[e],b.test(c))return!0},AbstractChosen.prototype.choices_count=function(){var a,b,c,d;if(null!=this.selected_option_count)return this.selected_option_count;for(this.selected_option_count=0,d=this.form_field.options,b=0,c=d.length;c>b;b++)a=d[b],a.selected&&(this.selected_option_count+=1);return this.selected_option_count},AbstractChosen.prototype.choices_click=function(a){return a.preventDefault(),this.results_showing||this.is_disabled?void 0:this.results_show()},AbstractChosen.prototype.keyup_checker=function(a){var b,c;switch(b=null!=(c=a.which)?c:a.keyCode,this.search_field_scale(),b){case 8:if(this.is_multiple&&this.backstroke_length<1&&this.choices_count()>0)return this.keydown_backstroke();if(!this.pending_backstroke)return this.result_clear_highlight(),this.results_search();break;case 13:if(a.preventDefault(),this.results_showing)return this.result_select(a);break;case 27:return this.results_showing&&this.results_hide(),!0;case 9:case 38:case 40:case 16:case 91:case 17:break;default:return this.results_search()}},AbstractChosen.prototype.clipboard_event_checker=function(){var a=this;return setTimeout(function(){return a.results_search()},50)},AbstractChosen.prototype.container_width=function(){return null!=this.options.width?this.options.width:""+this.form_field.offsetWidth+"px"},AbstractChosen.prototype.include_option_in_results=function(a){return this.is_multiple&&!this.display_selected_options&&a.selected?!1:!this.display_disabled_options&&a.disabled?!1:a.empty?!1:!0},AbstractChosen.prototype.search_results_touchstart=function(a){return this.touch_started=!0,this.search_results_mouseover(a)},AbstractChosen.prototype.search_results_touchmove=function(a){return this.touch_started=!1,this.search_results_mouseout(a)},AbstractChosen.prototype.search_results_touchend=function(a){return this.touch_started?this.search_results_mouseup(a):void 0},AbstractChosen.prototype.outerHTML=function(a){var b;return a.outerHTML?a.outerHTML:(b=document.createElement("div"),b.appendChild(a),b.innerHTML)},AbstractChosen.browser_is_supported=function(){return"Microsoft Internet Explorer"===window.navigator.appName?document.documentMode>=8:/iP(od|hone)/i.test(window.navigator.userAgent)?!1:/Android/i.test(window.navigator.userAgent)&&/Mobile/i.test(window.navigator.userAgent)?!1:!0},AbstractChosen.default_multiple_text="Select Some Options",AbstractChosen.default_single_text="Select an Option",AbstractChosen.default_no_result_text="No results match",AbstractChosen}(),a=jQuery,a.fn.extend({chosen:function(b){return AbstractChosen.browser_is_supported()?this.each(function(){var c,d;c=a(this),d=c.data("chosen"),"destroy"===b&&d?d.destroy():d||c.data("chosen",new Chosen(this,b))}):this}}),Chosen=function(c){function Chosen(){return b=Chosen.__super__.constructor.apply(this,arguments)}return d(Chosen,c),Chosen.prototype.setup=function(){return this.form_field_jq=a(this.form_field),this.current_selectedIndex=this.form_field.selectedIndex,this.is_rtl=this.form_field_jq.hasClass("chosen-rtl")},Chosen.prototype.set_up_html=function(){var b,c;return b=["chosen-container"],b.push("chosen-container-"+(this.is_multiple?"multi":"single")),this.inherit_select_classes&&this.form_field.className&&b.push(this.form_field.className),this.is_rtl&&b.push("chosen-rtl"),c={"class":b.join(" "),style:"width: "+this.container_width()+";",title:this.form_field.title},this.form_field.id.length&&(c.id=this.form_field.id.replace(/[^\w]/g,"_")+"_chosen"),this.container=a("<div />",c),this.is_multiple?this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="'+this.default_text+'" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>'):this.container.html('<a class="chosen-single chosen-default" tabindex="-1"><span>'+this.default_text+'</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>'),this.form_field_jq.hide().after(this.container),this.dropdown=this.container.find("div.chosen-drop").first(),this.search_field=this.container.find("input").first(),this.search_results=this.container.find("ul.chosen-results").first(),this.search_field_scale(),this.search_no_results=this.container.find("li.no-results").first(),this.is_multiple?(this.search_choices=this.container.find("ul.chosen-choices").first(),this.search_container=this.container.find("li.search-field").first()):(this.search_container=this.container.find("div.chosen-search").first(),this.selected_item=this.container.find(".chosen-single").first()),this.results_build(),this.set_tab_index(),this.set_label_behavior(),this.form_field_jq.trigger("chosen:ready",{chosen:this})},Chosen.prototype.register_observers=function(){var a=this;return this.container.bind("mousedown.chosen",function(b){a.container_mousedown(b)}),this.container.bind("mouseup.chosen",function(b){a.container_mouseup(b)}),this.container.bind("mouseenter.chosen",function(b){a.mouse_enter(b)}),this.container.bind("mouseleave.chosen",function(b){a.mouse_leave(b)}),this.search_results.bind("mouseup.chosen",function(b){a.search_results_mouseup(b)}),this.search_results.bind("mouseover.chosen",function(b){a.search_results_mouseover(b)}),this.search_results.bind("mouseout.chosen",function(b){a.search_results_mouseout(b)}),this.search_results.bind("mousewheel.chosen DOMMouseScroll.chosen",function(b){a.search_results_mousewheel(b)}),this.search_results.bind("touchstart.chosen",function(b){a.search_results_touchstart(b)}),this.search_results.bind("touchmove.chosen",function(b){a.search_results_touchmove(b)}),this.search_results.bind("touchend.chosen",function(b){a.search_results_touchend(b)}),this.form_field_jq.bind("chosen:updated.chosen",function(b){a.results_update_field(b)}),this.form_field_jq.bind("chosen:activate.chosen",function(b){a.activate_field(b)}),this.form_field_jq.bind("chosen:open.chosen",function(b){a.container_mousedown(b)}),this.form_field_jq.bind("chosen:close.chosen",function(b){a.input_blur(b)}),this.search_field.bind("blur.chosen",function(b){a.input_blur(b)}),this.search_field.bind("keyup.chosen",function(b){a.keyup_checker(b)}),this.search_field.bind("keydown.chosen",function(b){a.keydown_checker(b)}),this.search_field.bind("focus.chosen",function(b){a.input_focus(b)}),this.search_field.bind("cut.chosen",function(b){a.clipboard_event_checker(b)}),this.search_field.bind("paste.chosen",function(b){a.clipboard_event_checker(b)}),this.is_multiple?this.search_choices.bind("click.chosen",function(b){a.choices_click(b)}):this.container.bind("click.chosen",function(a){a.preventDefault()})},Chosen.prototype.destroy=function(){return a(this.container[0].ownerDocument).unbind("click.chosen",this.click_test_action),this.search_field[0].tabIndex&&(this.form_field_jq[0].tabIndex=this.search_field[0].tabIndex),this.container.remove(),this.form_field_jq.removeData("chosen"),this.form_field_jq.show()},Chosen.prototype.search_field_disabled=function(){return this.is_disabled=this.form_field_jq[0].disabled,this.is_disabled?(this.container.addClass("chosen-disabled"),this.search_field[0].disabled=!0,this.is_multiple||this.selected_item.unbind("focus.chosen",this.activate_action),this.close_field()):(this.container.removeClass("chosen-disabled"),this.search_field[0].disabled=!1,this.is_multiple?void 0:this.selected_item.bind("focus.chosen",this.activate_action))},Chosen.prototype.container_mousedown=function(b){return this.is_disabled||(b&&"mousedown"===b.type&&!this.results_showing&&b.preventDefault(),null!=b&&a(b.target).hasClass("search-choice-close"))?void 0:(this.active_field?this.is_multiple||!b||a(b.target)[0]!==this.selected_item[0]&&!a(b.target).parents("a.chosen-single").length||(b.preventDefault(),this.results_toggle()):(this.is_multiple&&this.search_field.val(""),a(this.container[0].ownerDocument).bind("click.chosen",this.click_test_action),this.results_show()),this.activate_field())},Chosen.prototype.container_mouseup=function(a){return"ABBR"!==a.target.nodeName||this.is_disabled?void 0:this.results_reset(a)},Chosen.prototype.search_results_mousewheel=function(a){var b;return a.originalEvent&&(b=-a.originalEvent.wheelDelta||a.originalEvent.detail),null!=b?(a.preventDefault(),"DOMMouseScroll"===a.type&&(b=40*b),this.search_results.scrollTop(b+this.search_results.scrollTop())):void 0},Chosen.prototype.blur_test=function(){return!this.active_field&&this.container.hasClass("chosen-container-active")?this.close_field():void 0},Chosen.prototype.close_field=function(){return a(this.container[0].ownerDocument).unbind("click.chosen",this.click_test_action),this.active_field=!1,this.results_hide(),this.container.removeClass("chosen-container-active"),this.clear_backstroke(),this.show_search_field_default(),this.search_field_scale()},Chosen.prototype.activate_field=function(){return this.container.addClass("chosen-container-active"),this.active_field=!0,this.search_field.val(this.search_field.val()),this.search_field.focus()},Chosen.prototype.test_active_click=function(b){var c;return c=a(b.target).closest(".chosen-container"),c.length&&this.container[0]===c[0]?this.active_field=!0:this.close_field()},Chosen.prototype.results_build=function(){return this.parsing=!0,this.selected_option_count=null,this.results_data=SelectParser.select_to_array(this.form_field),this.is_multiple?this.search_choices.find("li.search-choice").remove():this.is_multiple||(this.single_set_selected_text(),this.disable_search||this.form_field.options.length<=this.disable_search_threshold?(this.search_field[0].readOnly=!0,this.container.addClass("chosen-container-single-nosearch")):(this.search_field[0].readOnly=!1,this.container.removeClass("chosen-container-single-nosearch"))),this.update_results_content(this.results_option_build({first:!0})),this.search_field_disabled(),this.show_search_field_default(),this.search_field_scale(),this.parsing=!1},Chosen.prototype.result_do_highlight=function(a){var b,c,d,e,f;if(a.length){if(this.result_clear_highlight(),this.result_highlight=a,this.result_highlight.addClass("highlighted"),d=parseInt(this.search_results.css("maxHeight"),10),f=this.search_results.scrollTop(),e=d+f,c=this.result_highlight.position().top+this.search_results.scrollTop(),b=c+this.result_highlight.outerHeight(),b>=e)return this.search_results.scrollTop(b-d>0?b-d:0);if(f>c)return this.search_results.scrollTop(c)}},Chosen.prototype.result_clear_highlight=function(){return this.result_highlight&&this.result_highlight.removeClass("highlighted"),this.result_highlight=null},Chosen.prototype.results_show=function(){return this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger("chosen:maxselected",{chosen:this}),!1):(this.container.addClass("chosen-with-drop"),this.results_showing=!0,this.search_field.focus(),this.search_field.val(this.search_field.val()),this.winnow_results(),this.form_field_jq.trigger("chosen:showing_dropdown",{chosen:this}))},Chosen.prototype.update_results_content=function(a){return this.search_results.html(a)},Chosen.prototype.results_hide=function(){return this.results_showing&&(this.result_clear_highlight(),this.container.removeClass("chosen-with-drop"),this.form_field_jq.trigger("chosen:hiding_dropdown",{chosen:this})),this.results_showing=!1},Chosen.prototype.set_tab_index=function(){var a;return this.form_field.tabIndex?(a=this.form_field.tabIndex,this.form_field.tabIndex=-1,this.search_field[0].tabIndex=a):void 0},Chosen.prototype.set_label_behavior=function(){var b=this;return this.form_field_label=this.form_field_jq.parents("label"),!this.form_field_label.length&&this.form_field.id.length&&(this.form_field_label=a("label[for='"+this.form_field.id+"']")),this.form_field_label.length>0?this.form_field_label.bind("click.chosen",function(a){return b.is_multiple?b.container_mousedown(a):b.activate_field()}):void 0},Chosen.prototype.show_search_field_default=function(){return this.is_multiple&&this.choices_count()<1&&!this.active_field?(this.search_field.val(this.default_text),this.search_field.addClass("default")):(this.search_field.val(""),this.search_field.removeClass("default"))},Chosen.prototype.search_results_mouseup=function(b){var c;return c=a(b.target).hasClass("active-result")?a(b.target):a(b.target).parents(".active-result").first(),c.length?(this.result_highlight=c,this.result_select(b),this.search_field.focus()):void 0},Chosen.prototype.search_results_mouseover=function(b){var c;return c=a(b.target).hasClass("active-result")?a(b.target):a(b.target).parents(".active-result").first(),c?this.result_do_highlight(c):void 0},Chosen.prototype.search_results_mouseout=function(b){return a(b.target).hasClass("active-result")?this.result_clear_highlight():void 0},Chosen.prototype.choice_build=function(b){var c,d,e=this;return c=a("<li />",{"class":"search-choice"}).html("<span>"+b.html+"</span>"),b.disabled?c.addClass("search-choice-disabled"):(d=a("<a />",{"class":"search-choice-close","data-option-array-index":b.array_index}),d.bind("click.chosen",function(a){return e.choice_destroy_link_click(a)}),c.append(d)),this.search_container.before(c)},Chosen.prototype.choice_destroy_link_click=function(b){return b.preventDefault(),b.stopPropagation(),this.is_disabled?void 0:this.choice_destroy(a(b.target))},Chosen.prototype.choice_destroy=function(a){return this.result_deselect(a[0].getAttribute("data-option-array-index"))?(this.show_search_field_default(),this.is_multiple&&this.choices_count()>0&&this.search_field.val().length<1&&this.results_hide(),a.parents("li").first().remove(),this.search_field_scale()):void 0},Chosen.prototype.results_reset=function(){return this.reset_single_select_options(),this.form_field.options[0].selected=!0,this.single_set_selected_text(),this.show_search_field_default(),this.results_reset_cleanup(),this.form_field_jq.trigger("change"),this.active_field?this.results_hide():void 0},Chosen.prototype.results_reset_cleanup=function(){return this.current_selectedIndex=this.form_field.selectedIndex,this.selected_item.find("abbr").remove()},Chosen.prototype.result_select=function(a){var b,c;return this.result_highlight?(b=this.result_highlight,this.result_clear_highlight(),this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger("chosen:maxselected",{chosen:this}),!1):(this.is_multiple?b.removeClass("active-result"):this.reset_single_select_options(),c=this.results_data[b[0].getAttribute("data-option-array-index")],c.selected=!0,this.form_field.options[c.options_index].selected=!0,this.selected_option_count=null,this.is_multiple?this.choice_build(c):this.single_set_selected_text(c.text),(a.metaKey||a.ctrlKey)&&this.is_multiple||this.results_hide(),this.search_field.val(""),(this.is_multiple||this.form_field.selectedIndex!==this.current_selectedIndex)&&this.form_field_jq.trigger("change",{selected:this.form_field.options[c.options_index].value}),this.current_selectedIndex=this.form_field.selectedIndex,this.search_field_scale())):void 0},Chosen.prototype.single_set_selected_text=function(a){return null==a&&(a=this.default_text),a===this.default_text?this.selected_item.addClass("chosen-default"):(this.single_deselect_control_build(),this.selected_item.removeClass("chosen-default")),this.selected_item.find("span").text(a)},Chosen.prototype.result_deselect=function(a){var b;return b=this.results_data[a],this.form_field.options[b.options_index].disabled?!1:(b.selected=!1,this.form_field.options[b.options_index].selected=!1,this.selected_option_count=null,this.result_clear_highlight(),this.results_showing&&this.winnow_results(),this.form_field_jq.trigger("change",{deselected:this.form_field.options[b.options_index].value}),this.search_field_scale(),!0)},Chosen.prototype.single_deselect_control_build=function(){return this.allow_single_deselect?(this.selected_item.find("abbr").length||this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>'),this.selected_item.addClass("chosen-single-with-deselect")):void 0},Chosen.prototype.get_search_text=function(){return this.search_field.val()===this.default_text?"":a("<div/>").text(a.trim(this.search_field.val())).html()},Chosen.prototype.winnow_results_set_highlight=function(){var a,b;return b=this.is_multiple?[]:this.search_results.find(".result-selected.active-result"),a=b.length?b.first():this.search_results.find(".active-result").first(),null!=a?this.result_do_highlight(a):void 0},Chosen.prototype.no_results=function(b){var c;return c=a('<li class="no-results">'+this.results_none_found+' "<span></span>"</li>'),c.find("span").first().html(b),this.search_results.append(c),this.form_field_jq.trigger("chosen:no_results",{chosen:this})},Chosen.prototype.no_results_clear=function(){return this.search_results.find(".no-results").remove()},Chosen.prototype.keydown_arrow=function(){var a;return this.results_showing&&this.result_highlight?(a=this.result_highlight.nextAll("li.active-result").first())?this.result_do_highlight(a):void 0:this.results_show()},Chosen.prototype.keyup_arrow=function(){var a;return this.results_showing||this.is_multiple?this.result_highlight?(a=this.result_highlight.prevAll("li.active-result"),a.length?this.result_do_highlight(a.first()):(this.choices_count()>0&&this.results_hide(),this.result_clear_highlight())):void 0:this.results_show()},Chosen.prototype.keydown_backstroke=function(){var a;return this.pending_backstroke?(this.choice_destroy(this.pending_backstroke.find("a").first()),this.clear_backstroke()):(a=this.search_container.siblings("li.search-choice").last(),a.length&&!a.hasClass("search-choice-disabled")?(this.pending_backstroke=a,this.single_backstroke_delete?this.keydown_backstroke():this.pending_backstroke.addClass("search-choice-focus")):void 0)},Chosen.prototype.clear_backstroke=function(){return this.pending_backstroke&&this.pending_backstroke.removeClass("search-choice-focus"),this.pending_backstroke=null},Chosen.prototype.keydown_checker=function(a){var b,c;switch(b=null!=(c=a.which)?c:a.keyCode,this.search_field_scale(),8!==b&&this.pending_backstroke&&this.clear_backstroke(),b){case 8:this.backstroke_length=this.search_field.val().length;break;case 9:this.results_showing&&!this.is_multiple&&this.result_select(a),this.mouse_on_container=!1;break;case 13:a.preventDefault();break;case 38:a.preventDefault(),this.keyup_arrow();break;case 40:a.preventDefault(),this.keydown_arrow()}},Chosen.prototype.search_field_scale=function(){var b,c,d,e,f,g,h,i,j;if(this.is_multiple){for(d=0,h=0,f="position:absolute; left: -1000px; top: -1000px; display:none;",g=["font-size","font-style","font-weight","font-family","line-height","text-transform","letter-spacing"],i=0,j=g.length;j>i;i++)e=g[i],f+=e+":"+this.search_field.css(e)+";";return b=a("<div />",{style:f}),b.text(this.search_field.val()),a("body").append(b),h=b.width()+25,b.remove(),c=this.container.outerWidth(),h>c-10&&(h=c-10),this.search_field.css({width:h+"px"})}},Chosen}(AbstractChosen)}.call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2244:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery Raty - A Star Rating Plugin
 *
 * The MIT License
 *
 * @author  : Washington Botelho
 * @doc     : http://wbotelhos.com/raty
 * @version : 2.7.0
 *
 */

;
(function($) {
  'use strict';

  var methods = {
    init: function(options) {
      return this.each(function() {
        this.self = $(this);

        methods.destroy.call(this.self);

        this.opt = $.extend(true, {}, $.fn.raty.defaults, options);

        methods._adjustCallback.call(this);
        methods._adjustNumber.call(this);
        methods._adjustHints.call(this);

        this.opt.score = methods._adjustedScore.call(this, this.opt.score);

        if (this.opt.starType !== 'img') {
          methods._adjustStarType.call(this);
        }

        methods._adjustPath.call(this);
        methods._createStars.call(this);

        if (this.opt.cancel) {
          methods._createCancel.call(this);
        }

        if (this.opt.precision) {
          methods._adjustPrecision.call(this);
        }

        methods._createScore.call(this);
        methods._apply.call(this, this.opt.score);
        methods._setTitle.call(this, this.opt.score);
        methods._target.call(this, this.opt.score);

        if (this.opt.readOnly) {
          methods._lock.call(this);
        } else {
          this.style.cursor = 'pointer';

          methods._binds.call(this);
        }
      });
    },

    _adjustCallback: function() {
      var options = ['number', 'readOnly', 'score', 'scoreName', 'target'];

      for (var i = 0; i < options.length; i++) {
        if (typeof this.opt[options[i]] === 'function') {
          this.opt[options[i]] = this.opt[options[i]].call(this);
        }
      }
    },

    _adjustedScore: function(score) {
      if (!score) {
        return score;
      }

      return methods._between(score, 0, this.opt.number);
    },

    _adjustHints: function() {
      if (!this.opt.hints) {
        this.opt.hints = [];
      }

      if (!this.opt.halfShow && !this.opt.half) {
        return;
      }

      var steps = this.opt.precision ? 10 : 2;

      for (var i = 0; i < this.opt.number; i++) {
        var group = this.opt.hints[i];

        if (Object.prototype.toString.call(group) !== '[object Array]') {
          group = [group];
        }

        this.opt.hints[i] = [];

        for (var j = 0; j < steps; j++) {
          var
            hint = group[j],
            last = group[group.length - 1];

          if (last === undefined) {
            last = null;
          }

          this.opt.hints[i][j] = hint === undefined ? last : hint;
        }
      }
    },

    _adjustNumber: function() {
      this.opt.number = methods._between(this.opt.number, 1, this.opt.numberMax);
    },

    _adjustPath: function() {
      this.opt.path = this.opt.path || '';

      if (this.opt.path && this.opt.path.charAt(this.opt.path.length - 1) !== '/') {
        this.opt.path += '/';
      }
    },

    _adjustPrecision: function() {
      this.opt.half = true;
    },

    _adjustStarType: function() {
      var replaces = ['cancelOff', 'cancelOn', 'starHalf', 'starOff', 'starOn'];

      this.opt.path = '';

      for (var i = 0; i < replaces.length; i++) {
        this.opt[replaces[i]] = this.opt[replaces[i]].replace('.', '-');
      }
    },

    _apply: function(score) {
      methods._fill.call(this, score);

      if (score) {
        if (score > 0) {
          this.score.val(score);
        }

        methods._roundStars.call(this, score);
      }
    },

    _between: function(value, min, max) {
      return Math.min(Math.max(parseFloat(value), min), max);
    },

    _binds: function() {
      if (this.cancel) {
        methods._bindOverCancel.call(this);
        methods._bindClickCancel.call(this);
        methods._bindOutCancel.call(this);
      }

      methods._bindOver.call(this);
      methods._bindClick.call(this);
      methods._bindOut.call(this);
    },

    _bindClick: function() {
      var that = this;

      that.stars.on('click.raty', function(evt) {
        var
          execute = true,
          score   = (that.opt.half || that.opt.precision) ? that.self.data('score') : (this.alt || $(this).data('alt'));

        if (that.opt.click) {
          execute = that.opt.click.call(that, +score, evt);
        }

        if (execute || execute === undefined) {
          if (that.opt.half && !that.opt.precision) {
            score = methods._roundHalfScore.call(that, score);
          }

          methods._apply.call(that, score);
        }
      });
    },

    _bindClickCancel: function() {
      var that = this;

      that.cancel.on('click.raty', function(evt) {
        that.score.removeAttr('value');

        if (that.opt.click) {
          that.opt.click.call(that, null, evt);
        }
      });
    },

    _bindOut: function() {
      var that = this;

      that.self.on('mouseleave.raty', function(evt) {
        var score = +that.score.val() || undefined;

        methods._apply.call(that, score);
        methods._target.call(that, score, evt);
        methods._resetTitle.call(that);

        if (that.opt.mouseout) {
          that.opt.mouseout.call(that, score, evt);
        }
      });
    },

    _bindOutCancel: function() {
      var that = this;

      that.cancel.on('mouseleave.raty', function(evt) {
        var icon = that.opt.cancelOff;

        if (that.opt.starType !== 'img') {
          icon = that.opt.cancelClass + ' ' + icon;
        }

        methods._setIcon.call(that, this, icon);

        if (that.opt.mouseout) {
          var score = +that.score.val() || undefined;

          that.opt.mouseout.call(that, score, evt);
        }
      });
    },

    _bindOver: function() {
      var that   = this,
          action = that.opt.half ? 'mousemove.raty' : 'mouseover.raty';

      that.stars.on(action, function(evt) {
        var score = methods._getScoreByPosition.call(that, evt, this);

        methods._fill.call(that, score);

        if (that.opt.half) {
          methods._roundStars.call(that, score, evt);
          methods._setTitle.call(that, score, evt);

          that.self.data('score', score);
        }

        methods._target.call(that, score, evt);

        if (that.opt.mouseover) {
          that.opt.mouseover.call(that, score, evt);
        }
      });
    },

    _bindOverCancel: function() {
      var that = this;

      that.cancel.on('mouseover.raty', function(evt) {
        var
          starOff = that.opt.path + that.opt.starOff,
          icon    = that.opt.cancelOn;

        if (that.opt.starType === 'img') {
          that.stars.attr('src', starOff);
        } else {
          icon = that.opt.cancelClass + ' ' + icon;

          that.stars.attr('class', starOff);
        }

        methods._setIcon.call(that, this, icon);
        methods._target.call(that, null, evt);

        if (that.opt.mouseover) {
          that.opt.mouseover.call(that, null);
        }
      });
    },

    _buildScoreField: function() {
      return $('<input />', { name: this.opt.scoreName, type: 'hidden' }).appendTo(this);
    },

    _createCancel: function() {
      var icon   = this.opt.path + this.opt.cancelOff,
          cancel = $('<' + this.opt.starType + ' />', { title: this.opt.cancelHint, 'class': this.opt.cancelClass });

      if (this.opt.starType === 'img') {
        cancel.attr({ src: icon, alt: 'x' });
      } else {
        // TODO: use $.data
        cancel.attr('data-alt', 'x').addClass(icon);
      }

      if (this.opt.cancelPlace === 'left') {
        this.self.prepend('&#160;').prepend(cancel);
      } else {
        this.self.append('&#160;').append(cancel);
      }

      this.cancel = cancel;
    },

    _createScore: function() {
      var score = $(this.opt.targetScore);

      this.score = score.length ? score : methods._buildScoreField.call(this);
    },

    _createStars: function() {
      for (var i = 1; i <= this.opt.number; i++) {
        var
          name  = methods._nameForIndex.call(this, i),
          attrs = { alt: i, src: this.opt.path + this.opt[name] };

        if (this.opt.starType !== 'img') {
          attrs = { 'data-alt': i, 'class': attrs.src }; // TODO: use $.data.
        }

        attrs.title = methods._getHint.call(this, i);

        $('<' + this.opt.starType + ' />', attrs).appendTo(this);

        if (this.opt.space) {
          this.self.append(i < this.opt.number ? '&#160;' : '');
        }
      }

      this.stars = this.self.children(this.opt.starType);
    },

    _error: function(message) {
      $(this).text(message);

      $.error(message);
    },

    _fill: function(score) {
      var hash = 0;

      for (var i = 1; i <= this.stars.length; i++) {
        var
          icon,
          star   = this.stars[i - 1],
          turnOn = methods._turnOn.call(this, i, score);

        if (this.opt.iconRange && this.opt.iconRange.length > hash) {
          var irange = this.opt.iconRange[hash];

          icon = methods._getRangeIcon.call(this, irange, turnOn);

          if (i <= irange.range) {
            methods._setIcon.call(this, star, icon);
          }

          if (i === irange.range) {
            hash++;
          }
        } else {
          icon = this.opt[turnOn ? 'starOn' : 'starOff'];

          methods._setIcon.call(this, star, icon);
        }
      }
    },

    _getFirstDecimal: function(number) {
      var
        decimal = number.toString().split('.')[1],
        result  = 0;

      if (decimal) {
        result = parseInt(decimal.charAt(0), 10);

        if (decimal.slice(1, 5) === '9999') {
          result++;
        }
      }

      return result;
    },

    _getRangeIcon: function(irange, turnOn) {
      return turnOn ? irange.on || this.opt.starOn : irange.off || this.opt.starOff;
    },

    _getScoreByPosition: function(evt, icon) {
      var score = parseInt(icon.alt || icon.getAttribute('data-alt'), 10);

      if (this.opt.half) {
        var
          size    = methods._getWidth.call(this),
          percent = parseFloat((evt.pageX - $(icon).offset().left) / size);

        score = score - 1 + percent;
      }

      return score;
    },

    _getHint: function(score, evt) {
      if (score !== 0 && !score) {
        return this.opt.noRatedMsg;
      }

      var
        decimal = methods._getFirstDecimal.call(this, score),
        integer = Math.ceil(score),
        group   = this.opt.hints[(integer || 1) - 1],
        hint    = group,
        set     = !evt || this.move;

      if (this.opt.precision) {
        if (set) {
          decimal = decimal === 0 ? 9 : decimal - 1;
        }

        hint = group[decimal];
      } else if (this.opt.halfShow || this.opt.half) {
        decimal = set && decimal === 0 ? 1 : decimal > 5 ? 1 : 0;

        hint = group[decimal];
      }

      return hint === '' ? '' : hint || score;
    },

    _getWidth: function() {
      var width = this.stars[0].width || parseFloat(this.stars.eq(0).css('font-size'));

      if (!width) {
        methods._error.call(this, 'Could not get the icon width!');
      }

      return width;
    },

    _lock: function() {
      var hint = methods._getHint.call(this, this.score.val());

      this.style.cursor = '';
      this.title        = hint;

      this.score.prop('readonly', true);
      this.stars.prop('title', hint);

      if (this.cancel) {
        this.cancel.hide();
      }

      this.self.data('readonly', true);
    },

    _nameForIndex: function(i) {
      return this.opt.score && this.opt.score >= i ? 'starOn' : 'starOff';
    },

    _resetTitle: function(star) {
      for (var i = 0; i < this.opt.number; i++) {
        this.stars[i].title = methods._getHint.call(this, i + 1);
      }
    },

     _roundHalfScore: function(score) {
      var integer = parseInt(score, 10),
          decimal = methods._getFirstDecimal.call(this, score);

      if (decimal !== 0) {
        decimal = decimal > 5 ? 1 : 0.5;
      }

      return integer + decimal;
    },

    _roundStars: function(score, evt) {
      var
        decimal = (score % 1).toFixed(2),
        name    ;

      if (evt || this.move) {
        name = decimal > 0.5 ? 'starOn' : 'starHalf';
      } else if (decimal > this.opt.round.down) {               // Up:   [x.76 .. x.99]
        name = 'starOn';

        if (this.opt.halfShow && decimal < this.opt.round.up) { // Half: [x.26 .. x.75]
          name = 'starHalf';
        } else if (decimal < this.opt.round.full) {             // Down: [x.00 .. x.5]
          name = 'starOff';
        }
      }

      if (name) {
        var
          icon = this.opt[name],
          star = this.stars[Math.ceil(score) - 1];

        methods._setIcon.call(this, star, icon);
      }                                                         // Full down: [x.00 .. x.25]
    },

    _setIcon: function(star, icon) {
      star[this.opt.starType === 'img' ? 'src' : 'className'] = this.opt.path + icon;
    },

    _setTarget: function(target, score) {
      if (score) {
        score = this.opt.targetFormat.toString().replace('{score}', score);
      }

      if (target.is(':input')) {
        target.val(score);
      } else {
        target.html(score);
      }
    },

    _setTitle: function(score, evt) {
      if (score) {
        var
          integer = parseInt(Math.ceil(score), 10),
          star    = this.stars[integer - 1];

        star.title = methods._getHint.call(this, score, evt);
      }
    },

    _target: function(score, evt) {
      if (this.opt.target) {
        var target = $(this.opt.target);

        if (!target.length) {
          methods._error.call(this, 'Target selector invalid or missing!');
        }

        var mouseover = evt && evt.type === 'mouseover';

        if (score === undefined) {
          score = this.opt.targetText;
        } else if (score === null) {
          score = mouseover ? this.opt.cancelHint : this.opt.targetText;
        } else {
          if (this.opt.targetType === 'hint') {
            score = methods._getHint.call(this, score, evt);
          } else if (this.opt.precision) {
            score = parseFloat(score).toFixed(1);
          }

          var mousemove = evt && evt.type === 'mousemove';

          if (!mouseover && !mousemove && !this.opt.targetKeep) {
            score = this.opt.targetText;
          }
        }

        methods._setTarget.call(this, target, score);
      }
    },

    _turnOn: function(i, score) {
      return this.opt.single ? (i === score) : (i <= score);
    },

    _unlock: function() {
      this.style.cursor = 'pointer';
      this.removeAttribute('title');

      this.score.removeAttr('readonly');

      this.self.data('readonly', false);

      for (var i = 0; i < this.opt.number; i++) {
        this.stars[i].title = methods._getHint.call(this, i + 1);
      }

      if (this.cancel) {
        this.cancel.css('display', '');
      }
    },

    cancel: function(click) {
      return this.each(function() {
        var self = $(this);

        if (self.data('readonly') !== true) {
          methods[click ? 'click' : 'score'].call(self, null);

          this.score.removeAttr('value');
        }
      });
    },

    click: function(score) {
      return this.each(function() {
        if ($(this).data('readonly') !== true) {
          score = methods._adjustedScore.call(this, score);

          methods._apply.call(this, score);

          if (this.opt.click) {
            this.opt.click.call(this, score, $.Event('click'));
          }

          methods._target.call(this, score);
        }
      });
    },

    destroy: function() {
      return this.each(function() {
        var self = $(this),
            raw  = self.data('raw');

        if (raw) {
          self.off('.raty').empty().css({ cursor: raw.style.cursor }).removeData('readonly');
        } else {
          self.data('raw', self.clone()[0]);
        }
      });
    },

    getScore: function() {
      var score = [],
          value ;

      this.each(function() {
        value = this.score.val();

        score.push(value ? +value : undefined);
      });

      return (score.length > 1) ? score : score[0];
    },

    move: function(score) {
      return this.each(function() {
        var
          integer  = parseInt(score, 10),
          decimal  = methods._getFirstDecimal.call(this, score);

        if (integer >= this.opt.number) {
          integer = this.opt.number - 1;
          decimal = 10;
        }

        var
          width   = methods._getWidth.call(this),
          steps   = width / 10,
          star    = $(this.stars[integer]),
          percent = star.offset().left + steps * decimal,
          evt     = $.Event('mousemove', { pageX: percent });

        this.move = true;

        star.trigger(evt);

        this.move = false;
      });
    },

    readOnly: function(readonly) {
      return this.each(function() {
        var self = $(this);

        if (self.data('readonly') !== readonly) {
          if (readonly) {
            self.off('.raty').children('img').off('.raty');

            methods._lock.call(this);
          } else {
            methods._binds.call(this);
            methods._unlock.call(this);
          }

          self.data('readonly', readonly);
        }
      });
    },

    reload: function() {
      return methods.set.call(this, {});
    },

    score: function() {
      var self = $(this);

      return arguments.length ? methods.setScore.apply(self, arguments) : methods.getScore.call(self);
    },

    set: function(options) {
      return this.each(function() {
        $(this).raty($.extend({}, this.opt, options));
      });
    },

    setScore: function(score) {
      return this.each(function() {
        if ($(this).data('readonly') !== true) {
          score = methods._adjustedScore.call(this, score);

          methods._apply.call(this, score);
          methods._target.call(this, score);
        }
      });
    }
  };

  $.fn.raty = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist!');
    }
  };

  $.fn.raty.defaults = {
    cancel       : false,
    cancelClass  : 'raty-cancel',
    cancelHint   : 'Cancel this rating!',
    cancelOff    : 'cancel-off.png',
    cancelOn     : 'cancel-on.png',
    cancelPlace  : 'left',
    click        : undefined,
    half         : false,
    halfShow     : true,
    hints        : ['bad', 'poor', 'regular', 'good', 'excellent'],
    iconRange    : undefined,
    mouseout     : undefined,
    mouseover    : undefined,
    noRatedMsg   : 'Not rated yet!',
    number       : 5,
    numberMax    : 20,
    path         : undefined,
    precision    : false,
    readOnly     : false,
    round        : { down: 0.25, full: 0.6, up: 0.76 },
    score        : undefined,
    scoreName    : 'score',
    single       : false,
    space        : true,
    starHalf     : 'star-half.png',
    starOff      : 'star-off.png',
    starOn       : 'star-on.png',
    starType     : 'img',
    target       : undefined,
    targetFormat : '{score}',
    targetKeep   : false,
    targetScore  : undefined,
    targetText   : '',
    targetType   : 'hint'
  };

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2245:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * @preserve
 * bootpag - jQuery plugin for dynamic pagination
 *
 * Copyright (c) 2015 botmonster@7items.com
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://botmonster.com/jquery-bootpag/
 *
 * Version:  1.0.7
 *
 */
(function($, window) {

    $.fn.bootpag = function(options){

        var $owner = this,
            settings = $.extend({
                total: 0,
                page: 1,
                maxVisible: null,
                leaps: true,
                href: 'javascript:void(0);',
                hrefVariable: '{{number}}',
                next: '&raquo;',
                prev: '&laquo;',
                firstLastUse: false,
                first: '<span aria-hidden="true">&larr;</span>',
                last: '<span aria-hidden="true">&rarr;</span>',
                wrapClass: 'pagination',
                activeClass: 'active',
                disabledClass: 'disabled',
                nextClass: 'next',
                prevClass: 'prev',
                lastClass: 'last',
                firstClass: 'first'
            },
            $owner.data('settings') || {},
            options || {});

        if(settings.total <= 0)
            return this;

          if(!$.isNumeric(settings.maxVisible) && !settings.maxVisible){
            settings.maxVisible = parseInt(settings.total, 10);
        }

        $owner.data('settings', settings);

        function renderPage($bootpag, page){

            page = parseInt(page, 10);
            var lp,
                maxV = settings.maxVisible == 0 ? 1 : settings.maxVisible,
                step = settings.maxVisible == 1 ? 0 : 1,
                vis = Math.floor((page - 1) / maxV) * maxV,
                $page = $bootpag.find('li');
            settings.page = page = page < 0 ? 0 : page > settings.total ? settings.total : page;
            $page.removeClass(settings.activeClass);
            lp = page - 1 < 1 ? 1 :
                settings.leaps && page - 1 >= settings.maxVisible ?
                    Math.floor((page - 1) / maxV) * maxV : page - 1;

            if(settings.firstLastUse) {
                $page
                    .first()
                    .toggleClass(settings.disabledClass, page === 1);
            }

            var lfirst = $page.first();
            if(settings.firstLastUse) {
                lfirst = lfirst.next();
            }

            lfirst
                .toggleClass(settings.disabledClass, page === 1)
                .attr('data-lp', lp)
                .find('a').attr('href', href(lp));

            var step = settings.maxVisible == 1 ? 0 : 1;

            lp = page + 1 > settings.total ? settings.total :
                    settings.leaps && page + 1 < settings.total - settings.maxVisible ?
                        vis + settings.maxVisible + step: page + 1;

            var llast = $page.last();
            if(settings.firstLastUse) {
                llast = llast.prev();
            }

            llast
                .toggleClass(settings.disabledClass, page === settings.total)
                .attr('data-lp', lp)
                .find('a').attr('href', href(lp));

            $page
                .last()
                .toggleClass(settings.disabledClass, page === settings.total);

            var $currPage = $page.filter('[data-lp='+page+']');

            var clist = "." + [settings.nextClass,
                               settings.prevClass,
                               settings.firstClass,
                               settings.lastClass].join(",.");
            if(!$currPage.not(clist).length){
                var d = page <= vis ? -settings.maxVisible : 0;
                $page.not(clist).each(function(index){
                    lp = index + 1 + vis + d;
                    $(this)
                        .attr('data-lp', lp)
                        .toggle(lp <= settings.total)
                        .find('a').html(lp).attr('href', href(lp));
                });
                $currPage = $page.filter('[data-lp='+page+']');
            }
            $currPage.not(clist).addClass(settings.activeClass);
            $owner.data('settings', settings);
        }

        function href(c){

            return settings.href.replace(settings.hrefVariable, c);
        }

        return this.each(function(){

            var $bootpag, lp, me = $(this),
                p = ['<ul class="', settings.wrapClass, ' bootpag">'];

            if(settings.firstLastUse){
                p = p.concat(['<li data-lp="1" class="', settings.firstClass,
                       '"><a href="', href(1), '">', settings.first, '</a></li>']);
            }
            if(settings.prev){
                p = p.concat(['<li data-lp="1" class="', settings.prevClass,
                       '"><a href="', href(1), '">', settings.prev, '</a></li>']);
            }
            for(var c = 1; c <= Math.min(settings.total, settings.maxVisible); c++){
                p = p.concat(['<li data-lp="', c, '"><a href="', href(c), '">', c, '</a></li>']);
            }
            if(settings.next){
                lp = settings.leaps && settings.total > settings.maxVisible
                    ? Math.min(settings.maxVisible + 1, settings.total) : 2;
                p = p.concat(['<li data-lp="', lp, '" class="',
                             settings.nextClass, '"><a href="', href(lp),
                             '">', settings.next, '</a></li>']);
            }
            if(settings.firstLastUse){
                p = p.concat(['<li data-lp="', settings.total, '" class="last"><a href="',
                             href(settings.total),'">', settings.last, '</a></li>']);
            }
            p.push('</ul>');
            me.find('ul.bootpag').remove();
            me.append(p.join(''));
            $bootpag = me.find('ul.bootpag');

            me.find('li').click(function paginationClick(){

                var me = $(this);
                if(me.hasClass(settings.disabledClass) || me.hasClass(settings.activeClass)){
                    return;
                }
                var page = parseInt(me.attr('data-lp'), 10);
                $owner.find('ul.bootpag').each(function(){
                    renderPage($(this), page);
                });

                $owner.trigger('page', page);
            });
            renderPage($bootpag, settings.page);
        });
    }

})(jQuery, window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2246:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*
 *   A base class for generating AJAX channels and handling success and
 *   error responses.
 *
 *   This class serves two puroses. The first is to abstract away from the
 *   nitty gritty of the $.ajax method. Simply pass a dictionary to the post
 *   or get methods and it handles the rest.
 *   
 *   The second is to provide a consistent experience to the user in the
 *   (unlikely) case of an error callback. It will display to the user a nice
 *   error message, complete with support contact information. 
 *
 *   This class extends Backbone.Model. Note that we are not using the models
 *   fetch functionality, which is tied to REST concepts. 
 * 
 *   Usage:
 * 
 *      myChannel = new AJAXView({ 
 *        url: '/ajax/myapp/myaction/', 
 *        successCallback: function(response){ 
 *          // Update some visual element 
 *        } 
 *      });
 *      myChannel.post({'foo': 'bar'}); 
 *   
 */
var AJAXView = Backbone.View.extend({
    url: null,

    initialize: function () {
        // Necessary Javascript voodoo
        _.bindAll(this, 
                  'get',
                  'post',
                  'successCallback',
                  'errorCallback'
                  );
    },

    /* 
     *  Submit GET request to url.
     *      params - a dictionary of key/value pairs that will be converted
     *               into a querystring
     *      url - (optional) override of this.url
     */ 
    get: function(params, url){
        alert("Not yet implemented");
        if (typeof url === 'undefined'){
            url = this.options.url;
        }
        // TODO: append params to querystring, being conscious of ? or no
        // TODO: Add stint to prevent IE from caching (e.g. ?noiecache=12345)
    },

    /* 
     *  Post to url, sending contents of post_data. 
     *      post_data - a dictionary of key, value pairs
     *      url - (optional) override of this.url
     */ 
    post: function(postData, url, contentType) {
        url = url || this.options.url;
        contentType = contentType || 'application/x-www-form-urlencoded';
        this._post(postData, url, 'POST', contentType);
    },

    put: function(put_data, url, contentType) {
        url = url || this.options.url;
        contentType = contentType || 'application/x-www-form-urlencoded';
        this._post(put_data, url, 'PUT', contentType);
    },
    
    _post: function(post_data, url, type, contentType) {
        $.ajax({
            type: type,
            url: url,
            data: post_data,
            dataType: 'json',
            contentType: contentType,
            success: this.successCallback,
            error: this.errorCallback
        });
    },

    successCallback: function(result){
        alert("Override me");
    },

    errorCallback: function(data){
        alert("Oops, an error occurred. The Rover.com tech team has been " +
              "alerted and will fix it shortly. If you would like immediate " + 
              "help visit our Help Center at support.rover.com, or call the " +
              "Barkline at 888-453-7889");
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(445), __webpack_require__(187)))

/***/ }),

/***/ 2247:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 *	jQuery dotdotdot 1.6.16
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */

(function( $, undef )
{
	if ( $.fn.dotdotdot )
	{
		return;
	}

	$.fn.dotdotdot = function( o )
	{
		if ( this.length == 0 )
		{
			$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
			return this;
		}
		if ( this.length > 1 )
		{
			return this.each(
				function()
				{
					$(this).dotdotdot( o );
				}
			);
		}


		var $dot = this;

		if ( $dot.data( 'dotdotdot' ) )
		{
			$dot.trigger( 'destroy.dot' );
		}

		$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
		$dot.css( 'word-wrap', 'break-word' );
		if ($dot.css( 'white-space' ) === 'nowrap')
		{
			$dot.css( 'white-space', 'normal' );
		}

		$dot.bind_events = function()
		{
			$dot.bind(
				'update.dot',
				function( e, c )
				{
					e.preventDefault();
					e.stopPropagation();

					opts.maxHeight = ( typeof opts.height == 'number' )
						? opts.height
						: getTrueInnerHeight( $dot );

					opts.maxHeight += opts.tolerance;

					if ( typeof c != 'undefined' )
					{
						if ( typeof c == 'string' || c instanceof HTMLElement )
						{
					 		c = $('<div />').append( c ).contents();
						}
						if ( c instanceof $ )
						{
							orgContent = c;
						}
					}

					$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
					$inr.contents()
						.detach()
						.end()
						.append( orgContent.clone( true ) )
						.find( 'br' )
						.replaceWith( '  <br />  ' )
						.end()
						.css({
							'height'	: 'auto',
							'width'		: 'auto',
							'border'	: 'none',
							'padding'	: 0,
							'margin'	: 0
						});

					var after = false,
						trunc = false;

					if ( conf.afterElement )
					{
						after = conf.afterElement.clone( true );
					    after.show();
						conf.afterElement.detach();
					}

					if ( test( $inr, opts ) )
					{
						if ( opts.wrap == 'children' )
						{
							trunc = children( $inr, opts, after );
						}
						else
						{
							trunc = ellipsis( $inr, $dot, $inr, opts, after );
						}
					}
					$inr.replaceWith( $inr.contents() );
					$inr = null;

					if ( $.isFunction( opts.callback ) )
					{
						opts.callback.call( $dot[ 0 ], trunc, orgContent );
					}

					conf.isTruncated = trunc;
					return trunc;
				}

			).bind(
				'isTruncated.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], conf.isTruncated );
					}
					return conf.isTruncated;
				}

			).bind(
				'originalContent.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], orgContent );
					}
					return orgContent;
				}

			).bind(
				'destroy.dot',
				function( e )
				{
					e.preventDefault();
					e.stopPropagation();

					$dot.unwatch()
						.unbind_events()
						.contents()
						.detach()
						.end()
						.append( orgContent )
						.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
						.data( 'dotdotdot', false );
				}
			);
			return $dot;
		};	//	/bind_events

		$dot.unbind_events = function()
		{
			$dot.unbind('.dot');
			return $dot;
		};	//	/unbind_events

		$dot.watch = function()
		{
			$dot.unwatch();
			if ( opts.watch == 'window' )
			{
				var $window = $(window),
					_wWidth = $window.width(),
					_wHeight = $window.height();

				$window.bind(
					'resize.dot' + conf.dotId,
					function()
					{
						if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
						{
							_wWidth = $window.width();
							_wHeight = $window.height();

							if ( watchInt )
							{
								clearInterval( watchInt );
							}
							watchInt = setTimeout(
								function()
								{
									$dot.trigger( 'update.dot' );
								}, 100
							);
						}
					}
				);
			}
			else
			{
				watchOrg = getSizes( $dot );
				watchInt = setInterval(
					function()
					{
						if ( $dot.is( ':visible' ) )
						{
							var watchNew = getSizes( $dot );
							if ( watchOrg.width  != watchNew.width ||
								 watchOrg.height != watchNew.height )
							{
								$dot.trigger( 'update.dot' );
								watchOrg = watchNew;
							}
						}
					}, 500
				);
			}
			return $dot;
		};
		$dot.unwatch = function()
		{
			$(window).unbind( 'resize.dot' + conf.dotId );
			if ( watchInt )
			{
				clearInterval( watchInt );
			}
			return $dot;
		};

		var	orgContent	= $dot.contents(),
			opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
			conf		= {},
			watchOrg	= {},
			watchInt	= null,
			$inr		= null;


		if ( !( opts.lastCharacter.remove instanceof Array ) )
		{
			opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
		}
		if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
		{
			opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
		}


		conf.afterElement	= getElement( opts.after, $dot );
		conf.isTruncated	= false;
		conf.dotId			= dotId++;


		$dot.data( 'dotdotdot', true )
			.bind_events()
			.trigger( 'update.dot' );

		if ( opts.watch )
		{
			$dot.watch();
		}

		return $dot;
	};


	//	public
	$.fn.dotdotdot.defaults = {
		'ellipsis'			: '... ',
		'wrap'				: 'word',
		'fallbackToLetter'	: true,
		'lastCharacter'		: {},
		'tolerance'			: 0,
		'callback'			: null,
		'after'				: null,
		'height'			: null,
		'watch'				: false,
		'windowResizeFix'	: true
	};
	$.fn.dotdotdot.defaultArrays = {
		'lastCharacter'		: {
			'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
			'noEllipsis'		: []
		}
	};
	$.fn.dotdotdot.debug = function( msg ) {};


	//	private
	var dotId = 1;

	function children( $elem, o, after )
	{
		var $elements 	= $elem.children(),
			isTruncated	= false;

		$elem.empty();

		for ( var a = 0, l = $elements.length; a < l; a++ )
		{
			var $e = $elements.eq( a );
			$elem.append( $e );
			if ( after )
			{
				$elem.append( after );
			}
			if ( test( $elem, o ) )
			{
				$e.remove();
				isTruncated = true;
				break;
			}
			else
			{
				if ( after )
				{
					after.detach();
				}
			}
		}
		return isTruncated;
	}
	function ellipsis( $elem, $d, $i, o, after )
	{
		var isTruncated	= false;

		//	Don't put the ellipsis directly inside these elements
		var notx = 'table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';

		//	Don't remove these elements even if they are after the ellipsis
		var noty = 'script, .dotdotdot-keep';

		$elem
			.contents()
			.detach()
			.each(
				function()
				{

					var e	= this,
						$e	= $(e);

					if ( typeof e == 'undefined' || ( e.nodeType == 3 && $.trim( e.data ).length == 0 ) )
					{
						return true;
					}
					else if ( $e.is( noty ) )
					{
						$elem.append( $e );
					}
					else if ( isTruncated )
					{
						return true;
					}
					else
					{
						$elem.append( $e );
						if ( after )
						{
							$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
						}
						if ( test( $i, o ) )
						{
							if ( e.nodeType == 3 ) // node is TEXT
							{
								isTruncated = ellipsisElement( $e, $d, $i, o, after );
							}
							else
							{
								isTruncated = ellipsis( $e, $d, $i, o, after );
							}

							if ( !isTruncated )
							{
								$e.detach();
								isTruncated = true;
							}
						}

						if ( !isTruncated )
						{
							if ( after )
							{
								after.detach();
							}
						}
					}
				}
			);

		return isTruncated;
	}
	function ellipsisElement( $e, $d, $i, o, after )
	{
		var e = $e[ 0 ];

		if ( !e )
		{
			return false;
		}

		var txt			= getTextContent( e ),
			space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
			separator	= ( o.wrap == 'letter' ) ? '' : space,
			textArr		= txt.split( separator ),
			position 	= -1,
			midPos		= -1,
			startPos	= 0,
			endPos		= textArr.length - 1;


		//	Only one word
		if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
		{
			separator	= '';
			textArr		= txt.split( separator );
			endPos		= textArr.length - 1;
		}

		while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
		{
			var m = Math.floor( ( startPos + endPos ) / 2 );
			if ( m == midPos )
			{
				break;
			}
			midPos = m;

			setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );

			if ( !test( $i, o ) )
			{
				position = midPos;
				startPos = midPos;
			}
			else
			{
				endPos = midPos;

				//	Fallback to letter
				if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
				{
					separator	= '';
					textArr		= textArr[ 0 ].split( separator );
					position	= -1;
					midPos		= -1;
					startPos	= 0;
					endPos		= textArr.length - 1;
				}
			}
		}

		if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
		{
			txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
			setTextContent( e, txt );
		}
		else
		{
			var $w = $e.parent();
			$e.detach();

			var afterLength = ( after && after.closest($w).length ) ? after.length : 0;

			if ( $w.contents().length > afterLength )
			{
				e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
			}
			else
			{
				e = findLastTextNode( $w, $d, true );
				if ( !afterLength )
				{
					$w.detach();
				}
			}
			if ( e )
			{
				txt = addEllipsis( getTextContent( e ), o );
				setTextContent( e, txt );
				if ( afterLength && after )
				{
					$(e).parent().append( after );
				}
			}
		}

		return true;
	}
	function test( $i, o )
	{
		return $i.innerHeight() > o.maxHeight;
	}
	function addEllipsis( txt, o )
	{
		while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
		{
			txt = txt.slice( 0, -1 );
		}
		if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
		{
			txt += o.ellipsis;
		}
		return txt;
	}
	function getSizes( $d )
	{
		return {
			'width'	: $d.innerWidth(),
			'height': $d.innerHeight()
		};
	}
	function setTextContent( e, content )
	{
		if ( e.innerText )
		{
			e.innerText = content;
		}
		else if ( e.nodeValue )
		{
			e.nodeValue = content;
		}
		else if (e.textContent)
		{
			e.textContent = content;
		}

	}
	function getTextContent( e )
	{
		if ( e.innerText )
		{
			return e.innerText;
		}
		else if ( e.nodeValue )
		{
			return e.nodeValue;
		}
		else if ( e.textContent )
		{
			return e.textContent;
		}
		else
		{
			return "";
		}
	}
	function getPrevNode( n )
	{
		do
		{
			n = n.previousSibling;
		}
		while ( n && n.nodeType !== 1 && n.nodeType !== 3 );

		return n;
	}
	function findLastTextNode( $el, $top, excludeCurrent )
	{
		var e = $el && $el[ 0 ], p;
		if ( e )
		{
			if ( !excludeCurrent )
			{
				if ( e.nodeType === 3 )
				{
					return e;
				}
				if ( $.trim( $el.text() ) )
				{
					return findLastTextNode( $el.contents().last(), $top );
				}
			}
			p = getPrevNode( e );
			while ( !p )
			{
				$el = $el.parent();
				if ( $el.is( $top ) || !$el.length )
				{
					return false;
				}
				p = getPrevNode( $el[0] );
			}
			if ( p )
			{
				return findLastTextNode( $(p), $top );
			}
		}
		return false;
	}
	function getElement( e, $i )
	{
		if ( !e )
		{
			return false;
		}
		if ( typeof e === 'string' )
		{
			e = $(e, $i);
			return ( e.length )
				? e
				: false;
		}
		return !e.jquery
			? false
			: e;
	}
	function getTrueInnerHeight( $el )
	{
		var h = $el.innerHeight(),
			a = [ 'paddingTop', 'paddingBottom' ];

		for ( var z = 0, l = a.length; z < l; z++ )
		{
			var m = parseInt( $el.css( a[ z ] ), 10 );
			if ( isNaN( m ) )
			{
				m = 0;
			}
			h -= m;
		}
		return h;
	}


	//	override jQuery.html
	var _orgHtml = $.fn.html;
	$.fn.html = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			return this.trigger( 'update', [ str ] );
		}
		return _orgHtml.apply( this, arguments );
	};


	//	override jQuery.text
	var _orgText = $.fn.text;
	$.fn.text = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			str = $( '<div />' ).text( str ).html();
			return this.trigger( 'update', [ str ] );
		}
		return _orgText.apply( this, arguments );
	};


})( jQuery );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2248:
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var $, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlashAndSpace, hasTextSelected, luhnCheck, reFormatCVC, reFormatCardNumber, reFormatExpiry, reFormatNumeric, replaceFullWidthChars, restrictCVC, restrictCardNumber, restrictExpiry, restrictNumeric, safeVal, setCardType,
    __slice = [].slice,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  $ = window.jQuery || window.Zepto || window.$;

  $.payment = {};

  $.payment.fn = {};

  $.fn.payment = function() {
    var args, method;
    method = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    return $.payment.fn[method].apply(this, args);
  };

  defaultFormat = /(\d{1,4})/g;

  $.payment.cards = cards = [
    {
      type: 'maestro',
      patterns: [5018, 502, 503, 506, 56, 58, 639, 6220, 67],
      format: defaultFormat,
      length: [12, 13, 14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'forbrugsforeningen',
      patterns: [600],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'dankort',
      patterns: [5019],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'visa',
      patterns: [4],
      format: defaultFormat,
      length: [13, 16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'mastercard',
      patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'amex',
      patterns: [34, 37],
      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
      length: [15],
      cvcLength: [3, 4],
      luhn: true
    }, {
      type: 'dinersclub',
      patterns: [30, 36, 38, 39],
      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
      length: [14],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'discover',
      patterns: [60, 64, 65, 622],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'unionpay',
      patterns: [62, 88],
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: false
    }, {
      type: 'jcb',
      patterns: [35],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }
  ];

  cardFromNumber = function(num) {
    var card, p, pattern, _i, _j, _len, _len1, _ref;
    num = (num + '').replace(/\D/g, '');
    for (_i = 0, _len = cards.length; _i < _len; _i++) {
      card = cards[_i];
      _ref = card.patterns;
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        pattern = _ref[_j];
        p = pattern + '';
        if (num.substr(0, p.length) === p) {
          return card;
        }
      }
    }
  };

  cardFromType = function(type) {
    var card, _i, _len;
    for (_i = 0, _len = cards.length; _i < _len; _i++) {
      card = cards[_i];
      if (card.type === type) {
        return card;
      }
    }
  };

  luhnCheck = function(num) {
    var digit, digits, odd, sum, _i, _len;
    odd = true;
    sum = 0;
    digits = (num + '').split('').reverse();
    for (_i = 0, _len = digits.length; _i < _len; _i++) {
      digit = digits[_i];
      digit = parseInt(digit, 10);
      if ((odd = !odd)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  };

  hasTextSelected = function($target) {
    var _ref;
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
      return true;
    }
    if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
      if (document.selection.createRange().text) {
        return true;
      }
    }
    return false;
  };

  safeVal = function(value, $target) {
    var currPair, cursor, digit, error, last, prevPair;
    try {
      cursor = $target.prop('selectionStart');
    } catch (_error) {
      error = _error;
      cursor = null;
    }
    last = $target.val();
    $target.val(value);
    if (cursor !== null && $target.is(":focus")) {
      if (cursor === last.length) {
        cursor = value.length;
      }
      if (last !== value) {
        prevPair = last.slice(cursor - 1, +cursor + 1 || 9e9);
        currPair = value.slice(cursor - 1, +cursor + 1 || 9e9);
        digit = value[cursor];
        if (/\d/.test(digit) && prevPair === ("" + digit + " ") && currPair === (" " + digit)) {
          cursor = cursor + 1;
        }
      }
      $target.prop('selectionStart', cursor);
      return $target.prop('selectionEnd', cursor);
    }
  };

  replaceFullWidthChars = function(str) {
    var chars, chr, fullWidth, halfWidth, idx, value, _i, _len;
    if (str == null) {
      str = '';
    }
    fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
    halfWidth = '0123456789';
    value = '';
    chars = str.split('');
    for (_i = 0, _len = chars.length; _i < _len; _i++) {
      chr = chars[_i];
      idx = fullWidth.indexOf(chr);
      if (idx > -1) {
        chr = halfWidth[idx];
      }
      value += chr;
    }
    return value;
  };

  reFormatNumeric = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = value.replace(/\D/g, '');
      return safeVal(value, $target);
    });
  };

  reFormatCardNumber = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = $.payment.formatCardNumber(value);
      return safeVal(value, $target);
    });
  };

  formatCardNumber = function(e) {
    var $target, card, digit, length, re, upperLength, value;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    value = $target.val();
    card = cardFromNumber(value + digit);
    length = (value.replace(/\D/g, '') + digit).length;
    upperLength = 16;
    if (card) {
      upperLength = card.length[card.length.length - 1];
    }
    if (length >= upperLength) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (card && card.type === 'amex') {
      re = /^(\d{4}|\d{4}\s\d{6})$/;
    } else {
      re = /(?:^|\s)(\d{4})$/;
    }
    if (re.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value + ' ' + digit);
      });
    } else if (re.test(value + digit)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value + digit + ' ');
      });
    }
  };

  formatBackCardNumber = function(e) {
    var $target, value;
    $target = $(e.currentTarget);
    value = $target.val();
    if (e.which !== 8) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (/\d\s$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d\s$/, ''));
      });
    } else if (/\s\d?$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d$/, ''));
      });
    }
  };

  reFormatExpiry = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = $.payment.formatExpiry(value);
      return safeVal(value, $target);
    });
  };

  formatExpiry = function(e) {
    var $target, digit, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val() + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val("0" + val + " / ");
      });
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      return setTimeout(function() {
        var m1, m2;
        m1 = parseInt(val[0], 10);
        m2 = parseInt(val[1], 10);
        if (m2 > 2 && m1 !== 0) {
          return $target.val("0" + m1 + " / " + m2);
        } else {
          return $target.val("" + val + " / ");
        }
      });
    }
  };

  formatForwardExpiry = function(e) {
    var $target, digit, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val();
    if (/^\d\d$/.test(val)) {
      return $target.val("" + val + " / ");
    }
  };

  formatForwardSlashAndSpace = function(e) {
    var $target, val, which;
    which = String.fromCharCode(e.which);
    if (!(which === '/' || which === ' ')) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val();
    if (/^\d$/.test(val) && val !== '0') {
      return $target.val("0" + val + " / ");
    }
  };

  formatBackExpiry = function(e) {
    var $target, value;
    $target = $(e.currentTarget);
    value = $target.val();
    if (e.which !== 8) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (/\d\s\/\s$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d\s\/\s$/, ''));
      });
    }
  };

  reFormatCVC = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = value.replace(/\D/g, '').slice(0, 4);
      return safeVal(value, $target);
    });
  };

  restrictNumeric = function(e) {
    var input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  };

  restrictCardNumber = function(e) {
    var $target, card, digit, value;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    value = ($target.val() + digit).replace(/\D/g, '');
    card = cardFromNumber(value);
    if (card) {
      return value.length <= card.length[card.length.length - 1];
    } else {
      return value.length <= 16;
    }
  };

  restrictExpiry = function(e) {
    var $target, digit, value;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    value = $target.val() + digit;
    value = value.replace(/\D/g, '');
    if (value.length > 6) {
      return false;
    }
  };

  restrictCVC = function(e) {
    var $target, digit, val;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    val = $target.val() + digit;
    return val.length <= 4;
  };

  setCardType = function(e) {
    var $target, allTypes, card, cardType, val;
    $target = $(e.currentTarget);
    val = $target.val();
    cardType = $.payment.cardType(val) || 'unknown';
    if (!$target.hasClass(cardType)) {
      allTypes = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
          card = cards[_i];
          _results.push(card.type);
        }
        return _results;
      })();
      $target.removeClass('unknown');
      $target.removeClass(allTypes.join(' '));
      $target.addClass(cardType);
      $target.toggleClass('identified', cardType !== 'unknown');
      return $target.trigger('payment.cardType', cardType);
    }
  };

  $.payment.fn.formatCardCVC = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictCVC);
    this.on('paste', reFormatCVC);
    this.on('change', reFormatCVC);
    this.on('input', reFormatCVC);
    return this;
  };

  $.payment.fn.formatCardExpiry = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictExpiry);
    this.on('keypress', formatExpiry);
    this.on('keypress', formatForwardSlashAndSpace);
    this.on('keypress', formatForwardExpiry);
    this.on('keydown', formatBackExpiry);
    this.on('change', reFormatExpiry);
    this.on('input', reFormatExpiry);
    return this;
  };

  $.payment.fn.formatCardNumber = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictCardNumber);
    this.on('keypress', formatCardNumber);
    this.on('keydown', formatBackCardNumber);
    this.on('keyup', setCardType);
    this.on('paste', reFormatCardNumber);
    this.on('change', reFormatCardNumber);
    this.on('input', reFormatCardNumber);
    this.on('input', setCardType);
    return this;
  };

  $.payment.fn.restrictNumeric = function() {
    this.on('keypress', restrictNumeric);
    this.on('paste', reFormatNumeric);
    this.on('change', reFormatNumeric);
    this.on('input', reFormatNumeric);
    return this;
  };

  $.payment.fn.cardExpiryVal = function() {
    return $.payment.cardExpiryVal($(this).val());
  };

  $.payment.cardExpiryVal = function(value) {
    var month, prefix, year, _ref;
    _ref = value.split(/[\s\/]+/, 2), month = _ref[0], year = _ref[1];
    if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
      prefix = (new Date).getFullYear();
      prefix = prefix.toString().slice(0, 2);
      year = prefix + year;
    }
    month = parseInt(month, 10);
    year = parseInt(year, 10);
    return {
      month: month,
      year: year
    };
  };

  $.payment.validateCardNumber = function(num) {
    var card, _ref;
    num = (num + '').replace(/\s+|-/g, '');
    if (!/^\d+$/.test(num)) {
      return false;
    }
    card = cardFromNumber(num);
    if (!card) {
      return false;
    }
    return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
  };

  $.payment.validateCardExpiry = function(month, year) {
    var currentTime, expiry, _ref;
    if (typeof month === 'object' && 'month' in month) {
      _ref = month, month = _ref.month, year = _ref.year;
    }
    if (!(month && year)) {
      return false;
    }
    month = $.trim(month);
    year = $.trim(year);
    if (!/^\d+$/.test(month)) {
      return false;
    }
    if (!/^\d+$/.test(year)) {
      return false;
    }
    if (!((1 <= month && month <= 12))) {
      return false;
    }
    if (year.length === 2) {
      if (year < 70) {
        year = "20" + year;
      } else {
        year = "19" + year;
      }
    }
    if (year.length !== 4) {
      return false;
    }
    expiry = new Date(year, month);
    currentTime = new Date;
    expiry.setMonth(expiry.getMonth() - 1);
    expiry.setMonth(expiry.getMonth() + 1, 1);
    return expiry > currentTime;
  };

  $.payment.validateCardCVC = function(cvc, type) {
    var card, _ref;
    cvc = $.trim(cvc);
    if (!/^\d+$/.test(cvc)) {
      return false;
    }
    card = cardFromType(type);
    if (card != null) {
      return _ref = cvc.length, __indexOf.call(card.cvcLength, _ref) >= 0;
    } else {
      return cvc.length >= 3 && cvc.length <= 4;
    }
  };

  $.payment.cardType = function(num) {
    var _ref;
    if (!num) {
      return null;
    }
    return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
  };

  $.payment.formatCardNumber = function(num) {
    var card, groups, upperLength, _ref;
    num = num.replace(/\D/g, '');
    card = cardFromNumber(num);
    if (!card) {
      return num;
    }
    upperLength = card.length[card.length.length - 1];
    num = num.slice(0, upperLength);
    if (card.format.global) {
      return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
    } else {
      groups = card.format.exec(num);
      if (groups == null) {
        return;
      }
      groups.shift();
      groups = $.grep(groups, function(n) {
        return n;
      });
      return groups.join(' ');
    }
  };

  $.payment.formatExpiry = function(expiry) {
    var mon, parts, sep, year;
    parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
    if (!parts) {
      return '';
    }
    mon = parts[1] || '';
    sep = parts[2] || '';
    year = parts[3] || '';
    if (year.length > 0) {
      sep = ' / ';
    } else if (sep === ' /') {
      mon = mon.substring(0, 1);
      sep = '';
    } else if (mon.length === 2 || sep.length > 0) {
      sep = ' / ';
    } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
      mon = "0" + mon;
      sep = ' / ';
    }
    return mon + sep + year;
  };

}).call(this);


/***/ }),

/***/ 2249:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * Mailcheck https://github.com/mailcheck/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * Released under the MIT License.
 *
 * v 1.1.0
 */

var Mailcheck = {
  domainThreshold: 4,
  topLevelThreshold: 3,

  defaultDomains: ["yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com",
    "live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk",
    "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "mail.com", "outlook.com", "icloud.com"],

  defaultTopLevelDomains: ["co.jp", "co.uk", "com", "net", "org", "info", "edu", "gov", "mil", "ca"],

  run: function(opts) {
    opts.domains = opts.domains || Mailcheck.defaultDomains;
    opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
    opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;

    var defaultCallback = function(result){ return result };
    var suggestedCallback = opts.suggested || defaultCallback;
    var emptyCallback = opts.empty || defaultCallback;

    var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.topLevelDomains, opts.distanceFunction);

    return result ? suggestedCallback(result) : emptyCallback()
  },

  suggest: function(email, domains, topLevelDomains, distanceFunction) {
    email = email.toLowerCase();

    var emailParts = this.splitEmail(email);

    var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

    if (closestDomain) {
      if (closestDomain != emailParts.domain) {
        // The email address closely matches one of the supplied domains; return a suggestion
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    } else {
      // The email address does not closely match one of the supplied domains
      var closestTopLevelDomain = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);
      if (emailParts.domain && closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
        // The email address may have a mispelled top-level domain; return a suggestion
        var domain = emailParts.domain;
        closestDomain = domain.substring(0, domain.lastIndexOf(emailParts.topLevelDomain)) + closestTopLevelDomain;
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    }
    /* The email address exactly matches one of the supplied domains, does not closely
     * match any domain and does not appear to simply have a mispelled top-level domain,
     * or is an invalid email address; do not return a suggestion.
     */
    return false;
  },

  findClosestDomain: function(domain, domains, distanceFunction, threshold) {
    threshold = threshold || this.topLevelThreshold;
    var dist;
    var minDist = 99;
    var closestDomain = null;

    if (!domain || !domains) {
      return false;
    }
    if(!distanceFunction) {
      distanceFunction = this.sift3Distance;
    }

    for (var i = 0; i < domains.length; i++) {
      if (domain === domains[i]) {
        return domain;
      }
      dist = distanceFunction(domain, domains[i]);
      if (dist < minDist) {
        minDist = dist;
        closestDomain = domains[i];
      }
    }

    if (minDist <= threshold && closestDomain !== null) {
      return closestDomain;
    } else {
      return false;
    }
  },

  sift3Distance: function(s1, s2) {
    // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
    if (s1 == null || s1.length === 0) {
      if (s2 == null || s2.length === 0) {
        return 0;
      } else {
        return s2.length;
      }
    }

    if (s2 == null || s2.length === 0) {
      return s1.length;
    }

    var c = 0;
    var offset1 = 0;
    var offset2 = 0;
    var lcs = 0;
    var maxOffset = 5;

    while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
      if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
        lcs++;
      } else {
        offset1 = 0;
        offset2 = 0;
        for (var i = 0; i < maxOffset; i++) {
          if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
            offset1 = i;
            break;
          }
          if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
            offset2 = i;
            break;
          }
        }
      }
      c++;
    }
    return (s1.length + s2.length) /2 - lcs;
  },

  splitEmail: function(email) {
    var parts = email.trim().split('@');

    if (parts.length < 2) {
      return false;
    }

    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === '') {
        return false;
      }
    }

    var domain = parts.pop();
    var domainParts = domain.split('.');
    var tld = '';

    if (domainParts.length == 0) {
      // The address does not have a top-level domain
      return false;
    } else if (domainParts.length == 1) {
      // The address has only a top-level domain (valid under RFC)
      tld = domainParts[0];
    } else {
      // The address has a domain and a top-level domain
      for (var i = 1; i < domainParts.length; i++) {
        tld += domainParts[i] + '.';
      }
      if (domainParts.length >= 2) {
        tld = tld.substring(0, tld.length - 1);
      }
    }

    return {
      topLevelDomain: tld,
      domain: domain,
      address: parts.join('@')
    }
  },

  // Encode the email address to prevent XSS but leave in valid
  // characters, following this official spec:
  // http://en.wikipedia.org/wiki/Email_address#Syntax
  encodeEmail: function(email) {
    var result = encodeURI(email);
    result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
                   .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
                   .replace('%7D', '}');
    return result;
  }
};

// Export the mailcheck object if we're in a CommonJS env (e.g. Node).
// Modeled off of Underscore.js.
if (typeof module !== 'undefined' && module.exports) {
    module.exports = Mailcheck;
}

if (typeof window !== 'undefined' && window.jQuery) {
  (function($){
    $.fn.mailcheck = function(opts) {
      var self = this;
      if (opts.suggested) {
        var oldSuggested = opts.suggested;
        opts.suggested = function(result) {
          oldSuggested(self, result);
        };
      }

      if (opts.empty) {
        var oldEmpty = opts.empty;
        opts.empty = function() {
          oldEmpty.call(null, self);
        };
      }

      opts.email = this.val();
      Mailcheck.run(opts);
    }
  })(jQuery);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2250:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2014 Rico Sta. Cruz
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */

/* jshint expr: true */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(187)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    factory(root.jQuery);
  }

}(this, function($) {

  $.transit = {
    version: "0.9.12",

    // Map of $.css() keys to values for 'transitionProperty'.
    // See https://developer.mozilla.org/en/CSS/CSS_transitions#Properties_that_can_be_animated
    propertyMap: {
      marginLeft    : 'margin',
      marginRight   : 'margin',
      marginBottom  : 'margin',
      marginTop     : 'margin',
      paddingLeft   : 'padding',
      paddingRight  : 'padding',
      paddingBottom : 'padding',
      paddingTop    : 'padding'
    },

    // Will simply transition "instantly" if false
    enabled: true,

    // Set this to false if you don't want to use the transition end property.
    useTransitionEnd: false
  };

  var div = document.createElement('div');
  var support = {};

  // Helper function to get the proper vendor property name.
  // (`transition` => `WebkitTransition`)
  function getVendorPropertyName(prop) {
    // Handle unprefixed versions (FF16+, for example)
    if (prop in div.style) return prop;

    var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
    var prop_ = prop.charAt(0).toUpperCase() + prop.substr(1);

    for (var i=0; i<prefixes.length; ++i) {
      var vendorProp = prefixes[i] + prop_;
      if (vendorProp in div.style) { return vendorProp; }
    }
  }

  // Helper function to check if transform3D is supported.
  // Should return true for Webkits and Firefox 10+.
  function checkTransform3dSupport() {
    div.style[support.transform] = '';
    div.style[support.transform] = 'rotateY(90deg)';
    return div.style[support.transform] !== '';
  }

  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

  // Check for the browser's transitions support.
  support.transition      = getVendorPropertyName('transition');
  support.transitionDelay = getVendorPropertyName('transitionDelay');
  support.transform       = getVendorPropertyName('transform');
  support.transformOrigin = getVendorPropertyName('transformOrigin');
  support.filter          = getVendorPropertyName('Filter');
  support.transform3d     = checkTransform3dSupport();

  var eventNames = {
    'transition':       'transitionend',
    'MozTransition':    'transitionend',
    'OTransition':      'oTransitionEnd',
    'WebkitTransition': 'webkitTransitionEnd',
    'msTransition':     'MSTransitionEnd'
  };

  // Detect the 'transitionend' event needed.
  var transitionEnd = support.transitionEnd = eventNames[support.transition] || null;

  // Populate jQuery's `$.support` with the vendor prefixes we know.
  // As per [jQuery's cssHooks documentation](http://api.jquery.com/jQuery.cssHooks/),
  // we set $.support.transition to a string of the actual property name used.
  for (var key in support) {
    if (support.hasOwnProperty(key) && typeof $.support[key] === 'undefined') {
      $.support[key] = support[key];
    }
  }

  // Avoid memory leak in IE.
  div = null;

  // ## $.cssEase
  // List of easing aliases that you can use with `$.fn.transition`.
  $.cssEase = {
    '_default':       'ease',
    'in':             'ease-in',
    'out':            'ease-out',
    'in-out':         'ease-in-out',
    'snap':           'cubic-bezier(0,1,.5,1)',
    // Penner equations
    'easeInCubic':    'cubic-bezier(.550,.055,.675,.190)',
    'easeOutCubic':   'cubic-bezier(.215,.61,.355,1)',
    'easeInOutCubic': 'cubic-bezier(.645,.045,.355,1)',
    'easeInCirc':     'cubic-bezier(.6,.04,.98,.335)',
    'easeOutCirc':    'cubic-bezier(.075,.82,.165,1)',
    'easeInOutCirc':  'cubic-bezier(.785,.135,.15,.86)',
    'easeInExpo':     'cubic-bezier(.95,.05,.795,.035)',
    'easeOutExpo':    'cubic-bezier(.19,1,.22,1)',
    'easeInOutExpo':  'cubic-bezier(1,0,0,1)',
    'easeInQuad':     'cubic-bezier(.55,.085,.68,.53)',
    'easeOutQuad':    'cubic-bezier(.25,.46,.45,.94)',
    'easeInOutQuad':  'cubic-bezier(.455,.03,.515,.955)',
    'easeInQuart':    'cubic-bezier(.895,.03,.685,.22)',
    'easeOutQuart':   'cubic-bezier(.165,.84,.44,1)',
    'easeInOutQuart': 'cubic-bezier(.77,0,.175,1)',
    'easeInQuint':    'cubic-bezier(.755,.05,.855,.06)',
    'easeOutQuint':   'cubic-bezier(.23,1,.32,1)',
    'easeInOutQuint': 'cubic-bezier(.86,0,.07,1)',
    'easeInSine':     'cubic-bezier(.47,0,.745,.715)',
    'easeOutSine':    'cubic-bezier(.39,.575,.565,1)',
    'easeInOutSine':  'cubic-bezier(.445,.05,.55,.95)',
    'easeInBack':     'cubic-bezier(.6,-.28,.735,.045)',
    'easeOutBack':    'cubic-bezier(.175, .885,.32,1.275)',
    'easeInOutBack':  'cubic-bezier(.68,-.55,.265,1.55)'
  };

  // ## 'transform' CSS hook
  // Allows you to use the `transform` property in CSS.
  //
  //     $("#hello").css({ transform: "rotate(90deg)" });
  //
  //     $("#hello").css('transform');
  //     //=> { rotate: '90deg' }
  //
  $.cssHooks['transit:transform'] = {
    // The getter returns a `Transform` object.
    get: function(elem) {
      return $(elem).data('transform') || new Transform();
    },

    // The setter accepts a `Transform` object or a string.
    set: function(elem, v) {
      var value = v;

      if (!(value instanceof Transform)) {
        value = new Transform(value);
      }

      // We've seen the 3D version of Scale() not work in Chrome when the
      // element being scaled extends outside of the viewport.  Thus, we're
      // forcing Chrome to not use the 3d transforms as well.  Not sure if
      // translate is affectede, but not risking it.  Detection code from
      // http://davidwalsh.name/detecting-google-chrome-javascript
      if (support.transform === 'WebkitTransform' && !isChrome) {
        elem.style[support.transform] = value.toString(true);
      } else {
        elem.style[support.transform] = value.toString();
      }

      $(elem).data('transform', value);
    }
  };

  // Add a CSS hook for `.css({ transform: '...' })`.
  // In jQuery 1.8+, this will intentionally override the default `transform`
  // CSS hook so it'll play well with Transit. (see issue #62)
  $.cssHooks.transform = {
    set: $.cssHooks['transit:transform'].set
  };

  // ## 'filter' CSS hook
  // Allows you to use the `filter` property in CSS.
  //
  //     $("#hello").css({ filter: 'blur(10px)' });
  //
  $.cssHooks.filter = {
    get: function(elem) {
      return elem.style[support.filter];
    },
    set: function(elem, value) {
      elem.style[support.filter] = value;
    }
  };

  // jQuery 1.8+ supports prefix-free transitions, so these polyfills will not
  // be necessary.
  if ($.fn.jquery < "1.8") {
    // ## 'transformOrigin' CSS hook
    // Allows the use for `transformOrigin` to define where scaling and rotation
    // is pivoted.
    //
    //     $("#hello").css({ transformOrigin: '0 0' });
    //
    $.cssHooks.transformOrigin = {
      get: function(elem) {
        return elem.style[support.transformOrigin];
      },
      set: function(elem, value) {
        elem.style[support.transformOrigin] = value;
      }
    };

    // ## 'transition' CSS hook
    // Allows you to use the `transition` property in CSS.
    //
    //     $("#hello").css({ transition: 'all 0 ease 0' });
    //
    $.cssHooks.transition = {
      get: function(elem) {
        return elem.style[support.transition];
      },
      set: function(elem, value) {
        elem.style[support.transition] = value;
      }
    };
  }

  // ## Other CSS hooks
  // Allows you to rotate, scale and translate.
  registerCssHook('scale');
  registerCssHook('scaleX');
  registerCssHook('scaleY');
  registerCssHook('translate');
  registerCssHook('rotate');
  registerCssHook('rotateX');
  registerCssHook('rotateY');
  registerCssHook('rotate3d');
  registerCssHook('perspective');
  registerCssHook('skewX');
  registerCssHook('skewY');
  registerCssHook('x', true);
  registerCssHook('y', true);

  // ## Transform class
  // This is the main class of a transformation property that powers
  // `$.fn.css({ transform: '...' })`.
  //
  // This is, in essence, a dictionary object with key/values as `-transform`
  // properties.
  //
  //     var t = new Transform("rotate(90) scale(4)");
  //
  //     t.rotate             //=> "90deg"
  //     t.scale              //=> "4,4"
  //
  // Setters are accounted for.
  //
  //     t.set('rotate', 4)
  //     t.rotate             //=> "4deg"
  //
  // Convert it to a CSS string using the `toString()` and `toString(true)` (for WebKit)
  // functions.
  //
  //     t.toString()         //=> "rotate(90deg) scale(4,4)"
  //     t.toString(true)     //=> "rotate(90deg) scale3d(4,4,0)" (WebKit version)
  //
  function Transform(str) {
    if (typeof str === 'string') { this.parse(str); }
    return this;
  }

  Transform.prototype = {
    // ### setFromString()
    // Sets a property from a string.
    //
    //     t.setFromString('scale', '2,4');
    //     // Same as set('scale', '2', '4');
    //
    setFromString: function(prop, val) {
      var args =
        (typeof val === 'string')  ? val.split(',') :
        (val.constructor === Array) ? val :
        [ val ];

      args.unshift(prop);

      Transform.prototype.set.apply(this, args);
    },

    // ### set()
    // Sets a property.
    //
    //     t.set('scale', 2, 4);
    //
    set: function(prop) {
      var args = Array.prototype.slice.apply(arguments, [1]);
      if (this.setter[prop]) {
        this.setter[prop].apply(this, args);
      } else {
        this[prop] = args.join(',');
      }
    },

    get: function(prop) {
      if (this.getter[prop]) {
        return this.getter[prop].apply(this);
      } else {
        return this[prop] || 0;
      }
    },

    setter: {
      // ### rotate
      //
      //     .css({ rotate: 30 })
      //     .css({ rotate: "30" })
      //     .css({ rotate: "30deg" })
      //     .css({ rotate: "30deg" })
      //
      rotate: function(theta) {
        this.rotate = unit(theta, 'deg');
      },

      rotateX: function(theta) {
        this.rotateX = unit(theta, 'deg');
      },

      rotateY: function(theta) {
        this.rotateY = unit(theta, 'deg');
      },

      // ### scale
      //
      //     .css({ scale: 9 })      //=> "scale(9,9)"
      //     .css({ scale: '3,2' })  //=> "scale(3,2)"
      //
      scale: function(x, y) {
        if (y === undefined) { y = x; }
        this.scale = x + "," + y;
      },

      // ### skewX + skewY
      skewX: function(x) {
        this.skewX = unit(x, 'deg');
      },

      skewY: function(y) {
        this.skewY = unit(y, 'deg');
      },

      // ### perspectvie
      perspective: function(dist) {
        this.perspective = unit(dist, 'px');
      },

      // ### x / y
      // Translations. Notice how this keeps the other value.
      //
      //     .css({ x: 4 })       //=> "translate(4px, 0)"
      //     .css({ y: 10 })      //=> "translate(4px, 10px)"
      //
      x: function(x) {
        this.set('translate', x, null);
      },

      y: function(y) {
        this.set('translate', null, y);
      },

      // ### translate
      // Notice how this keeps the other value.
      //
      //     .css({ translate: '2, 5' })    //=> "translate(2px, 5px)"
      //
      translate: function(x, y) {
        if (this._translateX === undefined) { this._translateX = 0; }
        if (this._translateY === undefined) { this._translateY = 0; }

        if (x !== null && x !== undefined) { this._translateX = unit(x, 'px'); }
        if (y !== null && y !== undefined) { this._translateY = unit(y, 'px'); }

        this.translate = this._translateX + "," + this._translateY;
      }
    },

    getter: {
      x: function() {
        return this._translateX || 0;
      },

      y: function() {
        return this._translateY || 0;
      },

      scale: function() {
        var s = (this.scale || "1,1").split(',');
        if (s[0]) { s[0] = parseFloat(s[0]); }
        if (s[1]) { s[1] = parseFloat(s[1]); }

        // "2.5,2.5" => 2.5
        // "2.5,1" => [2.5,1]
        return (s[0] === s[1]) ? s[0] : s;
      },

      rotate3d: function() {
        var s = (this.rotate3d || "0,0,0,0deg").split(',');
        for (var i=0; i<=3; ++i) {
          if (s[i]) { s[i] = parseFloat(s[i]); }
        }
        if (s[3]) { s[3] = unit(s[3], 'deg'); }

        return s;
      }
    },

    // ### parse()
    // Parses from a string. Called on constructor.
    parse: function(str) {
      var self = this;
      str.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function(x, prop, val) {
        self.setFromString(prop, val);
      });
    },

    // ### toString()
    // Converts to a `transition` CSS property string. If `use3d` is given,
    // it converts to a `-webkit-transition` CSS property string instead.
    toString: function(use3d) {
      var re = [];

      for (var i in this) {
        if (this.hasOwnProperty(i)) {
          // Don't use 3D transformations if the browser can't support it.
          if ((!support.transform3d) && (
            (i === 'rotateX') ||
            (i === 'rotateY') ||
            (i === 'perspective') ||
            (i === 'transformOrigin'))) { continue; }

          if (i[0] !== '_') {
            if (use3d && (i === 'scale')) {
              re.push(i + "3d(" + this[i] + ",1)");
            } else if (use3d && (i === 'translate')) {
              re.push(i + "3d(" + this[i] + ",0)");
            } else {
              re.push(i + "(" + this[i] + ")");
            }
          }
        }
      }

      return re.join(" ");
    }
  };

  function callOrQueue(self, queue, fn) {
    if (queue === true) {
      self.queue(fn);
    } else if (queue) {
      self.queue(queue, fn);
    } else {
      self.each(function () {
                fn.call(this);
            });
    }
  }

  // ### getProperties(dict)
  // Returns properties (for `transition-property`) for dictionary `props`. The
  // value of `props` is what you would expect in `$.css(...)`.
  function getProperties(props) {
    var re = [];

    $.each(props, function(key) {
      key = $.camelCase(key); // Convert "text-align" => "textAlign"
      key = $.transit.propertyMap[key] || $.cssProps[key] || key;
      key = uncamel(key); // Convert back to dasherized

      // Get vendor specify propertie
      if (support[key])
        key = uncamel(support[key]);

      if ($.inArray(key, re) === -1) { re.push(key); }
    });

    return re;
  }

  // ### getTransition()
  // Returns the transition string to be used for the `transition` CSS property.
  //
  // Example:
  //
  //     getTransition({ opacity: 1, rotate: 30 }, 500, 'ease');
  //     //=> 'opacity 500ms ease, -webkit-transform 500ms ease'
  //
  function getTransition(properties, duration, easing, delay) {
    // Get the CSS properties needed.
    var props = getProperties(properties);

    // Account for aliases (`in` => `ease-in`).
    if ($.cssEase[easing]) { easing = $.cssEase[easing]; }

    // Build the duration/easing/delay attributes for it.
    var attribs = '' + toMS(duration) + ' ' + easing;
    if (parseInt(delay, 10) > 0) { attribs += ' ' + toMS(delay); }

    // For more properties, add them this way:
    // "margin 200ms ease, padding 200ms ease, ..."
    var transitions = [];
    $.each(props, function(i, name) {
      transitions.push(name + ' ' + attribs);
    });

    return transitions.join(', ');
  }

  // ## $.fn.transition
  // Works like $.fn.animate(), but uses CSS transitions.
  //
  //     $("...").transition({ opacity: 0.1, scale: 0.3 });
  //
  //     // Specific duration
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500);
  //
  //     // With duration and easing
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in');
  //
  //     // With callback
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, function() { ... });
  //
  //     // With everything
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in', function() { ... });
  //
  //     // Alternate syntax
  //     $("...").transition({
  //       opacity: 0.1,
  //       duration: 200,
  //       delay: 40,
  //       easing: 'in',
  //       complete: function() { /* ... */ }
  //      });
  //
  $.fn.transition = $.fn.transit = function(properties, duration, easing, callback) {
    var self  = this;
    var delay = 0;
    var queue = true;

    var theseProperties = $.extend(true, {}, properties);

    // Account for `.transition(properties, callback)`.
    if (typeof duration === 'function') {
      callback = duration;
      duration = undefined;
    }

    // Account for `.transition(properties, options)`.
    if (typeof duration === 'object') {
      easing = duration.easing;
      delay = duration.delay || 0;
      queue = typeof duration.queue === "undefined" ? true : duration.queue;
      callback = duration.complete;
      duration = duration.duration;
    }

    // Account for `.transition(properties, duration, callback)`.
    if (typeof easing === 'function') {
      callback = easing;
      easing = undefined;
    }

    // Alternate syntax.
    if (typeof theseProperties.easing !== 'undefined') {
      easing = theseProperties.easing;
      delete theseProperties.easing;
    }

    if (typeof theseProperties.duration !== 'undefined') {
      duration = theseProperties.duration;
      delete theseProperties.duration;
    }

    if (typeof theseProperties.complete !== 'undefined') {
      callback = theseProperties.complete;
      delete theseProperties.complete;
    }

    if (typeof theseProperties.queue !== 'undefined') {
      queue = theseProperties.queue;
      delete theseProperties.queue;
    }

    if (typeof theseProperties.delay !== 'undefined') {
      delay = theseProperties.delay;
      delete theseProperties.delay;
    }

    // Set defaults. (`400` duration, `ease` easing)
    if (typeof duration === 'undefined') { duration = $.fx.speeds._default; }
    if (typeof easing === 'undefined')   { easing = $.cssEase._default; }

    duration = toMS(duration);

    // Build the `transition` property.
    var transitionValue = getTransition(theseProperties, duration, easing, delay);

    // Compute delay until callback.
    // If this becomes 0, don't bother setting the transition property.
    var work = $.transit.enabled && support.transition;
    var i = work ? (parseInt(duration, 10) + parseInt(delay, 10)) : 0;

    // If there's nothing to do...
    if (i === 0) {
      var fn = function(next) {
        self.css(theseProperties);
        if (callback) { callback.apply(self); }
        if (next) { next(); }
      };

      callOrQueue(self, queue, fn);
      return self;
    }

    // Save the old transitions of each element so we can restore it later.
    var oldTransitions = {};

    var run = function(nextCall) {
      var bound = false;

      // Prepare the callback.
      var cb = function() {
        if (bound) { self.unbind(transitionEnd, cb); }

        if (i > 0) {
          self.each(function() {
            this.style[support.transition] = (oldTransitions[this] || null);
          });
        }

        if (typeof callback === 'function') { callback.apply(self); }
        if (typeof nextCall === 'function') { nextCall(); }
      };

      if ((i > 0) && (transitionEnd) && ($.transit.useTransitionEnd)) {
        // Use the 'transitionend' event if it's available.
        bound = true;
        self.bind(transitionEnd, cb);
      } else {
        // Fallback to timers if the 'transitionend' event isn't supported.
        window.setTimeout(cb, i);
      }

      // Apply transitions.
      self.each(function() {
        if (i > 0) {
          this.style[support.transition] = transitionValue;
        }
        $(this).css(theseProperties);
      });
    };

    // Defer running. This allows the browser to paint any pending CSS it hasn't
    // painted yet before doing the transitions.
    var deferredRun = function(next) {
        this.offsetWidth; // force a repaint
        run(next);
    };

    // Use jQuery's fx queue.
    callOrQueue(self, queue, deferredRun);

    // Chainability.
    return this;
  };

  function registerCssHook(prop, isPixels) {
    // For certain properties, the 'px' should not be implied.
    if (!isPixels) { $.cssNumber[prop] = true; }

    $.transit.propertyMap[prop] = support.transform;

    $.cssHooks[prop] = {
      get: function(elem) {
        var t = $(elem).css('transit:transform');
        return t.get(prop);
      },

      set: function(elem, value) {
        var t = $(elem).css('transit:transform');
        t.setFromString(prop, value);

        $(elem).css({ 'transit:transform': t });
      }
    };

  }

  // ### uncamel(str)
  // Converts a camelcase string to a dasherized string.
  // (`marginLeft` => `margin-left`)
  function uncamel(str) {
    return str.replace(/([A-Z])/g, function(letter) { return '-' + letter.toLowerCase(); });
  }

  // ### unit(number, unit)
  // Ensures that number `number` has a unit. If no unit is found, assume the
  // default is `unit`.
  //
  //     unit(2, 'px')          //=> "2px"
  //     unit("30deg", 'rad')   //=> "30deg"
  //
  function unit(i, units) {
    if ((typeof i === "string") && (!i.match(/^[\-0-9\.]+$/))) {
      return i;
    } else {
      return "" + i + units;
    }
  }

  // ### toMS(duration)
  // Converts given `duration` to a millisecond string.
  //
  // toMS('fast') => $.fx.speeds[i] => "200ms"
  // toMS('normal') //=> $.fx.speeds._default => "400ms"
  // toMS(10) //=> '10ms'
  // toMS('100ms') //=> '100ms'  
  //
  function toMS(duration) {
    var i = duration;

    // Allow string durations like 'fast' and 'slow', without overriding numeric values.
    if (typeof i === 'string' && (!i.match(/^[\-0-9\.]+/))) { i = $.fx.speeds[i] || $.fx.speeds._default; }

    return unit(i, 'ms');
  }

  // Export some functions for testable-ness.
  $.transit.getTransitionValue = getTransition;

  return $;
}));


/***/ }),

/***/ 2251:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function($){
  $.fn.money_field = function(opts) {
    var defaults = { width: null, symbol: '$' };
    var opts     = $.extend(defaults, opts);
    return this.each(function() {
      if(opts.width)
        $(this).css('width', opts.width + 'px');
      $(this).wrap("<div class='input-group'>").before("<span class='input-group-addon'>" + opts.symbol + "</span>");
    });
  };
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2252:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.BabySitter
// -------------------
// v0.1.10
//
// Copyright (c)2015 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.babysitter

(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(857), __webpack_require__(445)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(Backbone, _) {
      return factory(Backbone, _);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    var Backbone = require('backbone');
    var _ = require('underscore');
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  'use strict';

  var previousChildViewContainer = Backbone.ChildViewContainer;

  // BabySitter.ChildViewContainer
  // -----------------------------
  //
  // Provide a container to store, retrieve and
  // shut down child views.
  
  Backbone.ChildViewContainer = (function (Backbone, _) {
  
    // Container Constructor
    // ---------------------
  
    var Container = function(views){
      this._views = {};
      this._indexByModel = {};
      this._indexByCustom = {};
      this._updateLength();
  
      _.each(views, this.add, this);
    };
  
    // Container Methods
    // -----------------
  
    _.extend(Container.prototype, {
  
      // Add a view to this container. Stores the view
      // by `cid` and makes it searchable by the model
      // cid (and model itself). Optionally specify
      // a custom key to store an retrieve the view.
      add: function(view, customIndex){
        var viewCid = view.cid;
  
        // store the view
        this._views[viewCid] = view;
  
        // index it by model
        if (view.model){
          this._indexByModel[view.model.cid] = viewCid;
        }
  
        // index by custom
        if (customIndex){
          this._indexByCustom[customIndex] = viewCid;
        }
  
        this._updateLength();
        return this;
      },
  
      // Find a view by the model that was attached to
      // it. Uses the model's `cid` to find it.
      findByModel: function(model){
        return this.findByModelCid(model.cid);
      },
  
      // Find a view by the `cid` of the model that was attached to
      // it. Uses the model's `cid` to find the view `cid` and
      // retrieve the view using it.
      findByModelCid: function(modelCid){
        var viewCid = this._indexByModel[modelCid];
        return this.findByCid(viewCid);
      },
  
      // Find a view by a custom indexer.
      findByCustom: function(index){
        var viewCid = this._indexByCustom[index];
        return this.findByCid(viewCid);
      },
  
      // Find by index. This is not guaranteed to be a
      // stable index.
      findByIndex: function(index){
        return _.values(this._views)[index];
      },
  
      // retrieve a view by its `cid` directly
      findByCid: function(cid){
        return this._views[cid];
      },
  
      // Remove a view
      remove: function(view){
        var viewCid = view.cid;
  
        // delete model index
        if (view.model){
          delete this._indexByModel[view.model.cid];
        }
  
        // delete custom index
        _.any(this._indexByCustom, function(cid, key) {
          if (cid === viewCid) {
            delete this._indexByCustom[key];
            return true;
          }
        }, this);
  
        // remove the view from the container
        delete this._views[viewCid];
  
        // update the length
        this._updateLength();
        return this;
      },
  
      // Call a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.call`.
      call: function(method){
        this.apply(method, _.tail(arguments));
      },
  
      // Apply a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.apply`.
      apply: function(method, args){
        _.each(this._views, function(view){
          if (_.isFunction(view[method])){
            view[method].apply(view, args || []);
          }
        });
      },
  
      // Update the `.length` attribute on this container
      _updateLength: function(){
        this.length = _.size(this._views);
      }
    });
  
    // Borrowing this code from Backbone.Collection:
    // http://backbonejs.org/docs/backbone.html#section-106
    //
    // Mix in methods from Underscore, for iteration, and other
    // collection related features.
    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
  
    _.each(methods, function(method) {
      Container.prototype[method] = function() {
        var views = _.values(this._views);
        var args = [views].concat(_.toArray(arguments));
        return _[method].apply(_, args);
      };
    });
  
    // return the public API
    return Container;
  })(Backbone, _);
  

  Backbone.ChildViewContainer.VERSION = '0.1.10';

  Backbone.ChildViewContainer.noConflict = function () {
    Backbone.ChildViewContainer = previousChildViewContainer;
    return this;
  };

  return Backbone.ChildViewContainer;

}));


/***/ }),

/***/ 2253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_apiUrl__ = __webpack_require__(35);






(function (Rover, $) {
  Rover.models.Image = __WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__["a" /* default */].Model.extend({
    idAttribute: 'url',
    urlRoot: Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_apiUrl__["a" /* apiUrl */])('images/'),
    defaults: {
      thumb: null,
      image: null,
      caption: null,
      index: null
    },
    url: function url() {
      if (this.isNew()) return this.urlRoot;
      return this.get('url');
    }
  });
  Rover.models.LegacyImage = __WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__["a" /* default */].Model.extend({
    defaults: {
      id: null,
      thumb: null,
      image: null,
      caption: null,
      index: null
    }
  });
  Rover.models.ImageCollection = __WEBPACK_IMPORTED_MODULE_0__rover_globals_backbone__["a" /* default */].Collection.extend({
    model: Rover.models.Image,
    initialize: function initialize(models, opts) {
      // eslint-disable-next-line no-redeclare
      var opts = opts || {};
      this.objectType = opts.objectType || null;
      this.objectOpk = opts.objectOpk || null; // Allow specifying the collection URL on instantiation

      if (opts.url) {
        this.url = opts.url;
      }

      return this;
    },
    parse: function parse(resp, options) {
      return resp.results;
    },
    create: function create(opts) {
      // eslint-disable-next-line no-redeclare
      var opts = __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].extend({
        url: this.url,
        addToCollection: true
      }, opts),
          success = opts.success,
          self = this;

      opts.success = function (model) {
        if (opts.addToCollection) self.add(model);
        if (success) success(model);
      };

      this.uploadS3Image(opts);
    },
    validateFileSize: function validateFileSize(file) {
      if (file.size >= Rover.settings.imageUploadMaxSize) {
        return "File size too large. Got ".concat(file.size, ". Maximum is ").concat(Rover.settings.imageUploadMaxSize, ".");
      }
    },
    uploadS3Image: function uploadS3Image(opts) {
      var self = this,
          // eslint-disable-next-line no-redeclare
      opts = __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].extend({
        authorizeUrl: Rover.urls.imageUploadAuthorize
      }, opts),
          $input = $('<input>').attr('type', 'file').fileupload(__WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].extend({}, opts.fileupload)),
          file = opts.file; // Handle uploading the file to the signed S3 url
      // and calling a callback on success
      // The original method's opts.error will be called
      // on error


      var uploadToS3 = function uploadToS3(file, url, cb) {
        $input.fileupload('send', {
          url: url,
          files: [file],
          type: 'PUT',
          multipart: false,
          beforeSend: function beforeSend(xhr, data) {
            xhr.setRequestHeader('Content-Type', file.type);
            xhr.setRequestHeader('Content-Disposition', 'inline');
          },
          success: function success(result, textStatus, jqXHR) {
            cb();
          },
          error: opts.error
        });
      }; // 1. Get a signed s3 url
      // 2. Upload our file to the signed s3 url
      // 3. POST the url to our collection root url to register it
      // 4. Add the created model to this collection and fire success


      $.ajax({
        method: 'POST',
        url: opts.authorizeUrl,
        data: {
          file_name: file.name,
          content_type: file.type,
          object_type: this.objectType,
          object_opk: this.objectOpk
        },
        beforeSend: __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].bind(function (xhr) {
          var error = this.validateFileSize(file);
          if (!error) return;
          opts.error(xhr, error, '');
          return false;
        }, this),
        success: function success(authorizeData) {
          var s3Url = authorizeData.upload_url;
          uploadToS3(file, s3Url, function () {
            $.ajax({
              method: 'POST',
              url: self.url,
              data: {
                image_url: s3Url
              },
              success: function success(modelData) {
                var Model = self.model;
                var model = new Model(modelData);
                if (opts.success) opts.success(model);
              },
              error: opts.error
            });
          });
        },
        error: opts.error
      });
    }
  });
  Rover.collections.PersonImageCollection = Rover.models.ImageCollection.extend({
    url: "".concat(Rover.urls.personImageListAPI, "?page_size=2000")
  });
  Rover.collections.PetImageCollection = Rover.models.ImageCollection.extend({});
})(__WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"], __WEBPACK_IMPORTED_MODULE_2__rover_globals_jquery__["default"]);

/***/ }),

/***/ 2254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_conversation__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_requestable__ = __webpack_require__(1102);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models.RecurringBillingModel = __WEBPACK_IMPORTED_MODULE_5__models_requestable__["default"].extend({
  isRecurring: true,
  initialize: function initialize() {
    var _this = this;

    this.on('change:days change:start_date', function () {
      _this.trigger('datesChanged');
    });
  },
  getOpk: function getOpk() {
    return this.getActiveConversation().getOpk();
  },
  getActiveConversation: function getActiveConversation() {
    return new __WEBPACK_IMPORTED_MODULE_4__models_conversation__["default"](this.get('active_conversation'));
  },
  getServiceType: function getServiceType() {
    return this.getActiveConversation().getServiceType();
  },
  getRelationship: function getRelationship() {
    return this.getActiveConversation().getRelationship();
  },
  getState: function getState() {
    return this.getActiveConversation().getState();
  },
  getDatesData: function getDatesData() {
    return {
      start_date: this.get('start_date'),
      days: this.get('days')
    };
  },
  unitsAndDatesAsSentence: function unitsAndDatesAsSentence() {
    var out = '';
    var days = __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].utils.simpleSyndeticJoin(this.daysListMap(function (day) {
      return day;
    }));

    if (this.getActiveConversation().supportsNumUnitsPerDay()) {
      var numUnitsPerDay = this.getNumUnitsPerDay();
      out =
      /*i18n*/
      {
        id: "{numUnitsPerDay, plural, one {# time per day} other {# times per day}}",
        values: {
          numUnitsPerDay: numUnitsPerDay
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{out} weekly on {days}",
      values: {
        out: out,
        days: days
      }
    });
  },
  daysAsSentence: function daysAsSentence() {
    return __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].utils.simpleSyndeticJoin(this.daysListMap(function (day) {
      return day;
    }));
  },
  daysMap: function daysMap(func) {
    return __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].map(this.get('days'), func);
  },
  dayI18n: function dayI18n(day) {
    return __WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._(__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].utils.capitalizeFirstLetter(day));
  },
  daysListMap: function daysListMap(func) {
    var _this2 = this;

    return this.daysMap(function (day) {
      return _this2.dayI18n(day.day).slice(0, 3);
    });
  },
  daysList: function daysList() {
    return this.daysListMap(function (day) {
      return day.slice(0, 3);
    });
  },
  getNumUnitsPerDay: function getNumUnitsPerDay() {
    var days = this.get('days');

    if (days.length === 0) {
      return 1;
    }

    return days[0].num_units;
  },
  getPerDaySummary: function getPerDaySummary() {
    var numUnitsPerDay = this.getNumUnitsPerDay();
    var daysAsSentence = this.daysAsSentence();

    if (this.getServiceType().is_daytime_traveling) {
      var longAddOns = ['long-walk', 'long-drop-in'];
      var minuteCount = this.attributes.booking_add_ons.filter(function (sao) {
        return longAddOns.includes(sao.slug);
      }).length > 0 ? '60' : '30';
      return __WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._(
      /* i18n: {0} wil be num units per day, {1} will be num of minutes, {2} will be list of week days */
      {
        id: "{numUnitsPerDay} per day \u2022 {minuteCount} min \u2022 repeats weekly on {daysAsSentence}",
        values: {
          numUnitsPerDay: numUnitsPerDay,
          minuteCount: minuteCount,
          daysAsSentence: daysAsSentence
        }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._(
    /* i18n: {0} wil be num units per day, {1} will be list of week days */
    {
      id: "{numUnitsPerDay} per day \u2022 repeats every {daysAsSentence}",
      values: {
        numUnitsPerDay: numUnitsPerDay,
        daysAsSentence: daysAsSentence
      }
    });
  },
  saveNumUnitsPerDay: function saveNumUnitsPerDay(numUnitsPerDay, optimisticAttrUpdate) {
    var newDays = this.daysMap(function (day) {
      return {
        day: day.day,
        num_units: numUnitsPerDay
      };
    });
    return this.saveDraftPricing({
      days: newDays
    }, optimisticAttrUpdate);
  },
  shadowSave: function shadowSave(attributes) {
    var _this3 = this;

    // For some operations (i.e. create request, cancel request) the API
    // expects the client to set some model attributes to specific values,
    // call PUT, then it will return the model with updated attributes.
    //
    // There may be many Views listening to attributes on this model. If
    // we have to change one of those attributes to facilitate the the
    // specific API operation (like 'request') then some listeners may
    // be triggered even though we didn't set that attribute to a normal
    // state.
    //
    // To work around this trouble, we're creating a copy of the model
    // which includes all of that model's attributes, saving it, and
    // when that save succeeds, updating the original with the new
    // attributes.
    //
    // Alternatives to this approach include:
    // 1. Use this.set(attributes, {silent: true}) which will suppress
    //    triggers. If the subsequent save fails, however, the model
    //    could be left in an invalid state. Also, the Backbone docs
    //    say that you should probably never use {silent: True}
    // 2. Put a property on the Conversation model so that it can track
    //    when this save is in flight. All listeners on request should
    //    ignore changes while it is in flight. Once the save completes,
    //    disable the flag.
    var shadowAttributes = _objectSpread(_objectSpread({}, this.attributes), attributes);

    var shadow = new __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models.RecurringBillingModel(shadowAttributes);
    shadow.set('booking_add_ons', shadow.getActiveBookingAddOns());
    return shadow.save().then(function (data, responseStatus, xhr) {
      _this3.set(data);
    }, function (err) {
      var confirmation;
      var non_field_errors = err.responseJSON.non_field_errors || [];

      if (err.status === 409) {
        confirmation = confirm(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._('This request has been updated since you loaded this page. Press OK to see up-to-date details.'));
      } else if (err.status === 400) {
        if (non_field_errors.includes('start_date cannot be in the past')) {
          confirmation = confirm(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._('This request has a start date in the past. It will need to be changed before it can be booked.'));
        } else if (non_field_errors.includes('free bookings are not allowed')) {
          confirmation = confirm(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_translation__["default"]._('Free bookings are not allowed.'));
        }
      }

      if (confirmation) {
        location.reload();
      }
    });
  },
  getDraftPricing: function getDraftPricing(options) {
    var uri = this.get('urls').pricing;

    var request = _objectSpread({
      service: this.get('service'),
      requester: this.get('requester').url,
      pets: __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].pluck(this.get('pets'), 'url'),
      days: this.get('days'),
      start_date: this.get('start_date'),
      booking_add_ons: this.get('booking_add_ons')
    }, options);

    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].ajax({
      method: 'POST',
      url: uri,
      data: JSON.stringify(request),
      contentType: 'application/json'
    });
  },
  savePricingDataPostBooking: function savePricingDataPostBooking(data) {
    var _this4 = this;

    var requestSet = false;

    if (this.get('request') === null) {
      this.set('request', true);
      requestSet = true;
    }

    return this.savePricingData(data).fail(function (err) {
      if (requestSet) _this4.set('request', null);

      _this4.handleError(err);
    });
  }
});

/***/ }),

/***/ 2255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(17);


__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models = __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models || {};

(function () {
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models.Service = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
    idAttribute: 'url',
    initialize: function initialize(options) {
      this.url = options.url;
    }
  });
})();

__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models.ServiceModel = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  url: function url() {
    return this.instanceUrl;
  },
  initialize: function initialize(options) {
    this.instanceUrl = options.url;
  }
});

/***/ }),

/***/ 2256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'




(function () {
  function ISOFormat(dateStr) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(dateStr, [__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT, __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO]).format(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO);
  }

  __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models.DateRange = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
    defaults: {
      start_date: '',
      end_date: '',
      frequency: 'onetime'
    },
    iso_start_date: function iso_start_date() {
      var date = this.get('start_date');
      return date ? ISOFormat(date) : date;
    },
    iso_end_date: function iso_end_date() {
      var date = this.get('end_date');
      return date ? ISOFormat(date) : date;
    },
    toJSON: function toJSON() {
      var data = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.prototype.toJSON.call(this); // Make sure the end date is always greater than or equal to
      // the start date

      if (this.iso_end_date() < this.iso_start_date()) {
        data.end_date = data.start_date;
      }

      return data;
    }
  });
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models.MultiDate = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
    defaults: {
      dates: []
    },
    iso_dates: function iso_dates() {
      return __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].map(this.get('dates'), ISOFormat);
    },
    setDays: function setDays(days) {
      var dates = __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].uniq(__WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].map(days, __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bind(this._dateFromDayStr, this)));

      dates.sort();
      this.set('dates', dates);
    },
    _dateFromDayStr: function _dateFromDayStr(day) {
      // Find the moment.js day number for 'day'
      var dayNumber = __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].reduce([/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i], function (prev, current, index) {
        return day.search(current) > -1 ? index : prev;
      }, -1); // Make sure we don't return days in the past


      if (dayNumber < __WEBPACK_IMPORTED_MODULE_4_moment___default()().day()) {
        dayNumber += 7;
      }

      return __WEBPACK_IMPORTED_MODULE_4_moment___default()().day(dayNumber).format(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_SHORT);
    }
  });
})();

/***/ }),

/***/ 2257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_dataLayer__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__backbone_views_archive_modal_view__ = __webpack_require__(1697);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  var $conversation = null;
  var saveOptions = null;
  var conversationDetailUrl = null;
  var SOURCE_HEADER = __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].api.getSourceHeader(Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-book-or-archive-actions').length > 0 ? 'web/inbox-pending' : 'web/conversation-detail');

  var saveAndReload = function saveAndReload(options) {
    save(options, function () {
      location.reload(true);
    });
  };

  var saveAndStay = function saveAndStay(options) {
    save(options, showArchiveSuccessModal);
  };

  var save = function save(options, onSuccess) {
    saveOptions = options;

    if (typeof options.shouldAcceptNonSpayed !== 'undefined' || typeof options.shouldAcceptNonNeutered !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].ajax({
        url: __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].urls.serviceHostingPreferences,
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          accepts_unspayed_females: options.shouldAcceptNonSpayed,
          accepts_non_neutered_males: options.shouldAcceptNonNeutered
        }),
        success: function success() {
          archive(onSuccess);
        },
        error: onSaveError
      });
    } else {
      archive(onSuccess);
    }
  };

  var onSaveError = function onSaveError() {
    var failureModal = new __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */]({
      title: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Failure'),
      content: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Your preferences could not be updated. Please try again in a few moments.'),
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
  };

  var archive = function archive(onSuccess) {
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: saveOptions.reason ? {
          reason: saveOptions.reason
        } : null
      }),
      success: onSuccess,
      error: showArchiveErrorModal
    });
    window.archive_modal.togglePrimaryButton(false, true);
  };

  var showArchiveSuccessModal = function showArchiveSuccessModal() {
    var confirmationModal = new __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */]({
      title: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Success'),
      content: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Your conversation has been archived'),
      showFooter: true,
      cancelText: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Undo'),
      okCloses: true
    });
    confirmationModal.on('cancel', function () {
      undoArchive();
    });
    window.archive_modal.close();
    confirmationModal.open();
    toggleUndoButton(true);
  };

  var showArchiveErrorModal = function showArchiveErrorModal() {
    var failureModal = new __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */]({
      title: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Failure'),
      content: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Your conversation couldn’t be archived. Please try again in a few moments.'),
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
    toggleUndoButton(false);
  };

  var undoArchive = function undoArchive() {
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: null
      }),
      success: function success() {
        toggleUndoButton(false);
      },
      error: showArchiveUndoErrorModal
    });
  };

  var showArchiveUndoErrorModal = function showArchiveUndoErrorModal() {
    var failureModal = new __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */]({
      title: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Failure'),
      content: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Unable to undo archiving. Please try again in a few moments.'),
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
  };

  var toggleUndoButton = function toggleUndoButton(show) {
    $conversation.find('.js-archive-complete').toggle(show);
    $conversation.find('.js-move-to-archive').toggle(!show);
  };

  var showModalHandler = function showModalHandler(modalArgs) {
    return function (event) {
      var archiveConversationBtn = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(event.currentTarget);
      $conversation = archiveConversationBtn.closest('.js-conversation-container');
      var currentOpk = $conversation.attr('data-opk');
      conversationDetailUrl = $conversation.data('conversation-detail-url');

      var eventData = __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].extend({}, {
        event: archiveConversationBtn.data('event')
      }, archiveConversationBtn.data('event-merge'));

      __WEBPACK_IMPORTED_MODULE_3__rover_globals_dataLayer__["a" /* default */].push(eventData);
      window.archive_modal = new __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].views.ArchiveModalView(_objectSpread({
        title: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Archive this request'),
        content: Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-archive-modal'),
        showFooter: true,
        cancelText: null,
        okText: __WEBPACK_IMPORTED_MODULE_4__rover_utilities_translation__["default"]._('Save'),
        conversationDetailUrl: conversationDetailUrl
      }, modalArgs));
      window.archive_modal.open();
    };
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-cta-archive-conversation').on('click', showModalHandler({
    okIcon: 'fr-spin rover-icon rover-icon-in-spinner archive-modal-loading-icon',
    onSave: saveAndReload,
    okCloses: false
  }));
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-move-to-archive').on('click', showModalHandler({
    okCloses: true,
    onSave: saveAndStay
  }));
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-undoarchive').on('click', function () {
    undoArchive();
  });
});

/***/ }),

/***/ 2258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backbone_views_contact_backups_modal_view__ = __webpack_require__(2259);



$(function () {
  var $conversation = null;
  var inquiryTierUrl = null;
  var SOURCE_HEADER = Rover.api.getSourceHeader('web/conversation-detail');

  var showContactBackupsErrorModal = function showContactBackupsErrorModal() {
    var failureModal = new __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__["a" /* default */]({
      title: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Failure'),
      content: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Your backups could not be contacted. Please try again in a few moments.'),
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
    window.contact_backups_modal.close();
  };

  var successHandler = function successHandler() {
    window.contact_backups_modal.close();
    window.location.reload();
  };

  var save = function save() {
    $.ajax({
      url: inquiryTierUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        status: 'active'
      }),
      success: successHandler,
      error: showContactBackupsErrorModal
    });
    window.contact_backups_modal.togglePrimaryButton();
  };

  $('.js-cta-contact-backups-now').on('click', function (event) {
    $conversation = $(this).closest('.js-conversation-container');
    inquiryTierUrl = $conversation.data('inquiry-next-tier-url');
    var contactBackupsText = $conversation.data('inquiry-contact-backups-text');
    window.contact_backups_modal = new Rover.views.ContactBackupsModal({
      title: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Contact backups now'),
      content: contactBackupsText,
      showFooter: true,
      okCloses: false,
      okIcon: 'fr-spin rover-icon rover-icon-in-spinner archive-modal-loading-icon',
      okText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Send'),
      inquiryTierUrl: inquiryTierUrl,
      onSave: save
    });
    window.contact_backups_modal.open();
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(187)))

/***/ }),

/***/ 2259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__ = __webpack_require__(322);


__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].views.ContactBackupsModal = __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__["a" /* default */].extend({
  initialize: function initialize(options) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__["a" /* default */].prototype.initialize.call(this, options); // super()

    _.bindAll(this, 'togglePrimaryButton');

    this.$el.find('.js-modal-primary-action').click(function () {
      return _this.options.onSave();
    });
  },
  togglePrimaryButton: function togglePrimaryButton() {
    var selector = this.$el.find('.js-modal-primary-action');
    selector.attr('disabled', 'true');
    selector.children('i').toggleClass('hidden');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(445)))

/***/ }),

/***/ 2260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__ = __webpack_require__(322);


Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('a.sadsal_terms-and-conditions-link').on('click', function () {
    new __WEBPACK_IMPORTED_MODULE_1__components_rover_modal__["a" /* default */]({
      title: 'Terms & Conditions',
      content: '<p>If you choose to donate, the percentage you specify will be deducted from your earnings on each booking you complete. You’ll see this come through as part of Rover’s take rate. Rover will then make the donation on your behalf.</p>' + '<p>You won’t be taxed for making donations. Your 1099 income will be less the amount you’ve donated.</p>' + '<p>Donations made through Sit a Dog, Save a Life are not tax deductible because they are not included in your reported income.</p>',
      showFooter: false,
      cancelText: null,
      okText: null,
      applyScrollFix: false
    }).open();
  });
});

/***/ }),

/***/ 2261:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function ($) {
  $.fn.serializeObject = function () {
    var obj = {};
    var data = this.serializeArray();
    $.each(data, function () {
      if (obj.hasOwnProperty(this.name)) {
        if (!obj[this.name].push) {
          obj[this.name] = [obj[this.name]];
        }

        obj[this.name].push(this.value || '');
      } else {
        obj[this.name] = this.value || '';
      }
    });
    return obj;
  };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2262:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(function () {
  var toggleVisible = function toggleVisible(e) {
    var $currentTarget = $(e.currentTarget),
        toggleOff = $currentTarget.attr('data-toggle-off'),
        toggleOn = $currentTarget.attr('data-toggle-on'),
        $toggleOff = $(toggleOff),
        $toggleOn = $(toggleOn),
        fadedIn = false;

    var showToggleOnElts = function showToggleOnElts() {
      // because the callback is called for each element hidden, we
      // need to keep track and only toggle once
      if (!fadedIn) {
        fadedIn = true;

        if (!$toggleOn.is(':visible')) {
          $toggleOn.hide().removeClass('hide').fadeIn('fast');
        }

        $(window).trigger('toggle-fired', {
          on: toggleOn,
          off: toggleOff
        });
      }
    };

    if ($toggleOff.length) {
      $toggleOff.fadeOut('fast', function () {
        $(this).addClass('hide');
        showToggleOnElts();
      });
    } else {
      showToggleOnElts();
    }
  };

  $('.js-toggle').on('click', toggleVisible);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),

/***/ 2263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);

Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  var handleCookieableClick = function handleCookieableClick() {
    var $elt = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this),
        cookieName = $elt.attr('data-cookieable-name'),
        expires = parseInt($elt.attr('data-cookieable-expires'), 10) || 7;

    if (cookieName) {
      __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].cookie(cookieName, true, {
        expires: expires,
        path: '/'
      });
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('body').on('click', '.js-cookieable', handleCookieableClick);
});

/***/ }),

/***/ 2264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_embedded__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_modal__ = __webpack_require__(322);





(function (document) {
  function getModalContent(conversation) {
    if (!conversation || !conversation.blocking_modal) {
      var d = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].Deferred();
      d.reject();
      return d.promise();
    }

    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].get(conversation.blocking_modal.web_url);
  }

  function showModal(modalContent) {
    var backboneModal = new __WEBPACK_IMPORTED_MODULE_3__rover_modal__["a" /* default */]({
      content: modalContent,
      disableCancel: true,
      animate: true,
      padding: false,
      showFooter: false
    });
    backboneModal.open(); // and then wait for the acknowledgement

    var d = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].Deferred();
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('safety-dialog-acknowledged', function () {
      backboneModal.close();
      d.resolve();
    });
    return d.promise();
  }
  /*
        Returns a Promise which will be fulfilled if the dialog is completed
        or will be rejected if the dialog is not needed or if anything fails.
    */


  function handleSafetyDialog(conversationUri) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].get(conversationUri).then(getModalContent).then(showModal);
  }

  function doSafetyAdvisory(conversation) {
    return getModalContent(conversation).then(showModal);
  }

  function triggerSafetyDialogAcknowledged() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).trigger('safety-dialog-acknowledged');
    Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_embedded__["closeDialog"])();
  }

  function acknowledgeSafetyForm($target) {
    var payload = $target.serialize();
    var uri = $target.attr('action');
    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].post(uri, payload).always(triggerSafetyDialogAcknowledged);
  } // Enable button for embedded mobile only after document ready to prohibit exposing DRF on safety acknowledgement POST


  function enableSafetyButton() {
    var safetyAckBtn = document.getElementById('safety-ack-btn');

    if (safetyAckBtn) {
      safetyAckBtn.removeAttribute('disabled');
    }
  }

  function init() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('submit', '#safety-acknowledgement-form', function (event) {
      event.preventDefault();
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(event.currentTarget).attr('disabled', 'disabled');
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(event.currentTarget).closest('.js-modal-dialog').addClass('rover-loading');
      acknowledgeSafetyForm(Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(event.currentTarget));
    });
  }

  __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].safety = {
    handleSafetyDialog: handleSafetyDialog,
    doSafetyAdvisory: doSafetyAdvisory
  };
  init();
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).ready(enableSafetyButton);
})(document);

/***/ }),

/***/ 2265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../globals/jquery.ts
var jquery = __webpack_require__(9);

// EXTERNAL MODULE: ../globals/dataLayer.ts
var dataLayer = __webpack_require__(169);

// EXTERNAL MODULE: ../globals/Rover.ts
var Rover = __webpack_require__(13);

// EXTERNAL MODULE: ../utilities/Alerts.js
var Alerts = __webpack_require__(353);

// EXTERNAL MODULE: ../node_modules/vue/dist/vue.common.js
var vue_common = __webpack_require__(543);
var vue_common_default = /*#__PURE__*/__webpack_require__.n(vue_common);

// EXTERNAL MODULE: ../globals/Mustache.ts
var Mustache = __webpack_require__(103);

// EXTERNAL MODULE: ../globals/currentUser/index.ts + 1 modules
var currentUser = __webpack_require__(446);

// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(31);

// CONCATENATED MODULE: ./js/components/social/utils.js
/* globals FB */







 // Helper functions for Facebook calls

var FacebookUtils = {
  observer: new vue_common_default.a(),
  initialized: false,
  setUpFBAsyncInit: function setUpFBAsyncInit() {
    // Facebook's API automatically calls this function once it has finished loading
    window.fbAsyncInit = function () {
      var FB = window.FB;
      FB.init({
        appId: Rover["default"].facebook.appId,
        // App ID
        version: 'v7.0',
        status: true,
        // check login status
        cookie: true,
        // enable cookies to allow the server to access the session
        xfbml: true // parse XFBML

      });
      FB.Event.subscribe('edge.create', FacebookUtils.eventHandlers.handleFacebookLike);
      FB.Event.subscribe('auth.authResponseChange', FacebookUtils.eventHandlers.handleFacebookAuthChange);
      FB.Event.subscribe('comment.create', FacebookUtils.eventHandlers.handleFacebookCommentCreate); // Show all FBui elements

      Object(jquery["default"])('.FBui').show();
      FacebookUtils.initialized = true;
      FacebookUtils.observer.$emit('FB:initialized');
    };
  },
  isInitialized: function isInitialized() {
    return new Promise(function (resolve, reject) {
      return FacebookUtils.initialized ? resolve(window.FB) : FacebookUtils.observer.$on('FB:initialized', function () {
        return resolve(window.FB);
      });
    });
  },
  defaultFBSignupError: function defaultFBSignupError() {
    var customerSupportPhone = Rover["default"].context.customerSupportPhone;
    alert(translation["default"]._(
    /*i18n*/
    {
      id: "We're sorry, we were unable to connect your Facebook account due to an error. If you would like immediate help visit our Help Center at support.rover.com, or call us at {customerSupportPhone}",
      values: {
        customerSupportPhone: customerSupportPhone
      }
    }));
  },
  defaultFBLoginError: function defaultFBLoginError() {
    var customerSupportPhone = Rover["default"].context.customerSupportPhone;
    alert(translation["default"]._(
    /*i18n*/
    {
      id: "We're sorry, we were unable to authenticate with Facebook. If you would like immediate help visit our Help Center at support.rover.com, or call us at {customerSupportPhone}",
      values: {
        customerSupportPhone: customerSupportPhone
      }
    }));
  },
  connectAccount: function connectAccount(authResponse, successCallback, errorCallback) {
    jquery["default"].ajax({
      method: 'GET',
      url: Rover["default"].facebook.authCallbackUrl,
      data: {
        facebook_id: authResponse.user_id,
        opk: currentUser["a" /* default */].opk
      }
    }).done(function () {
      jquery["default"].ajax({
        method: 'POST',
        url: Rover["default"].facebook.authCallbackUrl,
        data: {
          token: authResponse.access_token,
          facebook_id: authResponse.user_id,
          purpose: 'connect'
        }
      }).done(successCallback).fail(errorCallback);
    }).fail(errorCallback);
  },
  connectAndResubmit: function connectAndResubmit($form, connect) {
    if (connect) {
      Rover["default"].facebook.login(function () {
        Object(jquery["default"])('.js-need-connect-to-share').addClass('hide');
        Rover["default"].facebook.submittedForm.trigger('submit');
      }, function () {
        FacebookUtils.defaultFBSignupError();
      }, 'email,publish_actions');
    } else {
      Object(jquery["default"])('.js-need-connect-to-share').removeClass('hide');
    }
  },
  publishGranted: function publishGranted(permissionData) {
    if (permissionData) {
      for (var i = 0; i < permissionData.length; i += 1) {
        var permObj = permissionData[i];

        if (permObj.permission === 'publish_actions' && permObj.status === 'granted') {
          return true;
        }
      }
    }

    return false;
  },
  sharePhotoError: function sharePhotoError($form, response) {
    if (response.type === 'needs_connect') {
      Object(jquery["default"])('.js-need-connect-to-share').removeClass('hide');
    } else {
      FacebookUtils.defaultFBLoginError();
    }
  },
  clickHandlers: {
    handleConnectButtonClick: function handleConnectButtonClick(e) {
      Rover["default"].facebook.currentConnectButton = Object(jquery["default"])(e.currentTarget);
      Rover["default"].facebook.currentConnectButton.btn('loading');
      Rover["default"].facebook.connectLocation = Rover["default"].facebook.currentConnectButton.attr('data-connect-location');

      var resetButton = function resetButton(success) {
        Rover["default"].facebook.currentConnectButton.btn('reset');

        if (success) {
          if (Rover["default"].facebook.currentConnectButton.attr('data-hide-on-success')) {
            Rover["default"].facebook.currentConnectButton.hide();

            if (Rover["default"].facebook.currentConnectButton.parents('.js-connect-facebook-wrapper')) {
              Rover["default"].facebook.currentConnectButton.parents('.js-connect-facebook-wrapper').hide();
            }
          }

          if (Rover["default"].facebook.currentConnectButton.attr('data-show-success-message')) {
            Alerts["a" /* default */].showAlert('success', 'Your account is now connected with Facebook!');
          }

          Object(jquery["default"])(window).trigger('connectsuccess.facebook.rover');
        }
      };

      Rover["default"].facebook.login(function (authResponse) {
        FacebookUtils.connectAccount(authResponse, function () {
          resetButton(true);
        }, function (xhr) {
          var msg = 'We were unable to connect your Facebook account.' + ' Please try again later.';

          if (parseInt(xhr.status, 10) === 409) {
            msg = 'Another user is already connected to this Facebook account.' + ' Please try again with a different Facebook login.';
          }

          Alerts["a" /* default */].showAlert('warning', msg);
          resetButton(false);
        });
      }, function () {
        resetButton(false);
      });
    },
    handleSignupButtonClick: function handleSignupButtonClick(e) {
      Rover["default"].facebook.currentConnectButton = Object(jquery["default"])(e.currentTarget);
      Rover["default"].facebook.currentConnectButton.btn('loading');
      Rover["default"].facebook.signup(false, function () {
        dataLayer["a" /* default */].push({
          event: 'account-sign-up-facebook-sign-up',
          submitStatus: 'fail',
          errorMessage: translation["default"]._('We were unable to connect with Facebook. Please use the form below to sign up.')
        });
        Rover["default"].facebook.currentConnectButton.btn('reset');
        var errorContainer = Rover["default"].facebook.currentConnectButton.attr('data-error-container');

        if (errorContainer) {
          Alerts["a" /* default */].showAlert('danger', 'We were unable to sign you up', errorContainer);
        } else {
          FacebookUtils.defaultFBSignupError();
        }
      });
    },
    handleFBuiClick: function handleFBuiClick(e) {
      var $elt = Object(jquery["default"])(e.currentTarget);
      var linkUrl = $elt.attr('data-link'); // NOTE: Do not specify the data-* attributes if you want to use the
      // OpenGraph tags on the page (which you should do)

      var data = {
        method: $elt.attr('data-method') || 'feed',
        link: $elt.attr('data-link'),
        href: $elt.attr('data-link'),
        name: $elt.attr('data-name'),
        picture: $elt.attr('data-picture'),
        source: $elt.attr('data-source'),
        caption: $elt.attr('data-caption'),
        description: $elt.attr('data-description')
      };
      FacebookUtils.isInitialized().then(function (FB) {
        FB.ui(data, function (response) {
          if (response) {
            var trackingEvent = $elt.attr('data-tracking-event') || 'share_review';
            var shareAction = 'share';

            if ($elt.hasClass('js-enter-contest')) {
              shareAction = 'contest-share';
            }

            Rover["default"].trackSocial('facebook', shareAction, $elt.attr('data-content-type'), $elt.attr('data-object-id'));
            Rover["default"].postShareCallback('facebook', 'share');
          }
        });
      });
    }
  },
  eventHandlers: {
    handleFacebookLike: function handleFacebookLike(url, htmlElement) {
      Rover["default"].postShareCallback('facebook', 'like');
    },
    handleFacebookCommentCreate: function handleFacebookCommentCreate(response) {
      jquery["default"].post('{% url "marketing-comment-notify" %}', {
        link: response.href
      });
    },
    handleFacebookAuthChange: function handleFacebookAuthChange(response) {
      Rover["default"].facebook.connected = response.status === 'connected';

      if (!Rover["default"].facebook.connected) {
        jquery["default"].removeCookie('longtermtoken');
        return;
      } // Only ask for a longterm token once a day


      if (jquery["default"].cookie('longtermtoken')) {
        return;
      }

      jquery["default"].cookie('longtermtoken', true, {
        expires: 1,
        path: '/'
      });
      var data = {
        token: response.authResponse.accessToken,
        facebook_id: response.authResponse.userID,
        purpose: 'refresh'
      };

      if (Rover["default"].facebook.connectLocation) {
        data.connect_location = Rover["default"].facebook.connectLocation;
      } // Ping our server to renew/get a long term access token (stored on FacebookInfo record)


      jquery["default"].post(Rover["default"].facebook.authCallbackUrl, data);
    }
  }
};
var TwitterUtils = {
  handleTwitterLoad: function handleTwitterLoad() {
    // Set up twitter event tracking and post-share callbacks
    if (window.twttr) {
      window.twttr.ready(function (twitterObject) {
        twitterObject.events.bind('follow', function () {
          Rover["default"].postShareCallback('twitter', 'like');
        });
        twitterObject.events.bind('tweet', function () {
          Rover["default"].postShareCallback('twitter', 'share');
        });
      });
    }
  },
  basicTwitterIntentSupport: function basicTwitterIntentSupport() {
    // @see - https://dev.twitter.com/web/intents
    if (window.twitterIntentHandler) return;
    var intentRegex = /twitter\.com(:\d{2,4})?\/intent\/(\w+)/;
    var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    var width = 550;
    var height = 420;
    var winHeight = screen.height;
    var winWidth = screen.width;

    function handleIntent(e) {
      var event = e || window.event;
      var target = event.target || event.srcElement;

      while (target && target.nodeName.toLowerCase() !== 'a') {
        target = target.parentNode;
      }

      if (target && target.nodeName.toLowerCase() === 'a' && target.href) {
        var m = target.href.match(intentRegex);

        if (m) {
          var left = Math.round(winWidth / 2 - width / 2);
          var top = 0;

          if (winHeight > height) {
            top = Math.round(winHeight / 2 - height / 2);
          }

          var o = "".concat(windowOptions, ",width=").concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top);
          window.open(target.href, 'intent', o);
          event.returnValue = false;

          if (event.preventDefault) {
            event.preventDefault();
          }
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener('click', handleIntent, false);
    } else if (document.attachEvent) {
      document.attachEvent('onclick', handleIntent);
    }

    window.twitterIntentHandler = true;
  }
};
var SocialUtils = {
  handlePinItClick: function handlePinItClick() {
    var newwindow = window.open(Object(jquery["default"])(this).attr('href'), 'name', 'height=300,width=600');

    if (window.focus) {
      newwindow.focus();
    }

    Rover["default"].postShareCallback('pinterest', 'share');
    return false;
  },
  loadSocialScripts: function loadSocialScripts() {
    // Load facebook SDK if FB elements present on page
    if (Object(jquery["default"])('.FBui').length || Object(jquery["default"])('.js-connect').length || Object(jquery["default"])('.js-connect-facebook').length || Object(jquery["default"])('.js-facebook-sign-up').length || Object(jquery["default"])('.js-facebook-register').length || Object(jquery["default"])('.js-facebook-share-modal').length || Object(jquery["default"])('.js-shareable-image').length || Object(jquery["default"])('.fb-like').length) {
      jquery["default"].getScript('//connect.facebook.net/en_US/sdk.js');
    } // Load google plus if share button markup is present on page


    if (Object(jquery["default"])('.g-plusone').length) {
      jquery["default"].getScript('https://apis.google.com/js/plusone.js'); // Configuration which is apparently required despite not being
      // documented anywhere.  Thanks, Google

      window.___gcfg = {
        lang: 'en-US'
      };
    } // Load twitter if share button markup is present on page
    // Otherwise just run a basic click handler for twitter intents


    if (Object(jquery["default"])('.twitter-share-button').length || Object(jquery["default"])('.js-twitter-custom-share').length) {
      jquery["default"].getScript('//platform.twitter.com/widgets.js', TwitterUtils.handleTwitterLoad);
    } else {
      TwitterUtils.basicTwitterIntentSupport();
    }
  },
  handleSocialSharePhoto: function handleSocialSharePhoto(e) {
    var $currentTarget = Object(jquery["default"])(e.currentTarget);
    var network = $currentTarget.attr('data-network');
    var $wrapper = $currentTarget.parents('.js-sharing-wrapper');
    var imageToShare = $wrapper.attr('data-image-to-share');
    var imageThumb = $wrapper.attr('data-image-thumbnail');
    var contentType = $wrapper.attr('data-content-type');
    var objectId = $wrapper.attr('data-object-id');
    var campaign = $wrapper.attr('data-campaign');
    var trackingContent = $wrapper.attr('data-tracking-content');
    var shareLocation = $wrapper.attr('data-share-location');
    var utmParams = {
      utm_medium: 'onsite',
      utm_source: network,
      utm_campaign: campaign,
      utm_content: trackingContent
    };
    var urlToShare = "".concat($wrapper.attr('data-url-to-share'), "?").concat(jquery["default"].param(utmParams));
    var href = imageToShare.includes('?') ? "".concat(imageToShare, "&").concat(jquery["default"].param(utmParams)) : "".concat(imageToShare, "?").concat(jquery["default"].param(utmParams));

    if (network === 'facebook') {
      FB.ui({
        method: 'share',
        href: href
      }, function (response) {
        Rover["default"].trackSocial('facebook', 'image-share', contentType, objectId);
      });
    } else if (network === 'pinterest') {
      var popupWidth = 750;
      var popupHeight = 331;
      var left = screen.width / 2 - popupWidth / 2;
      var top = screen.height / 2 - popupHeight / 2;
      var popupOptions = "top=".concat(top, ",left=").concat(left, ",height=").concat(popupHeight, ",width=").concat(popupWidth, ",toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no");
      var pinterestUrl = Mustache["default"].template('new_design/social/pinterest_share_link').render({
        url: encodeURIComponent(urlToShare),
        imageUrl: encodeURIComponent(imageToShare)
      });
      window.open(pinterestUrl, 'Share on Pinterest!', popupOptions);
    }
  }
};

// CONCATENATED MODULE: ./js/components/social/social.js



 // Facebook hooks

FacebookUtils.setUpFBAsyncInit(); // Dynamically load social network SDKs

SocialUtils.loadSocialScripts();
Rover["default"].facebook = Rover["default"].facebook || {};
Rover["default"].googlePlus = Rover["default"].googlePlus || {}; // A function that will be called by every social action callback
// function with its social network and action. Example
//
// 'facebook', 'share'
//
// Specific pages can implement this function to perform
// page-specific actions

Rover["default"].trackSocial = function (socialNetwork, action, contentType, objectId) {
  if (objectId && contentType) {
    jquery["default"].ajax({
      type: 'POST',
      url: Rover["default"].urls.analyticsTrackShare,
      data: JSON.stringify({
        action: action,
        content_type: contentType || null,
        object_id: objectId || null,
        social_network: socialNetwork
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: function success(data) {},
      failure: function failure(err) {}
    });
  }
};

Rover["default"].postShareCallback = function (socialNetwork, action, response) {
  Rover["default"].trackSocial(socialNetwork, action); // Allow for page-specific behavior after a share
  // (e.g. scrapsbook.js pops up a "thanks for sharing" modal)

  Rover["default"].pageSpecificPostShareCallback = Rover["default"].pageSpecificPostShareCallback || function () {};

  Rover["default"].pageSpecificPostShareCallback(socialNetwork, action, response);
}; // Callback for plus one events. Has to be global.


Rover["default"].googlePlus.plusOneClick = function (response) {
  if (response.state === 'on') {
    Rover["default"].postShareCallback('g_plus', 'share');
  }
}; // Log in via Facebook's FB API, returning Facebook auth credentials


Rover["default"].facebook.login = function (successCallback, errCallback, scope) {
  FacebookUtils.isInitialized().then(function (FB) {
    var errorCallback = jquery["default"].isFunction(errCallback) ? errCallback : FacebookUtils.defaultFBLoginError;
    FB.login(function (response) {
      if (response.status === 'connected') {
        // Reset any DOM state related to connecting
        Object(jquery["default"])('.js-need-connect-to-share').addClass('hide');
        Rover["default"].facebook.connected = true;

        if (jquery["default"].isFunction(successCallback)) {
          successCallback({
            access_token: response.authResponse.accessToken,
            signed_request: response.authResponse.signedRequest,
            user_id: response.authResponse.userID
          });
        }
      } else {
        if (response.status === 'not_authorized') {
          dataLayer["a" /* default */].push({
            event: 'account-sign-in-facebook',
            submitStatus: 'fail',
            errorMessage: 'not_authorized'
          });
        } else {
          dataLayer["a" /* default */].push({
            event: 'account-sign-in-facebook',
            submitStatus: 'fail',
            errorMessage: 'facebook-login-error'
          });
        }

        errorCallback(response);
      }
    }, // Specify which permissions we're requesting: email address
    {
      scope: scope || 'email'
    });
  });
};

Rover["default"].facebook.signup = function (successCallback, errCallback) {
  var errorCallback = jquery["default"].isFunction(errCallback) ? errCallback : FacebookUtils.defaultFBSignupError;

  var wrappedSuccessCallback = function wrappedSuccessCallback(authData) {
    if (jquery["default"].isFunction(successCallback)) {
      dataLayer["a" /* default */].push({
        event: 'account-sign-up-facebook-sign-up',
        submitStatus: 'success'
      });
      successCallback(authData);
    }

    var $form = Object(jquery["default"])('.js-facebook-register');
    Object(jquery["default"])('[name=access_token]', $form).val(authData.access_token);
    Object(jquery["default"])('[name=signed_request]', $form).val(authData.signed_request);
    Object(jquery["default"])('[name=facebook_id]', $form).val(authData.user_id);
    $form.attr('href', Object(jquery["default"])('input[name=next]').first().val());
    $form.submit();
  };

  Rover["default"].facebook.login(wrappedSuccessCallback, errorCallback);
}; // UI element click/submit bindings
// Facebook connect/signup/share


Object(jquery["default"])(document).on('click', '.FBui', FacebookUtils.clickHandlers.handleFBuiClick);
Object(jquery["default"])(document).on('click', '.js-connect-facebook', FacebookUtils.clickHandlers.handleConnectButtonClick);
Object(jquery["default"])(document).on('click', '.js-signup-with-facebook', FacebookUtils.clickHandlers.handleSignupButtonClick); // Pinterest - open a popup window

Object(jquery["default"])(document).on('click', '.pin-it-button', SocialUtils.handlePinItClick); // Photo sharing

Object(jquery["default"])(document).on('click', '.js-social-share-photo-button', SocialUtils.handleSocialSharePhoto);

/***/ }),

/***/ 2266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Handle popovers like we used to, but using new bootstrap
// http://stackoverflow.com/questions/7703878/how-can-i-hold-twitter-bootstrap-popover-open-until-my-mouse-moves-into-it



var popoverTemplate = function popoverTemplate() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "\n    <div class=\"popover ".concat(className, "\" onmouseover=\"clearTimeout(Rover.timeoutObj);$(this).mouseleave(function() {$(this).popover('hide');});\">\n        <div class=\"arrow\"></div>\n        <div class=\"popover-inner\">\n            <h3 class=\"popover-title\"></h3>\n            <div class=\"popover-content\">\n                <p></p>\n            </div>\n        </div>\n    </div>");
};

__WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].timeoutObj = false;

__WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].stickyPopover = function stickyPopover(selector, _ref) {
  var className = _ref.className,
      option = _objectWithoutProperties(_ref, ["className"]);

  var $elts = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(selector);

  if (!$elts.length) {
    return;
  }

  var options = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].extend({
    template: option.template ? option.template : popoverTemplate(className),
    html: true,
    container: '.js-popover-container',
    trigger: 'manual',
    closeOnBodyClick: true
  }, option);

  function onBodyClicked(e) {
    var $target = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.target);

    if (options.closeOnBodyClick) {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.popover').not($target.parent()).not($target).popover('hide');
    }
  } // eslint-disable-next-line func-names


  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(selector).each(function () {
    var self = this;
    var $popover = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).popover('destroy').popover(options);
    var touched = false;
    var showing = false;

    var showPopover = function showPopover() {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(self).popover('show');
      showing = true;
    };

    var hidePopover = function hidePopover() {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(self).popover('hide');
      showing = false;
    };

    $popover.off('touchstart').on('touchstart', function () {
      // prevents double open/flash
      touched = true;
      setTimeout(function () {
        touched = false;
      }, 150);
      if (showing) hidePopover();else showPopover();
    }).off('mouseenter').on('mouseenter', function () {
      // prevents double open/flash
      if (touched) return;
      showPopover();
    }).off('mouseleave').on('mouseleave', function () {
      __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].timeoutObj = setTimeout(hidePopover, 50);
    }).off('focus').on('focus', function () {
      if (!showing) showPopover();
    }).off('blur').on('blur', function () {
      if (showing) hidePopover();
    }).off('keypress').on('keypress', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if (showing) hidePopover();else showPopover();
    }).off('keydown').on('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (showing) hidePopover();
    });
    $popover.off('show.bs.popover').on('show.bs.popover', function () {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('body').on('click', onBodyClicked);
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(self).off('hide.bs.popover').on('hide.bs.popover', function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('body').off('click', onBodyClicked);
        Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(self).off('hide.bs.popover');
      });
    });
  });
};

/***/ }),

/***/ 2267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);


Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  var hidePhoto = function hidePhoto(e) {
    var $hideButton = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.currentTarget);
    $hideButton.btn('loading');
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].ajax({
      url: __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].urls.hidePhotoUrl,
      headers: {
        'Content-Type': 'application/json'
      },
      type: 'POST',
      data: JSON.stringify({
        image_id: $hideButton.attr('data-object-id')
      }),
      success: function success() {
        toggleHiddenPhotoOnPage($hideButton.attr('data-hidden') === 'false', $hideButton);
      },
      error: function error() {
        alert('Failed to perform operation. Please refresh the page and try again.');
        $hideButton.btn($hideButton.attr('data-hidden') === 'false' ? 'hide' : 'unhide');
      }
    });
  };

  var toggleHiddenPhotoOnPage = function toggleHiddenPhotoOnPage(wasHidden, $buttonClicked) {
    var $photoOnPage = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(".js-shareable-image[data-object-id=".concat($buttonClicked.attr('data-object-id'), "]"));

    if (wasHidden) {
      $buttonClicked.attr('data-hidden', 'true').btn('unhide');
      $photoOnPage.addClass('hidden-photo').attr('data-hidden', 'true').find('.js-hidden-photo').removeClass('hide');
    } else {
      $buttonClicked.attr('data-hidden', 'false').btn('hide');
      $photoOnPage.removeClass('hidden-photo').attr('data-hidden', 'false').find('.js-hidden-photo').addClass('hide');
    }
  };

  var addBindings = function addBindings() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('click', '.js-hide-photo', hidePhoto);
  };

  var init = function init() {
    addBindings();
  };

  init();
});

/***/ }),

/***/ 2268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_embedded__ = __webpack_require__(321);




var MAX_RATING = 5;
Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  'use strict';

  var validator;

  var starRatingErrorPlacement = function starRatingErrorPlacement($error, $element) {
    if ($element.hasClass('starrating') || $element.hasClass('labeledstarrating')) {
      $element = $element.closest('.form-group');
    }

    if ($element.attr('name') !== 'description') {
      __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.defaults.errorPlacement($error, $element);
    }
  };
  /*
   * Implement custom handling to jump to the first invalid
   * form field, even if it's one of our hidden star inputs.
   */


  var starRatingInvalidHandler = function starRatingInvalidHandler(ev, validator) {
    var $firstErrorElement = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(validator.errorList[0].element);

    if ($firstErrorElement.hasClass('starrating')) {
      var _top = $firstErrorElement.closest('.form-group').offset().top; // Add a bit of top because the wrapped control will be
      // covered otherwise

      _top -= 150;
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('html, body').animate({
        scrollTop: _top
      }, 'fast');
    }

    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.defaults.invalidHandler(ev, validator);
  };

  var petRatingFormValidator = {
    ignore: [],
    errorPlacement: starRatingErrorPlacement,
    invalidHandler: starRatingInvalidHandler
  };
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].validator.addMethod('requireAtLeastOneField', function (value, element, fields) {
    var $form = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(element).closest('form');

    var nonEmptyFields = __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].reduce(fields, function (memo, value) {
      return memo + ($form.find("[name=".concat(value, "]")).val() ? 1 : 0);
    }, 0);

    return nonEmptyFields > 0;
  });
  var sitterRatingFormValidator = {
    ignore: [],
    errorPlacement: starRatingErrorPlacement,
    invalidHandler: starRatingInvalidHandler,
    rules: {
      overall: {
        required: true
      }
    },
    messages: {
      overall: 'A star rating is required.'
    }
  };

  var initializeFormValidation = function initializeFormValidation() {
    // Pet ratings form handler
    if (Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-rate-pets-form').length > 0) {
      validator = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-rate-pets-form').roverValidate(petRatingFormValidator);
    } else {
      validator = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-rate-sitter-form').roverValidate(sitterRatingFormValidator);
    }
  };

  var initPopovers = function initPopovers() {
    __WEBPACK_IMPORTED_MODULE_1__rover_globals_Rover__["default"].stickyPopover(Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('[data-toggle="sticky-popover"]'), {
      container: 'body'
    });
  };

  var initializeRatings = function initializeRatings() {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-star-rating-widget').each(function () {
      var $this = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this);
      var overallInputName = $this.attr('data-uid');
      var $overallInput = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])("[name=".concat(overallInputName, "]"));
      var toggleContainer = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.rating-form-toggle-container');
      $this.raty({
        starType: 'i',
        starOn: 'rover-icon rover-icon-in-star star-rating-on',
        starOff: 'rover-icon rover-icon-in-star-o star-rating-off',
        cancel: false,
        half: false,
        score: function score() {
          return $overallInput.val();
        },
        click: function click(score) {
          if (toggleContainer) {
            toggleContainer.show();
          }

          $overallInput.val(score); // Trigger revalidation on click if the input is in
          // an error state.

          if ($overallInput.hasClass('error')) {
            validator.validate().element($overallInput);
          }
        }
      });
    });
  };

  var initializePreferenceToggles = function initializePreferenceToggles() {
    var toggleContainer = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.rating-form-toggle-container');

    if (toggleContainer) {
      toggleContainer.hide();
    }
  };

  var initializeReviewTracking = function initializeReviewTracking() {
    var sitterReviewForm = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-rate-sitter-form');

    if (sitterReviewForm.length > 0) {
      sitterReviewForm.submit(function (e) {
        var rating = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.target).find('#id_overall_stars > input').val();

        if (sitterReviewForm.valid()) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_embedded__["default"])('sitter-reviewed-by-owner');

          if (Number(rating) === MAX_RATING) {
            Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_embedded__["default"])('review-five-stars');
          }
        }

        e.preventDefault();
      });
    }
  };

  var fiveStarPetReview = function fiveStarPetReview() {
    var petReviewForm = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-rate-pets-form ');

    if (petReviewForm.length > 0) {
      petReviewForm.submit(function (e) {
        if (petReviewForm.valid()) {
          var numberOfPets = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-star-rating-widget').length;

          for (var i = 0; i < numberOfPets; i++) {
            var rating = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.target).find("#id_form-".concat(i, "-overall_stars > input")).val();

            if (Number(rating) === MAX_RATING) {
              Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_embedded__["default"])('review-five-stars');
              break;
            }
          }
        }

        e.preventDefault();
      });
    }
  };

  var init = function init() {
    initializePreferenceToggles();
    initializeRatings();
    initializeFormValidation();
    initPopovers();
    initializeReviewTracking();
    fiveStarPetReview();
  };

  init();
});

/***/ }),

/***/ 2269:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Cleave"] = factory();
	else
		root["Cleave"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	/**
	 * Construct a new Cleave instance by passing the configuration object
	 *
	 * @param {String | HTMLElement} element
	 * @param {Object} opts
	 */
	var Cleave = function (element, opts) {
	    var owner = this;

	    if (typeof element === 'string') {
	        owner.element = document.querySelector(element);
	    } else {
	        owner.element = ((typeof element.length !== 'undefined') && element.length > 0) ? element[0] : element;
	    }

	    if (!owner.element) {
	        throw new Error('[cleave.js] Please check the element');
	    }

	    opts.initValue = owner.element.value;

	    owner.properties = Cleave.DefaultProperties.assign({}, opts);

	    owner.init();
	};

	Cleave.prototype = {
	    init: function () {
	        var owner = this, pps = owner.properties;

	        // no need to use this lib
	        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
	            owner.onInput(pps.initValue);

	            return;
	        }

	        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);

	        owner.isAndroid = Cleave.Util.isAndroid();
	        owner.lastInputValue = '';

	        owner.onChangeListener = owner.onChange.bind(owner);
	        owner.onKeyDownListener = owner.onKeyDown.bind(owner);
	        owner.onFocusListener = owner.onFocus.bind(owner);
	        owner.onCutListener = owner.onCut.bind(owner);
	        owner.onCopyListener = owner.onCopy.bind(owner);

	        owner.element.addEventListener('input', owner.onChangeListener);
	        owner.element.addEventListener('keydown', owner.onKeyDownListener);
	        owner.element.addEventListener('focus', owner.onFocusListener);
	        owner.element.addEventListener('cut', owner.onCutListener);
	        owner.element.addEventListener('copy', owner.onCopyListener);


	        owner.initPhoneFormatter();
	        owner.initDateFormatter();
	        owner.initNumeralFormatter();

	        // avoid touch input field if value is null
	        // otherwise Firefox will add red box-shadow for <input required />
	        if (pps.initValue || (pps.prefix && !pps.noImmediatePrefix)) {
	            owner.onInput(pps.initValue);
	        }
	    },

	    initNumeralFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.numeral) {
	            return;
	        }

	        pps.numeralFormatter = new Cleave.NumeralFormatter(
	            pps.numeralDecimalMark,
	            pps.numeralIntegerScale,
	            pps.numeralDecimalScale,
	            pps.numeralThousandsGroupStyle,
	            pps.numeralPositiveOnly,
	            pps.stripLeadingZeroes,
	            pps.delimiter
	        );
	    },

	    initDateFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.date) {
	            return;
	        }

	        pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern);
	        pps.blocks = pps.dateFormatter.getBlocks();
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
	    },

	    initPhoneFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.phone) {
	            return;
	        }

	        // Cleave.AsYouTypeFormatter should be provided by
	        // external google closure lib
	        try {
	            pps.phoneFormatter = new Cleave.PhoneFormatter(
	                new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
	                pps.delimiter
	            );
	        } catch (ex) {
	            throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
	        }
	    },

	    onKeyDown: function (event) {
	        var owner = this, pps = owner.properties,
	            charCode = event.which || event.keyCode,
	            Util = Cleave.Util,
	            currentValue = owner.element.value;

	        if (Util.isAndroidBackspaceKeydown(owner.lastInputValue, currentValue)) {
	            charCode = 8;
	        }

	        owner.lastInputValue = currentValue;

	        // hit backspace when last character is delimiter
	        if (charCode === 8 && Util.isDelimiter(currentValue.slice(-pps.delimiterLength), pps.delimiter, pps.delimiters)) {
	            pps.backspace = true;

	            return;
	        }

	        pps.backspace = false;
	    },

	    onChange: function () {
	        this.onInput(this.element.value);
	    },

	    onFocus: function () {
	        var owner = this,
	            pps = owner.properties;

	        Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
	    },

	    onCut: function (e) {
	        this.copyClipboardData(e);
	        this.onInput('');
	    },

	    onCopy: function (e) {
	        this.copyClipboardData(e);
	    },

	    copyClipboardData: function (e) {
	        var owner = this,
	            pps = owner.properties,
	            Util = Cleave.Util,
	            inputValue = owner.element.value,
	            textToCopy = '';

	        if (!pps.copyDelimiter) {
	            textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
	        } else {
	            textToCopy = inputValue;
	        }

	        try {
	            if (e.clipboardData) {
	                e.clipboardData.setData('Text', textToCopy);
	            } else {
	                window.clipboardData.setData('Text', textToCopy);
	            }

	            e.preventDefault();
	        } catch (ex) {
	            //  empty
	        }
	    },

	    onInput: function (value) {
	        var owner = this, pps = owner.properties,
	            Util = Cleave.Util;

	        // case 1: delete one more character "4"
	        // 1234*| -> hit backspace -> 123|
	        // case 2: last character is not delimiter which is:
	        // 12|34* -> hit backspace -> 1|34*
	        // note: no need to apply this for numeral mode
	        if (!pps.numeral && pps.backspace && !Util.isDelimiter(value.slice(-pps.delimiterLength), pps.delimiter, pps.delimiters)) {
	            value = Util.headStr(value, value.length - pps.delimiterLength);
	        }

	        // phone formatter
	        if (pps.phone) {
	            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
	            } else {
	                pps.result = pps.phoneFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // numeral formatter
	        if (pps.numeral) {
	            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	                pps.result = pps.prefix + pps.numeralFormatter.format(value);
	            } else {
	                pps.result = pps.numeralFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // date
	        if (pps.date) {
	            value = pps.dateFormatter.getValidatedDate(value);
	        }

	        // strip delimiters
	        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

	        // strip prefix
	        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength);

	        // strip non-numeric characters
	        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

	        // convert case
	        value = pps.uppercase ? value.toUpperCase() : value;
	        value = pps.lowercase ? value.toLowerCase() : value;

	        // prefix
	        if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	            value = pps.prefix + value;

	            // no blocks specified, no need to do formatting
	            if (pps.blocksLength === 0) {
	                pps.result = value;
	                owner.updateValueState();

	                return;
	            }
	        }

	        // update credit card props
	        if (pps.creditCard) {
	            owner.updateCreditCardPropsByValue(value);
	        }

	        // strip over length characters
	        value = Util.headStr(value, pps.maxLength);

	        // apply blocks
	        pps.result = Util.getFormattedValue(
	            value,
	            pps.blocks, pps.blocksLength,
	            pps.delimiter, pps.delimiters, pps.delimiterLazyShow
	        );

	        owner.updateValueState();
	    },

	    updateCreditCardPropsByValue: function (value) {
	        var owner = this, pps = owner.properties,
	            Util = Cleave.Util,
	            creditCardInfo;

	        // At least one of the first 4 characters has changed
	        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
	            return;
	        }

	        creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

	        pps.blocks = creditCardInfo.blocks;
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Util.getMaxLength(pps.blocks);

	        // credit card type changed
	        if (pps.creditCardType !== creditCardInfo.type) {
	            pps.creditCardType = creditCardInfo.type;

	            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
	        }
	    },

	    setCurrentSelection: function (endPos, oldValue) {
	        var elem = this.element;

	        // If cursor was at the end of value, just place it back.
	        // Because new value could contain additional chars.
	        if (oldValue.length !== endPos && elem === document.activeElement) {
	          if ( elem.createTextRange ) {
	            var range = elem.createTextRange();

	            range.move('character', endPos);
	            range.select();
	          } else {
	            elem.setSelectionRange(endPos, endPos);
	          }
	        }
	    },

	    updateValueState: function () {
	        var owner = this,
	            pps = owner.properties;

	        if (!owner.element) {
	            return;
	        }

	        var endPos = owner.element.selectionEnd;
	        var oldValue = owner.element.value;

	        endPos += Cleave.Util.getPositionOffset(endPos, oldValue, pps.result, pps.delimiter, pps.delimiters);

	        // fix Android browser type="text" input field
	        // cursor not jumping issue
	        if (owner.isAndroid) {
	            window.setTimeout(function () {
	                owner.element.value = pps.result;
	                owner.setCurrentSelection(endPos, oldValue);
	            }, 1);

	            return;
	        }

	        owner.element.value = pps.result;
	        owner.setCurrentSelection(endPos, oldValue);
	    },

	    setPhoneRegionCode: function (phoneRegionCode) {
	        var owner = this, pps = owner.properties;

	        pps.phoneRegionCode = phoneRegionCode;
	        owner.initPhoneFormatter();
	        owner.onChange();
	    },

	    setRawValue: function (value) {
	        var owner = this, pps = owner.properties;

	        value = value !== undefined && value !== null ? value.toString() : '';

	        if (pps.numeral) {
	            value = value.replace('.', pps.numeralDecimalMark);
	        }

	        pps.backspace = false;
	        
	        owner.element.value = value;
	        owner.onInput(value);
	    },

	    getRawValue: function () {
	        var owner = this,
	            pps = owner.properties,
	            Util = Cleave.Util,
	            rawValue = owner.element.value;

	        if (pps.rawValueTrimPrefix) {
	            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength);
	        }

	        if (pps.numeral) {
	            rawValue = pps.numeralFormatter.getRawValue(rawValue);
	        } else {
	            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
	        }

	        return rawValue;
	    },

	    getISOFormatDate: function () {
	        var owner = this,
	            pps = owner.properties;

	        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
	    },

	    getFormattedValue: function () {
	        return this.element.value;
	    },

	    destroy: function () {
	        var owner = this;

	        owner.element.removeEventListener('input', owner.onChangeListener);
	        owner.element.removeEventListener('keydown', owner.onKeyDownListener);
	        owner.element.removeEventListener('focus', owner.onFocusListener);
	        owner.element.removeEventListener('cut', owner.onCutListener);
	        owner.element.removeEventListener('copy', owner.onCopyListener);
	    },

	    toString: function () {
	        return '[Cleave Object]';
	    }
	};

	Cleave.NumeralFormatter = __webpack_require__(1);
	Cleave.DateFormatter = __webpack_require__(2);
	Cleave.PhoneFormatter = __webpack_require__(3);
	Cleave.CreditCardDetector = __webpack_require__(4);
	Cleave.Util = __webpack_require__(5);
	Cleave.DefaultProperties = __webpack_require__(6);

	// for angular directive
	((typeof global === 'object' && global) ? global : window)['Cleave'] = Cleave;

	// CommonJS
	module.exports = Cleave;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	var NumeralFormatter = function (numeralDecimalMark,
	                                 numeralIntegerScale,
	                                 numeralDecimalScale,
	                                 numeralThousandsGroupStyle,
	                                 numeralPositiveOnly,
	                                 stripLeadingZeroes,
	                                 delimiter) {
	    var owner = this;

	    owner.numeralDecimalMark = numeralDecimalMark || '.';
	    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
	    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
	    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
	    owner.numeralPositiveOnly = !!numeralPositiveOnly;
	    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
	    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ',';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
	};

	NumeralFormatter.groupStyle = {
	    thousand: 'thousand',
	    lakh:     'lakh',
	    wan:      'wan',
	    none:     'none'    
	};

	NumeralFormatter.prototype = {
	    getRawValue: function (value) {
	        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
	    },

	    format: function (value) {
	        var owner = this, parts, partInteger, partDecimal = '';

	        // strip alphabet letters
	        value = value.replace(/[A-Za-z]/g, '')
	            // replace the first decimal mark with reserved placeholder
	            .replace(owner.numeralDecimalMark, 'M')

	            // strip non numeric letters except minus and "M"
	            // this is to ensure prefix has been stripped
	            .replace(/[^\dM-]/g, '')

	            // replace the leading minus with reserved placeholder
	            .replace(/^\-/, 'N')

	            // strip the other minus sign (if present)
	            .replace(/\-/g, '')

	            // replace the minus sign (if present)
	            .replace('N', owner.numeralPositiveOnly ? '' : '-')

	            // replace decimal mark
	            .replace('M', owner.numeralDecimalMark);

	        // strip any leading zeros
	        if (owner.stripLeadingZeroes) {
	            value = value.replace(/^(-)?0+(?=\d)/, '$1');
	        }

	        partInteger = value;

	        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
	            parts = value.split(owner.numeralDecimalMark);
	            partInteger = parts[0];
	            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
	        }

	        if (owner.numeralIntegerScale > 0) {
	          partInteger = partInteger.slice(0, owner.numeralIntegerScale + (value.slice(0, 1) === '-' ? 1 : 0));
	        }

	        switch (owner.numeralThousandsGroupStyle) {
	        case NumeralFormatter.groupStyle.lakh:
	            partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

	            break;

	        case NumeralFormatter.groupStyle.wan:
	            partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

	            break;

	        case NumeralFormatter.groupStyle.thousand:
	            partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

	            break;
	        }

	        return partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
	    }
	};

	module.exports = NumeralFormatter;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	var DateFormatter = function (datePattern) {
	    var owner = this;

	    owner.date = [];
	    owner.blocks = [];
	    owner.datePattern = datePattern;
	    owner.initBlocks();
	};

	DateFormatter.prototype = {
	    initBlocks: function () {
	        var owner = this;
	        owner.datePattern.forEach(function (value) {
	            if (value === 'Y') {
	                owner.blocks.push(4);
	            } else {
	                owner.blocks.push(2);
	            }
	        });
	    },

	    getISOFormatDate: function () {
	        var owner = this,
	            date = owner.date;

	        return date[2] ? (
	            date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0])
	        ) : '';
	    },

	    getBlocks: function () {
	        return this.blocks;
	    },

	    getValidatedDate: function (value) {
	        var owner = this, result = '';

	        value = value.replace(/[^\d]/g, '');

	        owner.blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    sub0 = sub.slice(0, 1),
	                    rest = value.slice(length);

	                switch (owner.datePattern[index]) {
	                case 'd':
	                    if (sub === '00') {
	                        sub = '01';
	                    } else if (parseInt(sub0, 10) > 3) {
	                        sub = '0' + sub0;
	                    } else if (parseInt(sub, 10) > 31) {
	                        sub = '31';
	                    }

	                    break;

	                case 'm':
	                    if (sub === '00') {
	                        sub = '01';
	                    } else if (parseInt(sub0, 10) > 1) {
	                        sub = '0' + sub0;
	                    } else if (parseInt(sub, 10) > 12) {
	                        sub = '12';
	                    }

	                    break;
	                }

	                result += sub;

	                // update remaining string
	                value = rest;
	            }
	        });

	        return this.getFixedDateString(result);
	    },

	    getFixedDateString: function (value) {
	        var owner = this, datePattern = owner.datePattern, date = [],
	            dayIndex = 0, monthIndex = 0, yearIndex = 0,
	            dayStartIndex = 0, monthStartIndex = 0, yearStartIndex = 0,
	            day, month, year, fullYearDone = false;

	        // mm-dd || dd-mm
	        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
	            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
	            monthStartIndex = 2 - dayStartIndex;
	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

	            date = this.getFixedDate(day, month, 0);
	        }

	        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
	        if (value.length === 8) {
	            datePattern.forEach(function (type, index) {
	                switch (type) {
	                case 'd':
	                    dayIndex = index;
	                    break;
	                case 'm':
	                    monthIndex = index;
	                    break;
	                default:
	                    yearIndex = index;
	                    break;
	                }
	            });

	            yearStartIndex = yearIndex * 2;
	            dayStartIndex = (dayIndex <= yearIndex) ? dayIndex * 2 : (dayIndex * 2 + 2);
	            monthStartIndex = (monthIndex <= yearIndex) ? monthIndex * 2 : (monthIndex * 2 + 2);

	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

	            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

	            date = this.getFixedDate(day, month, year);
	        }

	        owner.date = date;

	        return date.length === 0 ? value : datePattern.reduce(function (previous, current) {
	            switch (current) {
	            case 'd':
	                return previous + owner.addLeadingZero(date[0]);
	            case 'm':
	                return previous + owner.addLeadingZero(date[1]);
	            default:
	                return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2]) : '');
	            }
	        }, '');
	    },

	    getFixedDate: function (day, month, year) {
	        day = Math.min(day, 31);
	        month = Math.min(month, 12);
	        year = parseInt((year || 0), 10);

	        if ((month < 7 && month % 2 === 0) || (month > 8 && month % 2 === 1)) {
	            day = Math.min(day, month === 2 ? (this.isLeapYear(year) ? 29 : 28) : 30);
	        }

	        return [day, month, year];
	    },

	    isLeapYear: function (year) {
	        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	    },

	    addLeadingZero: function (number) {
	        return (number < 10 ? '0' : '') + number;
	    },

	    addLeadingZeroForYear: function (number) {
	        return (number < 10 ? '000' : (number < 100 ? '00' : (number < 1000 ? '0' : ''))) + number;
	    }
	};

	module.exports = DateFormatter;



/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	var PhoneFormatter = function (formatter, delimiter) {
	    var owner = this;

	    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ' ';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

	    owner.formatter = formatter;
	};

	PhoneFormatter.prototype = {
	    setFormatter: function (formatter) {
	        this.formatter = formatter;
	    },

	    format: function (phoneNumber) {
	        var owner = this;

	        owner.formatter.clear();

	        // only keep number and +
	        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

	        // strip delimiter
	        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

	        var result = '', current, validated = false;

	        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
	            current = owner.formatter.inputDigit(phoneNumber.charAt(i));

	            // has ()- or space inside
	            if (/[\s()-]/g.test(current)) {
	                result = current;

	                validated = true;
	            } else {
	                if (!validated) {
	                    result = current;
	                }
	                // else: over length input
	                // it turns to invalid number again
	            }
	        }

	        // strip ()
	        // e.g. US: 7161234567 returns (716) 123-4567
	        result = result.replace(/[()]/g, '');
	        // replace library delimiter with user customized delimiter
	        result = result.replace(/[\s-]/g, owner.delimiter);

	        return result;
	    }
	};

	module.exports = PhoneFormatter;



/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	var CreditCardDetector = {
	    blocks: {
	        uatp:          [4, 5, 6],
	        amex:          [4, 6, 5],
	        diners:        [4, 6, 4],
	        discover:      [4, 4, 4, 4],
	        mastercard:    [4, 4, 4, 4],
	        dankort:       [4, 4, 4, 4],
	        instapayment:  [4, 4, 4, 4],
	        jcb:           [4, 4, 4, 4],
	        maestro:       [4, 4, 4, 4],
	        visa:          [4, 4, 4, 4],
	        mir:           [4, 4, 4, 4],
	        unionPay:      [4, 4, 4, 4],
	        general:       [4, 4, 4, 4],
	        generalStrict: [4, 4, 4, 7]
	    },

	    re: {
	        // starts with 1; 15 digits, not starts with 1800 (jcb card)
	        uatp: /^(?!1800)1\d{0,14}/,

	        // starts with 34/37; 15 digits
	        amex: /^3[47]\d{0,13}/,

	        // starts with 6011/65/644-649; 16 digits
	        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

	        // starts with 300-305/309 or 36/38/39; 14 digits
	        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

	        // starts with 51-55/2221–2720; 16 digits
	        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

	        // starts with 5019/4175/4571; 16 digits
	        dankort: /^(5019|4175|4571)\d{0,12}/,

	        // starts with 637-639; 16 digits
	        instapayment: /^63[7-9]\d{0,13}/,

	        // starts with 2131/1800/35; 16 digits
	        jcb: /^(?:2131|1800|35\d{0,2})\d{0,12}/,

	        // starts with 50/56-58/6304/67; 16 digits
	        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

	        // starts with 22; 16 digits
	        mir: /^220[0-4]\d{0,12}/,

	        // starts with 4; 16 digits
	        visa: /^4\d{0,15}/,

	        // starts with 62; 16 digits
	        unionPay: /^62\d{0,14}/
	    },

	    getInfo: function (value, strictMode) {
	        var blocks = CreditCardDetector.blocks,
	            re = CreditCardDetector.re;

	        // Some credit card can have up to 19 digits number.
	        // Set strictMode to true will remove the 16 max-length restrain,
	        // however, I never found any website validate card number like
	        // this, hence probably you don't want to enable this option.
	        strictMode = !!strictMode;

	        for (var key in re) {
	            if (re[key].test(value)) {
	                var block;

	                if (strictMode) {
	                    block = blocks.generalStrict;
	                } else {
	                    block = blocks[key];
	                }

	                return {
	                    type: key,
	                    blocks: block
	                };
	            }
	        }

	        return {
	            type:   'unknown',
	            blocks: strictMode ? blocks.generalStrict : blocks.general
	        };
	    }
	};

	module.exports = CreditCardDetector;



/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	var Util = {
	    noop: function () {
	    },

	    strip: function (value, re) {
	        return value.replace(re, '');
	    },

	    isDelimiter: function (letter, delimiter, delimiters) {
	        // single delimiter
	        if (delimiters.length === 0) {
	            return letter === delimiter;
	        }

	        // multiple delimiters
	        return delimiters.some(function (current) {
	            if (letter === current) {
	                return true;
	            }
	        });
	    },

	    getDelimiterREByDelimiter: function (delimiter) {
	        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
	    },

	    getPositionOffset: function (prevPos, oldValue, newValue, delimiter, delimiters) {
	        var oldRawValue, newRawValue, lengthOffset;

	        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
	        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
	        lengthOffset = oldRawValue.length - newRawValue.length;

	        return (lengthOffset !== 0) ? (lengthOffset / Math.abs(lengthOffset)) : 0;
	    },

	    stripDelimiters: function (value, delimiter, delimiters) {
	        var owner = this;

	        // single delimiter
	        if (delimiters.length === 0) {
	            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

	            return value.replace(delimiterRE, '');
	        }

	        // multiple delimiters
	        delimiters.forEach(function (current) {
	            value = value.replace(owner.getDelimiterREByDelimiter(current), '');
	        });

	        return value;
	    },

	    headStr: function (str, length) {
	        return str.slice(0, length);
	    },

	    getMaxLength: function (blocks) {
	        return blocks.reduce(function (previous, current) {
	            return previous + current;
	        }, 0);
	    },

	    // strip value by prefix length
	    // for prefix: PRE
	    // (PRE123, 3) -> 123
	    // (PR123, 3) -> 23 this happens when user hits backspace in front of "PRE"
	    getPrefixStrippedValue: function (value, prefix, prefixLength) {
	        if (value.slice(0, prefixLength) !== prefix) {
	            var diffIndex = this.getFirstDiffIndex(prefix, value.slice(0, prefixLength));

	            value = prefix + value.slice(diffIndex, diffIndex + 1) + value.slice(prefixLength + 1);
	        }

	        return value.slice(prefixLength);
	    },

	    getFirstDiffIndex: function (prev, current) {
	        var index = 0;

	        while (prev.charAt(index) === current.charAt(index)) {
	            if (prev.charAt(index++) === '') {
	                return -1;
	            }
	        }

	        return index;
	    },

	    getFormattedValue: function (value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
	        var result = '',
	            multipleDelimiters = delimiters.length > 0,
	            currentDelimiter;

	        // no options, normal input
	        if (blocksLength === 0) {
	            return value;
	        }

	        blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    rest = value.slice(length);

	                if (multipleDelimiters) {
	                    currentDelimiter = delimiters[delimiterLazyShow ? (index - 1) : index] || currentDelimiter;
	                } else {
	                    currentDelimiter = delimiter;
	                }

	                if (delimiterLazyShow) {
	                    if (index > 0) {
	                        result += currentDelimiter;
	                    }

	                    result += sub;
	                } else {
	                    result += sub;

	                    if (sub.length === length && index < blocksLength - 1) {
	                        result += currentDelimiter;
	                    }
	                }

	                // update remaining string
	                value = rest;
	            }
	        });

	        return result;
	    },

	    // move cursor to the end
	    // the first time user focuses on an input with prefix
	    fixPrefixCursor: function (el, prefix, delimiter, delimiters) {
	        if (!el) {
	            return;
	        }

	        var val = el.value,
	            appendix = delimiter || (delimiters[0] || ' ');

	        if (!el.setSelectionRange || !prefix || (prefix.length + appendix.length) < val.length) {
	            return;
	        }

	        var len = val.length * 2;

	        // set timeout to avoid blink
	        setTimeout(function () {
	            el.setSelectionRange(len, len);
	        }, 1);
	    },

	    isAndroid: function () {
	        return navigator && /android/i.test(navigator.userAgent);
	    },

	    // On Android chrome, the keyup and keydown events
	    // always return key code 229 as a composition that
	    // buffers the user’s keystrokes
	    // see https://github.com/nosir/cleave.js/issues/147
	    isAndroidBackspaceKeydown: function (lastInputValue, currentInputValue) {
	        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
	            return false;
	        }

	        return currentInputValue === lastInputValue.slice(0, -1);
	    }
	};

	module.exports = Util;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	/**
	 * Props Assignment
	 *
	 * Separate this, so react module can share the usage
	 */
	var DefaultProperties = {
	    // Maybe change to object-assign
	    // for now just keep it as simple
	    assign: function (target, opts) {
	        target = target || {};
	        opts = opts || {};

	        // credit card
	        target.creditCard = !!opts.creditCard;
	        target.creditCardStrictMode = !!opts.creditCardStrictMode;
	        target.creditCardType = '';
	        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || (function () {});

	        // phone
	        target.phone = !!opts.phone;
	        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
	        target.phoneFormatter = {};

	        // date
	        target.date = !!opts.date;
	        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
	        target.dateFormatter = {};

	        // numeral
	        target.numeral = !!opts.numeral;
	        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
	        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
	        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
	        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
	        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
	        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;

	        // others
	        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

	        target.uppercase = !!opts.uppercase;
	        target.lowercase = !!opts.lowercase;

	        target.prefix = (target.creditCard || target.date) ? '' : (opts.prefix || '');
	        target.noImmediatePrefix = !!opts.noImmediatePrefix;
	        target.prefixLength = target.prefix.length;
	        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
	        target.copyDelimiter = !!opts.copyDelimiter;

	        target.initValue = (opts.initValue !== undefined && opts.initValue !== null) ? opts.initValue.toString() : '';

	        target.delimiter =
	            (opts.delimiter || opts.delimiter === '') ? opts.delimiter :
	                (opts.date ? '/' :
	                    (opts.numeral ? ',' :
	                        (opts.phone ? ' ' :
	                            ' ')));
	        target.delimiterLength = target.delimiter.length;
	        target.delimiterLazyShow = !!opts.delimiterLazyShow;
	        target.delimiters = opts.delimiters || [];

	        target.blocks = opts.blocks || [];
	        target.blocksLength = target.blocks.length;

	        target.root = (typeof global === 'object' && global) ? global : window;

	        target.maxLength = 0;

	        target.backspace = false;
	        target.result = '';

	        return target;
	    }
	};

	module.exports = DefaultProperties;


	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ])
});
;

/***/ }),

/***/ 2270:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(){function l(l,n){var u=l.split("."),d=Z;u[0]in d||!d.execScript||d.execScript("var "+u[0]);for(var A;u.length&&(A=u.shift());)u.length||void 0===n?d=d[A]?d[A]:d[A]={}:d[A]=n}function n(l,n){function u(){}u.prototype=n.prototype,l.M=n.prototype,l.prototype=new u,l.prototype.constructor=l,l.N=function(l,u,d){for(var A=Array(arguments.length-2),N=2;N<arguments.length;N++)A[N-2]=arguments[N];return n.prototype[u].apply(l,A)}}function u(l,n){null!=l&&this.a.apply(this,arguments)}function d(l){l.b=""}function A(l,n){l.sort(n||N)}function N(l,n){return l>n?1:n>l?-1:0}function $(l){var n,u=[],d=0;for(n in l)u[d++]=l[n];return u}function t(l,n){this.b=l,this.a={};for(var u=0;u<n.length;u++){var d=n[u];this.a[d.b]=d}}function e(l){return l=$(l.a),A(l,function(l,n){return l.b-n.b}),l}function r(l,n){switch(this.b=l,this.g=!!n.G,this.a=n.c,this.j=n.type,this.h=!1,this.a){case Y:case w:case x:case J:case Q:case W:case V:this.h=!0}this.f=n.defaultValue}function i(){this.a={},this.f=this.i().a,this.b=this.g=null}function a(l,n){for(var u=e(l.i()),d=0;d<u.length;d++){var A=u[d],N=A.b;if(null!=n.a[N]){l.b&&delete l.b[A.b];var $=11==A.a||10==A.a;if(A.g)for(var A=o(n,N)||[],t=0;t<A.length;t++){var r=l,i=N,C=$?A[t].clone():A[t];r.a[i]||(r.a[i]=[]),r.a[i].push(C),r.b&&delete r.b[i]}else A=o(n,N),$?($=o(l,N))?a($,A):p(l,N,A.clone()):p(l,N,A)}}}function o(l,n){var u=l.a[n];if(null==u)return null;if(l.g){if(!(n in l.b)){var d=l.g,A=l.f[n];if(null!=u)if(A.g){for(var N=[],$=0;$<u.length;$++)N[$]=d.b(A,u[$]);u=N}else u=d.b(A,u);return l.b[n]=u}return l.b[n]}return u}function C(l,n,u){var d=o(l,n);return l.f[n].g?d[u||0]:d}function s(l,n){var u;if(null!=l.a[n])u=C(l,n,void 0);else l:{if(u=l.f[n],void 0===u.f){var d=u.j;if(d===Boolean)u.f=!1;else if(d===Number)u.f=0;else{if(d!==String){u=new d;break l}u.f=u.h?"0":""}}u=u.f}return u}function f(l,n){return l.f[n].g?null!=l.a[n]?l.a[n].length:0:null!=l.a[n]?1:0}function p(l,n,u){l.a[n]=u,l.b&&(l.b[n]=u)}function c(l,n){var u,d=[];for(u in n)0!=u&&d.push(new r(u,n[u]));return new t(l,d)}/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function h(){i.call(this)}function g(){i.call(this)}function S(){i.call(this)}function M(){}function b(){}function m(){}/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function G(){this.a={}}function T(l,n){if(null==n)return null;n=n.toUpperCase();var u=l.a[n];if(null==u){if(u=ll[n],null==u)return null;u=(new m).a(S.i(),u),l.a[n]=u}return u}function y(l){return l=z[l],null==l?"ZZ":l[0]}function B(l){this.H=RegExp(" "),this.B="",this.m=new u,this.v="",this.h=new u,this.u=new u,this.j=!0,this.w=this.o=this.D=!1,this.F=G.b(),this.s=0,this.b=new u,this.A=!1,this.l="",this.a=new u,this.f=[],this.C=l,this.J=this.g=E(this,this.C)}function E(l,n){var u;if(null!=n&&isNaN(n)&&n.toUpperCase()in ll){if(u=T(l.F,n),null==u)throw"Invalid region code: "+n;u=s(u,10)}else u=0;return u=T(l.F,y(u)),null!=u?u:Nl}function v(l){for(var n=l.f.length,u=0;n>u;++u){var A=l.f[u],N=s(A,1);if(l.v==N)return!1;var $;$=l;var t=A,e=s(t,1);if(-1!=e.indexOf("|"))$=!1;else{e=e.replace($l,"\\d"),e=e.replace(tl,"\\d"),d($.m);var r;r=$;var t=s(t,2),i="999999999999999".match(e)[0];i.length<r.a.b.length?r="":(r=i.replace(new RegExp(e,"g"),t),r=r.replace(RegExp("9","g")," ")),0<r.length?($.m.a(r),$=!0):$=!1}if($)return l.v=N,l.A=rl.test(C(A,4)),l.s=0,!0}return l.j=!1}function R(l,n){for(var u=[],d=n.length-3,A=l.f.length,N=0;A>N;++N){var $=l.f[N];0==f($,3)?u.push(l.f[N]):($=C($,3,Math.min(d,f($,3)-1)),0==n.search($)&&u.push(l.f[N]))}l.f=u}function I(l,n){l.h.a(n);var u=n;if(dl.test(u)||1==l.h.b.length&&ul.test(u)){var A,u=n;"+"==u?(A=u,l.u.a(u)):(A=nl[u],l.u.a(A),l.a.a(A)),n=A}else l.j=!1,l.D=!0;if(!l.j){if(!l.D)if(H(l)){if(U(l))return L(l)}else if(0<l.l.length&&(u=l.a.toString(),d(l.a),l.a.a(l.l),l.a.a(u),u=l.b.toString(),A=u.lastIndexOf(l.l),d(l.b),l.b.a(u.substring(0,A))),l.l!=D(l))return l.b.a(" "),L(l);return l.h.toString()}switch(l.u.b.length){case 0:case 1:case 2:return l.h.toString();case 3:if(!H(l))return l.l=D(l),P(l);l.w=!0;default:return l.w?(U(l)&&(l.w=!1),l.b.toString()+l.a.toString()):0<l.f.length?(u=O(l,n),A=K(l),0<A.length?A:(R(l,l.a.toString()),v(l)?F(l):l.j?_(l,u):l.h.toString())):P(l)}}function L(l){return l.j=!0,l.w=!1,l.f=[],l.s=0,d(l.m),l.v="",P(l)}function K(l){for(var n=l.a.toString(),u=l.f.length,d=0;u>d;++d){var A=l.f[d],N=s(A,1);if(new RegExp("^(?:"+N+")$").test(n))return l.A=rl.test(C(A,4)),n=n.replace(new RegExp(N,"g"),C(A,2)),_(l,n)}return""}function _(l,n){var u=l.b.b.length;return l.A&&u>0&&" "!=l.b.toString().charAt(u-1)?l.b+" "+n:l.b+n}function P(l){var n=l.a.toString();if(3<=n.length){for(var u=l.o&&0<f(l.g,20)?o(l.g,20)||[]:o(l.g,19)||[],d=u.length,A=0;d>A;++A){var N,$=u[A];(N=null==l.g.a[12]||l.o||C($,6))||(N=s($,4),N=0==N.length||Al.test(N)),N&&el.test(s($,2))&&l.f.push($)}return R(l,n),n=K(l),0<n.length?n:v(l)?F(l):l.h.toString()}return _(l,n)}function F(l){var n=l.a.toString(),u=n.length;if(u>0){for(var d="",A=0;u>A;A++)d=O(l,n.charAt(A));return l.j?_(l,d):l.h.toString()}return l.b.toString()}function D(l){var n,u=l.a.toString(),A=0;return 1!=C(l.g,10)?n=!1:(n=l.a.toString(),n="1"==n.charAt(0)&&"0"!=n.charAt(1)&&"1"!=n.charAt(1)),n?(A=1,l.b.a("1").a(" "),l.o=!0):null!=l.g.a[15]&&(n=new RegExp("^(?:"+C(l.g,15)+")"),n=u.match(n),null!=n&&null!=n[0]&&0<n[0].length&&(l.o=!0,A=n[0].length,l.b.a(u.substring(0,A)))),d(l.a),l.a.a(u.substring(A)),u.substring(0,A)}function H(l){var n=l.u.toString(),u=new RegExp("^(?:\\+|"+C(l.g,11)+")"),u=n.match(u);return null!=u&&null!=u[0]&&0<u[0].length?(l.o=!0,u=u[0].length,d(l.a),l.a.a(n.substring(u)),d(l.b),l.b.a(n.substring(0,u)),"+"!=n.charAt(0)&&l.b.a(" "),!0):!1}function U(l){if(0==l.a.b.length)return!1;var n,A=new u;l:{if(n=l.a.toString(),0!=n.length&&"0"!=n.charAt(0))for(var N,$=n.length,t=1;3>=t&&$>=t;++t)if(N=parseInt(n.substring(0,t),10),N in z){A.a(n.substring(t)),n=N;break l}n=0}return 0==n?!1:(d(l.a),l.a.a(A.toString()),A=y(n),"001"==A?l.g=T(l.F,""+n):A!=l.C&&(l.g=E(l,A)),l.b.a(""+n).a(" "),l.l="",!0)}function O(l,n){var u=l.m.toString();if(0<=u.substring(l.s).search(l.H)){var A=u.search(l.H),u=u.replace(l.H,n);return d(l.m),l.m.a(u),l.s=A,u.substring(0,l.s+1)}return 1==l.f.length&&(l.j=!1),l.v="",l.h.toString()}var Z=this;u.prototype.b="",u.prototype.set=function(l){this.b=""+l},u.prototype.a=function(l,n,u){if(this.b+=String(l),null!=n)for(var d=1;d<arguments.length;d++)this.b+=arguments[d];return this},u.prototype.toString=function(){return this.b};var V=1,W=2,Y=3,w=4,x=6,J=16,Q=18;i.prototype.set=function(l,n){p(this,l.b,n)},i.prototype.clone=function(){var l=new this.constructor;return l!=this&&(l.a={},l.b&&(l.b={}),a(l,this)),l};var j;n(h,i);var X;n(g,i);var q;n(S,i),h.prototype.i=function(){return j||(j=c(h,{0:{name:"NumberFormat",I:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,c:9,type:String},2:{name:"format",required:!0,c:9,type:String},3:{name:"leading_digits_pattern",G:!0,c:9,type:String},4:{name:"national_prefix_formatting_rule",c:9,type:String},6:{name:"national_prefix_optional_when_formatting",c:8,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",c:9,type:String}})),j},h.ctor=h,h.ctor.i=h.prototype.i,g.prototype.i=function(){return X||(X=c(g,{0:{name:"PhoneNumberDesc",I:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",c:9,type:String},3:{name:"possible_number_pattern",c:9,type:String},6:{name:"example_number",c:9,type:String},7:{name:"national_number_matcher_data",c:12,type:String},8:{name:"possible_number_matcher_data",c:12,type:String}})),X},g.ctor=g,g.ctor.i=g.prototype.i,S.prototype.i=function(){return q||(q=c(S,{0:{name:"PhoneMetadata",I:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",c:11,type:g},2:{name:"fixed_line",c:11,type:g},3:{name:"mobile",c:11,type:g},4:{name:"toll_free",c:11,type:g},5:{name:"premium_rate",c:11,type:g},6:{name:"shared_cost",c:11,type:g},7:{name:"personal_number",c:11,type:g},8:{name:"voip",c:11,type:g},21:{name:"pager",c:11,type:g},25:{name:"uan",c:11,type:g},27:{name:"emergency",c:11,type:g},28:{name:"voicemail",c:11,type:g},24:{name:"no_international_dialling",c:11,type:g},9:{name:"id",required:!0,c:9,type:String},10:{name:"country_code",c:5,type:Number},11:{name:"international_prefix",c:9,type:String},17:{name:"preferred_international_prefix",c:9,type:String},12:{name:"national_prefix",c:9,type:String},13:{name:"preferred_extn_prefix",c:9,type:String},15:{name:"national_prefix_for_parsing",c:9,type:String},16:{name:"national_prefix_transform_rule",c:9,type:String},18:{name:"same_mobile_and_fixed_line_pattern",c:8,defaultValue:!1,type:Boolean},19:{name:"number_format",G:!0,c:11,type:h},20:{name:"intl_number_format",G:!0,c:11,type:h},22:{name:"main_country_for_code",c:8,defaultValue:!1,type:Boolean},23:{name:"leading_digits",c:9,type:String},26:{name:"leading_zero_possible",c:8,defaultValue:!1,type:Boolean}})),q},S.ctor=S,S.ctor.i=S.prototype.i,M.prototype.a=function(l){throw new l.b,Error("Unimplemented")},M.prototype.b=function(l,n){if(11==l.a||10==l.a)return n instanceof i?n:this.a(l.j.prototype.i(),n);if(14==l.a){if("string"==typeof n&&k.test(n)){var u=Number(n);if(u>0)return u}return n}if(!l.h)return n;if(u=l.j,u===String){if("number"==typeof n)return String(n)}else if(u===Number&&"string"==typeof n&&("Infinity"===n||"-Infinity"===n||"NaN"===n||k.test(n)))return Number(n);return n};var k=/^-?[0-9]+$/;n(b,M),b.prototype.a=function(l,n){var u=new l.b;return u.g=this,u.a=n,u.b={},u},n(m,b),m.prototype.b=function(l,n){return 8==l.a?!!n:M.prototype.b.apply(this,arguments)},m.prototype.a=function(l,n){return m.M.a.call(this,l,n)};/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var z={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],381:["RS"],382:["ME"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},ll={800:[null,[null,null,"\\d{8}","\\d{8}",null,null,"12345678"],[null,null,"NA","NA",null,null,"12345678"],[null,null,"NA","NA",null,null,"12345678"],[null,null,"\\d{8}","\\d{8}",null,null,"12345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",800,null,null,null,null,null,null,null,1,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],808:[null,[null,null,"\\d{8}","\\d{8}",null,null,"12345678"],[null,null,"NA","NA",null,null,"12345678"],[null,null,"NA","NA",null,null,"12345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"\\d{8}","\\d{8}",null,null,"12345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",808,null,null,null,null,null,null,null,1,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],870:[null,[null,null,"[35-7]\\d{8}","\\d{9}",null,null,"301234567"],[null,null,"NA","NA",null,null,"301234567"],[null,null,"(?:[356]\\d|7[6-8])\\d{7}","\\d{9}",null,null,"301234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",870,null,null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],878:[null,[null,null,"1\\d{11}","\\d{12}",null,null,"101234567890"],[null,null,"NA","NA",null,null,"101234567890"],[null,null,"NA","NA",null,null,"101234567890"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"10\\d{10}","\\d{12}",null,null,"101234567890"],"001",878,null,null,null,null,null,null,null,1,[[null,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],881:[null,[null,null,"[67]\\d{8}","\\d{9}",null,null,"612345678"],[null,null,"NA","NA",null,null,"612345678"],[null,null,"[67]\\d{8}","\\d{9}",null,null,"612345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",881,null,null,null,null,null,null,null,null,[[null,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[67]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],882:[null,[null,null,"[13]\\d{6,11}","\\d{7,12}",null,null,"3451234567"],[null,null,"NA","NA",null,null,"3451234567"],[null,null,"3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}","\\d{7,10}",null,null,"3451234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|345\\d{7}","\\d{7,12}",null,null,"3451234567"],"001",882,null,null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[null,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["348"]],[null,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1"]],[null,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],[null,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["16"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"348[57]\\d{7}","\\d{11}",null,null,"3451234567"]],883:[null,[null,null,"51\\d{7}(?:\\d{3})?","\\d{9}(?:\\d{3})?",null,null,"510012345"],[null,null,"NA","NA",null,null,"510012345"],[null,null,"NA","NA",null,null,"510012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})","\\d{9}(?:\\d{3})?",null,null,"510012345"],"001",883,null,null,null,null,null,null,null,1,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[null,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],[null,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],888:[null,[null,null,"\\d{11}","\\d{11}",null,null,"12345678901"],[null,null,"NA","NA",null,null,"12345678901"],[null,null,"NA","NA",null,null,"12345678901"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",888,null,null,null,null,null,null,null,1,[[null,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"\\d{11}","\\d{11}",null,null,"12345678901"],1,null,[null,null,"NA","NA"]],979:[null,[null,null,"\\d{9}","\\d{9}",null,null,"123456789"],[null,null,"NA","NA",null,null,"123456789"],[null,null,"NA","NA",null,null,"123456789"],[null,null,"NA","NA"],[null,null,"\\d{9}","\\d{9}",null,null,"123456789"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"001",979,null,null,null,null,null,null,null,1,[[null,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],AC:[null,[null,null,"[46]\\d{4}|[01589]\\d{5}","\\d{5,6}"],[null,null,"6[2-467]\\d{3}","\\d{5}",null,null,"62889"],[null,null,"4\\d{4}","\\d{5}",null,null,"40123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AC",247,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"[01589]\\d{5}","\\d{6}",null,null,"542011"],null,null,[null,null,"NA","NA"]],AD:[null,[null,null,"(?:[346-9]|180)\\d{5}","\\d{6,8}"],[null,null,"[78]\\d{5}","\\d{6}",null,null,"712345"],[null,null,"[346]\\d{5}","\\d{6}",null,null,"312345"],[null,null,"180[02]\\d{4}","\\d{8}",null,null,"18001234"],[null,null,"9\\d{5}","\\d{6}",null,null,"912345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AD",376,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})","$1 $2",["[346-9]"]],[null,"(180[02])(\\d{4})","$1 $2",["1"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AE:[null,[null,null,"[2-79]\\d{7,8}|800\\d{2,9}","\\d{5,12}"],[null,null,"[2-4679][2-8]\\d{6}","\\d{7,8}",null,null,"22345678"],[null,null,"5[0256]\\d{7}","\\d{9}",null,null,"501234567"],[null,null,"400\\d{6}|800\\d{2,9}","\\d{5,12}",null,null,"800123456"],[null,null,"900[02]\\d{5}","\\d{9}",null,null,"900234567"],[null,null,"700[05]\\d{5}","\\d{9}",null,null,"700012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AE",971,"00","0",null,null,"0",null,null,null,[[null,"([2-4679])(\\d{3})(\\d{4})","$1 $2 $3",["[2-4679][2-8]"],"0$1"],[null,"(5[0256])(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[null,"([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]0"],"$1"],[null,"([68]00)(\\d{2,9})","$1 $2",["60|8"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"600[25]\\d{5}","\\d{9}",null,null,"600212345"],null,null,[null,null,"NA","NA"]],AF:[null,[null,null,"[2-7]\\d{8}","\\d{7,9}"],[null,null,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}","\\d{7,9}",null,null,"234567890"],[null,null,"7(?:[014-9]\\d{7}|2[89]\\d{6})","\\d{9}",null,null,"701234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AF",93,"00","0",null,null,"0",null,null,null,[[null,"([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AG:[null,[null,null,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"2684601234"],[null,null,"268(?:464|7(?:2[0-9]|64|7[0-689]|8[02-68]))\\d{4}","\\d{10}",null,null,"2684641234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"26848[01]\\d{4}","\\d{10}",null,null,"2684801234"],"AG",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"26840[69]\\d{4}","\\d{10}",null,null,"2684061234"],null,"268",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AI:[null,[null,null,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"2644(?:6[12]|9[78])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"2644612345"],[null,null,"264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}","\\d{10}",null,null,"2642351234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"AI",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"264",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AL:[null,[null,null,"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}","\\d{5,9}"],[null,null,"(?:2(?:[168][1-9]|[247]\\d|9[1-7])|3(?:1[1-3]|[2-6]\\d|[79][1-8]|8[1-9])|4\\d{2}|5(?:1[1-4]|[2-578]\\d|6[1-5]|9[1-7])|8(?:[19][1-5]|[2-6]\\d|[78][1-7]))\\d{5}","\\d{5,8}",null,null,"22345678"],[null,null,"6[6-9]\\d{7}","\\d{9}",null,null,"661234567"],[null,null,"800\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"900\\d{3}","\\d{6}",null,null,"900123"],[null,null,"808\\d{3}","\\d{6}",null,null,"808123"],[null,null,"700\\d{5}","\\d{8}",null,null,"70012345"],[null,null,"NA","NA"],"AL",355,"00","0",null,null,"0",null,null,null,[[null,"(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"],"0$1"],[null,"(6[6-9])(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"],"0$1"],[null,"(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|8[016-9]|[79]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AM:[null,[null,null,"[1-9]\\d{7}","\\d{5,8}"],[null,null,"(?:1[01]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}","\\d{5,8}",null,null,"10123456"],[null,null,"(?:4[139]|55|77|9[1-9])\\d{6}","\\d{8}",null,null,"77123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"90[016]\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"80[1-4]\\d{5}","\\d{8}",null,null,"80112345"],[null,null,"NA","NA"],[null,null,"60[2-6]\\d{5}","\\d{8}",null,null,"60271234"],"AM",374,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[null,"(\\d{2})(\\d{6})","$1 $2",["4[139]|[5-7]|9[1-9]"],"0$1"],[null,"(\\d{3})(\\d{5})","$1 $2",["[23]"],"(0$1)"],[null,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AO:[null,[null,null,"[29]\\d{8}","\\d{9}"],[null,null,"2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}","\\d{9}",null,null,"222123456"],[null,null,"9[1-49]\\d{7}","\\d{9}",null,null,"923123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AO",244,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AR:[null,[null,null,"11\\d{8}|[2368]\\d{9}|9\\d{10}","\\d{6,11}"],[null,null,"11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}","\\d{6,10}",null,null,"1123456789"],[null,null,"675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})","\\d{6,11}",null,null,"91123456789"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"60[04579]\\d{7}","\\d{10}",null,null,"6001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AR",54,"00","0",null,null,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1",null,null,[[null,"([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[null,"(\\d{2})(\\d{4})","$1-$2",["[2-9]"],"$1"],[null,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"],"$1"],[null,"(\\d{4})(\\d{4})","$1-$2",["[2-9]"],"$1"],[null,"(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],"0$1"],[null,"(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[234689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],"0$1"],[null,"(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],"0$1"],[null,"(11)(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],"0$1",null,1],[null,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],"0$1",null,1],[null,"(\\d{3})","$1",["1[012]|911"],"$1"]],[[null,"([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[null,"(9)(11)(\\d{4})(\\d{4})","$1 $2 $3-$4",["911"]],[null,"(9)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9(?:2[234689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"]],[null,"(9)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9[23]"]],[null,"(11)(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],"0$1",null,1],[null,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],"0$1",null,1]],[null,null,"NA","NA"],null,null,[null,null,"810\\d{7}","\\d{10}",null,null,"8101234567"],[null,null,"810\\d{7}","\\d{10}",null,null,"8101234567"],null,null,[null,null,"NA","NA"]],AS:[null,[null,null,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"6846(?:22|33|44|55|77|88|9[19])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6846221234"],[null,null,"684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}","\\d{10}",null,null,"6847331234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"AS",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"684",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AT:[null,[null,null,"[1-9]\\d{3,12}","\\d{3,13}"],[null,null,"1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}","\\d{3,13}",null,null,"1234567890"],[null,null,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}","\\d{7,13}",null,null,"664123456"],[null,null,"800\\d{6,10}","\\d{9,13}",null,null,"800123456"],[null,null,"(?:9(?:0[01]|3[019]))\\d{6,10}","\\d{9,13}",null,null,"900123456"],[null,null,"8(?:10\\d|2(?:[01]\\d|8\\d?))\\d{5,9}","\\d{8,13}",null,null,"810123456"],[null,null,"NA","NA"],[null,null,"780\\d{6,10}","\\d{9,13}",null,null,"780123456"],"AT",43,"00","0",null,null,"0",null,null,null,[[null,"(116\\d{3})","$1",["116"],"$1"],[null,"(1)(\\d{3,12})","$1 $2",["1"],"0$1"],[null,"(5\\d)(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[null,"(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"],"0$1"],[null,"(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"],"0$1"],[null,"(\\d{3})(\\d{3,10})","$1 $2",["316|46|51|732|6(?:5[0-3579]|[6-9])|7(?:[28]0)|[89]"],"0$1"],[null,"(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}","\\d{5,13}",null,null,"50123"],null,null,[null,null,"NA","NA"]],AU:[null,[null,null,"[1-578]\\d{5,9}","\\d{6,10}"],[null,null,"[237]\\d{8}|8(?:[6-8]\\d{3}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}","\\d{8,9}",null,null,"212345678"],[null,null,"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","\\d{9}",null,null,"412345678"],[null,null,"180(?:0\\d{3}|2)\\d{3}","\\d{7,10}",null,null,"1800123456"],[null,null,"19(?:0[0126]\\d|[679])\\d{5}","\\d{8,10}",null,null,"1900123456"],[null,null,"13(?:00\\d{3}|45[0-4]|\\d)\\d{3}","\\d{6,10}",null,null,"1300123456"],[null,null,"500\\d{6}","\\d{9}",null,null,"500123456"],[null,null,"550\\d{6}","\\d{9}",null,null,"550123456"],"AU",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",null,null,"0",null,"0011",null,[[null,"([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[45]|14"],"0$1"],[null,"(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[null,"(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[38]0|90)","1(?:[38]00|90)"],"$1"],[null,"(180)(2\\d{3})","$1 $2",["180","1802"],"$1"],[null,"(19\\d)(\\d{3})","$1 $2",["19[13]"],"$1"],[null,"(19\\d{2})(\\d{4})","$1 $2",["19[679]"],"$1"],[null,"(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"],"$1"]],null,[null,null,"16\\d{3,7}","\\d{5,9}",null,null,"1612345"],1,null,[null,null,"1(?:3(?:00\\d{3}|45[0-4]|\\d)\\d{3}|80(?:0\\d{6}|2\\d{3}))","\\d{6,10}",null,null,"1300123456"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AW:[null,[null,null,"[25-9]\\d{6}","\\d{7}"],[null,null,"5(?:2\\d|8[1-9])\\d{4}","\\d{7}",null,null,"5212345"],[null,null,"(?:5(?:6\\d|9[2-478])|6(?:[039]0|22|4[01]|6[0-2])|7[34]\\d|9(?:6[45]|9[4-8]))\\d{4}","\\d{7}",null,null,"5601234"],[null,null,"800\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"900\\d{4}","\\d{7}",null,null,"9001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"28\\d{5}|501\\d{4}","\\d{7}",null,null,"5011234"],"AW",297,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],AX:[null,[null,null,"[135]\\d{5,9}|[27]\\d{4,9}|4\\d{5,10}|6\\d{7,8}|8\\d{6,9}","\\d{5,12}"],[null,null,"18[1-8]\\d{3,9}","\\d{6,12}",null,null,"1812345678"],[null,null,"4\\d{5,10}|50\\d{4,8}","\\d{6,11}",null,null,"412345678"],[null,null,"800\\d{4,7}","\\d{7,10}",null,null,"8001234567"],[null,null,"[67]00\\d{5,6}","\\d{8,9}",null,null,"600123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AX",358,"00|99[049]","0",null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",null,null,"100123"],[null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",null,null,"10112345"],null,null,[null,null,"NA","NA"]],AZ:[null,[null,null,"[1-9]\\d{8}","\\d{7,9}"],[null,null,"(?:1[28]\\d|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])|365)\\d{6}","\\d{7,9}",null,null,"123123456"],[null,null,"(?:4[04]|5[015]|60|7[07])\\d{7}","\\d{9}",null,null,"401234567"],[null,null,"88\\d{7}","\\d{9}",null,null,"881234567"],[null,null,"900200\\d{3}","\\d{9}",null,null,"900200123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"AZ",994,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["(?:1[28]|2(?:[45]2|[0-36])|365)"],"(0$1)"],[null,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BA:[null,[null,null,"[3-9]\\d{7,8}","\\d{6,9}"],[null,null,"(?:[35]\\d|49)\\d{6}","\\d{6,8}",null,null,"30123456"],[null,null,"6(?:03|44|71|[1-356])\\d{6}","\\d{8,9}",null,null,"61123456"],[null,null,"8[08]\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"9[0246]\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"8[12]\\d{6}","\\d{8}",null,null,"82123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BA",387,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"70[23]\\d{5}","\\d{8}",null,null,"70223456"],null,null,[null,null,"NA","NA"]],BB:[null,[null,null,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7(?:37|57)|9(?:1[89]|63))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"2464123456"],[null,null,"246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|8(?:[2-5]\\d|83))\\d{4}","\\d{10}",null,null,"2462501234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900\\d{7}|246976\\d{4}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"24631\\d{5}","\\d{10}",null,null,"2463101234"],"BB",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"246",[null,null,"NA","NA"],[null,null,"246(?:292|41[7-9]|43[01])\\d{4}","\\d{10}",null,null,"2464301234"],null,null,[null,null,"NA","NA"]],BD:[null,[null,null,"[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}","\\d{6,10}"],[null,null,"2(?:550\\d|7(?:1[0-267]|2[0-289]|3[0-29]|[46][01]|5[1-3]|7[017]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|6[1-35]|7[1-5]|8[1-8]|90)|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[0146-8]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}","\\d{6,9}",null,null,"27111234"],[null,null,"(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}","\\d{10}",null,null,"1812345678"],[null,null,"80[03]\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"96(?:0[49]|1[0-4]|6[69])\\d{6}","\\d{10}",null,null,"9604123456"],"BD",880,"00[12]?","0",null,null,"0",null,"00",null,[[null,"(2)(\\d{7,8})","$1-$2",["2"],"0$1"],[null,"(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"],"0$1"],[null,"(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"],"0$1"],[null,"(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BE:[null,[null,null,"[1-9]\\d{7,8}","\\d{8,9}"],[null,null,"(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}|80[2-8]\\d{5}","\\d{8}",null,null,"12345678"],[null,null,"4(?:6[0135-8]|[79]\\d|8[3-9])\\d{6}","\\d{9}",null,null,"470123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"(?:70[2-467]|90[0-79])\\d{5}","\\d{8}",null,null,"90123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BE",32,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[6-9]"],"0$1"],[null,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"78\\d{6}","\\d{8}",null,null,"78123456"],null,null,[null,null,"NA","NA"]],BF:[null,[null,null,"[267]\\d{7}","\\d{8}"],[null,null,"2(?:0(?:49|5[23]|9[016-9])|4(?:4[569]|5[4-6]|7[0179])|5(?:[34]\\d|50))\\d{4}","\\d{8}",null,null,"20491234"],[null,null,"6(?:[0-689]\\d|7[0-5])\\d{5}|7\\d{7}","\\d{8}",null,null,"70123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BF",226,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BG:[null,[null,null,"[23567]\\d{5,7}|[489]\\d{6,8}","\\d{5,9}"],[null,null,"2(?:[0-8]\\d{5,6}|9\\d{4,6})|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}","\\d{5,8}",null,null,"2123456"],[null,null,"(?:8[7-9]\\d|9(?:8\\d|99))\\d{6}|4(?:3[0789]|8\\d)\\d{5}","\\d{8,9}",null,null,"48123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"90\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"NA","NA"],[null,null,"700\\d{5}","\\d{5,9}",null,null,"70012345"],[null,null,"NA","NA"],"BG",359,"00","0",null,null,"0",null,null,null,[[null,"(2)(\\d{5})","$1 $2",["29"],"0$1"],[null,"(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[null,"(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[78]00"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["999"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BH:[null,[null,null,"[136-9]\\d{7}","\\d{8}"],[null,null,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d{2}))\\d{4}","\\d{8}",null,null,"17001234"],[null,null,"(?:3(?:[1-4679]\\d|5[013569]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9]|7[0-6])))\\d{4}","\\d{8}",null,null,"36001234"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"(?:87|9[014578])\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"84\\d{6}","\\d{8}",null,null,"84123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BH",973,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],
BI:[null,[null,null,"[267]\\d{7}","\\d{8}"],[null,null,"22\\d{6}","\\d{8}",null,null,"22201234"],[null,null,"(?:29|6[189]|7[124-9])\\d{6}","\\d{8}",null,null,"79561234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BI",257,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BJ:[null,[null,null,"[2689]\\d{7}|7\\d{3}","\\d{4,8}"],[null,null,"2(?:02|1[037]|2[45]|3[68])\\d{5}","\\d{8}",null,null,"20211234"],[null,null,"(?:6[1-8]|9[03-9])\\d{6}","\\d{8}",null,null,"90011234"],[null,null,"7[3-5]\\d{2}","\\d{4}",null,null,"7312"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"857[58]\\d{4}","\\d{8}",null,null,"85751234"],"BJ",229,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"81\\d{6}","\\d{8}",null,null,"81123456"],null,null,[null,null,"NA","NA"]],BL:[null,[null,null,"[56]\\d{8}","\\d{9}"],[null,null,"590(?:2[7-9]|5[12]|87)\\d{4}","\\d{9}",null,null,"590271234"],[null,null,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",null,null,"690301234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BL",590,"00","0",null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BM:[null,[null,null,"[4589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"4412345678"],[null,null,"441(?:[37]\\d|5[0-39])\\d{5}","\\d{10}",null,null,"4413701234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"BM",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"441",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BN:[null,[null,null,"[2-578]\\d{6}","\\d{7}"],[null,null,"2(?:[013-9]\\d|2[0-7])\\d{4}|[3-5]\\d{6}","\\d{7}",null,null,"2345678"],[null,null,"22[89]\\d{4}|[78]\\d{6}","\\d{7}",null,null,"7123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BN",673,"00",null,null,null,null,null,null,null,[[null,"([2-578]\\d{2})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BO:[null,[null,null,"[23467]\\d{7}","\\d{7,8}"],[null,null,"(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}","\\d{7,8}",null,null,"22123456"],[null,null,"[67]\\d{7}","\\d{8}",null,null,"71234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BO",591,"00(1\\d)?","0",null,null,"0(1\\d)?",null,null,null,[[null,"([234])(\\d{7})","$1 $2",["[234]"],null,"0$CC $1"],[null,"([67]\\d{7})","$1",["[67]"],null,"0$CC $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BQ:[null,[null,null,"[347]\\d{6}","\\d{7}"],[null,null,"(?:318[023]|416[023]|7(?:1[578]|50)\\d)\\d{3}","\\d{7}",null,null,"7151234"],[null,null,"(?:318[14-68]|416[15-9]|7(?:0[01]|7[07]|[89]\\d)\\d)\\d{3}","\\d{7}",null,null,"3181234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BQ",599,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BR:[null,[null,null,"[1-46-9]\\d{7,10}|5\\d{8,9}","\\d{8,11}"],[null,null,"(?:[14689][1-9]|2[12478]|3[1-578]|5[1-5]|7[13-579])[2-5]\\d{7}","\\d{8,11}",null,null,"1123456789"],[null,null,"1[1-9](?:7|9\\d)\\d{7}|(?:2[12478]|3[1-578]|[689][1-9]|7[13-579])(?:[6-8]|9\\d?)\\d{7}|(?:4[1-9]|5[1-5])[6-9]\\d{7}","\\d{10,11}",null,null,"11961234567"],[null,null,"800\\d{6,7}","\\d{8,11}",null,null,"800123456"],[null,null,"(?:300|[59]00\\d?)\\d{6}","\\d{8,11}",null,null,"300123456"],[null,null,"(?:300\\d(?:\\d{2})?|40(?:0\\d|20))\\d{4}","\\d{8,10}",null,null,"40041234"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",null,null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",null,null,[[null,"(\\d{4})(\\d{4})","$1-$2",["[2-9](?:[1-9]|0[1-9])"],"$1"],[null,"(\\d{5})(\\d{4})","$1-$2",["9(?:[1-9]|0[1-9])"],"$1"],[null,"(\\d{3,5})","$1",["1[125689]"],"$1"],[null,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["(?:[1689][1-9]|2[12478]|3[1-578]|7[13-579])9"],"($1)","0 $CC ($1)"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)","0 $CC ($1)"],[null,"(\\d{4})(\\d{4})","$1-$2",["(?:300|40(?:0|20))"]],[null,"([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"]],[[null,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["(?:[1689][1-9]|2[12478]|3[1-578]|7[13-579])9"],"($1)","0 $CC ($1)"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)","0 $CC ($1)"],[null,"(\\d{4})(\\d{4})","$1-$2",["(?:300|40(?:0|20))"]],[null,"([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"]],[null,null,"NA","NA"],null,null,[null,null,"(?:300\\d|40(?:0\\d|20))\\d{4}","\\d{8}",null,null,"40041234"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BS:[null,[null,null,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[3467]|8[0-4]|9[2-467])|461|502|6(?:0[1-3]|12|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"2423456789"],[null,null,"242(?:3(?:5[79]|[79]5)|4(?:[2-4][1-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-9]|65|77)|6[34]6|727)\\d{4}","\\d{10}",null,null,"2423591234"],[null,null,"242300\\d{4}|8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"BS",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"242",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BT:[null,[null,null,"[1-8]\\d{6,7}","\\d{6,8}"],[null,null,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}","\\d{6,7}",null,null,"2345678"],[null,null,"(?:1[67]|77)\\d{6}","\\d{8}",null,null,"17123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BT",975,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1|77"]],[null,"([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BW:[null,[null,null,"[2-79]\\d{6,7}","\\d{7,8}"],[null,null,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0235-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}","\\d{7}",null,null,"2401234"],[null,null,"7(?:[1-6]\\d|7[014-8])\\d{5}","\\d{8}",null,null,"71123456"],[null,null,"NA","NA"],[null,null,"90\\d{5}","\\d{7}",null,null,"9012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"79[12][01]\\d{4}","\\d{8}",null,null,"79101234"],"BW",267,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],[null,"(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"]],[null,"(90)(\\d{5})","$1 $2",["9"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BY:[null,[null,null,"[1-4]\\d{8}|800\\d{3,7}|[89]\\d{9,10}","\\d{6,11}"],[null,null,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}","\\d{6,11}",null,null,"152450911"],[null,null,"(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}","\\d{9}",null,null,"294911911"],[null,null,"8(?:0[13]|20\\d)\\d{7}|800\\d{3,7}","\\d{6,11}",null,null,"8011234567"],[null,null,"(?:810|902)\\d{7}","\\d{10}",null,null,"9021234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"249\\d{6}","\\d{9}",null,null,"249123456"],"BY",375,"810","8",null,null,"8?0?",null,"8~10",null,[[null,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],[null,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],[null,"([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],[null,"(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],[null,"(800)(\\d{3})","$1 $2",["800"],"8 $1"],[null,"(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"8(?:[013]|[12]0)\\d{8}|800\\d{3,7}|902\\d{7}","\\d{6,11}",null,null,"82012345678"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],BZ:[null,[null,null,"[2-8]\\d{6}|0\\d{10}","\\d{7}(?:\\d{4})?"],[null,null,"[234578][02]\\d{5}","\\d{7}",null,null,"2221234"],[null,null,"6[0-35-7]\\d{5}","\\d{7}",null,null,"6221234"],[null,null,"0800\\d{7}","\\d{11}",null,null,"08001234123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"BZ",501,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[null,"(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],CA:[null,[null,null,"[2-9]\\d{9}|3\\d{6}","\\d{7}(?:\\d{3})?"],[null,null,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}|310\\d{4}","\\d{7}(?:\\d{3})?",null,null,"2042345678"],[null,null,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"2042345678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}","\\d{7}(?:\\d{3})?",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"CA",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CC:[null,[null,null,"[1458]\\d{5,9}","\\d{6,10}"],[null,null,"89162\\d{4}","\\d{8,9}",null,null,"891621234"],[null,null,"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","\\d{9}",null,null,"412345678"],[null,null,"180(?:0\\d{3}|2)\\d{3}","\\d{7,10}",null,null,"1800123456"],[null,null,"190[0126]\\d{6}","\\d{10}",null,null,"1900123456"],[null,null,"13(?:00\\d{2})?\\d{4}","\\d{6,10}",null,null,"1300123456"],[null,null,"500\\d{6}","\\d{9}",null,null,"500123456"],[null,null,"550\\d{6}","\\d{9}",null,null,"550123456"],"CC",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",null,null,"0",null,"0011",null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CD:[null,[null,null,"[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}","\\d{7,9}"],[null,null,"1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}","\\d{7,9}",null,null,"1234567"],[null,null,"8(?:[0-2459]\\d{2}|8)\\d{5}|9[7-9]\\d{7}","\\d{7,9}",null,null,"991234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CD",243,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"],"0$1"],[null,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[null,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CF:[null,[null,null,"[278]\\d{7}","\\d{8}"],[null,null,"2[12]\\d{6}","\\d{8}",null,null,"21612345"],[null,null,"7[0257]\\d{6}","\\d{8}",null,null,"70012345"],[null,null,"NA","NA"],[null,null,"8776\\d{4}","\\d{8}",null,null,"87761234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CF",236,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CG:[null,[null,null,"[028]\\d{8}","\\d{9}"],[null,null,"222[1-589]\\d{5}","\\d{9}",null,null,"222123456"],[null,null,"0[14-6]\\d{7}","\\d{9}",null,null,"061234567"],[null,null,"NA","NA"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CG",242,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],[null,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],CH:[null,[null,null,"[2-9]\\d{8}|860\\d{9}","\\d{9}(?:\\d{3})?"],[null,null,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}","\\d{9}",null,null,"212345678"],[null,null,"7[5-9]\\d{7}","\\d{9}",null,null,"781234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"90[016]\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"84[0248]\\d{6}","\\d{9}",null,null,"840123456"],[null,null,"878\\d{6}","\\d{9}",null,null,"878123456"],[null,null,"NA","NA"],"CH",41,"00","0",null,null,"0",null,null,null,[[null,"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"],"0$1"],[null,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"],"0$1"]],null,[null,null,"74[0248]\\d{6}","\\d{9}",null,null,"740123456"],null,null,[null,null,"NA","NA"],[null,null,"5[18]\\d{7}","\\d{9}",null,null,"581234567"],null,null,[null,null,"860\\d{9}","\\d{12}",null,null,"860123456789"]],CI:[null,[null,null,"[02-8]\\d{7}","\\d{8}"],[null,null,"(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}","\\d{8}",null,null,"21234567"],[null,null,"(?:0[1-9]|4\\d|5[14-9]|6[015-79]|7[578]|87)\\d{6}","\\d{8}",null,null,"01234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CI",225,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],CK:[null,[null,null,"[2-8]\\d{4}","\\d{5}"],[null,null,"(?:2\\d|3[13-7]|4[1-5])\\d{3}","\\d{5}",null,null,"21234"],[null,null,"[5-8]\\d{4}","\\d{5}",null,null,"71234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CK",682,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CL:[null,[null,null,"(?:[2-9]|600|123)\\d{7,8}","\\d{7,11}"],[null,null,"2(?:1962\\d{4}|2\\d{7}|32[0-2]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d{7}","\\d{7,9}",null,null,"221234567"],[null,null,"9[4-9]\\d{7}","\\d{8,9}",null,null,"961234567"],[null,null,"800\\d{6}|1230\\d{7}","\\d{9,11}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"600\\d{7,8}","\\d{10,11}",null,null,"6001234567"],[null,null,"NA","NA"],[null,null,"44\\d{7}","\\d{9}",null,null,"441234567"],"CL",56,"(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0","0",null,null,"0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))",null,null,null,[[null,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)","$CC ($1)"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)","$CC ($1)"],[null,"(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"],"0$1"],[null,"(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"],"0$1"],[null,"([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"],"$1"],[null,"(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"],"$1"],[null,"(1230)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"$1"],[null,"(\\d{5})(\\d{4})","$1 $2",["219"],"($1)","$CC ($1)"],[null,"(\\d{4,5})","$1",["[1-9]"],"$1"]],[[null,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)","$CC ($1)"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)","$CC ($1)"],[null,"(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"],"0$1"],[null,"(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"],"0$1"],[null,"([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"],"$1"],[null,"(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"],"$1"],[null,"(1230)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"$1"],[null,"(\\d{5})(\\d{4})","$1 $2",["219"],"($1)","$CC ($1)"]],[null,null,"NA","NA"],null,null,[null,null,"600\\d{7,8}","\\d{10,11}",null,null,"6001234567"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CM:[null,[null,null,"[2368]\\d{7,8}","\\d{8,9}"],[null,null,"2(?:22|33|4[23])\\d{6}","\\d{9}",null,null,"222123456"],[null,null,"6[5-9]\\d{7}","\\d{9}",null,null,"671234567"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"88\\d{6}","\\d{8}",null,null,"88012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CM",237,"00",null,null,null,null,null,null,null,[[null,"([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|88"]],[null,"(800)(\\d{2})(\\d{3})","$1 $2 $3",["80"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CN:[null,[null,null,"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}","\\d{4,12}"],[null,null,"21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})|80(?:29|6[03578]|7[018]|81)\\d{4}","\\d{4,12}",null,null,"1012345678"],[null,null,"1(?:[38]\\d|4[57]|5[0-35-9]|7[036-8])\\d{8}","\\d{11}",null,null,"13123456789"],[null,null,"(?:10)?800\\d{7}","\\d{10,12}",null,null,"8001234567"],[null,null,"16[08]\\d{5}","\\d{8}",null,null,"16812345"],[null,null,"400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}","\\d{7,11}",null,null,"4001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CN",86,"(1(?:[129]\\d{3}|79\\d{2}))?00","0",null,null,"(1(?:[129]\\d{3}|79\\d{2}))|0",null,"00",null,[[null,"(80\\d{2})(\\d{4})","$1 $2",["80[2678]"],"0$1","$CC $1",1],[null,"([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],[null,"(\\d{5,6})","$1",["100|95"]],[null,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1","$CC $1"],[null,"(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d{2}[19]","[3-9]\\d{2}(?:10|9[56])"],"0$1","$CC $1"],[null,"(\\d{3,4})(\\d{4})","$1 $2",["[2-9]"]],[null,"(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","$CC $1",1],[null,"([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"],"0$1","$CC $1",1],[null,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-578]"],null,"$CC $1"],[null,"(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],[null,"(\\d{3})(\\d{7,8})","$1 $2",["950"]]],[[null,"(80\\d{2})(\\d{4})","$1 $2",["80[2678]"],"0$1","$CC $1",1],[null,"([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],[null,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1","$CC $1"],[null,"(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d{2}[19]","[3-9]\\d{2}(?:10|9[56])"],"0$1","$CC $1"],[null,"(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","$CC $1",1],[null,"([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"],"0$1","$CC $1",1],[null,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","$CC $1",1],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-578]"],null,"$CC $1"],[null,"(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],[null,"(\\d{3})(\\d{7,8})","$1 $2",["950"]]],[null,null,"NA","NA"],null,null,[null,null,"(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}","\\d{10,12}",null,null,"4001234567"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CO:[null,[null,null,"(?:[13]\\d{0,3}|[24-8])\\d{7}","\\d{7,11}"],[null,null,"[124-8][2-9]\\d{6}","\\d{8}",null,null,"12345678"],[null,null,"3(?:0[0-5]|1\\d|2[0-2]|5[01])\\d{7}","\\d{10}",null,null,"3211234567"],[null,null,"1800\\d{7}","\\d{11}",null,null,"18001234567"],[null,null,"19(?:0[01]|4[78])\\d{7}","\\d{11}",null,null,"19001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",null,null,"0([3579]|4(?:44|56))?",null,null,null,[[null,"(\\d)(\\d{7})","$1 $2",["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"],"($1)","0$CC $1"],[null,"(\\d{3})(\\d{7})","$1 $2",["3"],null,"0$CC $1"],[null,"(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1"]],[[null,"(\\d)(\\d{7})","$1 $2",["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"],"($1)","0$CC $1"],[null,"(\\d{3})(\\d{7})","$1 $2",["3"],null,"0$CC $1"],[null,"(1)(\\d{3})(\\d{7})","$1 $2 $3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"]]],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CR:[null,[null,null,"[24-9]\\d{7,9}","\\d{8,10}"],[null,null,"2[0-24-7]\\d{6}","\\d{8}",null,null,"22123456"],[null,null,"5(?:0[01]|7[0-3])\\d{5}|(?:[67][0-3]|8[3-9])\\d{6}","\\d{8}",null,null,"83123456"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"90[059]\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"210[0-6]\\d{4}|4\\d{7}|5100\\d{4}","\\d{8}",null,null,"40001234"],"CR",506,"00",null,null,null,"(19(?:0[012468]|1[09]|20|66|77|99))",null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"],null,"$CC $1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"],null,"$CC $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CU:[null,[null,null,"[2-57]\\d{5,7}","\\d{4,8}"],[null,null,"2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}","\\d{4,8}",null,null,"71234567"],[null,null,"5\\d{7}","\\d{8}",null,null,"51234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CU",53,"119","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],[null,"(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"],"(0$1)"],[null,"(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CV:[null,[null,null,"[259]\\d{6}","\\d{7}"],[null,null,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}","\\d{7}",null,null,"2211234"],[null,null,"(?:9\\d|59)\\d{5}","\\d{7}",null,null,"9911234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CV",238,"0",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CW:[null,[null,null,"[169]\\d{6,7}","\\d{7,8}"],[null,null,"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","\\d{7,8}",null,null,"94151234"],[null,null,"9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}","\\d{7,8}",null,null,"95181234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"60[0-2]\\d{4}","\\d{7}",null,null,"6001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],"CW",599,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],[null,"(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,[null,null,"955\\d{5}","\\d{7,8}",null,null,"95581234"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CX:[null,[null,null,"[1458]\\d{5,9}","\\d{6,10}"],[null,null,"89164\\d{4}","\\d{8,9}",null,null,"891641234"],[null,null,"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","\\d{9}",null,null,"412345678"],[null,null,"180(?:0\\d{3}|2)\\d{3}","\\d{7,10}",null,null,"1800123456"],[null,null,"190[0126]\\d{6}","\\d{10}",null,null,"1900123456"],[null,null,"13(?:00\\d{2})?\\d{4}","\\d{6,10}",null,null,"1300123456"],[null,null,"500\\d{6}","\\d{9}",null,null,"500123456"],[null,null,"550\\d{6}","\\d{9}",null,null,"550123456"],"CX",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",null,null,"0",null,"0011",null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],CY:[null,[null,null,"[257-9]\\d{7}","\\d{8}"],[null,null,"2[2-6]\\d{6}","\\d{8}",null,null,"22345678"],[null,null,"9[4-79]\\d{6}","\\d{8}",null,null,"96123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80001234"],[null,null,"90[09]\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"80[1-9]\\d{5}","\\d{8}",null,null,"80112345"],[null,null,"700\\d{5}","\\d{8}",null,null,"70012345"],[null,null,"NA","NA"],"CY",357,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{6})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"(?:50|77)\\d{6}","\\d{8}",null,null,"77123456"],null,null,[null,null,"NA","NA"]],CZ:[null,[null,null,"[2-8]\\d{8}|9\\d{8,11}","\\d{9,12}"],[null,null,"2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}","\\d{9,12}",null,null,"212345678"],[null,null,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}","\\d{9,12}",null,null,"601123456"],[null,null,"800\\d{6}","\\d{9,12}",null,null,"800123456"],[null,null,"9(?:0[05689]|76)\\d{6}","\\d{9,12}",null,null,"900123456"],[null,null,"8[134]\\d{7}","\\d{9,12}",null,null,"811234567"],[null,null,"70[01]\\d{6}","\\d{9,12}",null,null,"700123456"],[null,null,"9[17]0\\d{6}","\\d{9,12}",null,null,"910123456"],"CZ",420,"00",null,null,null,null,null,null,null,[[null,"([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],[null,"(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]],[null,"(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"9(?:5\\d|7[234])\\d{6}","\\d{9,12}",null,null,"972123456"],null,null,[null,null,"9(?:3\\d{9}|6\\d{7,10})","\\d{9,12}",null,null,"93123456789"]],DE:[null,[null,null,"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})","\\d{2,15}"],[null,null,"[246]\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-9]\\d)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})","\\d{2,15}",null,null,"30123456"],[null,null,"1(?:5[0-25-9]\\d{8}|6[023]\\d{7,8}|7(?:[0-57-9]\\d?|6\\d)\\d{7})","\\d{10,11}",null,null,"15123456789"],[null,null,"800\\d{7,12}","\\d{10,15}",null,null,"8001234567890"],[null,null,"137[7-9]\\d{6}|900(?:[135]\\d{6}|9\\d{7})","\\d{10,11}",null,null,"9001234567"],[null,null,"1(?:3(?:7[1-6]\\d{6}|8\\d{4})|80\\d{5,11})","\\d{7,14}",null,null,"18012345"],[null,null,"700\\d{8}","\\d{11}",null,null,"70012345678"],[null,null,"NA","NA"],"DE",49,"00","0",null,null,"0",null,null,null,[[null,"(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[null,"(15\\d{3})(\\d{6})","$1 $2",["15[0568]"],"0$1"],[null,"(1\\d{3})(\\d{7})","$1 $2",["15"],"0$1"],[null,"(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"],"0$1"],[null,"(\\d{3})(\\d{3,11})","$1 $2",["2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"],"0$1"],[null,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])","[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"],"0$1"],[null,"(3\\d{4})(\\d{1,10})","$1 $2",["3"],"0$1"],[null,"(800)(\\d{7,12})","$1 $2",["800"],"0$1"],[null,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["(?:18|90)0|137","1(?:37|80)|900[1359]"],"0$1"],[null,"(1\\d{2})(\\d{5,11})","$1 $2",["181"],"0$1"],[null,"(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[null,"(18\\d{2})(\\d{7})","$1 $2",["18[68]"],"0$1"],[null,"(18\\d)(\\d{8})","$1 $2",["18[2-579]"],"0$1"],[null,"(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"],"0$1"],[null,"(138)(\\d{4})","$1 $2",["138"],"0$1"],[null,"(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"],"0$1"],[null,"(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[null,"(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"]],null,[null,null,"16(?:4\\d{1,10}|[89]\\d{1,11})","\\d{4,14}",null,null,"16412345"],null,null,[null,null,"NA","NA"],[null,null,"18(?:1\\d{5,11}|[2-9]\\d{8})","\\d{8,14}",null,null,"18500123456"],null,null,[null,null,"1(?:5(?:(?:2\\d55|7\\d99|9\\d33)\\d{7}|(?:[034568]00|113)\\d{8})|6(?:013|255|399)\\d{7,8}|7(?:[015]13|[234]55|[69]33|[78]99)\\d{7,8})","\\d{12,13}",null,null,"177991234567"]],
DJ:[null,[null,null,"[27]\\d{7}","\\d{8}"],[null,null,"2(?:1[2-5]|7[45])\\d{5}","\\d{8}",null,null,"21360003"],[null,null,"77[0-26-8]\\d{5}","\\d{8}",null,null,"77831001"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"DJ",253,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],DK:[null,[null,null,"[2-9]\\d{7}","\\d{8}"],[null,null,"(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}","\\d{8}",null,null,"32123456"],[null,null,"(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}","\\d{8}",null,null,"20123456"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"90\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"DK",45,"00",null,null,null,null,null,null,1,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],DM:[null,[null,null,"[57-9]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"7674201234"],[null,null,"767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[2-7])\\d{4}","\\d{10}",null,null,"7672251234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"DM",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"767",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],DO:[null,[null,null,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})","\\d{7}(?:\\d{3})?",null,null,"8092345678"],[null,null,"8[024]9[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"8092345678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"DO",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"8[024]9",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],DZ:[null,[null,null,"(?:[1-4]|[5-9]\\d)\\d{7}","\\d{8,9}"],[null,null,"(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}","\\d{8,9}",null,null,"12345678"],[null,null,"(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-6])\\d{6}","\\d{9}",null,null,"551234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"80[3-689]1\\d{5}","\\d{9}",null,null,"808123456"],[null,null,"80[12]1\\d{5}","\\d{9}",null,null,"801123456"],[null,null,"NA","NA"],[null,null,"98[23]\\d{6}","\\d{9}",null,null,"983123456"],"DZ",213,"00","0",null,null,"0",null,null,null,[[null,"([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],[null,"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"],[null,"(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],EC:[null,[null,null,"1\\d{9,10}|[2-8]\\d{7}|9\\d{8}","\\d{7,11}"],[null,null,"[2-7][2-7]\\d{6}","\\d{7,8}",null,null,"22123456"],[null,null,"9(?:39|[45][89]|[67][7-9]|[89]\\d)\\d{6}","\\d{9}",null,null,"991234567"],[null,null,"1800\\d{6,7}","\\d{10,11}",null,null,"18001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"[2-7]890\\d{4}","\\d{8}",null,null,"28901234"],"EC",593,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],"(0$1)"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[null,"(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["1"],"$1"]],[[null,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[247]|[356][2-8]"]],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[null,"(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["1"],"$1"]],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],EE:[null,[null,null,"1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}","\\d{4,10}"],[null,null,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}","\\d{7}",null,null,"3212345"],[null,null,"(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}","\\d{7,8}",null,null,"51234567"],[null,null,"800(?:0\\d{3}|1\\d|[2-9])\\d{3}","\\d{7,10}",null,null,"80012345"],[null,null,"(?:40\\d{2}|900)\\d{4}","\\d{7,8}",null,null,"9001234"],[null,null,"NA","NA"],[null,null,"70[0-2]\\d{5}","\\d{8}",null,null,"70012345"],[null,null,"NA","NA"],"EE",372,"00",null,null,null,null,null,null,null,[[null,"([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],[null,"(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"]],[null,"(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"]],[null,"([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]],null,[null,null,"NA","NA"],null,null,[null,null,"1\\d{3,4}|800[2-9]\\d{3}","\\d{4,7}",null,null,"8002123"],[null,null,"1(?:2[01245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[012])\\d{1,2}","\\d{4,5}",null,null,"12123"],null,null,[null,null,"NA","NA"]],EG:[null,[null,null,"1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}","\\d{5,10}"],[null,null,"(?:1(?:3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|[57][23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}|1[69]\\d{3}","\\d{5,9}",null,null,"234567890"],[null,null,"1(?:0[0-269]|1[0-245]|2[0-278])\\d{7}","\\d{10}",null,null,"1001234567"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"900\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"EG",20,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[012]|[89]00"],"0$1"],[null,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|[89][2-9]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],EH:[null,[null,null,"[5689]\\d{8}","\\d{9}"],[null,null,"528[89]\\d{5}","\\d{9}",null,null,"528812345"],[null,null,"6(?:0[0-8]|[12-79]\\d|8[017])\\d{6}","\\d{9}",null,null,"650123456"],[null,null,"80\\d{7}","\\d{9}",null,null,"801234567"],[null,null,"89\\d{7}","\\d{9}",null,null,"891234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"EH",212,"00","0",null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,"528[89]",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ER:[null,[null,null,"[178]\\d{6}","\\d{6,7}"],[null,null,"1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}","\\d{6,7}",null,null,"8370362"],[null,null,"17[1-3]\\d{4}|7\\d{6}","\\d{7}",null,null,"7123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ER",291,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ES:[null,[null,null,"[5-9]\\d{8}","\\d{9}"],[null,null,"8(?:[13]0|[28][0-8]|[47][1-9]|5[01346-9]|6[0457-9])\\d{6}|9(?:[1238][0-8]\\d{6}|4[1-9]\\d{6}|5\\d{7}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})","\\d{9}",null,null,"810123456"],[null,null,"(?:6\\d{6}|7[1-4]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}","\\d{9}",null,null,"612345678"],[null,null,"[89]00\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"80[367]\\d{6}","\\d{9}",null,null,"803123456"],[null,null,"90[12]\\d{6}","\\d{9}",null,null,"901123456"],[null,null,"70\\d{7}","\\d{9}",null,null,"701234567"],[null,null,"NA","NA"],"ES",34,"00",null,null,null,null,null,null,null,[[null,"([89]00)(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[null,"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"51\\d{7}","\\d{9}",null,null,"511234567"],null,null,[null,null,"NA","NA"]],ET:[null,[null,null,"[1-59]\\d{8}","\\d{7,9}"],[null,null,"(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}","\\d{7,9}",null,null,"111112345"],[null,null,"9(?:[1-46]\\d|5[89])\\d{6}","\\d{9}",null,null,"911234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ET",251,"00","0",null,null,"0",null,null,null,[[null,"([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],FI:[null,[null,null,"1\\d{4,11}|[2-9]\\d{4,10}","\\d{5,12}"],[null,null,"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}","\\d{5,12}",null,null,"1312345678"],[null,null,"4\\d{5,10}|50\\d{4,8}","\\d{6,11}",null,null,"412345678"],[null,null,"800\\d{4,7}","\\d{7,10}",null,null,"8001234567"],[null,null,"[67]00\\d{5,6}","\\d{8,9}",null,null,"600123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"FI",358,"00|99[049]","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]00|[6-8]0)"],"0$1"],[null,"(116\\d{3})","$1",["116"],"$1"],[null,"(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],[null,"(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"],"0$1"]],null,[null,null,"NA","NA"],1,null,[null,null,"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",null,null,"100123"],[null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",null,null,"10112345"],null,null,[null,null,"NA","NA"]],FJ:[null,[null,null,"[36-9]\\d{6}|0\\d{10}","\\d{7}(?:\\d{4})?"],[null,null,"(?:3[0-5]|6[25-7]|8[58])\\d{5}","\\d{7}",null,null,"3212345"],[null,null,"(?:7[0-8]|8[034679]|9\\d)\\d{5}","\\d{7}",null,null,"7012345"],[null,null,"0800\\d{7}","\\d{11}",null,null,"08001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"FJ",679,"0(?:0|52)",null,null,null,null,null,"00",null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[36-9]"]],[null,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],FK:[null,[null,null,"[2-7]\\d{4}","\\d{5}"],[null,null,"[2-47]\\d{4}","\\d{5}",null,null,"31234"],[null,null,"[56]\\d{4}","\\d{5}",null,null,"51234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"FK",500,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],FM:[null,[null,null,"[39]\\d{6}","\\d{7}"],[null,null,"3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}","\\d{7}",null,null,"3201234"],[null,null,"3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}","\\d{7}",null,null,"3501234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"FM",691,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],FO:[null,[null,null,"[2-9]\\d{5}","\\d{6}"],[null,null,"(?:20|[3-4]\\d|8[19])\\d{4}","\\d{6}",null,null,"201234"],[null,null,"(?:[27][1-9]|5\\d)\\d{4}","\\d{6}",null,null,"211234"],[null,null,"80[257-9]\\d{3}","\\d{6}",null,null,"802123"],[null,null,"90(?:[1345][15-7]|2[125-7]|99)\\d{2}","\\d{6}",null,null,"901123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"(?:6[0-36]|88)\\d{4}","\\d{6}",null,null,"601234"],"FO",298,"00",null,null,null,"(10(?:01|[12]0|88))",null,null,null,[[null,"(\\d{6})","$1",null,null,"$CC $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],FR:[null,[null,null,"[1-9]\\d{8}","\\d{9}"],[null,null,"[1-5]\\d{8}","\\d{9}",null,null,"123456789"],[null,null,"6\\d{8}|7(?:00\\d{6}|[3-9]\\d{7})","\\d{9}",null,null,"612345678"],[null,null,"80[0-5]\\d{6}","\\d{9}",null,null,"801234567"],[null,null,"89[1-37-9]\\d{6}","\\d{9}",null,null,"891123456"],[null,null,"8(?:1[019]|2[0156]|84|90)\\d{6}","\\d{9}",null,null,"810123456"],[null,null,"NA","NA"],[null,null,"9\\d{8}","\\d{9}",null,null,"912345678"],"FR",33,"00","0",null,null,"0",null,null,null,[[null,"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"],[null,"(1\\d{2})(\\d{3})","$1 $2",["11"],"$1"],[null,"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],[[null,"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"],[null,"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"80[6-9]\\d{6}","\\d{9}",null,null,"806123456"],null,null,[null,null,"NA","NA"]],GA:[null,[null,null,"0?\\d{7}","\\d{7,8}"],[null,null,"01\\d{6}","\\d{8}",null,null,"01441234"],[null,null,"0?[2-7]\\d{6}","\\d{7,8}",null,null,"06031234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GA",241,"00",null,null,null,null,null,null,null,[[null,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],GB:[null,[null,null,"\\d{7,10}","\\d{4,10}"],[null,null,"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[012])\\d{7}|1(?:(?:1(?:3[0-48]|[46][0-4]|5[012789]|7[0-49]|8[01349])|21[0-7]|31[0-8]|[459]1\\d|61[0-46-9]))\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-4789]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1235679]|9[24578])|4(?:0[03-9]|[28][02-5789]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1235-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-5789])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[023678]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-5789]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-5789]|4[2-9]|5[0-579]|6[234789]|7[0124578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-4789]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[015789]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[234678]\\d{2}|16977[23]\\d{3}","\\d{4,10}",null,null,"1212345678"],[null,null,"7(?:[1-4]\\d\\d|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[04-9]\\d|1[02-9]|2[0-35-9]|3[0-689]))\\d{6}","\\d{10}",null,null,"7400123456"],[null,null,"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","\\d{7}(?:\\d{2,3})?",null,null,"8001234567"],[null,null,"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","\\d{10}",null,null,"9012345678"],[null,null,"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})","\\d{7}(?:\\d{3})?",null,null,"8431234567"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],[null,null,"56\\d{8}","\\d{10}",null,null,"5612345678"],"GB",44,"00","0"," x",null,"0",null,null,null,[[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7(?:0|6[013-9])","2|5[56]|7(?:0|6(?:[013-9]|2[0-35-9]))"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"],"0$1"],[null,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"],"0$1"],[null,"(1\\d{3})(\\d{5,6})","$1 $2",["1"],"0$1"],[null,"(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)","7(?:[1-5789]|624)"],"0$1"],[null,"(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[null,"(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[null,"(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"],"0$1"],[null,"(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1"],[null,"([58]00)(\\d{6})","$1 $2",["[58]00"],"0$1"]],null,[null,null,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",null,null,"7640123456"],1,null,[null,null,"NA","NA"],[null,null,"(?:3[0347]|55)\\d{8}","\\d{10}",null,null,"5512345678"],null,null,[null,null,"NA","NA"]],GD:[null,[null,null,"[4589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"4732691234"],[null,null,"473(?:4(?:0[2-79]|1[04-9]|20|58)|5(?:2[01]|3[3-8])|901)\\d{4}","\\d{10}",null,null,"4734031234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"GD",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"473",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GE:[null,[null,null,"[34578]\\d{8}","\\d{6,9}"],[null,null,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}","\\d{6,9}",null,null,"322123456"],[null,null,"5(?:14|5[01578]|68|7[0147-9]|9[0-35-9])\\d{6}","\\d{9}",null,null,"555123456"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"706\\d{6}","\\d{9}",null,null,"706123456"],"GE",995,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"706\\d{6}","\\d{9}",null,null,"706123456"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GF:[null,[null,null,"[56]\\d{8}","\\d{9}"],[null,null,"594(?:10|2[012457-9]|3[0-57-9]|4[3-9]|5[7-9]|6[0-3]|9[014])\\d{4}","\\d{9}",null,null,"594101234"],[null,null,"694(?:[04][0-7]|1[0-5]|3[018]|[29]\\d)\\d{4}","\\d{9}",null,null,"694201234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GF",594,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GG:[null,[null,null,"[135789]\\d{6,9}","\\d{6,10}"],[null,null,"1481\\d{6}","\\d{6,10}",null,null,"1481456789"],[null,null,"7(?:781|839|911)\\d{6}","\\d{10}",null,null,"7781123456"],[null,null,"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","\\d{7}(?:\\d{2,3})?",null,null,"8001234567"],[null,null,"(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","\\d{10}",null,null,"9012345678"],[null,null,"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})","\\d{7}(?:\\d{3})?",null,null,"8431234567"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],[null,null,"56\\d{8}","\\d{10}",null,null,"5612345678"],"GG",44,"00","0"," x",null,"0",null,null,null,null,null,[null,null,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",null,null,"7640123456"],null,null,[null,null,"NA","NA"],[null,null,"(?:3[0347]|55)\\d{8}","\\d{10}",null,null,"5512345678"],null,null,[null,null,"NA","NA"]],GH:[null,[null,null,"[235]\\d{8}|8\\d{7}","\\d{7,9}"],[null,null,"3(?:0[237]\\d|[167](?:2[0-6]|7\\d)|2(?:2[0-5]|7\\d)|3(?:2[0-3]|7\\d)|4(?:2[013-9]|3[01]|7\\d)|5(?:2[0-7]|7\\d)|8(?:2[0-2]|7\\d)|9(?:20|7\\d))\\d{5}","\\d{7,9}",null,null,"302345678"],[null,null,"(?:2[034678]\\d|5(?:[047]\\d|5[3-6]|6[01]))\\d{6}","\\d{9}",null,null,"231234567"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GH",233,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"],[null,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GI:[null,[null,null,"[2568]\\d{7}","\\d{8}"],[null,null,"2(?:00\\d|1(?:6[24-7]|9\\d)|2(?:00|2[2457]))\\d{4}","\\d{8}",null,null,"20012345"],[null,null,"(?:5[46-8]|62)\\d{6}","\\d{8}",null,null,"57123456"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"8[1-689]\\d{6}","\\d{8}",null,null,"88123456"],[null,null,"87\\d{6}","\\d{8}",null,null,"87123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GI",350,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{5})","$1 $2",["2"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GL:[null,[null,null,"[1-689]\\d{5}","\\d{6}"],[null,null,"(?:19|3[1-6]|6[14689]|8[14-79]|9\\d)\\d{4}","\\d{6}",null,null,"321000"],[null,null,"[245][2-9]\\d{4}","\\d{6}",null,null,"221234"],[null,null,"80\\d{4}","\\d{6}",null,null,"801234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"3[89]\\d{4}","\\d{6}",null,null,"381234"],"GL",299,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GM:[null,[null,null,"[2-9]\\d{6}","\\d{7}"],[null,null,"(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}","\\d{7}",null,null,"5661234"],[null,null,"[23679]\\d{6}","\\d{7}",null,null,"3012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GM",220,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GN:[null,[null,null,"[367]\\d{7,8}","\\d{8,9}"],[null,null,"30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}","\\d{8}",null,null,"30241234"],[null,null,"6[02356]\\d{7}","\\d{9}",null,null,"601123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"722\\d{6}","\\d{9}",null,null,"722123456"],"GN",224,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GP:[null,[null,null,"[56]\\d{8}","\\d{9}"],[null,null,"590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}","\\d{9}",null,null,"590201234"],[null,null,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",null,null,"690301234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GP",590,"00","0",null,null,"0",null,null,null,[[null,"([56]90)(\\d{2})(\\d{4})","$1 $2-$3",null,"0$1"]],null,[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GQ:[null,[null,null,"[23589]\\d{8}","\\d{9}"],[null,null,"3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}","\\d{9}",null,null,"333091234"],[null,null,"(?:222|55[15])\\d{6}","\\d{9}",null,null,"222123456"],[null,null,"80\\d[1-9]\\d{5}","\\d{9}",null,null,"800123456"],[null,null,"90\\d[1-9]\\d{5}","\\d{9}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GQ",240,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],[null,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GR:[null,[null,null,"[26-9]\\d{9}","\\d{10}"],[null,null,"2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}","\\d{10}",null,null,"2123456789"],[null,null,"69\\d{8}","\\d{10}",null,null,"6912345678"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"90[19]\\d{7}","\\d{10}",null,null,"9091234567"],[null,null,"8(?:0[16]|12|25)\\d{7}","\\d{10}",null,null,"8011234567"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],[null,null,"NA","NA"],"GR",30,"00",null,null,null,null,null,null,null,[[null,"([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],[null,"(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GT:[null,[null,null,"[2-7]\\d{7}|1[89]\\d{9}","\\d{8}(?:\\d{3})?"],[null,null,"[267][2-9]\\d{6}","\\d{8}",null,null,"22456789"],[null,null,"[345]\\d{7}","\\d{8}",null,null,"51234567"],[null,null,"18[01]\\d{8}","\\d{11}",null,null,"18001112222"],[null,null,"19\\d{9}","\\d{11}",null,null,"19001112222"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GT",502,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],[null,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GU:[null,[null,null,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6713001234"],[null,null,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6713001234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"GU",1,"011","1",null,null,"1",null,null,1,null,null,[null,null,"NA","NA"],null,"671",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GW:[null,[null,null,"(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})","\\d{7,9}"],[null,null,"443(?:2[0125]|3[1245]|4[12]|5[1-4]|70|9[1-467])\\d{4}","\\d{7,9}",null,null,"443201234"],[null,null,"9(?:55\\d|6(?:6\\d|9[012])|77\\d)\\d{5}","\\d{7,9}",null,null,"955012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"40\\d{5}","\\d{7,9}",null,null,"4012345"],"GW",245,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["44|9[567]"]],[null,"(\\d{3})(\\d{4})","$1 $2",["40"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],GY:[null,[null,null,"[2-4679]\\d{6}","\\d{7}"],[null,null,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}","\\d{7}",null,null,"2201234"],[null,null,"6\\d{6}","\\d{7}",null,null,"6091234"],[null,null,"(?:289|862)\\d{4}","\\d{7}",null,null,"2891234"],[null,null,"9008\\d{3}","\\d{7}",null,null,"9008123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"GY",592,"001",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],HK:[null,[null,null,"[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}","\\d{5,11}"],[null,null,"(?:[23]\\d|58)\\d{6}","\\d{8}",null,null,"21234567"],[null,null,"(?:5[1-79]\\d|6\\d{2}|8[4-79]\\d|9(?:0[1-9]|[1-8]\\d))\\d{5}","\\d{8}",null,null,"51234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"900(?:[0-24-9]\\d{7}|3\\d{1,4})","\\d{5,11}",null,null,"90012345678"],[null,null,"NA","NA"],[null,null,"8[1-3]\\d{6}","\\d{8}",null,null,"81123456"],[null,null,"NA","NA"],"HK",852,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[235-7]|[89](?:0[1-9]|[1-9])"]],[null,"(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]],[null,"(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"]],[null,"(900)(\\d{2,5})","$1 $2",["900"]]],null,[null,null,"7\\d{7}","\\d{8}",null,null,"71234567"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],HN:[null,[null,null,"[237-9]\\d{7}","\\d{8}"],[null,null,"2(?:2(?:0[019]|1[1-36]|[23]\\d|4[056]|5[57]|7[01389]|8[0146-9]|9[012])|4(?:2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:4[3-5]|5\\d|6[56]|74)|6(?:[056]\\d|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[34])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}","\\d{8}",null,null,"22123456"],[null,null,"[37-9]\\d{7}","\\d{8}",null,null,"91234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"HN",504,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1-$2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],HR:[null,[null,null,"[1-7]\\d{5,8}|[89]\\d{6,11}","\\d{6,12}"],[null,null,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}","\\d{6,9}",null,null,"12345678"],[null,null,"9(?:[1-9]\\d{6,10}|01\\d{6,9})","\\d{8,12}",null,null,"912345678"],[null,null,"80[01]\\d{4,7}","\\d{7,10}",null,null,"8001234567"],[null,null,"6(?:[01459]\\d{4,7})","\\d{6,9}",null,null,"611234"],[null,null,"NA","NA"],[null,null,"7[45]\\d{4,7}","\\d{6,9}",null,null,"741234567"],[null,null,"NA","NA"],"HR",385,"00","0",null,null,"0",null,null,null,[[null,"(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],[null,"(6[09])(\\d{4})(\\d{3})","$1 $2 $3",["6[09]"],"0$1"],[null,"([67]2)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]2"],"0$1"],[null,"([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],[null,"(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[null,"(9\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9"],"0$1"],[null,"(9\\d)(\\d{3,4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[0145]|7"],"0$1"],[null,"(\\d{2})(\\d{3,4})(\\d{3})","$1 $2 $3",["6[0145]|7"],"0$1"],[null,"(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[null,"(80[01])(\\d{3,4})(\\d{3})","$1 $2 $3",["8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"[76]2\\d{6,7}","\\d{8,9}",null,null,"62123456"],null,null,[null,null,"NA","NA"]],
HT:[null,[null,null,"[2-489]\\d{7}","\\d{8}"],[null,null,"2(?:[248]\\d|5[1-5]|94)\\d{5}","\\d{8}",null,null,"22453300"],[null,null,"(?:3[1-9]\\d|4\\d{2}|9(?:8[0-35]|9[5-9]))\\d{5}","\\d{8}",null,null,"34101234"],[null,null,"8\\d{7}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"98[89]\\d{5}","\\d{8}",null,null,"98901234"],"HT",509,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],HU:[null,[null,null,"[1-9]\\d{7,8}","\\d{6,9}"],[null,null,"(?:1\\d|2(?:1\\d|[2-9])|3(?:[2-7]|8\\d)|4[24-9]|5[2-79]|6[23689]|7(?:1\\d|[2-9])|8[2-57-9]|9[2-69])\\d{6}","\\d{6,9}",null,null,"12345678"],[null,null,"(?:[257]0|3[01])\\d{7}","\\d{9}",null,null,"201234567"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"9[01]\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"40\\d{6}","\\d{8}",null,null,"40123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"HU",36,"00","06",null,null,"06",null,null,null,[[null,"(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"($1)"],[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"($1)"]],null,[null,null,"NA","NA"],null,null,[null,null,"[48]0\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ID:[null,[null,null,"(?:[1-79]\\d{6,10}|8\\d{7,11})","\\d{5,12}"],[null,null,"2(?:1(?:14\\d{3}|[0-8]\\d{6,7}|500\\d{3}|9\\d{6})|2\\d{6,8}|4\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}","\\d{5,11}",null,null,"612345678"],[null,null,"(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359]|9\\d)|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,10}","\\d{9,12}",null,null,"812345678"],[null,null,"177\\d{6,8}|800\\d{5,7}","\\d{8,11}",null,null,"8001234567"],[null,null,"809\\d{7}","\\d{10}",null,null,"8091234567"],[null,null,"804\\d{7}","\\d{10}",null,null,"8041234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ID",62,"0(?:0[1789]|10(?:00|1[67]))","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],[null,"(\\d{3})(\\d{5,8})","$1 $2",["[4579]|2[035-9]|[36][02-9]"],"(0$1)"],[null,"(8\\d{2})(\\d{3,4})(\\d{3,5})","$1-$2-$3",["8[1-35-9]"],"0$1"],[null,"(1)(500)(\\d{3})","$1 $2 $3",["15"],"$1"],[null,"(177)(\\d{6,8})","$1 $2",["17"],"0$1"],[null,"(800)(\\d{5,7})","$1 $2",["800"],"0$1"],[null,"(804)(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[null,"(80\\d)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80[79]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"8071\\d{6}","\\d{10}",null,null,"8071123456"],[null,null,"1500\\d{3}|8071\\d{6}","\\d{7,10}",null,null,"8071123456"],null,null,[null,null,"NA","NA"]],IE:[null,[null,null,"[124-9]\\d{6,9}","\\d{5,10}"],[null,null,"1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})","\\d{5,10}",null,null,"2212345"],[null,null,"8(?:22\\d{6}|[35-9]\\d{7})","\\d{9}",null,null,"850123456"],[null,null,"1800\\d{6}","\\d{10}",null,null,"1800123456"],[null,null,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}","\\d{10}",null,null,"1520123456"],[null,null,"18[59]0\\d{6}","\\d{10}",null,null,"1850123456"],[null,null,"700\\d{6}","\\d{9}",null,null,"700123456"],[null,null,"76\\d{7}","\\d{9}",null,null,"761234567"],"IE",353,"00","0",null,null,"0",null,null,null,[[null,"(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[null,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[null,"(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"],"(0$1)"],[null,"(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"],"(0$1)"],[null,"(818)(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"],"(0$1)"],[null,"([78]\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],[null,"(700)(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[null,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:8[059]|5)","1(?:8[059]0|5)"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"18[59]0\\d{6}","\\d{10}",null,null,"1850123456"],[null,null,"818\\d{6}","\\d{9}",null,null,"818123456"],null,null,[null,null,"8[35-9]\\d{8}","\\d{10}",null,null,"8501234567"]],IL:[null,[null,null,"[17]\\d{6,9}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}","\\d{4,10}"],[null,null,"[2-489]\\d{7}","\\d{7,8}",null,null,"21234567"],[null,null,"5(?:[02-47-9]\\d{2}|5(?:01|2[23]|3[2-4]|4[45]|5[5689]|6[67]|7[0178]|8[6-9]|9[4-9])|6[2-9]\\d)\\d{5}","\\d{9}",null,null,"501234567"],[null,null,"1(?:80[019]\\d{3}|255)\\d{3}","\\d{7,10}",null,null,"1800123456"],[null,null,"1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}","\\d{8,10}",null,null,"1919123456"],[null,null,"1700\\d{6}","\\d{10}",null,null,"1700123456"],[null,null,"NA","NA"],[null,null,"7(?:18\\d|2[23]\\d|3[237]\\d|47\\d|6(?:5\\d|8[0168])|7\\d{2}|8(?:2\\d|33|55|77|81)|9[29]\\d)\\d{5}","\\d{9}",null,null,"771234567"],"IL",972,"0(?:0|1[2-9])","0",null,null,"0",null,null,null,[[null,"([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],[null,"([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[null,"(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"],"$1"],[null,"(1255)(\\d{3})","$1-$2",["125"],"$1"],[null,"(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120"],"$1"],[null,"(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121"],"$1"],[null,"(1599)(\\d{6})","$1-$2",["15"],"$1"],[null,"(\\d{4})","*$1",["[2-689]"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"1700\\d{6}|[2-689]\\d{3}","\\d{4,10}",null,null,"1700123456"],[null,null,"[2-689]\\d{3}|1599\\d{6}","\\d{4}(?:\\d{6})?",null,null,"1599123456"],null,null,[null,null,"NA","NA"]],IM:[null,[null,null,"[135789]\\d{6,9}","\\d{6,10}"],[null,null,"1624\\d{6}","\\d{6,10}",null,null,"1624456789"],[null,null,"7[569]24\\d{6}","\\d{10}",null,null,"7924123456"],[null,null,"808162\\d{4}","\\d{10}",null,null,"8081624567"],[null,null,"(?:872299|90[0167]624)\\d{4}","\\d{10}",null,null,"9016247890"],[null,null,"8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}","\\d{10}",null,null,"8456247890"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],[null,null,"56\\d{8}","\\d{10}",null,null,"5612345678"],"IM",44,"00","0"," x",null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}","\\d{10}",null,null,"5512345678"],null,null,[null,null,"NA","NA"]],IN:[null,[null,null,"1\\d{7,12}|[2-9]\\d{9,10}","\\d{6,13}"],[null,null,"(?:11|2[02]|33|4[04]|79)[2-7]\\d{7}|80[2-467]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-467])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-578]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}","\\d{6,10}",null,null,"1123456789"],[null,null,"(?:7(?:0\\d{3}|2(?:[0235679]\\d|[14][017-9]|8[0-59]|9[389])\\d|3(?:[05-8]\\d{2}|1(?:[089]\\d|7[5-8])|2(?:[5-8]\\d|[01][089])|3[17-9]\\d|4[789]\\d|9[01689]\\d)|4(?:0[1-9]\\d|1(?:[015-9]\\d|4[08])|[29][89]\\d|39\\d|8[389]\\d)|5(?:[034678]\\d|2[03-9]|5[017-9]|9[7-9])\\d|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9]\\d)\\d|7(?:0[2-9]|[1-79]\\d|8[1-9])\\d|8[0-79]\\d{2}|99[4-9]\\d)|8(?:0(?:[01589]\\d|6[67])|1(?:[02-57-9]\\d|1[0135-9])|2(?:[236-9]\\d|5[1-9])|3(?:[0357-9]\\d|4[1-9])|[45]\\d{2}|6[02457-9]\\d|7(?:07|[1-69]\\d)|8(?:[0-26-9]\\d|44|5[2-9])|9(?:[035-9]\\d|2[2-9]|4[0-8]))\\d|9\\d{4})\\d{5}","\\d{10}",null,null,"9123456789"],[null,null,"1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))","\\d{8,13}",null,null,"1800123456"],[null,null,"186[12]\\d{9}","\\d{13}",null,null,"1861123456789"],[null,null,"1860\\d{7}","\\d{11}",null,null,"18603451234"],[null,null,"NA","NA"],[null,null,"NA","NA"],"IN",91,"00","0",null,null,"0",null,null,null,[[null,"(\\d{5})(\\d{5})","$1 $2",["7(?:[02357]|4[0-389]|6[0-35-9]|8[0-79]|99)|8(?:0[015689]|1[0-57-9]|2[2356-9]|3[0-57-9]|[45]|6[02457-9]|7[01-69]|8[0-24-9]|9[02-9])|9","7(?:0|2(?:[0235679]|[14][017-9]|8[0-59]|9[389])|3(?:[05-8]|1[07-9]|2[015-8]|3[17-9]|4[789]|9[01689])|4(?:0[1-9]|1[014-9]|[29][89]|39|8[389])|5(?:[034678]|2[03-9]|5[017-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9])|7(?:0[2-9]|[1-79]|8[1-9])|8[0-79]|99[4-9])|8(?:0(?:[01589]|6[67])|1(?:[02-57-9]|1[0135-9])|2(?:[236-9]|5[1-9])|3(?:[0357-9]|4[1-9])|[45]|6[02457-9]|7(?:07|[1-69])|8(?:[0-26-9]|44|5[2-9])|9(?:[035-9]|2[2-9]|4[0-8]))|9","7(?:0|2(?:[0235679]|[14][017-9]|8[0-59]|9[389])|3(?:[05-8]|1(?:[089]|7[5-9])|2(?:[5-8]|[01][089])|3[17-9]|4[789]|9[01689])|4(?:0[1-9]|1(?:[015-9]|4[08])|[29][89]|39|8[389])|5(?:[034678]|2[03-9]|5[017-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9])|7(?:0[2-9]|[1-79]|8[1-9])|8[0-79]|99[4-9])|8(?:0(?:[01589]|6[67])|1(?:[02-57-9]|1[0135-9])|2(?:[236-9]|5[1-9])|3(?:[0357-9]|4[1-9])|[45]|6[02457-9]|7(?:07|[1-69])|8(?:[0-26-9]|44|5[2-9])|9(?:[035-9]|2[2-9]|4[0-8]))|9"],"0$1",null,1],[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79|80[2-46]"],"0$1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[569][14]|7[1257]|8[1346]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)"],"0$1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)","7(?:12|2[14]|3[134]|4[47]|5(?:1|5[2-6])|[67]1|88)"],"0$1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"],"0$1",null,1],[null,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"],"0$1",null,1],[null,"(1600)(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1",null,1],[null,"(1800)(\\d{4,5})","$1 $2",["180","1800"],"$1",null,1],[null,"(18[06]0)(\\d{2,4})(\\d{4})","$1 $2 $3",["18[06]","18[06]0"],"$1",null,1],[null,"(140)(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1",null,1],[null,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]","18(?:0[03]|6[12])"],"$1",null,1]],null,[null,null,"NA","NA"],null,null,[null,null,"1(?:600\\d{6}|8(?:0(?:0\\d{4,9}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))","\\d{8,13}",null,null,"1800123456"],[null,null,"140\\d{7}","\\d{10}",null,null,"1409305260"],null,null,[null,null,"NA","NA"]],IO:[null,[null,null,"3\\d{6}","\\d{7}"],[null,null,"37\\d{5}","\\d{7}",null,null,"3709100"],[null,null,"38\\d{5}","\\d{7}",null,null,"3801234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"IO",246,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],IQ:[null,[null,null,"[1-7]\\d{7,9}","\\d{6,10}"],[null,null,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}","\\d{6,9}",null,null,"12345678"],[null,null,"7[3-9]\\d{8}","\\d{10}",null,null,"7912345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"IQ",964,"00","0",null,null,"0",null,null,null,[[null,"(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[null,"([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[null,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],IR:[null,[null,null,"[1-8]\\d{9}|9(?:[0-4]\\d{8}|9\\d{2,8})","\\d{4,10}"],[null,null,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[146-8]|6[146]|7[1467]|8[13467])\\d{8}","\\d{10}",null,null,"2123456789"],[null,null,"9(?:0[1-3]|[13]\\d|2[0-2]|90)\\d{7}","\\d{10}",null,null,"9123456789"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"(?:[2-6]0\\d|993)\\d{7}","\\d{10}",null,null,"9932123456"],"IR",98,"00","0",null,null,"0",null,null,null,[[null,"(21)(\\d{3,5})","$1 $2",["21"],"0$1"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["9"],"0$1"],[null,"(\\d{3})(\\d{3})","$1 $2",["9"],"0$1"]],null,[null,null,"943\\d{7}","\\d{10}",null,null,"9432123456"],null,null,[null,null,"NA","NA"],[null,null,"9990\\d{0,6}","\\d{4,10}",null,null,"9990123456"],null,null,[null,null,"NA","NA"]],IS:[null,[null,null,"[4-9]\\d{6}|38\\d{7}","\\d{7,9}"],[null,null,"(?:4(?:1[0-24-6]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[013-79]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}","\\d{7}",null,null,"4101234"],[null,null,"38[589]\\d{6}|(?:6(?:1[1-8]|2[056]|3[089]|4[0167]|5[0159]|[67][0-69]|9\\d)|7(?:5[057]|6[0-2]|[78]\\d)|8(?:2[0-59]|3[0-4]|[469]\\d|5[1-9]))\\d{4}","\\d{7,9}",null,null,"6111234"],[null,null,"800\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"90\\d{5}","\\d{7}",null,null,"9011234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"49\\d{5}","\\d{7}",null,null,"4921234"],"IS",354,"1(?:0(?:01|10|20)|100)|00",null,null,null,null,null,"00",null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[null,"(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"809\\d{4}","\\d{7}",null,null,"8091234"],null,null,[null,null,"(?:6(?:2[1-478]|49|8\\d)|8(?:7[0189]|80)|95[48])\\d{4}","\\d{7}",null,null,"6211234"]],IT:[null,[null,null,"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})","\\d{6,11}"],[null,null,"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","\\d{6,11}",null,null,"0212345678"],[null,null,"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","\\d{9,11}",null,null,"3123456789"],[null,null,"80(?:0\\d{6}|3\\d{3})","\\d{6,9}",null,null,"800123456"],[null,null,"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","\\d{6,10}",null,null,"899123456"],[null,null,"84(?:[08]\\d{6}|[17]\\d{3})","\\d{6,9}",null,null,"848123456"],[null,null,"1(?:78\\d|99)\\d{6}","\\d{9,10}",null,null,"1781234567"],[null,null,"55\\d{8}","\\d{10}",null,null,"5512345678"],"IT",39,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],[null,"(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[null,"(0[26])(\\d{4,6})","$1 $2",["0[26]"]],[null,"(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],[null,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],[null,"(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],[null,"(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],[null,"(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,[null,null,"NA","NA"],1,null,[null,null,"848\\d{6}","\\d{9}",null,null,"848123456"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],JE:[null,[null,null,"[135789]\\d{6,9}","\\d{6,10}"],[null,null,"1534\\d{6}","\\d{6,10}",null,null,"1534456789"],[null,null,"7(?:509|7(?:00|97)|829|937)\\d{6}","\\d{10}",null,null,"7797123456"],[null,null,"80(?:07(?:35|81)|8901)\\d{4}","\\d{10}",null,null,"8007354567"],[null,null,"(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","\\d{10}",null,null,"9018105678"],[null,null,"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}","\\d{10}",null,null,"8447034567"],[null,null,"701511\\d{4}","\\d{10}",null,null,"7015115678"],[null,null,"56\\d{8}","\\d{10}",null,null,"5612345678"],"JE",44,"00","0"," x",null,"0",null,null,null,null,null,[null,null,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",null,null,"7640123456"],null,null,[null,null,"NA","NA"],[null,null,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","\\d{10}",null,null,"5512345678"],null,null,[null,null,"NA","NA"]],JM:[null,[null,null,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[027-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"8765123456"],[null,null,"876(?:2[16-9]\\d|[348]\\d{2}|5(?:0[3-9]|27|6[0-24-9]|[3-578]\\d)|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}","\\d{10}",null,null,"8762101234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"JM",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"876",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],JO:[null,[null,null,"[235-9]\\d{7,8}","\\d{8,9}"],[null,null,"(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|3(?:00|33)|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|90))\\d{4}","\\d{8}",null,null,"62001234"],[null,null,"7(?:55|7[025-9]|8[015-9]|9[0-25-9])\\d{6}","\\d{9}",null,null,"790123456"],[null,null,"80\\d{6}","\\d{8}",null,null,"80012345"],[null,null,"900\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"85\\d{6}","\\d{8}",null,null,"85012345"],[null,null,"70\\d{7}","\\d{9}",null,null,"700123456"],[null,null,"NA","NA"],"JO",962,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[null,"(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"],"0$1"],[null,"(\\d{3})(\\d{5,6})","$1 $2",["70|8[0158]|9"],"0$1"]],null,[null,null,"74(?:66|77)\\d{5}","\\d{9}",null,null,"746612345"],null,null,[null,null,"NA","NA"],[null,null,"8(?:10|8\\d)\\d{5}","\\d{8}",null,null,"88101234"],null,null,[null,null,"NA","NA"]],JP:[null,[null,null,"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})","\\d{8,17}"],[null,null,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}","\\d{9}",null,null,"312345678"],[null,null,"[7-9]0[1-9]\\d{7}","\\d{10}",null,null,"9012345678"],[null,null,"120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})","\\d{8,17}",null,null,"120123456"],[null,null,"990\\d{6}","\\d{9}",null,null,"990123456"],[null,null,"NA","NA"],[null,null,"60\\d{7}","\\d{9}",null,null,"601234567"],[null,null,"50[1-9]\\d{7}","\\d{10}",null,null,"5012345678"],"JP",81,"010","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[null,"(\\d{4})(\\d{4})","$1-$2",["0077"],"$1"],[null,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["0077"],"$1"],[null,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["0088"],"$1"],[null,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["00(?:37|66)"],"$1"],[null,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["00(?:37|66)"],"$1"],[null,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["00(?:37|66)"],"$1"],[null,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",["00(?:37|66)"],"$1"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"],"0$1"],[null,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:9[14-79]|74|[34]7|[56]9)|82|993"],"0$1"],[null,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"],"0$1"]],[[null,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"],"0$1"],[null,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:9[14-79]|74|[34]7|[56]9)|82|993"],"0$1"],[null,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"],"0$1"]],[null,null,"20\\d{8}","\\d{10}",null,null,"2012345678"],null,null,[null,null,"00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})","\\d{8,17}",null,null,"00777012"],[null,null,"570\\d{6}","\\d{9}",null,null,"570123456"],1,null,[null,null,"NA","NA"]],KE:[null,[null,null,"20\\d{6,7}|[4-9]\\d{6,9}","\\d{7,10}"],[null,null,"20\\d{6,7}|4(?:[0136]\\d{7}|[245]\\d{5,7})|5(?:[08]\\d{7}|[1-79]\\d{5,7})|6(?:[01457-9]\\d{5,7}|[26]\\d{7})","\\d{7,9}",null,null,"202012345"],[null,null,"7(?:[0-36]\\d|5[0-6]|[79][0-7]|8[0-25-9])\\d{6}","\\d{9}",null,null,"712123456"],[null,null,"800[24-8]\\d{5,6}","\\d{9,10}",null,null,"800223456"],[null,null,"900[02-9]\\d{5}","\\d{9}",null,null,"900223456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KE",254,"000","0",null,null,"005|0",null,null,null,[[null,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[null,"(\\d{3})(\\d{6})","$1 $2",["7"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KG:[null,[null,null,"[235-8]\\d{8,9}","\\d{5,10}"],[null,null,"(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}","\\d{5,10}",null,null,"312123456"],[null,null,"(?:20[0-35]|5[124-7]\\d|7[07]\\d)\\d{6}","\\d{9}",null,null,"700123456"],[null,null,"800\\d{6,7}","\\d{9,10}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KG",996,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-7]|31[25]"],"0$1"],[null,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KH:[null,[null,null,"[1-9]\\d{7,9}","\\d{6,10}"],[null,null,"(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|23(?:4[234]|8\\d{2})\\d{4}","\\d{6,9}",null,null,"23756789"],[null,null,"(?:1(?:[013-79]\\d|[28]\\d{1,2})|2[3-6]48|3(?:[18]\\d{2}|[2-6]48)|4[2-4]48|5[2-5]48|6(?:[016-9]\\d|[2-5]48)|7(?:[07-9]\\d|[16]\\d{2}|[2-5]48)|8(?:[013-79]\\d|8\\d{2})|9(?:6\\d{2}|7\\d{1,2}|[0-589]\\d))\\d{5}","\\d{8,9}",null,null,"91234567"],[null,null,"1800(?:1\\d|2[019])\\d{4}","\\d{10}",null,null,"1800123456"],[null,null,"1900(?:1\\d|2[09])\\d{4}","\\d{10}",null,null,"1900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KH",855,"00[14-9]","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],[null,"(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],
KI:[null,[null,null,"[2458]\\d{4}|3\\d{4,7}|7\\d{7}","\\d{5,8}"],[null,null,"(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}","\\d{5}",null,null,"31234"],[null,null,"7\\d{7}","\\d{8}",null,null,"72012345"],[null,null,"NA","NA"],[null,null,"3001\\d{4}","\\d{5,8}",null,null,"30010000"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KI",686,"00",null,null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KM:[null,[null,null,"[379]\\d{6}","\\d{7}"],[null,null,"7(?:6[0-37-9]|7[0-57-9])\\d{4}","\\d{7}",null,null,"7712345"],[null,null,"3[234]\\d{5}","\\d{7}",null,null,"3212345"],[null,null,"NA","NA"],[null,null,"(?:39[01]|9[01]0)\\d{4}","\\d{7}",null,null,"9001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KM",269,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KN:[null,[null,null,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"8692361234"],[null,null,"869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-6])\\d{4}","\\d{10}",null,null,"8697652917"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"KN",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"869",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KP:[null,[null,null,"1\\d{9}|[28]\\d{7}","\\d{6,8}|\\d{10}"],[null,null,"2\\d{7}|85\\d{6}","\\d{6,8}",null,null,"21234567"],[null,null,"19[123]\\d{7}","\\d{10}",null,null,"1921234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KP",850,"00|99","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[null,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}","\\d{8}",null,null,"23821234"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KR:[null,[null,null,"007\\d{9,11}|[1-7]\\d{3,9}|8\\d{8}","\\d{4,14}"],[null,null,"(?:2|3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})","\\d{4,10}",null,null,"22123456"],[null,null,"1[0-26-9]\\d{7,8}","\\d{9,10}",null,null,"1000000000"],[null,null,"(?:00798\\d{0,2}|80)\\d{7}","\\d{9,14}",null,null,"801234567"],[null,null,"60[2-9]\\d{6}","\\d{9}",null,null,"602345678"],[null,null,"NA","NA"],[null,null,"50\\d{8}","\\d{10}",null,null,"5012345678"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],"KR",82,"00(?:[124-68]|3\\d{2}|7(?:[0-8]\\d|9[0-79]))","0",null,null,"0(8[1-46-8]|85\\d{2})?",null,null,null,[[null,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["00798"],"$1","0$CC-$1"],[null,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["00798"],"$1","0$CC-$1"],[null,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["1(?:0|1[19]|[69]9|5[458])|[57]0","1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]","1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d)(\\d{4})","$1-$2-$3",["131","1312"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["131","131[13-9]"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["13[2-9]"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3-$4",["30"],"0$1","0$CC-$1"],[null,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"],"0$1","0$CC-$1"],[null,"(\\d)(\\d{3,4})","$1-$2",["21[0-46-9]"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{3,4})","$1-$2",["[3-6][1-9]1","[3-6][1-9]1(?:[0-46-9])"],"0$1","0$CC-$1"],[null,"(\\d{4})(\\d{4})","$1-$2",["1(?:5[46-9]|6[04678]|8[0579])","1(?:5(?:44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|55|77|99))"],"$1","0$CC-$1"]],[[null,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["1(?:0|1[19]|[69]9|5[458])|[57]0","1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]","1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d)(\\d{4})","$1-$2-$3",["131","1312"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["131","131[13-9]"],"0$1","0$CC-$1"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["13[2-9]"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3-$4",["30"],"0$1","0$CC-$1"],[null,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"],"0$1","0$CC-$1"],[null,"(\\d)(\\d{3,4})","$1-$2",["21[0-46-9]"],"0$1","0$CC-$1"],[null,"(\\d{2})(\\d{3,4})","$1-$2",["[3-6][1-9]1","[3-6][1-9]1(?:[0-46-9])"],"0$1","0$CC-$1"],[null,"(\\d{4})(\\d{4})","$1-$2",["1(?:5[46-9]|6[04678]|8[0579])","1(?:5(?:44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|55|77|99))"],"$1","0$CC-$1"]],[null,null,"15\\d{7,8}","\\d{9,10}",null,null,"1523456789"],null,null,[null,null,"00798\\d{7,9}","\\d{12,14}",null,null,"007981234567"],[null,null,"1(?:5(?:44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|55|77|99))\\d{4}","\\d{8}",null,null,"15441234"],null,null,[null,null,"NA","NA"]],KW:[null,[null,null,"[12569]\\d{6,7}","\\d{7,8}"],[null,null,"(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}","\\d{7,8}",null,null,"22345678"],[null,null,"(?:5(?:[05]\\d{2}|1[0-7]\\d|2(?:22|5[25]))|6(?:0[034679]\\d|5[015-9]\\d|6\\d{2}|7[067]\\d|9[0369]\\d)|9(?:0[09]\\d|22\\d|4[01479]\\d|55\\d|6[0679]\\d|[79]\\d{2}|8[057-9]\\d))\\d{4}","\\d{8}",null,null,"50012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"KW",965,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|9[024-9]|52[25]"]],[null,"(\\d{3})(\\d{5})","$1 $2",["244|5[015]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KY:[null,[null,null,"[3589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"3452221234"],[null,null,"345(?:32[1-9]|5(?:1[67]|2[5-7]|4[6-8]|76)|9(?:1[67]|2[2-9]|3[689]))\\d{4}","\\d{10}",null,null,"3453231234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}|345976\\d{4}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"KY",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"345849\\d{4}","\\d{10}",null,null,"3458491234"],null,"345",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],KZ:[null,[null,null,"(?:33\\d|7\\d{2}|80[09])\\d{7}","\\d{10}"],[null,null,"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[023]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[1-79]|4[0-35-9]|59)|4(?:2\\d|3[013-79]|4[0-8]|5[1-79])|5(?:2\\d|3[1-8]|4[1-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[237]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}","\\d{10}",null,null,"7123456789"],[null,null,"7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}","\\d{10}",null,null,"7710009998"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"809\\d{7}","\\d{10}",null,null,"8091234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"751\\d{7}","\\d{10}",null,null,"7511234567"],"KZ",7,"810","8",null,null,"8",null,"8~10",null,null,null,[null,null,"NA","NA"],null,null,[null,null,"751\\d{7}","\\d{10}",null,null,"7511234567"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LA:[null,[null,null,"[2-8]\\d{7,9}","\\d{6,10}"],[null,null,"(?:2[13]|3(?:0\\d|[14])|[5-7][14]|41|8[1468])\\d{6}","\\d{6,9}",null,null,"21212862"],[null,null,"20(?:2[2389]|5[4-689]|7[6-8]|9[15-9])\\d{6}","\\d{10}",null,null,"2023123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LA",856,"00","0",null,null,"0",null,null,null,[[null,"(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"],"0$1"],[null,"([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[null,"(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LB:[null,[null,null,"[13-9]\\d{6,7}","\\d{7,8}"],[null,null,"(?:[14-6]\\d{2}|7(?:[2-57]\\d|62|8[0-7]|9[04-9])|8[02-9]\\d|9\\d{2})\\d{4}","\\d{7}",null,null,"1123456"],[null,null,"(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3])|81\\d)\\d{5}","\\d{7,8}",null,null,"71123456"],[null,null,"NA","NA"],[null,null,"9[01]\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LB",961,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-6]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]|9"],"0$1"],[null,"([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[89][01]|7(?:[01]|6[013-9]|8[89]|9[1-3])"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LC:[null,[null,null,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"758(?:4(?:30|5[0-9]|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"7584305678"],[null,null,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2[0-8]))\\d{4}","\\d{10}",null,null,"7582845678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"LC",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"758",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LI:[null,[null,null,"6\\d{8}|[23789]\\d{6}","\\d{7,9}"],[null,null,"(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}","\\d{7}",null,null,"2345678"],[null,null,"6(?:51[01]|6(?:0[0-6]|2[016-9]|39))\\d{5}|7(?:[37-9]\\d|42|56)\\d{4}","\\d{7,9}",null,null,"660234567"],[null,null,"80(?:02[28]|9\\d{2})\\d{2}","\\d{7}",null,null,"8002222"],[null,null,"90(?:02[258]|1(?:23|3[14])|66[136])\\d{2}","\\d{7}",null,null,"9002222"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LI",423,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[23789]"]],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],[null,"(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"870(?:28|87)\\d{2}","\\d{7}",null,null,"8702812"],null,null,[null,null,"697(?:42|56|[7-9]\\d)\\d{4}","\\d{9}",null,null,"697861234"]],LK:[null,[null,null,"[1-9]\\d{8}","\\d{7,9}"],[null,null,"(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}","\\d{7,9}",null,null,"112345678"],[null,null,"7[0125-8]\\d{7}","\\d{9}",null,null,"712345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LK",94,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{1})(\\d{6})","$1 $2 $3",["[1-689]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LR:[null,[null,null,"2\\d{7,8}|[37-9]\\d{8}|4\\d{6}|5\\d{6,8}","\\d{7,9}"],[null,null,"2\\d{7}","\\d{8}",null,null,"21234567"],[null,null,"(?:330\\d|4[67]|5\\d|77\\d{2}|88\\d{2}|994\\d)\\d{5}|(?:20\\d{3}|33(?:0\\d{2}|2(?:02|5\\d))|555\\d{2}|77[0567]\\d{2}|88[068]\\d{2}|994\\d{2})\\d{4}","\\d{7,9}",null,null,"770123456"],[null,null,"NA","NA"],[null,null,"90[03]\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"332(?:0[02]|5\\d)\\d{4}","\\d{9}",null,null,"332001234"],"LR",231,"00","0",null,null,"0",null,null,null,[[null,"(2\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2579]"],"0$1"],[null,"([4-6])(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[38]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LS:[null,[null,null,"[2568]\\d{7}","\\d{8}"],[null,null,"2\\d{7}","\\d{8}",null,null,"22123456"],[null,null,"[56]\\d{7}","\\d{8}",null,null,"50123456"],[null,null,"800[256]\\d{4}","\\d{8}",null,null,"80021234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LS",266,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LT:[null,[null,null,"[3-9]\\d{7}","\\d{8}"],[null,null,"(?:3[1478]|4[124-6]|52)\\d{6}","\\d{8}",null,null,"31234567"],[null,null,"6\\d{7}","\\d{8}",null,null,"61234567"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"9(?:0[0239]|10)\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"808\\d{5}","\\d{8}",null,null,"80812345"],[null,null,"700\\d{5}","\\d{8}",null,null,"70012345"],[null,null,"NA","NA"],"LT",370,"00","8",null,null,"[08]",null,null,null,[[null,"([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"],"(8-$1)",null,1],[null,"([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"],"(8-$1)",null,1],[null,"([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",null,1],[null,"(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"],"(8-$1)",null,1]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"70[67]\\d{5}","\\d{8}",null,null,"70712345"],null,null,[null,null,"NA","NA"]],LU:[null,[null,null,"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})","\\d{4,11}"],[null,null,"(?:2[2-9]\\d{2,9}|(?:[3457]\\d{2}|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8})","\\d{4,11}",null,null,"27123456"],[null,null,"6[2679][18]\\d{6}","\\d{9}",null,null,"628123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"90[015]\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"801\\d{5}","\\d{8}",null,null,"80112345"],[null,null,"70\\d{6}","\\d{8}",null,null,"70123456"],[null,null,"20(?:1\\d{5}|[2-689]\\d{1,7})","\\d{4,10}",null,null,"20201234"],"LU",352,"00",null,null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)",null,null,null,[[null,"(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],null,"$CC $1"],[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:[1-9]|0[2-9])|9(?:[1-9]|0[2-46-9])"],null,"$CC $1"],[null,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"],null,"$CC $1"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],null,"$CC $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LV:[null,[null,null,"[2689]\\d{7}","\\d{8}"],[null,null,"6[3-8]\\d{6}","\\d{8}",null,null,"63123456"],[null,null,"2\\d{7}","\\d{8}",null,null,"21234567"],[null,null,"80\\d{6}","\\d{8}",null,null,"80123456"],[null,null,"90\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"81\\d{6}","\\d{8}",null,null,"81123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LV",371,"00",null,null,null,null,null,null,null,[[null,"([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],LY:[null,[null,null,"[25679]\\d{8}","\\d{7,9}"],[null,null,"(?:2[1345]|5[1347]|6[123479]|71)\\d{7}","\\d{7,9}",null,null,"212345678"],[null,null,"9[1-6]\\d{7}","\\d{9}",null,null,"912345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"LY",218,"00","0",null,null,"0",null,null,null,[[null,"([25679]\\d)(\\d{7})","$1-$2",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MA:[null,[null,null,"[5689]\\d{8}","\\d{9}"],[null,null,"5(?:2(?:(?:[015-7]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|9(?:0\\d|[89]0))|3(?:(?:[0-4]\\d|[57][2-9]|6[235-8]|9[3-9])\\d|8(?:0\\d|[89]0)))\\d{4}","\\d{9}",null,null,"520123456"],[null,null,"6(?:0[0-8]|[12-79]\\d|8[017])\\d{6}","\\d{9}",null,null,"650123456"],[null,null,"80\\d{7}","\\d{9}",null,null,"801234567"],[null,null,"89\\d{7}","\\d{9}",null,null,"891234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MA",212,"00","0",null,null,"0",null,null,null,[[null,"([56]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|6"],"0$1"],[null,"([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9])|892","5(?:2(?:[2-48]|90)|3(?:[5-79]|80))|892"],"0$1"],[null,"(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"],"0$1"],[null,"(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"],"0$1"]],null,[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MC:[null,[null,null,"[4689]\\d{7,8}","\\d{8,9}"],[null,null,"870\\d{5}|9[2-47-9]\\d{6}","\\d{8}",null,null,"99123456"],[null,null,"6\\d{8}|4(?:4\\d|5[1-9])\\d{5}","\\d{8,9}",null,null,"612345678"],[null,null,"90\\d{6}","\\d{8}",null,null,"90123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MC",377,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"$1"],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[null,"(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"8\\d{7}","\\d{8}"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MD:[null,[null,null,"[235-9]\\d{7}","\\d{8}"],[null,null,"(?:2(?:1[0569]|2\\d|3[015-7]|4[1-46-9]|5[0-24689]|6[2-589]|7[1-37]|9[1347-9])|5(?:33|5[257]))\\d{5}","\\d{8}",null,null,"22212345"],[null,null,"(?:562\\d|6(?:[089]\\d{2}|[12][01]\\d|7(?:[1-6]\\d|7[0-4]))|7(?:6[07]|7[457-9]|[89]\\d)\\d)\\d{4}","\\d{8}",null,null,"62112345"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"90[056]\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"808\\d{5}","\\d{8}",null,null,"80812345"],[null,null,"NA","NA"],[null,null,"3[08]\\d{6}","\\d{8}",null,null,"30123456"],"MD",373,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],[null,"([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-79]|[5-7]"],"0$1"],[null,"([89]\\d{2})(\\d{5})","$1 $2",["[89]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"8(?:03|14)\\d{5}","\\d{8}",null,null,"80312345"],null,null,[null,null,"NA","NA"]],ME:[null,[null,null,"[2-9]\\d{7,8}","\\d{6,9}"],[null,null,"(?:20[2-8]|3(?:0[2-7]|[12][35-7]|3[4-7])|4(?:0[2367]|1[267])|5(?:0[467]|1[267]|2[367]))\\d{5}","\\d{6,8}",null,null,"30234567"],[null,null,"6(?:00\\d|32\\d|[89]\\d{2}|61\\d|7(?:[0-8]\\d|9(?:[3-9]|[0-2]\\d)))\\d{4}","\\d{8,9}",null,null,"67622901"],[null,null,"80\\d{6}","\\d{8}",null,null,"80080002"],[null,null,"(?:9(?:4[1568]|5[178]))\\d{5}","\\d{8}",null,null,"94515151"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"78[1-9]\\d{5}","\\d{8}",null,null,"78108780"],"ME",382,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]","[2-57-9]|6(?:[03689]|7(?:[0-8]|9[3-9]))"],"0$1"],[null,"(67)(9)(\\d{3})(\\d{3})","$1 $2 $3 $4",["679","679[0-2]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"77\\d{6}","\\d{8}",null,null,"77273012"],null,null,[null,null,"NA","NA"]],MF:[null,[null,null,"[56]\\d{8}","\\d{9}"],[null,null,"590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}","\\d{9}",null,null,"590271234"],[null,null,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",null,null,"690301234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MF",590,"00","0",null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MG:[null,[null,null,"[23]\\d{8}","\\d{7,9}"],[null,null,"20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}","\\d{7,9}",null,null,"202123456"],[null,null,"3[2-49]\\d{7}","\\d{9}",null,null,"321234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"22\\d{7}","\\d{9}",null,null,"221234567"],"MG",261,"00","0",null,null,"0",null,null,null,[[null,"([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MH:[null,[null,null,"[2-6]\\d{6}","\\d{7}"],[null,null,"(?:247|528|625)\\d{4}","\\d{7}",null,null,"2471234"],[null,null,"(?:235|329|45[56]|545)\\d{4}","\\d{7}",null,null,"2351234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"635\\d{4}","\\d{7}",null,null,"6351234"],"MH",692,"011","1",null,null,"1",null,null,null,[[null,"(\\d{3})(\\d{4})","$1-$2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MK:[null,[null,null,"[2-578]\\d{7}","\\d{8}"],[null,null,"(?:2(?:[23]\\d|5[124578]|6[01])|3(?:1[3-6]|[23][2-6]|4[2356])|4(?:[23][2-6]|4[3-6]|5[256]|6[25-8]|7[24-6]|8[4-6]))\\d{5}","\\d{6,8}",null,null,"22212345"],[null,null,"7(?:[0-25-8]\\d{2}|32\\d|421)\\d{4}","\\d{8}",null,null,"72345678"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"5[02-9]\\d{6}","\\d{8}",null,null,"50012345"],[null,null,"8(?:0[1-9]|[1-9]\\d)\\d{5}","\\d{8}",null,null,"80123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MK",389,"00","0",null,null,"0",null,null,null,[[null,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[null,"([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[null,"([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ML:[null,[null,null,"[246-9]\\d{7}","\\d{8}"],[null,null,"(?:2(?:0(?:2\\d|7[0-8])|1(?:2[5-7]|[3-689]\\d))|44[1239]\\d)\\d{4}","\\d{8}",null,null,"20212345"],[null,null,"(?:2(?:079|17\\d)|[679]\\d{3}|8[239]\\d{2})\\d{4}","\\d{8}",null,null,"65012345"],[null,null,"80\\d{6}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ML",223,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]],[null,"(\\d{4})","$1",["67|74"]]],[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]]],[null,null,"NA","NA"],null,null,[null,null,"80\\d{6}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MM:[null,[null,null,"[14578]\\d{5,7}|[26]\\d{5,8}|9(?:2\\d{0,2}|[58]|3\\d|4\\d{1,2}|6\\d?|[79]\\d{0,2})\\d{6}","\\d{5,10}"],[null,null,"1(?:2\\d{1,2}|[3-5]\\d|6\\d?|[89][0-6]\\d)\\d{4}|2(?:2(?:000\\d{3}|\\d{4})|3\\d{4}|4(?:0\\d{5}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5})|[6-9]\\d{4})|4(?:2[245-8]|[346][2-6]|5[3-5])\\d{4}|5(?:2(?:20?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7(?:[2367]|4\\d|5\\d?|8[145]\\d)|8[245]|9[24])\\d{4}|7(?:[04][24-8]|[15][2-7]|22|3[2-4])\\d{4}|8(?:1(?:2\\d{1,2}|[3-689]\\d)|2(?:2\\d|3(?:\\d|20)|[4-8]\\d)|3[24]\\d|4[24-7]\\d|5[245]\\d|6[23]\\d)\\d{3}","\\d{5,9}",null,null,"1234567"],[null,null,"17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2}|6[0-5]\\d)|3[0-36]\\d|4(?:0[0-4]\\d|[1379]\\d|2\\d{2}|4[0-589]\\d|5\\d{2}|88)|5[0-6]|61?\\d|7(?:3\\d|[789]\\d{2})|8\\d|9(?:1\\d|[67]\\d{2}|[089]))\\d{5}","\\d{7,10}",null,null,"92123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"1333\\d{4}","\\d{8}",null,null,"13331234"],"MM",95,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"],"0$1"],[null,"(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"],"0$1"],[null,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["67|81"],"0$1"],[null,"(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"],"0$1"],[null,"(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[null,"(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"],"0$1"],[null,"(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"],"0$1"],[null,"(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MN:[null,[null,null,"[12]\\d{7,9}|[57-9]\\d{7}","\\d{6,10}"],[null,null,"[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}","\\d{6,10}",null,null,"50123456"],[null,null,"(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}","\\d{8}",null,null,"88123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"7[05-8]\\d{6}","\\d{8}",null,null,"75123456"],"MN",976,"001","0",null,null,"0",null,null,null,[[null,"([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[null,"([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[null,"([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"],"0$1"],[null,"(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],[null,"([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MO:[null,[null,null,"[268]\\d{7}","\\d{8}"],[null,null,"(?:28[2-57-9]|8[2-57-9]\\d)\\d{5}","\\d{8}",null,null,"28212345"],[null,null,"6(?:[2356]\\d|8[158])\\d{5}","\\d{8}",null,null,"66123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MO",853,"00",null,null,null,null,null,null,null,[[null,"([268]\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MP:[null,[null,null,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6702345678"],[null,null,"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6702345678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"MP",1,"011","1",null,null,"1",null,null,1,null,null,[null,null,"NA","NA"],null,"670",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MQ:[null,[null,null,"[56]\\d{8}","\\d{9}"],[null,null,"596(?:0[2-5]|[12]0|3[05-9]|4[024-8]|[5-7]\\d|89|9[4-8])\\d{4}","\\d{9}",null,null,"596301234"],[null,null,"696(?:[0-479]\\d|5[01]|8[0-689])\\d{4}","\\d{9}",null,null,"696201234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MQ",596,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MR:[null,[null,null,"[2-48]\\d{7}","\\d{8}"],[null,null,"25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}","\\d{8}",null,null,"35123456"],[null,null,"[234][0-46-9]\\d{6}","\\d{8}",null,null,"22123456"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MR",222,"00",null,null,null,null,null,null,null,[[null,"([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MS:[null,[null,null,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"664491\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6644912345"],[null,null,"66449[2-6]\\d{4}","\\d{10}",null,null,"6644923456"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"MS",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"664",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MT:[null,[null,null,"[2357-9]\\d{7}","\\d{8}"],[null,null,"2(?:0(?:1[0-6]|3[1-4]|[69]\\d)|[1-357]\\d{2})\\d{4}","\\d{8}",null,null,"21001234"],[null,null,"(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|696|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}","\\d{8}",null,null,"96961234"],[null,null,"800[3467]\\d{4}","\\d{8}",null,null,"80071234"],[null,null,"5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168])|[12]\\d0[1-5])\\d{3}","\\d{8}",null,null,"50037123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"3550\\d{4}","\\d{8}",null,null,"35501234"],"MT",356,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"7117\\d{4}","\\d{8}",null,null,"71171234"],null,null,[null,null,"NA","NA"],[null,null,"501\\d{5}","\\d{8}",null,null,"50112345"],null,null,[null,null,"NA","NA"]],MU:[null,[null,null,"[2-9]\\d{6,7}","\\d{7,8}"],[null,null,"(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(?:44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}","\\d{7,8}",null,null,"2012345"],[null,null,"5(?:2[59]\\d|4(?:2[1-389]|4\\d|7[1-9]|9\\d)|7\\d{2}|8(?:[0-2568]\\d|7[15-8])|9[0-8]\\d)\\d{4}","\\d{8}",null,null,"52512345"],[null,null,"80[012]\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"30\\d{5}","\\d{7}",null,null,"3012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"3(?:20|9\\d)\\d{4}","\\d{7}",null,null,"3201234"],"MU",230,"0(?:0|[2-7]0|33)",null,null,null,null,null,"020",null,[[null,"([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],[null,"(5\\d{3})(\\d{4})","$1 $2",["5"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MV:[null,[null,null,"[3467]\\d{6}|9(?:00\\d{7}|\\d{6})","\\d{7,10}"],[null,null,"(?:3(?:0[01]|3[0-59])|6(?:[567][02468]|8[024689]|90))\\d{4}","\\d{7}",null,null,"6701234"],[null,null,"(?:46[46]|7[3-9]\\d|9[15-9]\\d)\\d{4}","\\d{7}",null,null,"7712345"],[null,null,"NA","NA"],[null,null,"900\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MV",960,"0(?:0|19)",null,null,null,null,null,"00",null,[[null,"(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:[1-9]|0[1-9])"]],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["900"]]],null,[null,null,"781\\d{4}","\\d{7}",null,null,"7812345"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],
MW:[null,[null,null,"(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}","\\d{7,9}"],[null,null,"(?:1[2-9]|21\\d{2})\\d{5}","\\d{7,9}",null,null,"1234567"],[null,null,"(?:111|77\\d|88\\d|99\\d)\\d{6}","\\d{9}",null,null,"991234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MW",265,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"],"0$1"],[null,"(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1789]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MX:[null,[null,null,"[1-9]\\d{9,10}","\\d{7,11}"],[null,null,"(?:33|55|81)\\d{8}|(?:2(?:0[01]|2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}","\\d{7,10}",null,null,"2221234567"],[null,null,"1(?:(?:33|55|81)\\d{8}|(?:2(?:2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})","\\d{11}",null,null,"12221234567"],[null,null,"8(?:00|88)\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"900\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"300\\d{7}","\\d{10}",null,null,"3001234567"],[null,null,"500\\d{7}","\\d{10}",null,null,"5001234567"],[null,null,"NA","NA"],"MX",52,"0[09]","01",null,null,"0[12]|04[45](\\d{10})","1$1",null,null,[[null,"([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"],"01 $1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"],"01 $1",null,1],[null,"(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,1],[null,"(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,1]],[[null,"([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"],"01 $1",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"],"01 $1",null,1],[null,"(1)([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3 $4",["1(?:33|55|81)"]],[null,"(1)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"]]],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],MY:[null,[null,null,"[13-9]\\d{7,9}","\\d{6,10}"],[null,null,"(?:3[2-9]\\d|[4-9][2-9])\\d{6}","\\d{6,9}",null,null,"323456789"],[null,null,"1(?:1[1-5]\\d{2}|[02-4679][2-9]\\d|59\\d{2}|8(?:1[23]|[2-9]\\d))\\d{5}","\\d{9,10}",null,null,"123456789"],[null,null,"1[378]00\\d{6}","\\d{10}",null,null,"1300123456"],[null,null,"1600\\d{6}","\\d{10}",null,null,"1600123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"154\\d{7}","\\d{10}",null,null,"1541234567"],"MY",60,"00","0",null,null,"0",null,null,null,[[null,"([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[null,"(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],[null,"([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],[null,"(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0"]],[null,"(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],[null,"(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],MZ:[null,[null,null,"[28]\\d{7,8}","\\d{8,9}"],[null,null,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}","\\d{8}",null,null,"21123456"],[null,null,"8[23467]\\d{7}","\\d{9}",null,null,"821234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"MZ",258,"00",null,null,null,null,null,null,null,[[null,"([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],[null,"(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NA:[null,[null,null,"[68]\\d{7,8}","\\d{8,9}"],[null,null,"6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4(?:[024]|10?|3[15]?)|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[289]|7[01]|81)|4(?:17|2(?:[012]|7?)|4(?:[06]|1\\d?)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|69|7[01]))\\d{4}","\\d{8,9}",null,null,"61221234"],[null,null,"(?:60|8[125])\\d{7}","\\d{9}",null,null,"811234567"],[null,null,"NA","NA"],[null,null,"8701\\d{5}","\\d{9}",null,null,"870123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"8(?:3\\d{2}|86)\\d{5}","\\d{8,9}",null,null,"88612345"],"NA",264,"00","0",null,null,"0",null,null,null,[[null,"(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1235]"],"0$1"],[null,"(6\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[null,"(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[null,"(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NC:[null,[null,null,"[2-57-9]\\d{5}","\\d{6}"],[null,null,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}","\\d{6}",null,null,"201234"],[null,null,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}","\\d{6}",null,null,"751234"],[null,null,"NA","NA"],[null,null,"36\\d{4}","\\d{6}",null,null,"366711"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NC",687,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NE:[null,[null,null,"[0289]\\d{7}","\\d{8}"],[null,null,"2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}","\\d{8}",null,null,"20201234"],[null,null,"(?:8[089]|9\\d)\\d{6}","\\d{8}",null,null,"93123456"],[null,null,"08\\d{6}","\\d{8}",null,null,"08123456"],[null,null,"09\\d{6}","\\d{8}",null,null,"09123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NE",227,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[289]|09"]],[null,"(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],NF:[null,[null,null,"[13]\\d{5}","\\d{5,6}"],[null,null,"(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}","\\d{5,6}",null,null,"106609"],[null,null,"3[58]\\d{4}","\\d{5,6}",null,null,"381234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NF",672,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{4})","$1 $2",["1"]],[null,"(\\d)(\\d{5})","$1 $2",["3"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NG:[null,[null,null,"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}","\\d{5,14}"],[null,null,"[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}","\\d{5,9}",null,null,"12345678"],[null,null,"(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70[1-689]\\d|8(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))|90[23589]\\d)\\d{6}","\\d{8,10}",null,null,"8021234567"],[null,null,"800\\d{7,11}","\\d{10,14}",null,null,"80017591759"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NG",234,"009","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[23589]"],"0$1"],[null,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"],"0$1"],[null,"([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"],"0$1"],[null,"([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"],"0$1"],[null,"(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"700\\d{7,11}","\\d{10,14}",null,null,"7001234567"],null,null,[null,null,"NA","NA"]],NI:[null,[null,null,"[12578]\\d{7}","\\d{8}"],[null,null,"2\\d{7}","\\d{8}",null,null,"21234567"],[null,null,"5(?:5[0-7]\\d{5}|[78]\\d{6})|7[5-8]\\d{6}|8\\d{7}","\\d{8}",null,null,"81234567"],[null,null,"1800\\d{4}","\\d{8}",null,null,"18001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NI",505,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NL:[null,[null,null,"1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}","\\d{5,10}"],[null,null,"(?:1[0135-8]|2[02-69]|3[0-68]|4[0135-9]|[57]\\d|8[478])\\d{7}","\\d{9}",null,null,"101234567"],[null,null,"6[1-58]\\d{7}","\\d{9}",null,null,"612345678"],[null,null,"800\\d{4,7}","\\d{7,10}",null,null,"8001234"],[null,null,"90[069]\\d{4,7}","\\d{7,10}",null,null,"9061234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"85\\d{7}","\\d{9}",null,null,"851234567"],"NL",31,"00","0",null,null,"0",null,null,null,[[null,"([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"],"0$1"],[null,"([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[null,"(6)(\\d{8})","$1 $2",["6[0-57-9]"],"0$1"],[null,"(66)(\\d{7})","$1 $2",["66"],"0$1"],[null,"(14)(\\d{3,4})","$1 $2",["14"],"$1"],[null,"([89]0\\d)(\\d{4,7})","$1 $2",["80|9"],"0$1"]],null,[null,null,"66\\d{7}","\\d{9}",null,null,"662345678"],null,null,[null,null,"14\\d{3,4}","\\d{5,6}"],[null,null,"140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])","\\d{5,6}",null,null,"14020"],null,null,[null,null,"NA","NA"]],NO:[null,[null,null,"0\\d{4}|[2-9]\\d{7}","\\d{5}(?:\\d{3})?"],[null,null,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","\\d{8}",null,null,"21234567"],[null,null,"(?:4[015-8]|5[89]|87|9\\d)\\d{6}","\\d{8}",null,null,"40612345"],[null,null,"80[01]\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"82[09]\\d{5}","\\d{8}",null,null,"82012345"],[null,null,"810(?:0[0-6]|[2-8]\\d)\\d{3}","\\d{8}",null,null,"81021234"],[null,null,"880\\d{5}","\\d{8}",null,null,"88012345"],[null,null,"85[0-5]\\d{5}","\\d{8}",null,null,"85012345"],"NO",47,"00",null,null,null,null,null,null,null,[[null,"([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],[null,"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}","\\d{5}(?:\\d{3})?",null,null,"01234"],1,null,[null,null,"81[23]\\d{5}","\\d{8}",null,null,"81212345"]],NP:[null,[null,null,"[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})","\\d{6,10}"],[null,null,"(?:1[0-6]\\d|2[13-79][2-6]|3[135-8][2-6]|4[146-9][2-6]|5[135-7][2-6]|6[13-9][2-6]|7[15-9][2-6]|8[1-46-9][2-6]|9[1-79][2-6])\\d{5}","\\d{6,8}",null,null,"14567890"],[null,null,"9(?:6[013]|7[245]|8[0-24-6])\\d{7}","\\d{10}",null,null,"9841234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NP",977,"00","0",null,null,"0",null,null,null,[[null,"(1)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[null,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"],"0$1"],[null,"(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NR:[null,[null,null,"[458]\\d{6}","\\d{7}"],[null,null,"(?:444|888)\\d{4}","\\d{7}",null,null,"4441234"],[null,null,"55[5-9]\\d{4}","\\d{7}",null,null,"5551234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NR",674,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NU:[null,[null,null,"[1-5]\\d{3}","\\d{4}"],[null,null,"[34]\\d{3}","\\d{4}",null,null,"4002"],[null,null,"[125]\\d{3}","\\d{4}",null,null,"1234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"NU",683,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],NZ:[null,[null,null,"6[235-9]\\d{6}|[2-57-9]\\d{7,10}","\\d{7,11}"],[null,null,"(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}|24099\\d{3}","\\d{7,8}",null,null,"32345678"],[null,null,"2(?:[028]\\d{7,8}|1(?:[03]\\d{5,7}|[12457]\\d{5,6}|[689]\\d{5})|[79]\\d{7})","\\d{8,10}",null,null,"211234567"],[null,null,"508\\d{6,7}|80\\d{6,8}","\\d{8,10}",null,null,"800123456"],[null,null,"90\\d{7,9}","\\d{9,11}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"70\\d{7}","\\d{9}",null,null,"701234567"],[null,null,"NA","NA"],"NZ",64,"0(?:0|161)","0",null,null,"0",null,"00",null,[[null,"([34679])(\\d{3})(\\d{4})","$1-$2 $3",["[346]|7[2-57-9]|9[1-9]"],"0$1"],[null,"(24099)(\\d{3})","$1 $2",["240","2409","24099"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"],"0$1"],[null,"(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"],"0$1"]],null,[null,null,"[28]6\\d{6,7}","\\d{8,9}",null,null,"26123456"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],OM:[null,[null,null,"(?:5|[279]\\d)\\d{6}|800\\d{5,6}","\\d{7,9}"],[null,null,"2[2-6]\\d{6}","\\d{8}",null,null,"23123456"],[null,null,"7[19]\\d{6}|9(?:0[1-9]|[1-9]\\d)\\d{5}","\\d{8}",null,null,"92123456"],[null,null,"8007\\d{4,5}|500\\d{4}","\\d{7,9}",null,null,"80071234"],[null,null,"900\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"OM",968,"00",null,null,null,null,null,null,null,[[null,"(2\\d)(\\d{6})","$1 $2",["2"]],[null,"([79]\\d{3})(\\d{4})","$1 $2",["[79]"]],[null,"([58]00)(\\d{4,6})","$1 $2",["[58]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PA:[null,[null,null,"[1-9]\\d{6,7}","\\d{7,8}"],[null,null,"(?:1(?:0[0-8]|1[49]|2[37]|3[0137]|4[147]|5[05]|6[58]|7[0167]|8[58]|9[139])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[09]\\d|1[014-7]|2[0-3]|3[03]|4[03-57]|55|6[068]|7[06-8]|8[06-9])|4(?:3[013-69]|4\\d|7[0-589])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[469]0|5[06-9]|7[0-24-79]|8[7-9])|8(?:09|[34]\\d|5[0134]|8[02])|9(?:0[6-9]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}","\\d{7}",null,null,"2001234"],[null,null,"(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[0-24-9])\\d{5}","\\d{7,8}",null,null,"60012345"],[null,null,"80[09]\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"(?:779|8(?:55|60|7[78])|9(?:00|81))\\d{4}","\\d{7}",null,null,"8601234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PA",507,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[null,"(\\d{4})(\\d{4})","$1-$2",["6"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PE:[null,[null,null,"[14-9]\\d{7,8}","\\d{6,9}"],[null,null,"(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}","\\d{6,8}",null,null,"11234567"],[null,null,"9\\d{8}","\\d{9}",null,null,"912345678"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"805\\d{5}","\\d{8}",null,null,"80512345"],[null,null,"801\\d{5}","\\d{8}",null,null,"80112345"],[null,null,"80[24]\\d{5}","\\d{8}",null,null,"80212345"],[null,null,"NA","NA"],"PE",51,"19(?:1[124]|77|90)00","0"," Anexo ",null,"0",null,null,null,[[null,"(1)(\\d{7})","$1 $2",["1"],"(0$1)"],[null,"([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"],"(0$1)"],[null,"(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],[null,"(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PF:[null,[null,null,"4\\d{5,7}|8\\d{7}","\\d{6}(?:\\d{2})?"],[null,null,"4(?:[09][45689]\\d|4)\\d{4}","\\d{6}(?:\\d{2})?",null,null,"40412345"],[null,null,"8[79]\\d{6}","\\d{8}",null,null,"87123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PF",689,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],[null,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]],null,[null,null,"NA","NA"],null,null,[null,null,"44\\d{4}","\\d{6}",null,null,"441234"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PG:[null,[null,null,"[1-9]\\d{6,7}","\\d{7,8}"],[null,null,"(?:3[0-2]\\d|4[25]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}","\\d{7}",null,null,"3123456"],[null,null,"(?:20150|68\\d{2}|7(?:[0-689]\\d|75)\\d{2})\\d{3}","\\d{7,8}",null,null,"6812345"],[null,null,"180\\d{4}","\\d{7}",null,null,"1801234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"275\\d{4}","\\d{7}",null,null,"2751234"],"PG",675,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],[null,"(\\d{4})(\\d{4})","$1 $2",["20|7"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PH:[null,[null,null,"2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}","\\d{5,13}"],[null,null,"2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})","\\d{5,10}",null,null,"21234567"],[null,null,"(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[236-9]|50|7[34-79]|89|9[4-9]))\\d{7}","\\d{10}",null,null,"9051234567"],[null,null,"1800\\d{7,9}","\\d{11,13}",null,null,"180012345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PH",63,"00","0",null,null,"0",null,null,null,[[null,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],[null,"(2)(\\d{5})","$1 $2",["2"],"(0$1)"],[null,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],[null,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],[null,"([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],[null,"(1800)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[null,"(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PK:[null,[null,null,"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))","\\d{6,12}"],[null,null,"(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}","\\d{6,10}",null,null,"2123456789"],[null,null,"3(?:0\\d|1[0-6]|2[0-5]|3[0-7]|4[0-8]|55|64)\\d{7}","\\d{10}",null,null,"3012345678"],[null,null,"800\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"900\\d{5}","\\d{8}",null,null,"90012345"],[null,null,"NA","NA"],[null,null,"122\\d{6}","\\d{9}",null,null,"122044444"],[null,null,"NA","NA"],"PK",92,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"],"(0$1)"],[null,"(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"],"(0$1)"],[null,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[null,"(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d[2-9]"],"(0$1)"],[null,"(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],[null,"([15]\\d{3})(\\d{5,6})","$1 $2",["58[12]|1"],"(0$1)"],[null,"(586\\d{2})(\\d{5})","$1 $2",["586"],"(0$1)"],[null,"([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}","\\d{11,12}",null,null,"21111825888"],null,null,[null,null,"NA","NA"]],PL:[null,[null,null,"[12]\\d{6,8}|[3-57-9]\\d{8}|6\\d{5,8}","\\d{6,9}"],[null,null,"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])\\d{7}|[12]2\\d{5}","\\d{6,9}",null,null,"123456789"],[null,null,"(?:5[0137]|6[069]|7[2389]|88)\\d{7}","\\d{9}",null,null,"512345678"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"70\\d{7}","\\d{9}",null,null,"701234567"],[null,null,"801\\d{6}","\\d{9}",null,null,"801234567"],[null,null,"NA","NA"],[null,null,"39\\d{7}","\\d{9}",null,null,"391234567"],"PL",48,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],[null,"(\\d{2})(\\d{1})(\\d{4})","$1 $2 $3",["[12]2"]],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|5[0137]|6[0469]|7[02389]|8[08]"]],[null,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[null,"(\\d{3})(\\d{3})","$1 $2",["64"]]],null,[null,null,"64\\d{4,7}","\\d{6,9}",null,null,"641234567"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PM:[null,[null,null,"[45]\\d{5}","\\d{6}"],[null,null,"41\\d{4}","\\d{6}",null,null,"411234"],[null,null,"55\\d{4}","\\d{6}",null,null,"551234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PM",508,"00","0",null,null,"0",null,null,null,[[null,"([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PR:[null,[null,null,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"(?:787|939)[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"7872345678"],[null,null,"(?:787|939)[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"7872345678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"PR",1,"011","1",null,null,"1",null,null,1,null,null,[null,null,"NA","NA"],null,"787|939",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PS:[null,[null,null,"[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})","\\d{4,10}"],[null,null,"(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}","\\d{7,8}",null,null,"22234567"],[null,null,"5[69]\\d{7}","\\d{9}",null,null,"599123456"],[null,null,"1800\\d{6}","\\d{10}",null,null,"1800123456"],[null,null,"1(?:4|9\\d)\\d{2}","\\d{4,5}",null,null,"19123"],[null,null,"1700\\d{6}","\\d{10}",null,null,"1700123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PS",970,"00","0",null,null,"0",null,null,null,[[null,"([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],[null,"(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[null,"(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PT:[null,[null,null,"[2-46-9]\\d{8}","\\d{9}"],[null,null,"2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}","\\d{9}",null,null,"212345678"],[null,null,"9(?:[1236]\\d{2}|480)\\d{5}","\\d{9}",null,null,"912345678"],[null,null,"80[02]\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"6(?:0[178]|4[68])\\d{6}|76(?:0[1-57]|1[2-47]|2[237])\\d{5}","\\d{9}",null,null,"760123456"],[null,null,"80(?:8\\d|9[1579])\\d{5}","\\d{9}",null,null,"808123456"],[null,null,"884[0-4689]\\d{5}","\\d{9}",null,null,"884123456"],[null,null,"30\\d{7}","\\d{9}",null,null,"301234567"],"PT",351,"00",null,null,null,null,null,null,null,[[null,"(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],[null,"([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"7(?:0(?:7\\d|8[17]))\\d{5}","\\d{9}",null,null,"707123456"],null,null,[null,null,"600\\d{6}","\\d{9}",null,null,"600110000"]],PW:[null,[null,null,"[2-8]\\d{6}","\\d{7}"],[null,null,"2552255|(?:277|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76))\\d{4}","\\d{7}",null,null,"2771234"],[null,null,"(?:6[234689]0|77[45789])\\d{4}","\\d{7}",null,null,"6201234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"PW",680,"01[12]",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],PY:[null,[null,null,"5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}","\\d{5,9}"],[null,null,"(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}","\\d{5,9}",null,null,"212345678"],[null,null,"9(?:6[12]|[78][1-6]|9[1-5])\\d{6}","\\d{9}",null,null,"961456789"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"8700[0-4]\\d{4}","\\d{9}",null,null,"870012345"],"PY",595,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{5,7})","$1 $2",["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],"($1)"],[null,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[null,"(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8700"]],[null,"(\\d{3})(\\d{4,6})","$1 $2",["[2-8][1-9]"],"($1)"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"[2-9]0\\d{4,7}","\\d{6,9}",null,null,"201234567"],null,null,[null,null,"NA","NA"]],QA:[null,[null,null,"[2-8]\\d{6,7}","\\d{7,8}"],[null,null,"4[04]\\d{6}","\\d{7,8}",null,null,"44123456"],[null,null,"[3567]\\d{7}","\\d{7,8}",null,null,"33123456"],[null,null,"800\\d{4}","\\d{7,8}",null,null,"8001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"QA",974,"00",null,null,null,null,null,null,null,[[null,"([28]\\d{2})(\\d{4})","$1 $2",["[28]"]],[null,"([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"]]],null,[null,null,"2(?:[12]\\d|61)\\d{4}","\\d{7}",null,null,"2123456"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],RE:[null,[null,null,"[268]\\d{8}","\\d{9}"],[null,null,"262\\d{6}","\\d{9}",null,null,"262161234"],[null,null,"6(?:9[23]|47)\\d{6}","\\d{9}",null,null,"692123456"],[null,null,"80\\d{7}","\\d{9}",null,null,"801234567"],[null,null,"89[1-37-9]\\d{6}","\\d{9}",null,null,"891123456"],[null,null,"8(?:1[019]|2[0156]|84|90)\\d{6}","\\d{9}",null,null,"810123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],"RE",262,"00","0",null,null,"0",null,null,null,[[null,"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",null,"0$1"]],null,[null,null,"NA","NA"],1,"262|6[49]|8",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],RO:[null,[null,null,"2\\d{5,8}|[37-9]\\d{8}","\\d{6,9}"],[null,null,"2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3[13-6]\\d{7}","\\d{6,9}",null,null,"211234567"],[null,null,"7(?:[0-8]\\d{2}|99\\d)\\d{5}","\\d{9}",null,null,"712345678"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"90[036]\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"801\\d{6}","\\d{9}",null,null,"801123456"],[null,null,"802\\d{6}","\\d{9}",null,null,"802123456"],[null,null,"NA","NA"],"RO",40,"00","0"," int ",null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[null,"(21)(\\d{4})","$1 $2",["21"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"],"0$1"],[null,"(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"37\\d{7}","\\d{9}",null,null,"372123456"],null,null,[null,null,"NA","NA"]],RS:[null,[null,null,"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})","\\d{5,12}"],[null,null,"(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}","\\d{5,12}",null,null,"10234567"],[null,null,"6(?:[0-689]|7\\d)\\d{6,7}","\\d{8,10}",null,null,"601234567"],[null,null,"800\\d{3,9}","\\d{6,12}",null,null,"80012345"],[null,null,"(?:90[0169]|78\\d)\\d{3,7}","\\d{6,12}",null,null,"90012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"RS",381,"00","0",null,null,"0",null,null,null,[[null,"([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"],"0$1"],[null,"([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"],"0$1"],[null,"(6\\d)(\\d{6,8})","$1 $2",["6"],"0$1"],[null,"([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"],"0$1"],[null,"(7[26])(\\d{4,9})","$1 $2",["7[26]"],"0$1"],[null,"(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"7[06]\\d{4,10}","\\d{6,12}",null,null,"700123456"],null,null,[null,null,"NA","NA"]],RU:[null,[null,null,"[3489]\\d{9}","\\d{10}"],[null,null,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}","\\d{10}",null,null,"3011234567"],[null,null,"9\\d{9}","\\d{10}",null,null,"9123456789"],[null,null,"80[04]\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"80[39]\\d{7}","\\d{10}",null,null,"8091234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"RU",7,"810","8",null,null,"8",null,"8~10",null,[[null,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[1-79]"],"$1",null,1],[null,"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]"],"8 ($1)",null,1],[null,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",null,1]],[[null,"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]"],"8 ($1)",null,1],[null,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",null,1]],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],RW:[null,[null,null,"[027-9]\\d{7,8}","\\d{8,9}"],[null,null,"2[258]\\d{7}|06\\d{6}","\\d{8,9}",null,null,"250123456"],[null,null,"7[238]\\d{7}","\\d{9}",null,null,"720123456"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"900\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"RW",250,"00","0",null,null,"0",null,null,null,[[null,"(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"$1"],[null,"([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],[null,"(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],
SA:[null,[null,null,"1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}","\\d{7,10}"],[null,null,"11\\d{7}|1?(?:2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}","\\d{7,9}",null,null,"112345678"],[null,null,"(?:5(?:[013-689]\\d|7[0-26-8])|811\\d)\\d{6}","\\d{9,10}",null,null,"512345678"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"NA","NA"],[null,null,"92[05]\\d{6}","\\d{9}",null,null,"920012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SA",966,"00","0",null,null,"0",null,null,null,[[null,"([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"],"0$1"],[null,"(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"],"0$1"],[null,"(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[null,"(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],[null,"(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"$1"],[null,"(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SB:[null,[null,null,"[1-9]\\d{4,6}","\\d{5,7}"],[null,null,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}","\\d{5}",null,null,"40123"],[null,null,"48\\d{3}|7(?:30|[46-8]\\d|5[025-9]|9[0-5])\\d{4}|8[4-9]\\d{5}|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}","\\d{5,7}",null,null,"7421234"],[null,null,"1[38]\\d{3}","\\d{5}",null,null,"18123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"5[12]\\d{3}","\\d{5}",null,null,"51123"],"SB",677,"0[01]",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{5})","$1 $2",["[7-9]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SC:[null,[null,null,"[2468]\\d{5,6}","\\d{6,7}"],[null,null,"4[2-46]\\d{5}","\\d{7}",null,null,"4217123"],[null,null,"2[5-8]\\d{5}","\\d{7}",null,null,"2510123"],[null,null,"8000\\d{2}","\\d{6}",null,null,"800000"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"64\\d{5}","\\d{7}",null,null,"6412345"],"SC",248,"0[0-2]",null,null,null,null,null,"00",null,[[null,"(\\d{3})(\\d{3})","$1 $2",["8"]],[null,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SD:[null,[null,null,"[19]\\d{8}","\\d{9}"],[null,null,"1(?:[125]\\d|8[3567])\\d{6}","\\d{9}",null,null,"121231234"],[null,null,"9[0-3569]\\d{7}","\\d{9}",null,null,"911231234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SD",249,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SE:[null,[null,null,"[1-35-9]\\d{5,11}|4\\d{6,8}","\\d{6,12}"],[null,null,"1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})","\\d{7,9}",null,null,"8123456"],[null,null,"7[02369]\\d{7}","\\d{9}",null,null,"701234567"],[null,null,"20\\d{4,7}","\\d{6,9}",null,null,"20123456"],[null,null,"649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}","\\d{7,10}",null,null,"9001234567"],[null,null,"77(?:0\\d{3}(?:\\d{3})?|[1-7]\\d{6})","\\d{6}(?:\\d{3})?",null,null,"771234567"],[null,null,"75[1-8]\\d{6}","\\d{9}",null,null,"751234567"],[null,null,"NA","NA"],"SE",46,"00","0",null,null,"0",null,null,null,[[null,"(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[null,"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],"0$1"],[null,"([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["1[136]|2[136]|3[356]|4[0246]|6[03]|90"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],"0$1"],[null,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],"0$1"],[null,"(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],"0$1"],[null,"(77)(\\d{2})(\\d{2})","$1-$2$3",["7"],"0$1"],[null,"(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[null,"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],"0$1"],[null,"(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],"0$1"],[null,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],"0$1"]],[[null,"(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1 $2 $3 $4",["8"]],[null,"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]],[null,"([1-469]\\d)(\\d{3})(\\d{2})","$1 $2 $3",["1[136]|2[136]|3[356]|4[0246]|6[03]|90"]],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]],[null,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]],[null,"(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7"]],[null,"(77)(\\d{2})(\\d{2})","$1 $2 $3",["7"]],[null,"(20)(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[null,"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9[034]"]],[null,"(9[034]\\d)(\\d{4})","$1 $2",["9[034]"]],[null,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["25[245]|67[3-6]"]]],[null,null,"74[02-9]\\d{6}","\\d{9}",null,null,"740123456"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"(?:25[245]|67[3-6])\\d{9}","\\d{12}",null,null,"254123456789"]],SG:[null,[null,null,"[36]\\d{7}|[17-9]\\d{7,10}","\\d{8,11}"],[null,null,"6[1-9]\\d{6}","\\d{8}",null,null,"61234567"],[null,null,"(?:8[1-8]|9[0-8])\\d{6}","\\d{8}",null,null,"81234567"],[null,null,"1?800\\d{7}","\\d{10,11}",null,null,"18001234567"],[null,null,"1900\\d{7}","\\d{11}",null,null,"19001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"3[12]\\d{6}","\\d{8}",null,null,"31234567"],"SG",65,"0[0-3]\\d",null,null,null,null,null,null,null,[[null,"([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"]],[null,"(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]"]],[null,"(7000)(\\d{4})(\\d{3})","$1 $2 $3",["70"]],[null,"(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"7000\\d{7}","\\d{11}",null,null,"70001234567"],null,null,[null,null,"NA","NA"]],SH:[null,[null,null,"[256]\\d{4}","\\d{4,5}"],[null,null,"2(?:[0-57-9]\\d|6[4-9])\\d{2}","\\d{5}",null,null,"22158"],[null,null,"[56]\\d{4}","\\d{5}"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"262\\d{2}","\\d{5}"],"SH",290,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SI:[null,[null,null,"[1-7]\\d{6,7}|[89]\\d{4,7}","\\d{5,8}"],[null,null,"(?:1\\d|[25][2-8]|3[24-8]|4[24-8]|7[3-8])\\d{6}","\\d{7,8}",null,null,"11234567"],[null,null,"(?:[37][01]|4[0139]|51|6[48])\\d{6}","\\d{8}",null,null,"31234567"],[null,null,"80\\d{4,6}","\\d{6,8}",null,null,"80123456"],[null,null,"90\\d{4,6}|89[1-3]\\d{2,5}","\\d{5,8}",null,null,"90123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"(?:59|8[1-3])\\d{6}","\\d{8}",null,null,"59012345"],"SI",386,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|3[24-8]|4[24-8]|5[2-8]|7[3-8]"],"(0$1)"],[null,"([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[null,"([89][09])(\\d{3,6})","$1 $2",["[89][09]"],"0$1"],[null,"([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SJ:[null,[null,null,"0\\d{4}|[4789]\\d{7}","\\d{5}(?:\\d{3})?"],[null,null,"79\\d{6}","\\d{8}",null,null,"79123456"],[null,null,"(?:4[015-8]|5[89]|9\\d)\\d{6}","\\d{8}",null,null,"41234567"],[null,null,"80[01]\\d{5}","\\d{8}",null,null,"80012345"],[null,null,"82[09]\\d{5}","\\d{8}",null,null,"82012345"],[null,null,"810(?:0[0-6]|[2-8]\\d)\\d{3}","\\d{8}",null,null,"81021234"],[null,null,"880\\d{5}","\\d{8}",null,null,"88012345"],[null,null,"85[0-5]\\d{5}","\\d{8}",null,null,"85012345"],"SJ",47,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}","\\d{5}(?:\\d{3})?",null,null,"01234"],1,null,[null,null,"81[23]\\d{5}","\\d{8}",null,null,"81212345"]],SK:[null,[null,null,"(?:[2-68]\\d{5,8}|9\\d{6,8})","\\d{6,9}"],[null,null,"2(?:16\\d{3,4}|\\d{8})|[3-5](?:[1-8]16\\d{2,3}|\\d{8})","\\d{6,9}",null,null,"212345678"],[null,null,"9(?:0[1-8]|1[0-24-9]|4[0489]|50)\\d{6}","\\d{9}",null,null,"912123456"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"9(?:[78]\\d{7}|00\\d{6})","\\d{9}",null,null,"900123456"],[null,null,"8[5-9]\\d{7}","\\d{9}",null,null,"850123456"],[null,null,"NA","NA"],[null,null,"6(?:02|5[0-4]|9[0-6])\\d{6}","\\d{9}",null,null,"690123456"],"SK",421,"00","0",null,null,"0",null,null,null,[[null,"(2)(16)(\\d{3,4})","$1 $2 $3",["216"],"0$1"],[null,"([3-5]\\d)(16)(\\d{2,3})","$1 $2 $3",["[3-5]"],"0$1"],[null,"(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[null,"([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"],[null,"([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[null,"(9090)(\\d{3})","$1 $2",["9090"],"0$1"]],null,[null,null,"9090\\d{3}","\\d{7}",null,null,"9090123"],null,null,[null,null,"(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}|9090\\d{3}","\\d{7,9}",null,null,"800123456"],[null,null,"96\\d{7}","\\d{9}",null,null,"961234567"],null,null,[null,null,"NA","NA"]],SL:[null,[null,null,"[2-9]\\d{7}","\\d{6,8}"],[null,null,"[235]2[2-4][2-9]\\d{4}","\\d{6,8}",null,null,"22221234"],[null,null,"(?:2[15]|3[03-5]|4[04]|5[05]|66|7[6-9]|88|99)\\d{6}","\\d{6,8}",null,null,"25123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SL",232,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{6})","$1 $2",null,"(0$1)"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SM:[null,[null,null,"[05-7]\\d{7,9}","\\d{6,10}"],[null,null,"0549(?:8[0157-9]|9\\d)\\d{4}","\\d{6,10}",null,null,"0549886377"],[null,null,"6[16]\\d{6}","\\d{8}",null,null,"66661212"],[null,null,"NA","NA"],[null,null,"7[178]\\d{6}","\\d{8}",null,null,"71123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"5[158]\\d{6}","\\d{8}",null,null,"58001110"],"SM",378,"00",null,null,null,"(?:0549)?([89]\\d{5})","0549$1",null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[null,"(0549)(\\d{6})","$1 $2",["0"]],[null,"(\\d{6})","0549 $1",["[89]"]]],[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[null,"(0549)(\\d{6})","($1) $2",["0"]],[null,"(\\d{6})","(0549) $1",["[89]"]]],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],SN:[null,[null,null,"[3789]\\d{8}","\\d{9}"],[null,null,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611|90[1-5])\\d{5}","\\d{9}",null,null,"301012345"],[null,null,"7(?:[067]\\d|21|8[0-26]|90)\\d{6}","\\d{9}",null,null,"701234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"88[4689]\\d{6}","\\d{9}",null,null,"884123456"],[null,null,"81[02468]\\d{6}","\\d{9}",null,null,"810123456"],[null,null,"NA","NA"],[null,null,"3392\\d{5}|93330\\d{4}","\\d{9}",null,null,"933301234"],"SN",221,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],[null,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SO:[null,[null,null,"[1-79]\\d{6,8}","\\d{7,9}"],[null,null,"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|59)\\d{5}","\\d{7}",null,null,"4012345"],[null,null,"(?:15\\d|2(?:4\\d|8)|6[1-35-9]?\\d{2}|7(?:[1-8]\\d|99?\\d)|9(?:0[67]|[2-9])\\d)\\d{5}","\\d{7,9}",null,null,"71123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SO",252,"00","0",null,null,"0",null,null,null,[[null,"(\\d)(\\d{6})","$1 $2",["2[0-79]|[13-5]"]],[null,"(\\d)(\\d{7})","$1 $2",["24|[67]"]],[null,"(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],[null,"(90\\d)(\\d{3})(\\d{3})","$1 $2 $3",["90"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SR:[null,[null,null,"[2-8]\\d{5,6}","\\d{6,7}"],[null,null,"(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}","\\d{6,7}",null,null,"211234"],[null,null,"(?:7[124-7]|8[1-9])\\d{5}","\\d{7}",null,null,"7412345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"5(?:6\\d{4}|90[0-4]\\d{3})","\\d{6,7}",null,null,"561234"],"SR",597,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],[null,"(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],[null,"(\\d{3})(\\d{4})","$1-$2",["59|[6-8]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SS:[null,[null,null,"[19]\\d{8}","\\d{9}"],[null,null,"18\\d{7}","\\d{9}",null,null,"181234567"],[null,null,"(?:12|9[1257])\\d{7}","\\d{9}",null,null,"977123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SS",211,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ST:[null,[null,null,"[29]\\d{6}","\\d{7}"],[null,null,"22\\d{5}","\\d{7}",null,null,"2221234"],[null,null,"9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d{2})\\d{3}","\\d{7}",null,null,"9812345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ST",239,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SV:[null,[null,null,"[267]\\d{7}|[89]\\d{6}(?:\\d{4})?","\\d{7,8}|\\d{11}"],[null,null,"2[1-6]\\d{6}","\\d{8}",null,null,"21234567"],[null,null,"[67]\\d{7}","\\d{8}",null,null,"70123456"],[null,null,"800\\d{4}(?:\\d{4})?","\\d{7}(?:\\d{4})?",null,null,"8001234"],[null,null,"900\\d{4}(?:\\d{4})?","\\d{7}(?:\\d{4})?",null,null,"9001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SV",503,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[null,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[null,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SX:[null,[null,null,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"7215(?:4[2-8]|8[239]|9[056])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"7215425678"],[null,null,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}","\\d{10}",null,null,"7215205678"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002123456"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002123456"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"SX",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"721",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SY:[null,[null,null,"[1-59]\\d{7,8}","\\d{6,9}"],[null,null,"(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}","\\d{6,9}",null,null,"112345678"],[null,null,"9(?:22|[35][0-8]|4\\d|6[024-9]|88|9[0-489])\\d{6}","\\d{9}",null,null,"944567890"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SY",963,"00","0",null,null,"0",null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",null,1],[null,"(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",null,1]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],SZ:[null,[null,null,"[027]\\d{7}","\\d{8}"],[null,null,"2[2-5]\\d{6}","\\d{8}",null,null,"22171234"],[null,null,"7[6-8]\\d{6}","\\d{8}",null,null,"76123456"],[null,null,"0800\\d{4}","\\d{8}",null,null,"08001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"SZ",268,"00",null,null,null,null,null,null,null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[027]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"0800\\d{4}","\\d{8}",null,null,"08001234"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],TA:[null,[null,null,"8\\d{3}","\\d{4}"],[null,null,"8\\d{3}","\\d{4}",null,null,"8999"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TA",290,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TC:[null,[null,null,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"649(?:712|9(?:4\\d|50))\\d{4}","\\d{7}(?:\\d{3})?",null,null,"6497121234"],[null,null,"649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-7])|4[34][1-3])\\d{4}","\\d{10}",null,null,"6492311234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"64971[01]\\d{4}","\\d{10}",null,null,"6497101234"],"TC",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"649",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TD:[null,[null,null,"[2679]\\d{7}","\\d{8}"],[null,null,"22(?:[3789]0|5[0-5]|6[89])\\d{4}","\\d{8}",null,null,"22501234"],[null,null,"(?:6[023568]\\d|77\\d|9\\d{2})\\d{5}","\\d{8}",null,null,"63012345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TD",235,"00|16",null,null,null,null,null,"00",null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TG:[null,[null,null,"[29]\\d{7}","\\d{8}"],[null,null,"2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}","\\d{8}",null,null,"22212345"],[null,null,"9[0-389]\\d{6}","\\d{8}",null,null,"90112345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TG",228,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TH:[null,[null,null,"[2-9]\\d{7,8}|1\\d{3}(?:\\d{5,6})?","\\d{4}|\\d{8,10}"],[null,null,"(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}","\\d{8}",null,null,"21234567"],[null,null,"(?:14|6[1-3]|[89]\\d)\\d{7}","\\d{9}",null,null,"812345678"],[null,null,"1800\\d{6}","\\d{10}",null,null,"1800123456"],[null,null,"1900\\d{6}","\\d{10}",null,null,"1900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"6[08]\\d{7}","\\d{9}",null,null,"601234567"],"TH",66,"00","0",null,null,"0",null,null,null,[[null,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[null,"([13-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"],"0$1"],[null,"(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1"],"$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"1\\d{3}","\\d{4}",null,null,"1100"],[null,null,"1\\d{3}","\\d{4}",null,null,"1100"],null,null,[null,null,"NA","NA"]],TJ:[null,[null,null,"[3-589]\\d{8}","\\d{3,9}"],[null,null,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}","\\d{3,9}",null,null,"372123456"],[null,null,"(?:41[18]|50[125]|88\\d|9[0-35-9]\\d)\\d{6}","\\d{9}",null,null,"917123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TJ",992,"810","8",null,null,"8",null,"8~10",null,[[null,"([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],"(8) $1",null,1],[null,"([4589]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[58]|9(?:1[59]|[0235-9])"],"(8) $1",null,1],[null,"(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"],"(8) $1",null,1],[null,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"],"(8) $1",null,1]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TK:[null,[null,null,"[2-47]\\d{3,6}","\\d{4,7}"],[null,null,"(?:2[2-4]|[34]\\d)\\d{2,5}","\\d{4,7}",null,null,"3101"],[null,null,"7[2-4]\\d{2,5}","\\d{4,7}",null,null,"7290"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TK",690,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TL:[null,[null,null,"[2-489]\\d{6}|7\\d{6,7}","\\d{7,8}"],[null,null,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}","\\d{7}",null,null,"2112345"],[null,null,"7[3-8]\\d{6}","\\d{8}",null,null,"77212345"],[null,null,"80\\d{5}","\\d{7}",null,null,"8012345"],[null,null,"90\\d{5}","\\d{7}",null,null,"9012345"],[null,null,"NA","NA"],[null,null,"70\\d{5}","\\d{7}",null,null,"7012345"],[null,null,"NA","NA"],"TL",670,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[2-489]"]],[null,"(\\d{4})(\\d{4})","$1 $2",["7"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TM:[null,[null,null,"[1-6]\\d{7}","\\d{8}"],[null,null,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}","\\d{8}",null,null,"12345678"],[null,null,"6[1-9]\\d{6}","\\d{8}",null,null,"66123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TM",993,"810","8",null,null,"8",null,"8~10",null,[[null,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[null,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],[null,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["13|[2-5]"],"(8 $1)"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TN:[null,[null,null,"[2-57-9]\\d{7}","\\d{8}"],[null,null,"3(?:[012]\\d|6[0-4]|91)\\d{5}|7\\d{7}|81200\\d{3}","\\d{8}",null,null,"71234567"],[null,null,"(?:[259]\\d|4[0-6])\\d{6}","\\d{8}",null,null,"20123456"],[null,null,"8010\\d{4}","\\d{8}",null,null,"80101234"],[null,null,"88\\d{6}","\\d{8}",null,null,"88123456"],[null,null,"8[12]10\\d{4}","\\d{8}",null,null,"81101234"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TN",216,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TO:[null,[null,null,"[02-8]\\d{4,6}","\\d{5,7}"],[null,null,"(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}","\\d{5}",null,null,"20123"],[null,null,"(?:7[578]|8[47-9])\\d{5}","\\d{7}",null,null,"7715123"],[null,null,"0800\\d{3}","\\d{7}",null,null,"0800222"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TO",676,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],[null,"(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],[null,"(\\d{4})(\\d{3})","$1 $2",["0"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],TR:[null,[null,null,"[2-589]\\d{9}|444\\d{4}","\\d{7,10}"],[null,null,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}","\\d{10}",null,null,"2123456789"],[null,null,"5(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{7}","\\d{10}",null,null,"5012345678"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"900\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TR",90,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)",null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[589]"],"0$1",null,1],[null,"(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],null,[null,null,"512\\d{7}","\\d{10}",null,null,"5123456789"],null,null,[null,null,"444\\d{4}","\\d{7}",null,null,"4441444"],[null,null,"444\\d{4}|850\\d{7}","\\d{7,10}",null,null,"4441444"],null,null,[null,null,"NA","NA"]],TT:[null,[null,null,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"868(?:2(?:01|2[1-6]|3[1-5])|6(?:0[79]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}","\\d{7}(?:\\d{3})?",null,null,"8682211234"],[null,null,"868(?:2(?:[789]\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}","\\d{10}",null,null,"8682911234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"TT",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"868",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"868619\\d{4}","\\d{10}"]],TV:[null,[null,null,"[279]\\d{4,6}","\\d{5,7}"],[null,null,"2[02-9]\\d{3}","\\d{5}",null,null,"20123"],[null,null,"(?:70\\d|90)\\d{4}","\\d{6,7}",null,null,"901234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"TV",688,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TW:[null,[null,null,"[2-689]\\d{7,8}|7\\d{7,9}","\\d{8,10}"],[null,null,"[2-8]\\d{7,8}","\\d{8,9}",null,null,"21234567"],[null,null,"9\\d{8}","\\d{9}",null,null,"912345678"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"900\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"70\\d{8}","\\d{10}",null,null,"7012345678"],"TW",886,"0(?:0[25679]|19)","0","#",null,"0",null,null,null,[[null,"([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[2-6]|[78][1-9]"],"0$1"],[null,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["80|9"],"0$1"],[null,"(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],TZ:[null,[null,null,"\\d{9}","\\d{7,9}"],[null,null,"2[2-8]\\d{7}","\\d{7,9}",null,null,"222345678"],[null,null,"(?:6[25-8]|7[13-9])\\d{7}","\\d{9}",null,null,"621234567"],[null,null,"80[08]\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"90\\d{7}","\\d{9}",null,null,"900123456"],[null,null,"8(?:40|6[01])\\d{6}","\\d{9}",null,null,"840123456"],[null,null,"NA","NA"],[null,null,"41\\d{7}","\\d{9}",null,null,"412345678"],"TZ",255,"00[056]","0",null,null,"0",null,null,null,[[null,"([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[null,"([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"],[null,"([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],UA:[null,[null,null,"[3-9]\\d{8}","\\d{5,9}"],[null,null,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}","\\d{5,9}",null,null,"311234567"],[null,null,"(?:39|50|6[36-8]|73|9[1-9])\\d{7}","\\d{9}",null,null,"391234567"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"900\\d{6}","\\d{9}",null,null,"900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"89\\d{7}","\\d{9}",null,null,"891234567"],"UA",380,"00","0",null,null,"0",null,"0~0",null,[[null,"([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|73|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|73|9[1-9]"],"0$1"],[null,"([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"],"0$1"],[null,"([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])","3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],UG:[null,[null,null,"\\d{9}","\\d{5,9}"],[null,null,"20(?:[0147]\\d{2}|2(?:40|[5-9]\\d)|3[23]\\d|5[0-4]\\d|6[03]\\d|8[0-2]\\d)\\d{4}|[34]\\d{8}","\\d{5,9}",null,null,"312345678"],[null,null,"2030\\d{5}|7(?:0[0-7]|[15789]\\d|2[03]|30|[46][0-4])\\d{6}","\\d{9}",null,null,"712345678"],[null,null,"800[123]\\d{5}","\\d{9}",null,null,"800123456"],[null,null,"90[123]\\d{6}","\\d{9}",null,null,"901123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"UG",256,"00[057]","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{6})","$1 $2",["[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"],"0$1"],[null,"(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"],"0$1"],[null,"(2024)(\\d{5})","$1 $2",["2024"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],US:[null,[null,null,"[2-9]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|69|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[01678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"2015555555"],[null,null,"(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|69|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[01678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}","\\d{7}(?:\\d{3})?",null,null,"2015555555"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"US",1,"011","1",null,null,"1",null,null,1,[[null,"(\\d{3})(\\d{4})","$1-$2",null,null,null,1],[null,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,1]],[[null,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3"]],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],
UY:[null,[null,null,"[2489]\\d{6,7}","\\d{7,8}"],[null,null,"2\\d{7}|4[2-7]\\d{6}","\\d{7,8}",null,null,"21231234"],[null,null,"9[1-9]\\d{6}","\\d{8}",null,null,"94231234"],[null,null,"80[05]\\d{4}","\\d{7}",null,null,"8001234"],[null,null,"90[0-8]\\d{4}","\\d{7}",null,null,"9001234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"UY",598,"0(?:1[3-9]\\d|0)","0"," int. ",null,"0",null,"00",null,[[null,"(\\d{4})(\\d{4})","$1 $2",["[24]"]],[null,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],[null,"(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],UZ:[null,[null,null,"[679]\\d{8}","\\d{7,9}"],[null,null,"(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}","\\d{7,9}",null,null,"662345678"],[null,null,"6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}","\\d{7,9}",null,null,"912345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"UZ",998,"810","8",null,null,"8",null,"8~10",null,[[null,"([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",null,"8 $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],VA:[null,[null,null,"(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))","\\d{6,11}"],[null,null,"06698\\d{5}","\\d{10}",null,null,"0669812345"],[null,null,"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","\\d{9,11}",null,null,"3123456789"],[null,null,"80(?:0\\d{6}|3\\d{3})","\\d{6,9}",null,null,"800123456"],[null,null,"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","\\d{6,10}",null,null,"899123456"],[null,null,"84(?:[08]\\d{6}|[17]\\d{3})","\\d{6,9}",null,null,"848123456"],[null,null,"1(?:78\\d|99)\\d{6}","\\d{9,10}",null,null,"1781234567"],[null,null,"55\\d{8}","\\d{10}",null,null,"5512345678"],"VA",39,"00",null,null,null,null,null,null,null,null,null,[null,null,"NA","NA"],null,null,[null,null,"848\\d{6}","\\d{9}",null,null,"848123456"],[null,null,"NA","NA"],1,null,[null,null,"NA","NA"]],VC:[null,[null,null,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"7842661234"],[null,null,"784(?:4(?:3[0-4]|5[45]|89|9[0-58])|5(?:2[6-9]|3[0-4]))\\d{4}","\\d{10}",null,null,"7844301234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"VC",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"784",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],VE:[null,[null,null,"[24589]\\d{9}","\\d{7,10}"],[null,null,"(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}","\\d{7,10}",null,null,"2121234567"],[null,null,"4(?:1[24-8]|2[46])\\d{7}","\\d{10}",null,null,"4121234567"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"900\\d{7}","\\d{10}",null,null,"9001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"VE",58,"00","0",null,null,"0",null,null,null,[[null,"(\\d{3})(\\d{7})","$1-$2",null,"0$1","$CC $1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],VG:[null,[null,null,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})","\\d{7}(?:\\d{3})?",null,null,"2842291234"],[null,null,"284(?:(?:3(?:0[0-3]|4[0-367]|94)|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})","\\d{10}",null,null,"2843001234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"VG",1,"011","1",null,null,"1",null,null,null,null,null,[null,null,"NA","NA"],null,"284",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],VI:[null,[null,null,"[3589]\\d{9}","\\d{7}(?:\\d{3})?"],[null,null,"340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"3406421234"],[null,null,"340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}","\\d{7}(?:\\d{3})?",null,null,"3406421234"],[null,null,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"8002345678"],[null,null,"900[2-9]\\d{6}","\\d{10}",null,null,"9002345678"],[null,null,"NA","NA"],[null,null,"5(?:00|33|44|66|77|88)[2-9]\\d{6}","\\d{10}",null,null,"5002345678"],[null,null,"NA","NA"],"VI",1,"011","1",null,null,"1",null,null,1,null,null,[null,null,"NA","NA"],null,"340",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],VN:[null,[null,null,"[17]\\d{6,9}|[2-69]\\d{7,9}|8\\d{6,8}","\\d{7,10}"],[null,null,"(?:2(?:[025-79]|1[0189]|[348][01])|3(?:[0136-9]|[25][01])|4\\d|5(?:[01][01]|[2-9])|6(?:[0-46-8]|5[01])|7(?:[02-79]|[18][01]))\\d{7}|8(?:[1-57]\\d|[689][0-79])\\d{6}","\\d{9,10}",null,null,"2101234567"],[null,null,"(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}|8[689]8\\d{6}","\\d{9,10}",null,null,"912345678"],[null,null,"1800\\d{4,6}","\\d{8,10}",null,null,"1800123456"],[null,null,"1900\\d{4,6}","\\d{8,10}",null,null,"1900123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"VN",84,"00","0",null,null,"0",null,null,null,[[null,"([17]99)(\\d{4})","$1 $2",["[17]99"],"0$1",null,1],[null,"([48])(\\d{4})(\\d{4})","$1 $2 $3",["4|8(?:[1-57]|[689][0-79])"],"0$1",null,1],[null,"([235-7]\\d)(\\d{4})(\\d{3})","$1 $2 $3",["2[025-79]|3[0136-9]|5[2-9]|6[0-46-8]|7[02-79]"],"0$1",null,1],[null,"(80)(\\d{5})","$1 $2",["80"],"0$1",null,1],[null,"(69\\d)(\\d{4,5})","$1 $2",["69"],"0$1",null,1],[null,"([235-7]\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["2[1348]|3[25]|5[01]|65|7[18]"],"0$1",null,1],[null,"([89]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8[689]8|9"],"0$1",null,1],[null,"(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"],"0$1",null,1],[null,"(1[89]00)(\\d{4,6})","$1 $2",["1[89]0"],"$1",null,1]],null,[null,null,"NA","NA"],null,null,[null,null,"[17]99\\d{4}|69\\d{5,6}","\\d{7,8}",null,null,"1992000"],[null,null,"[17]99\\d{4}|69\\d{5,6}|80\\d{5}","\\d{7,8}",null,null,"1992000"],null,null,[null,null,"NA","NA"]],VU:[null,[null,null,"[2-57-9]\\d{4,6}","\\d{5,7}"],[null,null,"(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}","\\d{5}",null,null,"22123"],[null,null,"(?:5(?:7[2-5]|[0-689]\\d)|7[013-7]\\d)\\d{4}","\\d{7}",null,null,"5912345"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"VU",678,"00",null,null,null,null,null,null,null,[[null,"(\\d{3})(\\d{4})","$1 $2",["[579]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"3[03]\\d{3}|900\\d{4}","\\d{5,7}",null,null,"30123"],null,null,[null,null,"NA","NA"]],WF:[null,[null,null,"[4-8]\\d{5}","\\d{6}"],[null,null,"(?:50|68|72)\\d{4}","\\d{6}",null,null,"501234"],[null,null,"(?:50|68|72|8[23])\\d{4}","\\d{6}",null,null,"501234"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"WF",681,"00",null,null,null,null,null,null,null,[[null,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"[48]0\\d{4}","\\d{6}",null,null,"401234"]],WS:[null,[null,null,"[2-8]\\d{4,6}","\\d{5,7}"],[null,null,"(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}","\\d{5,7}",null,null,"22123"],[null,null,"(?:60|7[25-7]\\d)\\d{4}","\\d{6,7}",null,null,"601234"],[null,null,"800\\d{3}","\\d{6}",null,null,"800123"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"WS",685,"0",null,null,null,null,null,null,null,[[null,"(8\\d{2})(\\d{3,4})","$1 $2",["8"]],[null,"(7\\d)(\\d{5})","$1 $2",["7"]],[null,"(\\d{5})","$1",["[2-6]"]]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],YE:[null,[null,null,"[1-7]\\d{6,8}","\\d{6,9}"],[null,null,"(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}","\\d{6,8}",null,null,"1234567"],[null,null,"7[0137]\\d{7}","\\d{9}",null,null,"712345678"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"YE",967,"00","0",null,null,"0",null,null,null,[[null,"([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],[null,"(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],YT:[null,[null,null,"[268]\\d{8}","\\d{9}"],[null,null,"269(?:6[0-4]|50)\\d{4}","\\d{9}",null,null,"269601234"],[null,null,"639\\d{6}","\\d{9}",null,null,"639123456"],[null,null,"80\\d{7}","\\d{9}",null,null,"801234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"YT",262,"00","0",null,null,"0",null,null,null,null,null,[null,null,"NA","NA"],null,"269|63",[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ZA:[null,[null,null,"[1-79]\\d{8}|8(?:[067]\\d{7}|[1-4]\\d{3,7})","\\d{5,9}"],[null,null,"(?:1[0-8]|2[0-378]|3[1-69]|4\\d|5[1346-8])\\d{7}","\\d{9}",null,null,"101234567"],[null,null,"(?:6[0-5]|7[0-46-9])\\d{7}|8[1-4]\\d{3,7}","\\d{5,9}",null,null,"711234567"],[null,null,"80\\d{7}","\\d{9}",null,null,"801234567"],[null,null,"86[2-9]\\d{6}|90\\d{7}","\\d{9}",null,null,"862345678"],[null,null,"860\\d{6}","\\d{9}",null,null,"860123456"],[null,null,"NA","NA"],[null,null,"87\\d{7}","\\d{9}",null,null,"871234567"],"ZA",27,"00","0",null,null,"0",null,null,null,[[null,"(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-47]|6[1-9])"],"0$1"],[null,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[null,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"861\\d{6}","\\d{9}",null,null,"861123456"],null,null,[null,null,"NA","NA"]],ZM:[null,[null,null,"[289]\\d{8}","\\d{9}"],[null,null,"21[1-8]\\d{6}","\\d{9}",null,null,"211234567"],[null,null,"9(?:5[05]|6\\d|7[1-9])\\d{6}","\\d{9}",null,null,"955123456"],[null,null,"800\\d{6}","\\d{9}",null,null,"800123456"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],"ZM",260,"00","0",null,null,"0",null,null,null,[[null,"([29]\\d)(\\d{7})","$1 $2",["[29]"],"0$1"],[null,"(800)(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]],ZW:[null,[null,null,"2(?:[012457-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{8}","\\d{3,10}"],[null,null,"(?:2(?:0(?:4\\d|5\\d{2})|2[278]\\d|48\\d|7(?:[1-7]\\d|[089]\\d{2})|8(?:[2-57-9]|[146]\\d{2})|98)|3(?:08|17|3[78]|7(?:[19]|[56]\\d)|8[37]|98)|5[15][78]|6(?:28\\d{2}|[36]7|75\\d|[69]8|8(?:7\\d|8)))\\d{3}|(?:2(?:1[39]|2[0157]|6[14]|7[35]|84)|329)\\d{7}|(?:1(?:3\\d{2}|9\\d|[4-8])|2(?:0\\d{2}|[569]\\d)|3(?:[26]|[013459]\\d)|5(?:0|5\\d{2}|[689]\\d)|6(?:[39]|[01246]\\d|[78]\\d{2}))\\d{3}|(?:29\\d|39|54)\\d{6}|(?:(?:25|54)83|2582\\d)\\d{3}|(?:4\\d{6,7}|9[2-9]\\d{4,5})","\\d{3,10}",null,null,"1312345"],[null,null,"7[1378]\\d{7}","\\d{9}",null,null,"711234567"],[null,null,"800\\d{7}","\\d{10}",null,null,"8001234567"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"NA","NA"],[null,null,"86(?:1[12]|30|44|55|77|8[367]|99)\\d{6}","\\d{10}",null,null,"8686123456"],"ZW",263,"00","0",null,null,"0",null,null,null,[[null,"([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"],"0$1"],[null,"(7\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["7"],"0$1"],[null,"(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"],"0$1"],[null,"([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:08|17|3[78]|7[1569]|8[37]|98)|5[15][78]|6(?:[29]8|[38]7|6[78]|75|[89]8)"],"0$1"],[null,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|6[14]|7[35]|84)|329"],"0$1"],[null,"([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[0569]|3[0-69]|5[05689]|6[0-46-9]"],"0$1"],[null,"([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"],"0$1"],[null,"([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"],"0$1"],[null,"(8\\d{3})(\\d{6})","$1 $2",["86"],"0$1"],[null,"(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1"]],null,[null,null,"NA","NA"],null,null,[null,null,"NA","NA"],[null,null,"NA","NA"],null,null,[null,null,"NA","NA"]]};G.b=function(){return G.a?G.a:G.a=new G};var nl={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","０":"0","１":"1","２":"2","３":"3","４":"4","５":"5","６":"6","７":"7","８":"8","９":"9","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9"},ul=RegExp("[+＋]+"),dl=RegExp("([0-9０-９٠-٩۰-۹])"),Al=/^\(?\$1\)?$/,Nl=new S;p(Nl,11,"NA");var $l=/\[([^\[\]])*\]/g,tl=/\d(?=[^,}][^,}])/g,el=RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)+$"),rl=/[- ]/;B.prototype.K=function(){this.B="",d(this.h),d(this.u),d(this.m),this.s=0,this.v="",d(this.b),this.l="",d(this.a),this.j=!0,this.w=this.o=this.D=!1,this.f=[],this.A=!1,this.g!=this.J&&(this.g=E(this,this.C))},B.prototype.L=function(l){return this.B=I(this,l)},l("Cleave.AsYouTypeFormatter",B),l("Cleave.AsYouTypeFormatter.prototype.inputDigit",B.prototype.L),l("Cleave.AsYouTypeFormatter.prototype.clear",B.prototype.K)}.call("object"==typeof global&&global?global:window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),

/***/ 2271:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Exposing intl-tel-input as a component
 */
module.exports = __webpack_require__(2272);


/***/ }),

/***/ 2272:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * International Telephone Input v13.0.4
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// wrap in UMD - see https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
(function(factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(187) ], __WEBPACK_AMD_DEFINE_RESULT__ = (function($) {
            factory($, window, document);
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory(require("jquery"), window, document);
    } else {
        factory(jQuery, window, document);
    }
})(function($, window, document, undefined) {
    "use strict";
    // these vars persist through all instances of the plugin
    var pluginName = "intlTelInput", id = 1, // give each instance it's own id for namespaced event handling
    defaults = {
        // whether or not to allow the dropdown
        allowDropdown: true,
        // if there is just a dial code in the input: remove it on blur, and re-add it on focus
        autoHideDialCode: true,
        // add a placeholder in the input with an example number for the selected country
        autoPlaceholder: "polite",
        // modify the auto placeholder
        customPlaceholder: null,
        // append menu to a specific element
        dropdownContainer: "",
        // don't display these countries
        excludeCountries: [],
        // format the input value during initialisation and on setNumber
        formatOnDisplay: true,
        // geoIp lookup function
        geoIpLookup: null,
        // inject a hidden input with this name, and on submit, populate it with the result of getNumber
        hiddenInput: "",
        // initial country
        initialCountry: "",
        // localized country names e.g. { 'de': 'Deutschland' }
        localizedCountries: null,
        // don't insert international dial codes
        nationalMode: true,
        // display only these countries
        onlyCountries: [],
        // number type to use for placeholders
        placeholderNumberType: "MOBILE",
        // the countries at the top of the list. defaults to united states and united kingdom
        preferredCountries: [ "us", "gb" ],
        // display the country dial code next to the selected flag so it's not part of the typed number
        separateDialCode: false,
        // specify the path to the libphonenumber script to enable validation/formatting
        utilsScript: ""
    }, keys = {
        UP: 38,
        DOWN: 40,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32,
        TAB: 9
    }, // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
    regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
    // keep track of if the window.load event has fired as impossible to check after the fact
    $(window).on("load", function() {
        // UPDATE: use a public static field so we can fudge it in the tests
        $.fn[pluginName].windowLoaded = true;
    });
    function Plugin(element, options) {
        this.telInput = $(element);
        this.options = $.extend({}, defaults, options);
        // event namespace
        this.ns = "." + pluginName + id++;
        // Chrome, FF, Safari, IE9+
        this.isGoodBrowser = Boolean(element.setSelectionRange);
        this.hadInitialPlaceholder = Boolean($(element).attr("placeholder"));
    }
    Plugin.prototype = {
        _init: function() {
            // if in nationalMode, disable options relating to dial codes
            if (this.options.nationalMode) {
                this.options.autoHideDialCode = false;
            }
            // if separateDialCode then doesn't make sense to A) insert dial code into input (autoHideDialCode), and B) display national numbers (because we're displaying the country dial code next to them)
            if (this.options.separateDialCode) {
                this.options.autoHideDialCode = this.options.nationalMode = false;
            }
            // we cannot just test screen size as some smartphones/website meta tags will report desktop resolutions
            // Note: for some reason jasmine breaks if you put this in the main Plugin function with the rest of these declarations
            // Note: to target Android Mobiles (and not Tablets), we must find "Android" and "Mobile"
            this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (this.isMobile) {
                // trigger the mobile dropdown css
                $("body").addClass("iti-mobile");
                // on mobile, we want a full screen dropdown, so we must append it to the body
                if (!this.options.dropdownContainer) {
                    this.options.dropdownContainer = "body";
                }
            }
            // we return these deferred objects from the _init() call so they can be watched, and then we resolve them when each specific request returns
            // Note: again, jasmine breaks when I put these in the Plugin function
            this.autoCountryDeferred = new $.Deferred();
            this.utilsScriptDeferred = new $.Deferred();
            // in various situations there could be no country selected initially, but we need to be able to assume this variable exists
            this.selectedCountryData = {};
            // process all the data: onlyCountries, excludeCountries, preferredCountries etc
            this._processCountryData();
            // generate the markup
            this._generateMarkup();
            // set the initial state of the input value and the selected flag
            this._setInitialState();
            // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
            this._initListeners();
            // utils script, and auto country
            this._initRequests();
            // return the deferreds
            return [ this.autoCountryDeferred, this.utilsScriptDeferred ];
        },
        /********************
   *  PRIVATE METHODS
   ********************/
        // prepare all of the country data, including onlyCountries, excludeCountries and preferredCountries options
        _processCountryData: function() {
            // process onlyCountries or excludeCountries array if present
            this._processAllCountries();
            // process the countryCodes map
            this._processCountryCodes();
            // process the preferredCountries
            this._processPreferredCountries();
            // translate countries according to localizedCountries option
            if (this.options.localizedCountries) {
                this._translateCountriesByLocale();
            }
            // sort countries by name
            if (this.options.onlyCountries.length || this.options.localizedCountries) {
                this.countries.sort(this._countryNameSort);
            }
        },
        // add a country code to this.countryCodes
        _addCountryCode: function(iso2, dialCode, priority) {
            if (!(dialCode in this.countryCodes)) {
                this.countryCodes[dialCode] = [];
            }
            var index = priority || 0;
            this.countryCodes[dialCode][index] = iso2;
        },
        // process onlyCountries or excludeCountries array if present
        _processAllCountries: function() {
            if (this.options.onlyCountries.length) {
                var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                    return country.toLowerCase();
                });
                this.countries = allCountries.filter(function(country) {
                    return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
                });
            } else if (this.options.excludeCountries.length) {
                var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                    return country.toLowerCase();
                });
                this.countries = allCountries.filter(function(country) {
                    return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                });
            } else {
                this.countries = allCountries;
            }
        },
        // Translate Countries by object literal provided on config
        _translateCountriesByLocale: function() {
            for (var i = 0; i < this.countries.length; i++) {
                var iso = this.countries[i].iso2.toLowerCase();
                if (iso in this.options.localizedCountries) {
                    this.countries[i].name = this.options.localizedCountries[iso];
                }
            }
        },
        // sort by country name
        _countryNameSort: function(a, b) {
            return a.name.localeCompare(b.name);
        },
        // process the countryCodes map
        _processCountryCodes: function() {
            this.countryCodes = {};
            for (var i = 0; i < this.countries.length; i++) {
                var c = this.countries[i];
                this._addCountryCode(c.iso2, c.dialCode, c.priority);
                // area codes
                if (c.areaCodes) {
                    for (var j = 0; j < c.areaCodes.length; j++) {
                        // full dial code is country code + dial code
                        this._addCountryCode(c.iso2, c.dialCode + c.areaCodes[j]);
                    }
                }
            }
        },
        // process preferred countries - iterate through the preferences, fetching the country data for each one
        _processPreferredCountries: function() {
            this.preferredCountries = [];
            for (var i = 0; i < this.options.preferredCountries.length; i++) {
                var countryCode = this.options.preferredCountries[i].toLowerCase(), countryData = this._getCountryData(countryCode, false, true);
                if (countryData) {
                    this.preferredCountries.push(countryData);
                }
            }
        },
        // generate all of the markup for the plugin: the selected flag overlay, and the dropdown
        _generateMarkup: function() {
            // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can easily put the plugin in an inconsistent state e.g. the wrong flag selected for the autocompleted number, which on submit could mean the wrong number is saved (esp in nationalMode)
            this.telInput.attr("autocomplete", "off");
            // containers (mostly for positioning)
            var parentClass = "intl-tel-input";
            if (this.options.allowDropdown) {
                parentClass += " allow-dropdown";
            }
            if (this.options.separateDialCode) {
                parentClass += " separate-dial-code";
            }
            this.telInput.wrap($("<div>", {
                "class": parentClass
            }));
            this.flagsContainer = $("<div>", {
                "class": "flag-container"
            }).insertBefore(this.telInput);
            // currently selected flag (displayed to left of input)
            var selectedFlag = $("<div>", {
                "class": "selected-flag",
                role: "combobox",
                "aria-owns": "country-listbox"
            });
            selectedFlag.appendTo(this.flagsContainer);
            this.selectedFlagInner = $("<div>", {
                "class": "iti-flag"
            }).appendTo(selectedFlag);
            if (this.options.separateDialCode) {
                this.selectedDialCode = $("<div>", {
                    "class": "selected-dial-code"
                }).appendTo(selectedFlag);
            }
            if (this.options.allowDropdown) {
                // make element focusable and tab naviagable
                selectedFlag.attr("tabindex", "0");
                // CSS triangle
                $("<div>", {
                    "class": "iti-arrow"
                }).appendTo(selectedFlag);
                // country dropdown: preferred countries, then divider, then all countries
                this.countryList = $("<ul>", {
                    "class": "country-list hide",
                    id: "country-listbox",
                    "aria-expanded": "false",
                    role: "listbox"
                });
                if (this.preferredCountries.length) {
                    this._appendListItems(this.preferredCountries, "preferred");
                    $("<li>", {
                        "class": "divider",
                        role: "separator",
                        "aria-disabled": "true"
                    }).appendTo(this.countryList);
                }
                this._appendListItems(this.countries, "");
                // this is useful in lots of places
                this.countryListItems = this.countryList.children(".country");
                // create dropdownContainer markup
                if (this.options.dropdownContainer) {
                    this.dropdown = $("<div>", {
                        "class": "intl-tel-input iti-container"
                    }).append(this.countryList);
                } else {
                    this.countryList.appendTo(this.flagsContainer);
                }
            } else {
                // a little hack so we don't break anything
                this.countryListItems = $();
            }
            if (this.options.hiddenInput) {
                var hiddenInputName = this.options.hiddenInput;
                var name = this.telInput.attr("name");
                if (name) {
                    var i = name.lastIndexOf("[");
                    // if input name contains square brackets, then give the hidden input the same name,
                    // replacing the contents of the last set of brackets with the given hiddenInput name
                    if (i !== -1) hiddenInputName = name.substr(0, i) + "[" + hiddenInputName + "]";
                }
                this.hiddenInput = $("<input>", {
                    type: "hidden",
                    name: hiddenInputName
                }).insertAfter(this.telInput);
            }
        },
        // add a country <li> to the countryList <ul> container
        _appendListItems: function(countries, className) {
            // we create so many DOM elements, it is faster to build a temp string
            // and then add everything to the DOM in one go at the end
            var tmp = "";
            // for each country
            for (var i = 0; i < countries.length; i++) {
                var c = countries[i];
                // open the list item
                tmp += "<li class='country " + className + "' id='iti-item-" + c.iso2 + "' role='option' data-dial-code='" + c.dialCode + "' data-country-code='" + c.iso2 + "'>";
                // add the flag
                tmp += "<div class='flag-box'><div class='iti-flag " + c.iso2 + "'></div></div>";
                // and the country name and dial code
                tmp += "<span class='country-name'>" + c.name + "</span>";
                tmp += "<span class='dial-code'>+" + c.dialCode + "</span>";
                // close the list item
                tmp += "</li>";
            }
            this.countryList.append(tmp);
        },
        // set the initial state of the input value and the selected flag by:
        // 1. extracting a dial code from the given number
        // 2. using explicit initialCountry
        // 3. picking the first preferred country
        // 4. picking the first country
        _setInitialState: function() {
            var val = this.telInput.val();
            var dialCode = this._getDialCode(val);
            var isRegionlessNanp = this._isRegionlessNanp(val);
            // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the flag, else fall back to the default country
            if (dialCode && !isRegionlessNanp) {
                this._updateFlagFromNumber(val);
            } else if (this.options.initialCountry !== "auto") {
                // see if we should select a flag
                if (this.options.initialCountry) {
                    this._setFlag(this.options.initialCountry.toLowerCase());
                } else {
                    if (dialCode && isRegionlessNanp) {
                        // has intl dial code, is regionless nanp, and no initialCountry, so default to US
                        this._setFlag("us");
                    } else {
                        // no dial code and no initialCountry, so default to first in list
                        this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                        if (!val) {
                            this._setFlag(this.defaultCountry);
                        }
                    }
                }
                // if empty and no nationalMode and no autoHideDialCode then insert the default dial code
                if (!val && !this.options.nationalMode && !this.options.autoHideDialCode && !this.options.separateDialCode) {
                    this.telInput.val("+" + this.selectedCountryData.dialCode);
                }
            }
            // NOTE: if initialCountry is set to auto, that will be handled separately
            // format
            if (val) {
                // this wont be run after _updateDialCode as that's only called if no val
                this._updateValFromNumber(val);
            }
        },
        // initialise the main event listeners: input keyup, and click selected flag
        _initListeners: function() {
            this._initKeyListeners();
            if (this.options.autoHideDialCode) {
                this._initFocusListeners();
            }
            if (this.options.allowDropdown) {
                this._initDropdownListeners();
            }
            if (this.hiddenInput) {
                this._initHiddenInputListener();
            }
        },
        // update hidden input on form submit
        _initHiddenInputListener: function() {
            var that = this;
            var form = this.telInput.closest("form");
            if (form.length) {
                form.submit(function() {
                    that.hiddenInput.val(that.getNumber());
                });
            }
        },
        // initialise the dropdown listeners
        _initDropdownListeners: function() {
            var that = this;
            // hack for input nested inside label: clicking the selected-flag to open the dropdown would then automatically trigger a 2nd click on the input which would close it again
            var label = this.telInput.closest("label");
            if (label.length) {
                label.on("click" + this.ns, function(e) {
                    // if the dropdown is closed, then focus the input, else ignore the click
                    if (that.countryList.hasClass("hide")) {
                        that.telInput.focus();
                    } else {
                        e.preventDefault();
                    }
                });
            }
            // toggle country dropdown on click
            var selectedFlag = this.selectedFlagInner.parent();
            selectedFlag.on("click" + this.ns, function(e) {
                // only intercept this event if we're opening the dropdown
                // else let it bubble up to the top ("click-off-to-close" listener)
                // we cannot just stopPropagation as it may be needed to close another instance
                if (that.countryList.hasClass("hide") && !that.telInput.prop("disabled") && !that.telInput.prop("readonly")) {
                    that._showDropdown();
                }
            });
            // open dropdown list if currently focused
            this.flagsContainer.on("keydown" + that.ns, function(e) {
                var isDropdownHidden = that.countryList.hasClass("hide");
                if (isDropdownHidden && (e.which == keys.UP || e.which == keys.DOWN || e.which == keys.SPACE || e.which == keys.ENTER)) {
                    // prevent form from being submitted if "ENTER" was pressed
                    e.preventDefault();
                    // prevent event from being handled again by document
                    e.stopPropagation();
                    that._showDropdown();
                }
                // allow navigation from dropdown to input on TAB
                if (e.which == keys.TAB) {
                    that._closeDropdown();
                }
            });
        },
        // init many requests: utils script / geo ip lookup
        _initRequests: function() {
            var that = this;
            // if the user has specified the path to the utils script, fetch it on window.load, else resolve
            if (this.options.utilsScript && !window.intlTelInputUtils) {
                // if the plugin is being initialised after the window.load event has already been fired
                if ($.fn[pluginName].windowLoaded) {
                    $.fn[pluginName].loadUtils(this.options.utilsScript);
                } else {
                    // wait until the load event so we don't block any other requests e.g. the flags image
                    $(window).on("load", function() {
                        $.fn[pluginName].loadUtils(that.options.utilsScript);
                    });
                }
            } else {
                this.utilsScriptDeferred.resolve();
            }
            if (this.options.initialCountry === "auto") {
                this._loadAutoCountry();
            } else {
                this.autoCountryDeferred.resolve();
            }
        },
        // perform the geo ip lookup
        _loadAutoCountry: function() {
            var that = this;
            // 3 options:
            // 1) already loaded (we're done)
            // 2) not already started loading (start)
            // 3) already started loading (do nothing - just wait for loading callback to fire)
            if ($.fn[pluginName].autoCountry) {
                this.handleAutoCountry();
            } else if (!$.fn[pluginName].startedLoadingAutoCountry) {
                // don't do this twice!
                $.fn[pluginName].startedLoadingAutoCountry = true;
                if (typeof this.options.geoIpLookup === "function") {
                    this.options.geoIpLookup(function(countryCode) {
                        $.fn[pluginName].autoCountry = countryCode.toLowerCase();
                        // tell all instances the auto country is ready
                        // TODO: this should just be the current instances
                        // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight away (e.g. if they have already done the geo ip lookup somewhere else). Using setTimeout means that the current thread of execution will finish before executing this, which allows the plugin to finish initialising.
                        setTimeout(function() {
                            $(".intl-tel-input input").intlTelInput("handleAutoCountry");
                        });
                    });
                }
            }
        },
        // initialize any key listeners
        _initKeyListeners: function() {
            var that = this;
            // update flag on keyup
            // (keep this listener separate otherwise the setTimeout breaks all the tests)
            this.telInput.on("keyup" + this.ns, function() {
                if (that._updateFlagFromNumber(that.telInput.val())) {
                    that._triggerCountryChange();
                }
            });
            // update flag on cut/paste events (now supported in all major browsers)
            this.telInput.on("cut" + this.ns + " paste" + this.ns, function() {
                // hack because "paste" event is fired before input is updated
                setTimeout(function() {
                    if (that._updateFlagFromNumber(that.telInput.val())) {
                        that._triggerCountryChange();
                    }
                });
            });
        },
        // adhere to the input's maxlength attr
        _cap: function(number) {
            var max = this.telInput.attr("maxlength");
            return max && number.length > max ? number.substr(0, max) : number;
        },
        // listen for mousedown, focus and blur
        _initFocusListeners: function() {
            var that = this;
            // mousedown decides where the cursor goes, so if we're focusing we must preventDefault as we'll be inserting the dial code, and we want the cursor to be at the end no matter where they click
            this.telInput.on("mousedown" + this.ns, function(e) {
                if (!that.telInput.is(":focus") && !that.telInput.val()) {
                    e.preventDefault();
                    // but this also cancels the focus, so we must trigger that manually
                    that.telInput.focus();
                }
            });
            // on focus: if empty, insert the dial code for the currently selected flag
            this.telInput.on("focus" + this.ns, function(e) {
                if (!that.telInput.val() && !that.telInput.prop("readonly") && that.selectedCountryData.dialCode) {
                    // insert the dial code
                    that.telInput.val("+" + that.selectedCountryData.dialCode);
                    // after auto-inserting a dial code, if the first key they hit is '+' then assume they are entering a new number, so remove the dial code. use keypress instead of keydown because keydown gets triggered for the shift key (required to hit the + key), and instead of keyup because that shows the new '+' before removing the old one
                    that.telInput.one("keypress.plus" + that.ns, function(e) {
                        if (e.which == keys.PLUS) {
                            that.telInput.val("");
                        }
                    });
                    // after tabbing in, make sure the cursor is at the end we must use setTimeout to get outside of the focus handler as it seems the selection happens after that
                    setTimeout(function() {
                        var input = that.telInput[0];
                        if (that.isGoodBrowser) {
                            var len = that.telInput.val().length;
                            input.setSelectionRange(len, len);
                        }
                    });
                }
            });
            // on blur or form submit: if just a dial code then remove it
            var form = this.telInput.prop("form");
            if (form) {
                $(form).on("submit" + this.ns, function() {
                    that._removeEmptyDialCode();
                });
            }
            this.telInput.on("blur" + this.ns, function() {
                that._removeEmptyDialCode();
            });
        },
        _removeEmptyDialCode: function() {
            var value = this.telInput.val(), startsPlus = value.charAt(0) == "+";
            if (startsPlus) {
                var numeric = this._getNumeric(value);
                // if just a plus, or if just a dial code
                if (!numeric || this.selectedCountryData.dialCode == numeric) {
                    this.telInput.val("");
                }
            }
            // remove the keypress listener we added on focus
            this.telInput.off("keypress.plus" + this.ns);
        },
        // extract the numeric digits from the given string
        _getNumeric: function(s) {
            return s.replace(/\D/g, "");
        },
        // show the dropdown
        _showDropdown: function() {
            this._setDropdownPosition();
            // update highlighting and scroll to active list item
            var activeListItem = this.countryList.children(".active");
            if (activeListItem.length) {
                this._highlightListItem(activeListItem);
                this._scrollTo(activeListItem);
            }
            // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
            this._bindDropdownListeners();
            // update the arrow
            this.selectedFlagInner.children(".iti-arrow").addClass("up");
            this.telInput.trigger("open:countrydropdown");
        },
        // decide where to position dropdown (depends on position within viewport, and scroll)
        _setDropdownPosition: function() {
            var that = this;
            if (this.options.dropdownContainer) {
                this.dropdown.appendTo(this.options.dropdownContainer);
            }
            // show the menu and grab the dropdown height
            this.dropdownHeight = this.countryList.removeClass("hide").attr("aria-expanded", "true").outerHeight();
            if (!this.isMobile) {
                var pos = this.telInput.offset(), inputTop = pos.top, windowTop = $(window).scrollTop(), // dropdownFitsBelow = (dropdownBottom < windowBottom)
                dropdownFitsBelow = inputTop + this.telInput.outerHeight() + this.dropdownHeight < windowTop + $(window).height(), dropdownFitsAbove = inputTop - this.dropdownHeight > windowTop;
                // by default, the dropdown will be below the input. If we want to position it above the input, we add the dropup class.
                this.countryList.toggleClass("dropup", !dropdownFitsBelow && dropdownFitsAbove);
                // if dropdownContainer is enabled, calculate postion
                if (this.options.dropdownContainer) {
                    // by default the dropdown will be directly over the input because it's not in the flow. If we want to position it below, we need to add some extra top value.
                    var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.innerHeight();
                    // calculate placement
                    this.dropdown.css({
                        top: inputTop + extraTop,
                        left: pos.left
                    });
                    // close menu on window scroll
                    $(window).on("scroll" + this.ns, function() {
                        that._closeDropdown();
                    });
                }
            }
        },
        // we only bind dropdown listeners when the dropdown is open
        _bindDropdownListeners: function() {
            var that = this;
            // when mouse over a list item, just highlight that one
            // we add the class "highlight", so if they hit "enter" we know which one to select
            this.countryList.on("mouseover" + this.ns, ".country", function(e) {
                that._highlightListItem($(this));
            });
            // listen for country selection
            this.countryList.on("click" + this.ns, ".country", function(e) {
                that._selectListItem($(this));
            });
            // click off to close
            // (except when this initial opening click is bubbling up)
            // we cannot just stopPropagation as it may be needed to close another instance
            var isOpening = true;
            $("html").on("click" + this.ns, function(e) {
                if (!isOpening) {
                    that._closeDropdown();
                }
                isOpening = false;
            });
            // listen for up/down scrolling, enter to select, or letters to jump to country name.
            // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
            // just hit down and hold it to scroll down (no keyup event).
            // listen on the document because that's where key events are triggered if no input has focus
            var query = "", queryTimer = null;
            $(document).on("keydown" + this.ns, function(e) {
                // prevent down key from scrolling the whole page,
                // and enter key from submitting a form etc
                e.preventDefault();
                if (e.which == keys.UP || e.which == keys.DOWN) {
                    // up and down to navigate
                    that._handleUpDownKey(e.which);
                } else if (e.which == keys.ENTER) {
                    // enter to select
                    that._handleEnterKey();
                } else if (e.which == keys.ESC) {
                    // esc to close
                    that._closeDropdown();
                } else if (e.which >= keys.A && e.which <= keys.Z || e.which == keys.SPACE) {
                    // upper case letters (note: keyup/keydown only return upper case letters)
                    // jump to countries that start with the query string
                    if (queryTimer) {
                        clearTimeout(queryTimer);
                    }
                    query += String.fromCharCode(e.which);
                    that._searchForCountry(query);
                    // if the timer hits 1 second, reset the query
                    queryTimer = setTimeout(function() {
                        query = "";
                    }, 1e3);
                }
            });
        },
        // highlight the next/prev item in the list (and ensure it is visible)
        _handleUpDownKey: function(key) {
            var current = this.countryList.children(".highlight").first();
            var next = key == keys.UP ? current.prev() : current.next();
            if (next.length) {
                // skip the divider
                if (next.hasClass("divider")) {
                    next = key == keys.UP ? next.prev() : next.next();
                }
                this._highlightListItem(next);
                this._scrollTo(next);
            }
        },
        // select the currently highlighted item
        _handleEnterKey: function() {
            var currentCountry = this.countryList.children(".highlight").first();
            if (currentCountry.length) {
                this._selectListItem(currentCountry);
            }
        },
        // find the first list item whose name starts with the query string
        _searchForCountry: function(query) {
            for (var i = 0; i < this.countries.length; i++) {
                if (this._startsWith(this.countries[i].name, query)) {
                    var listItem = this.countryList.children("[data-country-code=" + this.countries[i].iso2 + "]").not(".preferred");
                    // update highlighting and scroll
                    this._highlightListItem(listItem);
                    this._scrollTo(listItem, true);
                    break;
                }
            }
        },
        // check if (uppercase) string a starts with string b
        _startsWith: function(a, b) {
            return a.substr(0, b.length).toUpperCase() == b;
        },
        // update the input's value to the given val (format first if possible)
        // NOTE: this is called from _setInitialState, handleUtils and setNumber
        _updateValFromNumber: function(number) {
            if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                var format = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) != "+") ? intlTelInputUtils.numberFormat.NATIONAL : intlTelInputUtils.numberFormat.INTERNATIONAL;
                number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
            }
            number = this._beforeSetNumber(number);
            this.telInput.val(number);
        },
        // check if need to select a new flag based on the given number
        // Note: called from _setInitialState, keyup handler, setNumber
        _updateFlagFromNumber: function(number) {
            // if we're in nationalMode and we already have US/Canada selected, make sure the number starts with a +1 so _getDialCode will be able to extract the area code
            // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag from the number), that means we're initialising the plugin with a number that already has a dial code, so fine to ignore this bit
            if (number && this.options.nationalMode && this.selectedCountryData.dialCode == "1" && number.charAt(0) != "+") {
                if (number.charAt(0) != "1") {
                    number = "1" + number;
                }
                number = "+" + number;
            }
            // try and extract valid dial code from input
            var dialCode = this._getDialCode(number), countryCode = null, numeric = this._getNumeric(number);
            if (dialCode) {
                // check if one of the matching countries is already selected
                var countryCodes = this.countryCodes[this._getNumeric(dialCode)], alreadySelected = $.inArray(this.selectedCountryData.iso2, countryCodes) > -1, // check if the given number contains a NANP area code i.e. the only dialCode that could be extracted was +1 (instead of say +1204) and the actual number's length is >=4
                isNanpAreaCode = dialCode == "+1" && numeric.length >= 4, nanpSelected = this.selectedCountryData.dialCode == "1";
                // only update the flag if:
                // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
                // AND
                // B) either a matching country is not already selected OR the number contains a NANP area code (ensure the flag is set to the first matching country)
                if (!(nanpSelected && this._isRegionlessNanp(numeric)) && (!alreadySelected || isNanpAreaCode)) {
                    // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first non-empty index
                    for (var j = 0; j < countryCodes.length; j++) {
                        if (countryCodes[j]) {
                            countryCode = countryCodes[j];
                            break;
                        }
                    }
                }
            } else if (number.charAt(0) == "+" && numeric.length) {
                // invalid dial code, so empty
                // Note: use getNumeric here because the number has not been formatted yet, so could contain bad chars
                countryCode = "";
            } else if (!number || number == "+") {
                // empty, or just a plus, so default
                countryCode = this.defaultCountry;
            }
            if (countryCode !== null) {
                return this._setFlag(countryCode);
            }
            return false;
        },
        // check if the given number is a regionless NANP number (expects the number to contain an international dial code)
        _isRegionlessNanp: function(number) {
            var numeric = this._getNumeric(number);
            if (numeric.charAt(0) == "1") {
                var areaCode = numeric.substr(1, 3);
                return $.inArray(areaCode, regionlessNanpNumbers) > -1;
            }
            return false;
        },
        // remove highlighting from other list items and highlight the given item
        _highlightListItem: function(listItem) {
            this.countryListItems.removeClass("highlight");
            listItem.addClass("highlight");
        },
        // find the country data for the given country code
        // the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
        _getCountryData: function(countryCode, ignoreOnlyCountriesOption, allowFail) {
            var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
            for (var i = 0; i < countryList.length; i++) {
                if (countryList[i].iso2 == countryCode) {
                    return countryList[i];
                }
            }
            if (allowFail) {
                return null;
            } else {
                throw new Error("No country data for '" + countryCode + "'");
            }
        },
        // select the given flag, update the placeholder and the active list item
        // Note: called from _setInitialState, _updateFlagFromNumber, _selectListItem, setCountry
        _setFlag: function(countryCode) {
            var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
            // do this first as it will throw an error and stop if countryCode is invalid
            this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
            // update the defaultCountry - we only need the iso2 from now on, so just store that
            if (this.selectedCountryData.iso2) {
                this.defaultCountry = this.selectedCountryData.iso2;
            }
            this.selectedFlagInner.attr("class", "iti-flag " + countryCode);
            // update the selected country's title attribute
            var title = countryCode ? this.selectedCountryData.name + ": +" + this.selectedCountryData.dialCode : "Unknown";
            this.selectedFlagInner.parent().attr("title", title);
            if (this.options.separateDialCode) {
                var dialCode = this.selectedCountryData.dialCode ? "+" + this.selectedCountryData.dialCode : "", parent = this.telInput.parent();
                if (prevCountry.dialCode) {
                    parent.removeClass("iti-sdc-" + (prevCountry.dialCode.length + 1));
                }
                if (dialCode) {
                    parent.addClass("iti-sdc-" + dialCode.length);
                }
                this.selectedDialCode.text(dialCode);
            }
            // and the input's placeholder
            this._updatePlaceholder();
            // update the active list item
            if (this.options.allowDropdown) {
                this.countryListItems.removeClass("active").attr("aria-selected", "false");
                if (countryCode) {
                    var listItem = this.countryListItems.find(".iti-flag." + countryCode).first().closest(".country");
                    listItem.addClass("active").attr("aria-selected", "true");
                    this.countryList.attr("aria-activedescendant", listItem.attr("id"));
                }
            }
            // return if the flag has changed or not
            return prevCountry.iso2 !== countryCode;
        },
        // update the input placeholder to an example number from the currently selected country
        _updatePlaceholder: function() {
            var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && (this.options.autoPlaceholder === true || this.options.autoPlaceholder === "polite");
            if (window.intlTelInputUtils && shouldSetPlaceholder) {
                var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType], placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
                placeholder = this._beforeSetNumber(placeholder);
                if (typeof this.options.customPlaceholder === "function") {
                    placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                }
                this.telInput.attr("placeholder", placeholder);
            }
        },
        // called when the user selects a list item from the dropdown
        _selectListItem: function(listItem) {
            // update selected flag and active list item
            var flagChanged = this._setFlag(listItem.attr("data-country-code"));
            this._closeDropdown();
            this._updateDialCode(listItem.attr("data-dial-code"), true);
            // focus the input
            this.telInput.focus();
            // put cursor at end - this fix is required for FF and IE11 (with nationalMode=false i.e. auto inserting dial code), who try to put the cursor at the beginning the first time
            if (this.isGoodBrowser) {
                var len = this.telInput.val().length;
                this.telInput[0].setSelectionRange(len, len);
            }
            if (flagChanged) {
                this._triggerCountryChange();
            }
        },
        // close the dropdown and unbind any listeners
        _closeDropdown: function() {
            this.countryList.addClass("hide");
            this.countryList.attr("aria-expanded", "false");
            // update the arrow
            this.selectedFlagInner.children(".iti-arrow").removeClass("up");
            // unbind key events
            $(document).off(this.ns);
            // unbind click-off-to-close
            $("html").off(this.ns);
            // unbind hover and click listeners
            this.countryList.off(this.ns);
            // remove menu from container
            if (this.options.dropdownContainer) {
                if (!this.isMobile) {
                    $(window).off("scroll" + this.ns);
                }
                this.dropdown.detach();
            }
            this.telInput.trigger("close:countrydropdown");
        },
        // check if an element is visible within it's container, else scroll until it is
        _scrollTo: function(element, middle) {
            var container = this.countryList, containerHeight = container.height(), containerTop = container.offset().top, containerBottom = containerTop + containerHeight, elementHeight = element.outerHeight(), elementTop = element.offset().top, elementBottom = elementTop + elementHeight, newScrollTop = elementTop - containerTop + container.scrollTop(), middleOffset = containerHeight / 2 - elementHeight / 2;
            if (elementTop < containerTop) {
                // scroll up
                if (middle) {
                    newScrollTop -= middleOffset;
                }
                container.scrollTop(newScrollTop);
            } else if (elementBottom > containerBottom) {
                // scroll down
                if (middle) {
                    newScrollTop += middleOffset;
                }
                var heightDifference = containerHeight - elementHeight;
                container.scrollTop(newScrollTop - heightDifference);
            }
        },
        // replace any existing dial code with the new one
        // Note: called from _selectListItem and setCountry
        _updateDialCode: function(newDialCode, hasSelectedListItem) {
            var inputVal = this.telInput.val(), newNumber;
            // save having to pass this every time
            newDialCode = "+" + newDialCode;
            if (inputVal.charAt(0) == "+") {
                // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
                var prevDialCode = this._getDialCode(inputVal);
                if (prevDialCode) {
                    // current number contains a valid dial code, so replace it
                    newNumber = inputVal.replace(prevDialCode, newDialCode);
                } else {
                    // current number contains an invalid dial code, so ditch it
                    // (no way to determine where the invalid dial code ends and the rest of the number begins)
                    newNumber = newDialCode;
                }
            } else if (this.options.nationalMode || this.options.separateDialCode) {
                // don't do anything
                return;
            } else {
                // nationalMode is disabled
                if (inputVal) {
                    // there is an existing value with no dial code: prefix the new dial code
                    newNumber = newDialCode + inputVal;
                } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                    // no existing value and either they've just selected a list item, or autoHideDialCode is disabled: insert new dial code
                    newNumber = newDialCode;
                } else {
                    return;
                }
            }
            this.telInput.val(newNumber);
        },
        // try and extract a valid international dial code from a full telephone number
        // Note: returns the raw string inc plus character and any whitespace/dots etc
        _getDialCode: function(number) {
            var dialCode = "";
            // only interested in international numbers (starting with a plus)
            if (number.charAt(0) == "+") {
                var numericChars = "";
                // iterate over chars
                for (var i = 0; i < number.length; i++) {
                    var c = number.charAt(i);
                    // if char is number
                    if ($.isNumeric(c)) {
                        numericChars += c;
                        // if current numericChars make a valid dial code
                        if (this.countryCodes[numericChars]) {
                            // store the actual raw string (useful for matching later)
                            dialCode = number.substr(0, i + 1);
                        }
                        // longest dial code is 4 chars
                        if (numericChars.length == 4) {
                            break;
                        }
                    }
                }
            }
            return dialCode;
        },
        // get the input val, adding the dial code if separateDialCode is enabled
        _getFullNumber: function() {
            var val = $.trim(this.telInput.val()), dialCode = this.selectedCountryData.dialCode, prefix, numericVal = this._getNumeric(val), // normalized means ensure starts with a 1, so we can match against the full dial code
            normalizedVal = numericVal.charAt(0) == "1" ? numericVal : "1" + numericVal;
            if (this.options.separateDialCode) {
                // when using separateDialCode, it is visible so is effectively part of the typed number
                prefix = "+" + dialCode;
            } else if (val && val.charAt(0) != "+" && val.charAt(0) != "1" && dialCode && dialCode.charAt(0) == "1" && dialCode.length == 4 && dialCode != normalizedVal.substr(0, 4)) {
                // ensure national NANP numbers contain the area code
                prefix = dialCode.substr(1);
            } else {
                prefix = "";
            }
            return prefix + val;
        },
        // remove the dial code if separateDialCode is enabled
        _beforeSetNumber: function(number) {
            if (this.options.separateDialCode) {
                var dialCode = this._getDialCode(number);
                if (dialCode) {
                    // US dialCode is "+1", which is what we want
                    // CA dialCode is "+1 123", which is wrong - should be "+1" (as it has multiple area codes)
                    // AS dialCode is "+1 684", which is what we want
                    // Solution: if the country has area codes, then revert to just the dial code
                    if (this.selectedCountryData.areaCodes !== null) {
                        dialCode = "+" + this.selectedCountryData.dialCode;
                    }
                    // a lot of numbers will have a space separating the dial code and the main number, and some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get rid of it
                    // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
                    var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                    number = number.substr(start);
                }
            }
            return this._cap(number);
        },
        // trigger the 'countrychange' event
        _triggerCountryChange: function() {
            this.telInput.trigger("countrychange", this.selectedCountryData);
        },
        /**************************
   *  SECRET PUBLIC METHODS
   **************************/
        // this is called when the geoip call returns
        handleAutoCountry: function() {
            if (this.options.initialCountry === "auto") {
                // we must set this even if there is an initial val in the input: in case the initial val is invalid and they delete it - they should see their auto country
                this.defaultCountry = $.fn[pluginName].autoCountry;
                // if there's no initial value in the input, then update the flag
                if (!this.telInput.val()) {
                    this.setCountry(this.defaultCountry);
                }
                this.autoCountryDeferred.resolve();
            }
        },
        // this is called when the utils request completes
        handleUtils: function() {
            // if the request was successful
            if (window.intlTelInputUtils) {
                // if there's an initial value in the input, then format it
                if (this.telInput.val()) {
                    this._updateValFromNumber(this.telInput.val());
                }
                this._updatePlaceholder();
            }
            this.utilsScriptDeferred.resolve();
        },
        /********************
   *  PUBLIC METHODS
   ********************/
        // remove plugin
        destroy: function() {
            if (this.options.allowDropdown) {
                // make sure the dropdown is closed (and unbind listeners)
                this._closeDropdown();
                // click event to open dropdown
                this.selectedFlagInner.parent().off(this.ns);
                // label click hack
                this.telInput.closest("label").off(this.ns);
            }
            // unbind submit event handler on form
            if (this.options.autoHideDialCode) {
                var form = this.telInput.prop("form");
                if (form) {
                    $(form).off(this.ns);
                }
            }
            // unbind all events: key events, and focus/blur events if autoHideDialCode=true
            this.telInput.off(this.ns);
            // remove markup (but leave the original input)
            var container = this.telInput.parent();
            container.before(this.telInput).remove();
        },
        // get the extension from the current number
        getExtension: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return "";
        },
        // format the number to the given format
        getNumber: function(format) {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.formatNumber(this._getFullNumber(), this.selectedCountryData.iso2, format);
            }
            return "";
        },
        // get the type of the entered number e.g. landline/mobile
        getNumberType: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return -99;
        },
        // get the country data for the currently selected flag
        getSelectedCountryData: function() {
            return this.selectedCountryData;
        },
        // get the validation error
        getValidationError: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getValidationError(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return -99;
        },
        // validate the input val - assumes the global function isValidNumber (from utilsScript)
        isValidNumber: function() {
            var val = $.trim(this._getFullNumber()), countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
            return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
        },
        // update the selected flag, and update the input val accordingly
        setCountry: function(countryCode) {
            countryCode = countryCode.toLowerCase();
            // check if already selected
            if (!this.selectedFlagInner.hasClass(countryCode)) {
                this._setFlag(countryCode);
                this._updateDialCode(this.selectedCountryData.dialCode, false);
                this._triggerCountryChange();
            }
        },
        // set the input value and update the flag
        setNumber: function(number) {
            // we must update the flag first, which updates this.selectedCountryData, which is used for formatting the number before displaying it
            var flagChanged = this._updateFlagFromNumber(number);
            this._updateValFromNumber(number);
            if (flagChanged) {
                this._triggerCountryChange();
            }
        },
        // set the placeholder number typ
        setPlaceholderNumberType: function(type) {
            this.options.placeholderNumberType = type;
            this._updatePlaceholder();
        }
    };
    // using https://github.com/jquery-boilerplate/jquery-boilerplate/wiki/Extending-jQuery-Boilerplate
    // (adapted to allow public functions)
    $.fn[pluginName] = function(options) {
        var args = arguments;
        // Is the first parameter an object (options), or was omitted,
        // instantiate a new instance of the plugin.
        if (options === undefined || typeof options === "object") {
            // collect all of the deferred objects for all instances created with this selector
            var deferreds = [];
            this.each(function() {
                if (!$.data(this, "plugin_" + pluginName)) {
                    var instance = new Plugin(this, options);
                    var instanceDeferreds = instance._init();
                    // we now have 2 deffereds: 1 for auto country, 1 for utils script
                    deferreds.push(instanceDeferreds[0]);
                    deferreds.push(instanceDeferreds[1]);
                    $.data(this, "plugin_" + pluginName, instance);
                }
            });
            // return the promise from the "master" deferred object that tracks all the others
            return $.when.apply(null, deferreds);
        } else if (typeof options === "string" && options[0] !== "_") {
            // If the first parameter is a string and it doesn't start
            // with an underscore or "contains" the `init`-function,
            // treat this as a call to a public method.
            // Cache the method call to make it possible to return a value
            var returns;
            this.each(function() {
                var instance = $.data(this, "plugin_" + pluginName);
                // Tests that there's already a plugin-instance
                // and checks that the requested public method exists
                if (instance instanceof Plugin && typeof instance[options] === "function") {
                    // Call the method of our plugin instance,
                    // and pass it the supplied arguments.
                    returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }
                // Allow instances to be destroyed via the 'destroy' method
                if (options === "destroy") {
                    $.data(this, "plugin_" + pluginName, null);
                }
            });
            // If the earlier cached method gives a value back return the value,
            // otherwise return this to preserve chainability.
            return returns !== undefined ? returns : this;
        }
    };
    /********************
 *  STATIC METHODS
 ********************/
    // get the country data object
    $.fn[pluginName].getCountryData = function() {
        return allCountries;
    };
    // load the utils script
    // (assumes it has not already loaded - we check this before calling this internally)
    // (also assumes that if it is called manually, it will only be once per page)
    $.fn[pluginName].loadUtils = function(path) {
        // 2 options:
        // 1) not already started loading (start)
        // 2) already started loading (do nothing - just wait for loading callback to fire, which will trigger handleUtils on all instances, resolving each of their utilsScriptDeferred objects)
        if (!$.fn[pluginName].startedLoadingUtilsScript) {
            // don't do this twice!
            $.fn[pluginName].startedLoadingUtilsScript = true;
            // dont use $.getScript as it prevents caching
            // return the ajax Deferred object, so manual calls can be chained with .then(callback)
            return $.ajax({
                type: "GET",
                url: path,
                complete: function() {
                    // tell all instances that the utils request is complete
                    $(".intl-tel-input input").intlTelInput("handleUtils");
                },
                dataType: "script",
                cache: true
            });
        }
        return null;
    };
    // default options
    $.fn[pluginName].defaults = defaults;
    // version
    $.fn[pluginName].version = "13.0.4";
    // Array of country objects for the flag dropdown.
    // Here is the criteria for the plugin to support a given country/territory
    // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
    // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
    // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
    // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
    // Each country array has the following information:
    // [
    //    Country name,
    //    iso2 code,
    //    International dial code,
    //    Order (if >1 country with same dial code),
    //    Area codes
    // ]
    var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1684" ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1264" ], [ "Antigua and Barbuda", "ag", "1268" ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1242" ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1246" ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1441" ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1284" ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1 ], [ "Cayman Islands", "ky", "1345" ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2 ], [ "Cocos (Keeling) Islands", "cc", "61", 1 ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1767" ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1473" ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1671" ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1 ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2 ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3 ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1 ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1 ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1664" ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1670" ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1869" ], [ "Saint Lucia", "lc", "1758" ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1784" ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1721" ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1 ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1868" ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1649" ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1340" ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1 ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1 ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1 ] ];
    // loop over all of the countries above
    for (var i = 0; i < allCountries.length; i++) {
        var c = allCountries[i];
        allCountries[i] = {
            name: c[0],
            iso2: c[1],
            dialCode: c[2],
            priority: c[3] || 0,
            areaCodes: c[4] || null
        };
    }
});

/***/ }),

/***/ 2273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2274:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de-de/countries.json": [
		835,
		7
	],
	"./es-es/countries.json": [
		836,
		6
	],
	"./fr-ca/countries.json": [
		837,
		5
	],
	"./fr-fr/countries.json": [
		838,
		4
	],
	"./it-it/countries.json": [
		839,
		3
	],
	"./nb-no/countries.json": [
		840,
		2
	],
	"./nl-nl/countries.json": [
		841,
		1
	],
	"./sv-se/countries.json": [
		842,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2274;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 2275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);

Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(function () {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('body').hasClass('js-account-notifications')) {
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('change', '.js-notify-opt-out', function () {
    var $el = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-granular-notify-controls');

    if (Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).is(':checked')) {
      $el.fadeOut();
    } else {
      $el.fadeIn();
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('change', '.js-quiet-hours', function () {
    var $el = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-quiet-hours-row');

    if (Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).is(':checked')) {
      $el.fadeIn();
    } else {
      $el.fadeOut();
    }
  });
});

/***/ }),

/***/ 2276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(17);


__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].models.WeekendAvailability = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  defaults: {
    week_monday: null,
    start_date: null,
    end_date: null,
    is_available: null,
    has_answered: null,
    strings: null
  },
  isNew: function isNew() {
    // Force a put request to the endpoint
    return false;
  },
  url: function url() {
    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].urls.weekendAvailability;
  },
  setAvailable: function setAvailable(success, error) {
    return this.save({
      is_available: true
    }, {
      success: success,
      error: error
    });
  },
  setUnavailable: function setUnavailable(success, error) {
    return this.save({
      is_available: false
    }, {
      success: success,
      error: error
    });
  }
});

/***/ }),

/***/ 2277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_Alerts__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_globals_moment__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(104);





 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'


Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(function () {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('body').hasClass('js-weekend-availability')) {
    return;
  }

  var WeekendAvailView = __WEBPACK_IMPORTED_MODULE_3__rover_globals_backbone__["a" /* default */].View.extend({
    initialize: function initialize() {
      var startDate = Object(__WEBPACK_IMPORTED_MODULE_4__rover_globals_moment__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.weekendAvail.get('start_date'), __WEBPACK_IMPORTED_MODULE_6__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO).format(__WEBPACK_IMPORTED_MODULE_6__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].MONTH_DAY_WEEK_MED);
      var lastDate = Object(__WEBPACK_IMPORTED_MODULE_4__rover_globals_moment__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.weekendAvail.get('last_day'), __WEBPACK_IMPORTED_MODULE_6__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_ISO).format(__WEBPACK_IMPORTED_MODULE_6__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].MONTH_DAY_WEEK_MED);
      this.$('.js-start-date').empty().append("<strong>".concat(startDate, "</strong>"));
      this.$('.js-last-date').empty().append("<strong>".concat(lastDate, "</strong>"));
      __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.weekendAvail.save({
        is_available: __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isAvailableIntent
      }, {
        success: __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bind(this.success, this),
        error: __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bind(this.error, this)
      });
    },
    success: function success() {
      this.$('.js-loading-content').remove();
      this.$('.js-loaded-content').removeClass('hidden');
    },
    error: function error() {
      __WEBPACK_IMPORTED_MODULE_0__rover_utilities_Alerts__["a" /* default */].showAlert('updating your availability');
    }
  });
  var weekendAvailView = new WeekendAvailView({
    el: '.js-weekend-availability'
  });
});

/***/ }),

/***/ 2278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_reportError__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_utilities_scrollToElement__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rover_utilities_userAgent__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rover_utilities_translation__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_rover_modal__ = __webpack_require__(322);









__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].views.QuizView = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].View.extend({
  initialize: function initialize() {
    __WEBPACK_IMPORTED_MODULE_2__rover_globals_underscore__["default"].bindAll(this, 'advanceQuestion', 'displayError', 'onQuestionSuccess', 'onQuestionError');

    var questions = this.getQuestions();
    var currentQuestion = this.getCurrentQuestion();

    if (Object(__WEBPACK_IMPORTED_MODULE_6__rover_utilities_userAgent__["f" /* isMobileBrowser */])()) {
      this.fixMobileTapDelay(currentQuestion);
    }

    var index = questions.index(currentQuestion);

    if (index === 0) {
      this.showIntroModal();
    } else if (index === -1) {
      // Quiz is done, show success view
      this.showQuizDone();
    }

    var self = this;
    Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-question-form').ajaxForm({
      beforeSubmit: function beforeSubmit() {
        Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-form-error').hide();
      },
      success: function success() {
        return self.onQuestionSuccess(this);
      },
      error: function error(response) {
        return self.onQuestionError(this, response);
      }
    });
  },
  fixMobileTapDelay: function fixMobileTapDelay(currentQuestion) {
    // An ugly hack to prevent quick taps from failing to select
    // the quiz answer on embedded web
    currentQuestion.find('label').on('touchend', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var input = Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])(e.currentTarget).find('input');
      input.click();
    });
  },
  onQuestionSuccess: function onQuestionSuccess(ajaxForm) {
    this.advanceQuestion();
  },
  onQuestionError: function onQuestionError(ajaxForm, response) {
    // If the user submitting the quiz answer is logged out redirect them to
    // the login page.
    if (response.status === 403) {
      window.location.assign(__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].urls.signin);
    } else {
      var _response$responseJSO;

      var errorMessage = // eslint-disable-next-line camelcase
      (response === null || response === void 0 ? void 0 : (_response$responseJSO = response.responseJSON) === null || _response$responseJSO === void 0 ? void 0 : _response$responseJSO.error_description) || __WEBPACK_IMPORTED_MODULE_7__rover_utilities_translation__["default"]._('Something went wrong with your request. Please try again later.');

      this.displayError(errorMessage);
    }
  },
  getQuestions: function getQuestions() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-quiz-question');
  },
  getCurrentQuestion: function getCurrentQuestion() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])(this.getQuestions().filter(':visible'));
  },
  getNextQuestion: function getNextQuestion() {
    var questions = this.getQuestions();
    var index = questions.index(this.getCurrentQuestion());
    var question = questions[index + 1];

    if (question) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])(question);
    }

    return null;
  },
  advanceQuestion: function advanceQuestion() {
    var nextQuestion = this.getNextQuestion();

    if (nextQuestion) {
      var currentQuestion = this.getCurrentQuestion();
      currentQuestion.hide();
      nextQuestion.show();
      var contentModuleId = nextQuestion.attr('data-content-module-id');
      Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-content-module').hide();
      Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])(".js-content-module[data-content-module-id=\"".concat(contentModuleId, "\"]")).show();
    } else {
      this.showQuizDone();
    }
  },
  displayError: function displayError(errorText) {
    var currentQuestion = this.getCurrentQuestion();
    currentQuestion.find('input[type=radio]').prop('checked', false);
    var $formErrorDiv = currentQuestion.find('.js-form-error');
    $formErrorDiv.html(errorText);
    $formErrorDiv.show();
    Object(__WEBPACK_IMPORTED_MODULE_5__rover_utilities_scrollToElement__["a" /* default */])($formErrorDiv.selector);
  },
  showIntroModal: function showIntroModal() {
    // for the new SSU we are not going to show the initial modal
    if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].flags.isNewSSU) {
      return;
    }

    var modal = new __WEBPACK_IMPORTED_MODULE_8__components_rover_modal__["a" /* default */]({
      title: Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-intro-modal-title').html(),
      content: Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-intro-modal-content').html()
    });
    modal.open();
  },
  showQuizDone: function showQuizDone() {
    // Do not display done page from legacy SSU when in new SSU. Reload so that we see the new
    // "done" page.
    if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].flags.isNewSSU) {
      // Triggering a POST request to trigger the save events. Then using
      // legacy logic to reload the page.
      __WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"].ajax({
        type: 'POST',
        data: JSON.stringify({
          quiz_completed: true
        }),
        contentType: 'application/json'
      }).success(function () {
        return window.location.reload();
      }).fail(function (e) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_reportError__["a" /* default */])(e);
      });
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-rover-primary-col').hide();
      Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-rover-secondary-col').hide();
      Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('.js-quiz-done').show();
    }
  }
});
Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])(function () {
  var $body = Object(__WEBPACK_IMPORTED_MODULE_3__rover_globals_jquery__["default"])('body');

  if (!$body.hasClass('js-safety-quiz')) {
    return;
  }

  new __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].views.QuizView({});
});

/***/ }),

/***/ 2279:
/***/ (function(module, exports, __webpack_require__) {

(function() {
  'use strict';

  // desiredOffset - page offset to scroll to
  // speed - duration of the scroll per 1000px
  function __ANIMATE_SCROLL_TO(desiredOffset) {
    var userOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var options = {
      speed: 500,
      minDuration: 250,
      maxDuration: 1500,
      cancelOnUserAction: true,
      element: window,
      horizontal: false,
      onComplete: undefined,
      passive: true,
      offset: 0
    };

    var optionsKeys = Object.keys(options);

    // Override default options
    for (var i = 0; i < optionsKeys.length; i++) {
      var key = optionsKeys[i];

      if (typeof userOptions[key] !== 'undefined') {
        options[key] = userOptions[key];
      }
    }

    if (!options.cancelOnUserAction && options.passive) {
      options.passive = false;
      if (userOptions.passive) {
        console && console.warn(
          'animated-scroll-to:\n "passive" was set to "false" to prevent errors, ' +
          'as using "cancelOnUserAction: false" doesn\'t work with passive events.')
      }
    }

    if (desiredOffset instanceof HTMLElement) {
      if (userOptions.element && userOptions.element instanceof HTMLElement) {
        if (options.horizontal) {
          desiredOffset = (desiredOffset.getBoundingClientRect().left + userOptions.element.scrollLeft)
            - userOptions.element.getBoundingClientRect().left;
        } else {
          desiredOffset = (desiredOffset.getBoundingClientRect().top + userOptions.element.scrollTop)
            - userOptions.element.getBoundingClientRect().top;
        }
      } else if (options.horizontal) {
        var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        desiredOffset = scrollLeft + desiredOffset.getBoundingClientRect().left;
      } else {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        desiredOffset = scrollTop + desiredOffset.getBoundingClientRect().top;
      }
    }

    // Add additonal user offset
    desiredOffset += options.offset

    options.isWindow = options.element === window;

    var initialScrollPosition = null;
    var initialAxisScollPosition = 0;
    var maxScroll = null;

    if (options.isWindow) {
      if (options.horizontal) {
        // get cross browser scroll positions
        initialScrollPosition = window.scrollX || document.documentElement.scrollLeft;
        initialAxisScollPosition = window.scrollY || document.documentElement.scrollTop;
        // cross browser document height minus window height
        maxScroll = Math.max(
          document.body.scrollWidth, document.documentElement.scrollWidth,
          document.body.offsetWidth, document.documentElement.offsetWidth,
          document.body.clientWidth, document.documentElement.clientWidth
        ) - window.innerWidth;
      } else {
        // get cross browser scroll positions
        initialScrollPosition = window.scrollY || document.documentElement.scrollTop;
        initialAxisScollPosition = window.scrollX || document.documentElement.scrollLeft;
        // cross browser document width minus window width
        maxScroll = Math.max(
          document.body.scrollHeight, document.documentElement.scrollHeight,
          document.body.offsetHeight, document.documentElement.offsetHeight,
          document.body.clientHeight, document.documentElement.clientHeight
        ) - window.innerHeight;
      }
    } else {
      // DOM element
      if (options.horizontal) {
        initialScrollPosition = options.element.scrollLeft;
        maxScroll = options.element.scrollWidth - options.element.clientWidth;
      } else {
        initialScrollPosition = options.element.scrollTop;
        maxScroll = options.element.scrollHeight - options.element.clientHeight;
      }
    }

    // If the scroll position is greater than maximum available scroll
    if (desiredOffset > maxScroll) {
      desiredOffset = maxScroll;
    }

    // Calculate diff to scroll
    var diff = desiredOffset - initialScrollPosition;

    // Do nothing if the page is already there
    if (diff === 0) {
      // Execute callback if there is any
      if (options.onComplete && typeof options.onComplete === 'function') {
        options.onComplete()
      }

      return;
    }

    // Calculate duration of the scroll
    var duration = Math.abs(Math.round((diff / 1000) * options.speed));

    // Set minimum and maximum duration
    if (duration < options.minDuration) {
      duration = options.minDuration;
    } else if (duration > options.maxDuration) {
      duration = options.maxDuration;
    }

    var startingTime = Date.now();

    // Request animation frame ID
    var requestID = null;

    // Method handler
    var handleUserEvent = null;
    var userEventOptions = { passive: options.passive };

    if (options.cancelOnUserAction) {
      // Set handler to cancel scroll on user action
      handleUserEvent = function() {
        removeListeners();
        cancelAnimationFrame(requestID);
      };
      window.addEventListener('keydown', handleUserEvent, userEventOptions);
      window.addEventListener('mousedown', handleUserEvent, userEventOptions);
    } else {
      // Set handler to prevent user actions while scroll is active
      handleUserEvent = function(e) { e.preventDefault(); };
      window.addEventListener('scroll', handleUserEvent, userEventOptions);
    }

    window.addEventListener('wheel', handleUserEvent, userEventOptions);
    window.addEventListener('touchstart', handleUserEvent, userEventOptions);

    var removeListeners = function () {
      window.removeEventListener('wheel', handleUserEvent, userEventOptions);
      window.removeEventListener('touchstart', handleUserEvent, userEventOptions);

      if (options.cancelOnUserAction) {
        window.removeEventListener('keydown', handleUserEvent, userEventOptions);
        window.removeEventListener('mousedown', handleUserEvent, userEventOptions);
      } else {
        window.removeEventListener('scroll', handleUserEvent, userEventOptions);
      }
    };

    var step = function () {
      var timeDiff = Date.now() - startingTime;
      var t = (timeDiff / duration) - 1;
      var easing = t * t * t + 1;
      var scrollPosition = Math.round(initialScrollPosition + (diff * easing));

      var doScroll = function(position) {
        if (options.isWindow) {
          if (options.horizontal) {
            options.element.scrollTo(position, initialAxisScollPosition);
          } else {
            options.element.scrollTo(initialAxisScollPosition, position);
          }
        } else if (options.horizontal) {
          options.element.scrollLeft = position;
        } else {
          options.element.scrollTop = position;
        }
      }

      if (timeDiff < duration && scrollPosition !== desiredOffset) {
        // If scroll didn't reach desired offset or time is not elapsed
        // Scroll to a new position
        // And request a new step
        doScroll(scrollPosition);

        requestID = requestAnimationFrame(step);
      } else {
        // If the time elapsed or we reached the desired offset
        // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
        // Clear animation frame to be sure
        doScroll(desiredOffset);

        cancelAnimationFrame(requestID);

        // Remove listeners
        removeListeners();

        // Animation is complete, execute callback if there is any
        if (options.onComplete && typeof options.onComplete === 'function') {
          options.onComplete()
        }
      }
    };

    // Start animating scroll
    requestID = requestAnimationFrame(step);
  }

  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      module.exports = __ANIMATE_SCROLL_TO;
      exports = module.exports;
    }
    exports.default = __ANIMATE_SCROLL_TO;
  } else if (window) {
    window.animateScrollTo = __ANIMATE_SCROLL_TO;
  }
}).call(this);


/***/ }),

/***/ 2280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../globals/jquery.ts
var jquery = __webpack_require__(9);

// EXTERNAL MODULE: ../globals/moment.ts
var moment = __webpack_require__(265);

// EXTERNAL MODULE: ../globals/Rover.ts
var Rover = __webpack_require__(13);

// EXTERNAL MODULE: ../globals/underscore.ts
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/datetimeInjected.ts + 1 modules
var datetimeInjected = __webpack_require__(104);

// EXTERNAL MODULE: ../utilities/conversation.js
var conversation = __webpack_require__(1696);

// CONCATENATED MODULE: ../utilities/person.js
function getPersonOpk(url) {
  if (!url) {
    return '';
  }

  var match = url.match(/people\/([a-zA-z0-9]+)\/$/);

  if (!match) {
    return '';
  }

  return match[1] || '';
}

/* harmony default export */ var person = (getPersonOpk);
// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(31);

// EXTERNAL MODULE: ../utilities/injector.js
var injector = __webpack_require__(23);

// EXTERNAL MODULE: ./js/models/requestable.js
var requestable = __webpack_require__(1102);

// CONCATENATED MODULE: ./js/models/conversation.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'







var personOpk = Object(injector["a" /* default */])('Rover.context.person.opk', '');
var ConversationModel = requestable["default"].extend({
  defaults: {
    dates: []
  },
  initialize: function initialize() {
    var _this = this;

    this.on('change:dates', underscore["default"].bind(function () {
      _this.trigger('datesChanged');
    }, this));
  },
  getOpk: function getOpk() {
    return Object(conversation["a" /* default */])(this.get('url'));
  },
  getProviderOpk: function getProviderOpk() {
    return person(this.get('provider').url);
  },
  getServiceType: function getServiceType() {
    return this.get('_service_type');
  },
  getRelationship: function getRelationship() {
    return this.get('relationship');
  },
  getDatesData: function getDatesData() {
    return {
      start_date: this.get('start_date'),
      end_date: this.get('end_date'),
      dates: this.get('dates')
    };
  },
  isEndDateExclusive: function isEndDateExclusive() {
    var serviceType = this.getServiceType();

    if (!serviceType) {
      return true;
    }

    if (serviceType.is_end_date_exclusive === false) {
      return false;
    }

    return true;
  },
  supportsNonContiguousDates: function supportsNonContiguousDates() {
    var serviceType = this.getServiceType();
    return !!serviceType && serviceType.supports_non_contiguous_dates;
  },
  supportsNumUnitsPerDay: function supportsNumUnitsPerDay() {
    var serviceType = this.getServiceType();
    return !!serviceType && serviceType.supports_num_units_per_day;
  },
  requiresDates: function requiresDates() {
    var serviceType = this.getServiceType();
    return !!serviceType && !serviceType.supports_start_end_date;
  },
  unitsAndDatesAsSentence: function unitsAndDatesAsSentence() {
    var out = '';

    if (this.supportsNumUnitsPerDay()) {
      var numUnitsPerDay = this.getNumUnitsPerDay();
      out = translation["default"]._("{numUnitsPerDay, plural, one {# time per day} other {# times per day}}", {
        numUnitsPerDay: numUnitsPerDay
      });
      out += ' ';
    }

    if (!this.supportsNonContiguousDates()) {
      var start = Object(moment["a" /* default */])(this.get('start_date')).format(this.dateDisplayFormat);
      var end = Object(moment["a" /* default */])(this.get('end_date')).format(this.dateDisplayFormat);
      out += translation["default"]._(
      /*i18n*/
      {
        id: "from {start} to {end}",
        values: {
          start: start,
          end: end
        }
      });
    } else {
      out += translation["default"]._(
      /*i18n*/
      {
        id: "on {0}",
        values: {
          0: Rover["default"].utils.simpleSyndeticJoin(this.datesList())
        }
      });
    }

    return out;
  },
  dropOff: function dropOff() {
    var out = '';

    if (this.supportsNumUnitsPerDay()) {
      return this.unitsAndDatesAsSentence();
    }

    if (!this.supportsNonContiguousDates()) {
      var start = Object(moment["a" /* default */])(this.get('start_date')).format(datetimeInjected["b" /* default */].MONTH_DAY_WEEK_MED);
      out += translation["default"]._(
      /*i18n*/
      {
        id: "Drop off: {start}",
        values: {
          start: start
        }
      });
    } else {
      out += translation["default"]._(
      /*i18n*/
      {
        id: "on {0}",
        values: {
          0: Rover["default"].utils.simpleSyndeticJoin(this.datesList())
        }
      });
    }

    return out;
  },
  from: function from() {
    var start = Object(moment["a" /* default */])(this.get('start_date')).format(datetimeInjected["b" /* default */].MONTH_DAY_WEEK_MED);
    return translation["default"]._(
    /*i18n*/
    {
      id: "From: {start}",
      values: {
        start: start
      }
    });
  },
  to: function to() {
    var end = Object(moment["a" /* default */])(this.get('end_date')).format(datetimeInjected["b" /* default */].MONTH_DAY_WEEK_MED);
    return translation["default"]._(
    /*i18n*/
    {
      id: "To: {end}",
      values: {
        end: end
      }
    });
  },
  pickUp: function pickUp() {
    if (this.supportsNonContiguousDates()) {
      return '';
    }

    var end = Object(moment["a" /* default */])(this.get('end_date')).format(datetimeInjected["b" /* default */].MONTH_DAY_WEEK_MED);

    var out = translation["default"]._(
    /*i18n*/
    {
      id: "Pick up: {end}",
      values: {
        end: end
      }
    });

    return out;
  },
  datesList: function datesList(format) {
    var dateFormat = format || this.dateDisplayFormat;
    return this.get('dates').map(function (date) {
      return Object(moment["a" /* default */])(date.date).format(dateFormat);
    });
  },
  isOvernightBoarding: function isOvernightBoarding() {
    return this.get('service_type') === 'overnight-boarding';
  },
  isOvernightTraveling: function isOvernightTraveling() {
    return this.get('service_type') === 'overnight-traveling';
  },
  isDoggyDayCare: function isDoggyDayCare() {
    return this.get('service_type') === 'doggy-day-care';
  },
  isDropIn: function isDropIn() {
    return this.get('service_type') === 'drop-in';
  },
  isDogWalking: function isDogWalking() {
    return this.get('service_type') === 'dog-walking';
  },
  getDuration: function getDuration() {
    var startDate = Object(moment["a" /* default */])(this.get('start_date'));
    var endDate = Object(moment["a" /* default */])(this.get('end_date'));
    var endDateExclusive = null;

    if (this.supportsNonContiguousDates()) {
      return this.get('dates').length;
    }

    if (!this.isEndDateExclusive()) {
      endDateExclusive = endDate.add(1, 'days');
    } else {
      endDateExclusive = endDate;
    }

    return Math.max(1, endDateExclusive.diff(startDate, 'days'));
  },
  getNumUnitsPerDay: function getNumUnitsPerDay() {
    var dates = this.get('dates');

    if (!this.supportsNumUnitsPerDay() || dates.length === 0) {
      return 1;
    }

    return dates[0].num_units;
  },
  saveNumUnitsPerDay: function saveNumUnitsPerDay(numUnitsPerDay, optimisticAttrUpdate) {
    var newDates = this.get('dates').map(function (date) {
      return {
        date: date.date,
        num_units: numUnitsPerDay
      };
    });
    return this.saveDraftPricing({
      dates: newDates
    }, optimisticAttrUpdate);
  },
  saveDates: function saveDates(dates, optimisticAttrUpdate) {
    var numUnitsToSet = this.getNumUnitsPerDay();

    if (!this.requiresDates()) {
      return null;
    }

    var newDates = dates.map(function (date) {
      return {
        date: date,
        num_units: numUnitsToSet
      };
    });
    return this.saveDraftPricing({
      dates: newDates
    }, optimisticAttrUpdate);
  },
  saveStartAndEndDate: function saveStartAndEndDate(startDate, endDate, optimisticAttrUpdate) {
    if (this.supportsNonContiguousDates()) {
      return null;
    }

    if (this.supportsNumUnitsPerDay()) {
      return this.saveDates(this.buildDerivedDates(startDate, endDate), optimisticAttrUpdate);
    }

    return this.saveDraftPricing({
      start_date: startDate,
      end_date: endDate
    }, optimisticAttrUpdate);
  },
  buildDerivedDates: function buildDerivedDates(startDate, endDate) {
    var dateFormat = this.dateFormat;
    var startDateM = Object(moment["a" /* default */])(startDate, dateFormat);
    var endDateM = Object(moment["a" /* default */])(endDate, dateFormat);
    var dates = [startDate];
    var diff = endDateM.diff(startDateM, 'days'); // start_date and end_date are equal

    if (diff === 0) {
      return dates;
    }

    for (var i = 1; i <= diff; i += 1) {
      dates.push(Object(moment["a" /* default */])(startDate, dateFormat).add(i, 'days').format(dateFormat));
    }

    return dates;
  },
  save: function save(attrs, options) {
    // We NEVER want to set the provider_archived_status when saving because
    // if we do, we're telling the api that this is an archiving operation
    // Write your own archiving operation, if you wish.
    this.unset('provider_archived_status', {
      silent: true
    });
    return requestable["default"].prototype.save.call(this, attrs, options);
  },
  shadowSave: function shadowSave(attributes) {
    // For some operations (i.e. create request, cancel request) the API
    // expects the client to set some model attributes to specific values,
    // call PUT, then it will return the model with updated attributes.
    //
    // There may be many Views listening to attributes on this model. If
    // we have to change one of those attributes to facilitate the the
    // specific API operation (like 'request') then some listeners may
    // be triggered even though we didn't set that attribute to a normal
    // state.
    //
    // To work around this trouble, we're creating a copy of the model
    // which includes all of that model's attributes, saving it, and
    // when that save succeeds, updating the original with the new
    // attributes.
    //
    // Alternatives to this approach include:
    // 1. Use this.set(attributes, {silent: true}) which will suppress
    //    triggers. If the subsequent save fails, however, the model
    //    could be left in an invalid state. Also, the Backbone docs
    //    say that you should probably never use {silent: True}
    // 2. Put a property on the Conversation model so that it can track
    //    when this save is in flight. All listeners on request should
    //    ignore changes while it is in flight. Once the save completes,
    //    disable the flag.
    var currentAttributes = this.attributes;
    var self = this;

    var shadowAttributes = _objectSpread(_objectSpread({}, currentAttributes), attributes);

    var shadow = new ConversationModel(shadowAttributes);
    shadow.set('booking_add_ons', shadow.getActiveBookingAddOns());
    return shadow.save().then(function (data) {
      self.set(self.parse(data));
    }, function (err) {
      var confirmation;

      if (err.status === 409) {
        // eslint-disable-next-line no-alert, no-restricted-globals
        confirmation = confirm(translation["default"]._('This request has been updated since you loaded this page. Press OK to see up-to-date details.'));
      }

      if (confirmation) {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }

      return err;
    });
  },
  getLockedAddOns: function getLockedAddOns() {
    if (this.isRecurring) {
      return [];
    }

    if (personOpk !== this.getProviderOpk()) {
      return [];
    }

    if (this.get('locked_service_add_ons') !== undefined) {
      return this.get('locked_service_add_ons');
    }

    var data = jquery["default"].ajax({
      method: 'GET',
      async: false,
      url: this.get('urls').locked_service_add_on_url
    });
    this.set({
      locked_service_add_ons: data.responseJSON.locked_service_add_ons
    });
    return this.get('locked_service_add_ons');
  },
  getLockedAddOnBySlug: function getLockedAddOnBySlug(slug) {
    return underscore["default"].find(this.getLockedAddOns(), function (lao) {
      return lao.slug === slug;
    });
  },
  hasLockedAddOns: function hasLockedAddOns() {
    return (this.getLockedAddOns() || []).length > 0;
  },
  calculateNewLockedAddOns: function calculateNewLockedAddOns() {
    var bookingAddOnsOverwrite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bookingAddOns = bookingAddOnsOverwrite.length === 0 ? this.get('booking_add_ons') : bookingAddOnsOverwrite;
    return jquery["default"].ajax({
      method: 'POST',
      url: this.get('urls').locked_service_add_on_calculator_url,
      data: JSON.stringify({
        conversation: this.get('url'),
        booking_add_ons: bookingAddOns
      }),
      contentType: 'application/json'
    });
  },
  lockRates: function lockRates() {
    var _this2 = this;

    return this.calculateNewLockedAddOns().then(function (data) {
      var request = {
        locked_service_add_ons: data.locked_service_add_ons
      };
      jquery["default"].ajax({
        method: 'POST',
        url: _this2.get('urls').locked_service_add_on_url,
        data: JSON.stringify(request),
        contentType: 'application/json'
      }).then(function (data) {
        _this2.set({
          locked_service_add_ons: data
        });
      });
    });
  },
  unlockRates: function unlockRates() {
    var _this3 = this;

    return jquery["default"].ajax({
      method: 'DELETE',
      url: this.get('urls').locked_service_add_on_url,
      contentType: 'application/json'
    }).then(function () {
      _this3.set({
        locked_service_add_ons: []
      });
    });
  },
  getDraftPricing: function getDraftPricing(options) {
    var uri = this.get('urls').pricing;
    var request = {
      service: this.get('service'),
      requester: this.get('requester').url,
      pets: underscore["default"].pluck(this.get('pets'), 'url'),
      booking_add_ons: this.get('booking_add_ons')
    };

    if (this.requiresDates()) {
      request.dates = this.get('dates');
    } else {
      request.start_date = this.get('start_date');
      request.end_date = this.get('end_date');
    }

    request = underscore["default"].extend(request, options);
    return jquery["default"].ajax({
      method: 'POST',
      url: uri,
      data: JSON.stringify(request),
      contentType: 'application/json'
    });
  },
  getPerDaySummary: function getPerDaySummary() {
    var numUnitsPerDay = this.getNumUnitsPerDay();
    var serviceType = this.getServiceType();
    var serviceTypeUnit = serviceType.alternative_rate_unit_translated;

    if (numUnitsPerDay > 1) {
      serviceTypeUnit = serviceType.alternative_rate_unit_plural;
    }

    if (serviceType.is_daytime_traveling) {
      var longAddOns = ['long-walk', 'long-drop-in'];
      var minCount = this.attributes.booking_add_ons.filter(function (sao) {
        return longAddOns.includes(sao.slug);
      }).length > 0 ? 60 : 30;

      if (this.attributes.dates.length > 1) {
        return translation["default"]._(
        /* i18n: {0} will be num units per day, {1} will be num of minutes */
        {
          id: "{numUnitsPerDay} per day \u2022 {minCount} min",
          values: {
            numUnitsPerDay: numUnitsPerDay,
            minCount: minCount
          }
        });
      }

      return translation["default"]._(
      /* i18n: {0} will be num units per day, {1} will be unit of service (walks/visits/etc), {2} will be num of minutes */
      {
        id: "{numUnitsPerDay} {serviceTypeUnit} \u2022 {minCount} min",
        values: {
          numUnitsPerDay: numUnitsPerDay,
          serviceTypeUnit: serviceTypeUnit,
          minCount: minCount
        }
      });
    }

    if (this.attributes.dates.length > 1) {
      return translation["default"]._(
      /* i18n: {0} will be num units per day */
      {
        id: "{numUnitsPerDay} per day",
        values: {
          numUnitsPerDay: numUnitsPerDay
        }
      });
    }

    return translation["default"]._(
    /* i18n: {0} will be num units per day, {1} will be unit of service (walks/visits/etc) */
    {
      id: "{numUnitsPerDay} {serviceTypeUnit}",
      values: {
        numUnitsPerDay: numUnitsPerDay,
        serviceTypeUnit: serviceTypeUnit
      }
    });
  }
});
/* harmony default export */ var models_conversation = __webpack_exports__["default"] = (ConversationModel);

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PREFERRED_COUNTRIES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initIntlTelInput;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateCleaveForInputs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cleave_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_injector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_retry__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cleave_js_dist_addons_cleave_phone_i18n__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cleave_js_dist_addons_cleave_phone_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cleave_js_dist_addons_cleave_phone_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_tel_input__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_tel_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_tel_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_tel_input_build_css_intlTelInput_css__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_tel_input_build_css_intlTelInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intl_tel_input_build_css_intlTelInput_css__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }









var defaultLocale = 'en-us';
var missingModuleMessage = 'Cannot find module';
var EU_COUNTRIES = ['gb', 'de', 'es', 'fr', 'it', 'nl', 'no', 'se'];
var DEFAULT_PREFERRED_COUNTRIES = ['us', 'ca', 'gb', 'de', 'es', 'fr', 'it', 'nl', 'no', 'se'];

function localizedIntlTelInput($intlTelInput, utilsLoadedCallback, localizedCountries) {
  $intlTelInput.each(function () {
    var _this = this;

    // hack: for django form to make sure the correct value is sent to django b/c we cannot call js using
    // traditional post. This will not be an issue if the flow use ajax
    var name = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('name');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('name', ''); // the utils script will be load lazily. Temp solution until we get better phone number input component

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).intlTelInput({
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/13.0.0/js/utils.js',
      hiddenInput: name,
      autoPlaceholder: 'off',
      preferredCountries: DEFAULT_PREFERRED_COUNTRIES,
      localizedCountries: localizedCountries,
      initialCountry: 'auto',
      geoIpLookup: function geoIpLookup(callback) {
        callback(Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_injector__["a" /* default */])('Rover.context.countryCode', 'US'));
      }
    }).done(function () {
      if (utilsLoadedCallback) {
        utilsLoadedCallback(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this));
      }
    });
    updateAccessibilityAttributes(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).on('countrychange', function (e, countryData) {
      if (typeof window.intlTelInputUtils === 'undefined') return;
      var newNumber = window.intlTelInputUtils.formatNumber(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this).val(), countryData.iso2, window.intlTelInputUtils.numberFormat.INTERNATIONAL);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this).intlTelInput('setNumber', newNumber);
    });
  });
  return $intlTelInput;
}

function initIntlTelInput(inputEl, utilsLoadedCallback) {
  var $intlTelInput = inputEl ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()(inputEl) : __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-intl-tel-input');

  var loadStrings = function loadStrings(language) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_retry__["a" /* default */])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var countries;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              countries = {};
              _context.prev = 1;
              _context.next = 4;
              return __webpack_require__(2274)("./".concat(language, "/countries.json"));

            case 4:
              countries = _context.sent;
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              if (_context.t0.message.includes(missingModuleMessage)) {
                _context.next = 11;
                break;
              }

              throw _context.t0;

            case 11:
              return _context.abrupt("return", countries);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    })));
  };

  var locale = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_injector__["a" /* default */])('Rover.context.language', defaultLocale);

  if (locale !== defaultLocale) {
    loadStrings(locale).then(function (localizedCountries) {
      return localizedIntlTelInput($intlTelInput, utilsLoadedCallback, localizedCountries);
    }, function () {
      return localizedIntlTelInput($intlTelInput, utilsLoadedCallback, {});
    });
  } else {
    localizedIntlTelInput($intlTelInput, utilsLoadedCallback, {});
  }

  return $intlTelInput;
}

function getCleaveOptions(countryCode) {
  switch (countryCode) {
    case 'us':
    case 'ca':
      return {
        blocks: [3, 3, 4],
        delimiter: '-',
        numericOnly: true
      };

    default:
      return {
        phone: true,
        phoneRegionCode: countryCode
      };
  }
}

function updateCleaveForInputs() {
  // For each of the input, initialize cleave. Cleave gets destroyed and recreated when user change country
  var countryCode = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).intlTelInput('getSelectedCountryData').iso2;
  if (!countryCode) return;
  var cleave = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('cleave');

  if (cleave) {
    cleave.destroy();
  }

  var value = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val() || ''; // hack: strip out +XX otherwise cleave will keep adding it in the beginning

  if (['us', 'ca'].includes(countryCode)) {
    if (value.startsWith('+1')) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val(value.substring(2));
    }
  }

  if (EU_COUNTRIES.includes(countryCode)) {
    var intlCodeRegex = /^\+\d{2}/;

    if (intlCodeRegex.test(value)) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val(value.substring(3));
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('cleave', new __WEBPACK_IMPORTED_MODULE_0_cleave_js___default.a(this, getCleaveOptions(countryCode)));
}

function updateAccessibilityAttributes($intlTelInput) {
  // These bring the input up to speed with modern accessibility guidelines.
  // This whole function can likely be removed once our intl-tel-input version is upgraded to the latest.
  // (See https://roverdotcom.atlassian.net/browse/DEV-56864)
  var $flagControl = $intlTelInput.siblings('.flag-container').children('.selected-flag');
  var $countryDropdown = $flagControl.siblings('.country-list');
  $flagControl.attr('aria-expanded', false);
  $intlTelInput.on('open:countrydropdown', function () {
    $flagControl.attr('aria-expanded', true);
  });
  $intlTelInput.on('close:countrydropdown', function () {
    $flagControl.attr('aria-expanded', false);
  }); // Create unique IDs for each input's elements (current version of intl-tel-input doesn't do this)

  var uniqueId = __WEBPACK_IMPORTED_MODULE_2_uuid___default()();
  var newId = "country-listbox-".concat(uniqueId);
  $countryDropdown.attr('id', newId);
  $flagControl.attr('aria-owns', "".concat(newId, " ").concat($intlTelInput.attr('id')));
  $intlTelInput.attr('role', 'textbox');
  $countryDropdown.children('.country.preferred').each(function (i, el) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).attr('id', "".concat(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).attr('id'), "-").concat(uniqueId));
  });
  $countryDropdown.attr('aria-activedescendant', "".concat($countryDropdown.attr('aria-activedescendant'), "-").concat(uniqueId));
}

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERVICE_TYPE_CHOICES; });
/* unused harmony export ALTERNATIVE_RATE_UNITS */
/* unused harmony export ADD_ON_TYPE_UNITS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERVICE_ADD_ON_UNITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SERVICE_TYPE_PRICE_UNITS; });
/* unused harmony export ADD_ON_FREQUENCY */
var _SERVICE_TYPE_PRICE_U;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SERVICE_TYPE_CHOICES = {
  boarding: 'overnight-boarding',
  traveling: 'overnight-traveling',
  dropIn: 'drop-in',
  dayCare: 'doggy-day-care',
  walking: 'dog-walking',
  onDemandWalking: 'on-demand-dog-walking',
  assignmentGrooming: 'on-demand-grooming',
  assignmentDropIn: 'on-demand-drop-in'
}; // model after SERVICE_TYPE_PRICE_UNITS or ALTERNATIVE_RATE_UNIT

var ALTERNATIVE_RATE_UNITS = {
  night: function night(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {night} other {nights}}",
        values: {
          count: count
        }
      }
    );
  },
  day: function day(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {day} other {days}}",
        values: {
          count: count
        }
      }
    );
  },
  visit: function visit(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {visit} other {visits}}",
        values: {
          count: count
        }
      }
    );
  },
  walk: function walk(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {walk} other {walks}}",
        values: {
          count: count
        }
      }
    );
  },
  groom: function groom(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {groom} other {grooms}}",
        values: {
          count: count
        }
      }
    );
  }
}; // model after UNIT_CHOICES which is used in AddOnType.unit

var ADD_ON_TYPE_UNITS = {
  night: function night(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {night} other {nights}}",
        values: {
          count: count
        }
      }
    );
  },
  bath: function bath(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {groom} other {grooms}}",
        values: {
          count: count
        }
      }
    );
  },
  walk: function walk(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {walk} other {walks}}",
        values: {
          count: count
        }
      }
    );
  },
  round_trip: function round_trip(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {round trip} other {round trips}}",
        values: {
          count: count
        }
      }
    );
  },
  session: function session(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {session} other {sessions}}",
        values: {
          count: count
        }
      }
    );
  }
}; // all possible unit values returned by service.add_on.unit. See services.models.ServiceAddOnMixin#get_rate_unit in backend

var SERVICE_ADD_ON_UNITS = _objectSpread(_objectSpread({}, ALTERNATIVE_RATE_UNITS), ADD_ON_TYPE_UNITS); // SERVICE_TYPE_ALTERNATIVE_RATE_UNIT, model after SERVICE_TYPE_PRICE_UNITS

var SERVICE_TYPE_PRICE_UNITS = (_SERVICE_TYPE_PRICE_U = {}, _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.boarding, ALTERNATIVE_RATE_UNITS.night), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.traveling, ALTERNATIVE_RATE_UNITS.night), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.dayCare, ALTERNATIVE_RATE_UNITS.day), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.dropIn, ALTERNATIVE_RATE_UNITS.visit), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.walking, ALTERNATIVE_RATE_UNITS.walk), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.onDemandWalking, ALTERNATIVE_RATE_UNITS.walk), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.assignmentGrooming, ALTERNATIVE_RATE_UNITS.groom), _defineProperty(_SERVICE_TYPE_PRICE_U, SERVICE_TYPE_CHOICES.assignmentDropIn, ALTERNATIVE_RATE_UNITS.visit), _SERVICE_TYPE_PRICE_U); // model after src/aplaceforrover/services/models.py:121 FREQUENCY_CHOICES + PRICE_UNITS

var ADD_ON_FREQUENCY = _objectSpread(_objectSpread({}, ALTERNATIVE_RATE_UNITS), {}, {
  night: function night(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {night} other {nights}}",
        values: {
          count: count
        }
      }
    );
  },
  event: function event(count) {
    return (
      /*i18n*/
      {
        id: "{count, plural, one {time} other {times}}",
        values: {
          count: count
        }
      }
    );
  },
  one_time_event: function one_time_event() {
    return (
      /*i18n*/
      {
        id: "time"
      }
    );
  }
});

/***/ })

},[2241]);


// WEBPACK FOOTER //
// common.16ff645dc2dc4c7d.js